webpackJsonp([29],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _exenv = __webpack_require__(4);

var serverLog = false;
var clientLog = false;

if (false) {
  // eslint-disable-next-line global-require
  serverLog = require('../server/services/logger_service');
} else {
  // eslint-disable-next-line global-require
  clientLog = __webpack_require__(132);
}

var log = _exenv.canUseDOM ? clientLog : serverLog;

module.exports = log;

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.figureOutPriorityTag = figureOutPriorityTag;
;(figureOutAdzone);
exports.buildPostAdModel = buildPostAdModel;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _cloneDeep = __webpack_require__(75);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _isString = __webpack_require__(92);

var _isString2 = _interopRequireDefault(_isString);

var _string_util = __webpack_require__(131);

var _string_util2 = _interopRequireDefault(_string_util);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function figureOutPriorityTag(originalTags) {
  var tags = (0, _cloneDeep2.default)(originalTags);
  var tagMatch = {
    slug: '',
    name: ''
  };

  if (tags && tags.length) {
    // We only care about first tag that is elibigle
    tags.reverse();
    tags.forEach(function (tag) {
      var tagSlug = tag.slug;
      var tagName = tag.name;
      // TODO: clean this up
      var matchedPriorityTag = (0, _get2.default)((0, _get2.default)(_ads2.default, 'priorityTags')[tagSlug], 'slug');
      if (tagMatch.slug === '' && matchedPriorityTag) {
        tagMatch.slug = matchedPriorityTag;
        tagMatch.name = matchedPriorityTag.replace(/-/gi, ' ');
      }

      if (tagName.indexOf('*') !== -1) {
        tagMatch.slug = tagName;
        tagMatch.name = tagName;
      }
    });
  }
  return tagMatch;
}

// construct adzone from a list of tags by looking up adtag mapping
function figureOutAdzone() {
  var originalTags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var category = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'news';
  var adsConfig = arguments[2];
  var pageType = arguments[3];

  var typeMap = {
    homepage: function homepage() {
      return 'homepage/homepage';
    },
    categoryPage: function categoryPage() {
      return category + '/' + category;
    },
    postPage: function postPage() {
      var adzone = 'misc/misc';
      var tagList = (0, _cloneDeep2.default)(originalTags);

      if (tagList.length) {
        // We only care about first tag that is elibigle
        tagList.reverse();

        // Matches tags against our existing list, if matched, set that tag as priority
        var tagMatch = null;

        // If there's a star tag, that tag will override the category in ad call and analytics
        var starTagMatch = null;

        tagList.forEach(function (tag) {
          var tagSlug = tag.slug;
          var tagName = tag.name;
          var matchedPriorityTag = (0, _get2.default)((0, _get2.default)(_ads2.default, 'priorityTags')[tagSlug], 'slug');
          if (tagMatch === null && matchedPriorityTag) {
            tagMatch = matchedPriorityTag;
          }

          if (tagName.indexOf('*') !== -1) {
            starTagMatch = tagName.replace(/\s+/g, '_');
          }
        });

        // adzone logic:
        // if the tag is found in the tag mapping, then use that mapping as tag
        // topic is category of the post
        // otherwise, defaults to misc

        if (starTagMatch) {
          return 'advertorial/' + starTagMatch;
        } else if (tagMatch) {
          var tagMatchDeslugged = (0, _string_util2.default)(tagMatch);
          adzone = (0, _isString2.default)(category) ? category + '/' + tagMatchDeslugged : 'misc/' + tagMatchDeslugged;
          if (starTagMatch) {
            adzone = starTagMatch + '/' + tagMatchDeslugged;
          }
        } else {
          adzone = (0, _isString2.default)(category) ? category + '/misc' : 'misc/misc';
        }
      } else {
        adzone = (0, _isString2.default)(category) ? category + '/misc' : 'misc/misc';
      }
      return adzone;
    },
    tagPage: function tagPage() {
      if (category.name) {
        if (category.name.indexOf('*') !== -1) {
          return 'advertorial/' + category.name.replace(/\s+/g, '_');
        }
        var matchedTopicCategory = (0, _get2.default)((0, _get2.default)(_ads2.default, 'priorityTags')[category.slug], 'category') || 'misc';
        return matchedTopicCategory + '/' + (0, _string_util2.default)(category.slug);
      }
      return '';
    },
    searchPage: function searchPage() {
      return 'search/search';
    },
    authorPage: function authorPage() {
      return 'author/author';
    },
    wpPage: function wpPage() {
      return 'page/page';
    },
    videoPage: function videoPage() {
      var video = (0, _get2.default)(category, 'data.playlist[0]', {});
      var series = video.series || 'video';
      return 'video/' + series;
    },
    videoPlaylistPage: function videoPlaylistPage() {
      var playlist = (0, _get2.default)(category, 'slug', '');
      return 'video/' + playlist;
    },
    videoIndexPage: function videoIndexPage() {
      return 'video/video';
    },
    productPage: function productPage() {
      return 'product/product';
    }
  };

  if (typeMap[pageType]) {
    return typeMap[pageType]();
  }

  // Default adzone
  return 'misc/misc';
}

/*
  Builds the following model params for ad key val generation
  name: topic (should only show on hp, topic, tag pages)
  type: homepage, post, postList, user
  kind: homepage, article, slideshow, video, collection profile
  url: url of the page (full url with http/https)
  topic: topic of the post
  supertag: primary tag
  tags: rest of the tag
  author: author name
*/
function buildPostAdModel(adsConfig, site, pageData, pageType) {
  var tagList = (0, _get2.default)(pageData, 'tags') || [];

  var category = (0, _get2.default)(pageData, 'categories[0].slug');

  // On topic pages category string is being passed in as the pageData param
  if (!category) {
    category = pageData;
  }
  var contentType = 'article';
  if ((0, _get2.default)(pageData, 'posterSlideshow.length')) {
    contentType = 'slideshow';
  } else if ((0, _get2.default)(pageData, 'hasVideoPoster') === true || (0, _get2.default)(pageData, 'posterVideo.feedId')) {
    contentType = 'video';
  }

  var typeMap = {
    homepage: function homepage() {
      return {
        name: 'homepage',
        type: 'homepage',
        kind: 'homepage',
        url: 'https://www.' + site + '.com'
      };
    },
    categoryPage: function categoryPage() {
      if (!category) {
        category = 'news';
      }

      return {
        type: 'category',
        kind: 'category',
        name: category,
        url: 'https://www.' + site + '.com/' + category
      };
    },
    tagPage: function tagPage() {
      var name = '';
      var tags = [];
      var slug = (0, _get2.default)(pageData, 'slug');
      var pageName = (0, _get2.default)(pageData, 'name');
      var categoryMatch = (0, _get2.default)((0, _get2.default)(_ads2.default, 'priorityTags')[slug], 'category');

      if (pageName) {
        if (pageName.indexOf('*') !== -1) {
          name = 'advertorial';
          tags.push(name);
          tags.push('custom');
          tags.push(slug);
        } else {
          if (categoryMatch) {
            name = categoryMatch;
            tags.push(categoryMatch);
            tags.push('custom');
          }
          tags.push(slug);
        }
      } else {
        tags.push(slug);
      }

      return {
        type: 'tag',
        kind: 'tag',
        name: name,
        tags: tags,
        url: 'https://www.' + site + '.com/section/' + slug
      };
    },
    searchPage: function searchPage() {
      return {
        kind: 'search',
        type: 'search',
        name: 'search'
      };
    },
    authorPage: function authorPage() {
      var author = (0, _get2.default)(pageData, 'slug');
      return {
        kind: 'author',
        type: 'author',
        name: 'author',
        author: author
      };
    },
    postPage: function postPage() {
      var tags = [];
      tagList.forEach(function (topicItem) {
        tags.push(topicItem.slug);
      });

      return {
        type: 'post',
        kind: contentType,
        url: 'https://www.fastcompany.com/' + (0, _get2.default)(pageData, 'id') + '/' + (0, _get2.default)(pageData, 'slug'),
        topic: category,
        supertag: '',
        tags: tags,
        author: (0, _get2.default)(pageData, 'author.slug')
      };
    },
    wpPage: function wpPage() {
      return {
        kind: 'page',
        type: 'page',
        name: 'page'
      };
    },
    videoPage: function videoPage() {
      return {
        kind: 'video',
        type: 'video',
        name: 'video'
      };
    },
    videoIndexPage: function videoIndexPage() {
      return {
        kind: 'video',
        type: 'video',
        name: 'video'
      };
    },
    videoPlaylistPage: function videoPlaylistPage() {
      return {
        kind: 'video',
        type: 'video',
        name: 'video'
      };
    },
    productPage: function productPage() {
      return {
        kind: 'product',
        type: 'product',
        name: 'product'
      };
    }
  };

  var fn = typeMap[pageType] || function noop() {};

  var model = (0, _extend2.default)({}, {
    site: site,
    adzone: figureOutAdzone(tagList, category, adsConfig, pageType)
  }, fn());

  return {
    config: adsConfig,
    model: model
  };
}

;(buildPostAdModel);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingSpinner = function (_Component) {
  _inherits(LoadingSpinner, _Component);

  function LoadingSpinner() {
    _classCallCheck(this, LoadingSpinner);

    return _possibleConstructorReturn(this, (LoadingSpinner.__proto__ || Object.getPrototypeOf(LoadingSpinner)).apply(this, arguments));
  }

  _createClass(LoadingSpinner, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var modifier = this.props.modifier;


      return _react2.default.createElement(
        'div',
        { className: 'loader-wrap' },
        _react2.default.createElement('div', { className: 'loader ' + (modifier ? 'loader--' + modifier : '') })
      );
    }
  }]);

  return LoadingSpinner;
}(_react.Component);

exports.default = LoadingSpinner;


LoadingSpinner.defaultProps = {
  modifier: ''
};

LoadingSpinner.propTypes = {
  modifier: _propTypes2.default.string
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  baseConfig: {
    companyID: '4160',
    siteZones: {
      fastcompany: 'mv.fc',
      fastcodesign: 'mv.fcdesign'
    }
  },
  priorityTags: {
    _custom: { slug: '_custom', category: 'advertorial' },
    _syndicated: { slug: '_syndicated', category: 'advertorial' },
    _brandview: { slug: '_brandview', category: 'advertorial' },
    '30-second-mba': { slug: '30-second-mba', category: 'studio' },
    'a-leap-forward': { slug: 'a-leap-forward', category: 'advertorial' },
    accelerator: { slug: 'accelerator', category: 'technology' },
    'ad-of-the-day': { slug: 'ad-of-the-day', category: 'misc' },
    adops: { slug: 'adops', category: 'misc' },
    afghanistan: { slug: 'afghanistan', category: 'misc' },
    agendas: { slug: 'agendas', category: 'misc' },
    'all-stars': { slug: 'all-stars', category: 'misc' },
    'almost-genius': { slug: 'almost-genius', category: 'misc' },
    analyzed: { slug: 'analyzed', category: 'misc' },
    'app-economy': { slug: 'app-economy', category: 'misc' },
    'apple-event': { slug: 'apple-event', category: 'misc' },
    asides: { slug: 'asides', category: 'misc' },
    'ask-the-experts': { slug: 'ask-the-experts', category: 'misc' },
    'awful-or-awesome': { slug: 'awful-or-awesome', category: 'misc' },
    badvocacy: { slug: 'badvocacy', category: 'misc' },
    bananas: { slug: 'bananas', category: 'misc' },
    'behind-the-brand': { slug: 'behind-the-brand', category: 'leadership' },
    'beside-great-leaders': {
      slug: 'beside-great-leaders',
      category: 'advertorial'
    },
    'big-bang-design': { slug: 'big-bang-design', category: 'misc' },
    biomimicry: { slug: 'biomimicry', category: 'innovation' },
    'biz-of-youtube': { slug: 'biz-of-youtube', category: 'misc' },
    'body-os': { slug: 'body-os', category: 'technology' },
    'body-week': { slug: 'body-week', category: 'misc' },
    'bottom-line': { slug: 'bottom-line', category: 'leadership' },
    'brand-evolution': { slug: 'brand-evolution', category: 'studio' },
    'breaking-the-status-quo': {
      slug: 'breaking-the-status-quo',
      category: 'misc'
    },
    'breakthrough-capitalism': {
      slug: 'breakthrough-capitalism',
      category: 'misc'
    },
    'brilliant-minds': { slug: 'brilliant-minds', category: 'advertorial' },
    'bugaboo-boxer': { slug: 'bugaboo-boxer', category: 'advertorial' },
    'build-a-business': { slug: 'build-a-business', category: 'leadership' },
    'builders-and-innovators': {
      slug: 'builders-and-innovators',
      category: 'advertorial'
    },
    'business-of-tech': { slug: 'business-of-tech', category: 'technology' },
    'business-simplified': {
      slug: 'business-simplified',
      category: 'advertorial'
    },
    'butterfly-effect': { slug: 'butterfly-effect', category: 'technology' },
    buyology: { slug: 'buyology', category: 'innovation' },
    cannes: { slug: 'cannes', category: 'misc' },
    'career-evolution': { slug: 'career-evolution', category: 'misc' },
    'ceelo-most-creative-videos': {
      slug: 'ceelo-most-creative-videos',
      category: 'studio'
    },
    'change-agents': { slug: 'change-agents', category: 'advertorial' },
    'change-generation': { slug: 'change-generation', category: 'innovation' },
    'chris-test': { slug: 'chris-test', category: 'misc' },
    'closer-to-next': { slug: 'closer-to-next', category: 'advertorial' },
    'co-creators': { slug: 'co-creators', category: 'misc' },
    'co-location': { slug: 'co-location', category: 'misc' },
    'coexists-2015-in-review': {
      slug: 'coexists-2015-in-review',
      category: 'misc'
    },
    'coexists-2016-in-review': {
      slug: 'coexists-2016-in-review',
      category: 'misc'
    },
    'coffee-week': { slug: 'coffee-week', category: 'misc' },
    'colabs-classes': { slug: 'colabs-classes', category: 'misc' },
    'conquering-the-cloud': {
      slug: 'conquering-the-cloud',
      category: 'advertorial'
    },
    'conquering-the-cloud-test': {
      slug: 'conquering-the-cloud-test',
      category: 'misc'
    },
    'content-and-pervasive-creativity': {
      slug: 'content-and-pervasive-creativity',
      category: 'advertorial'
    },
    'creating-happiness': { slug: 'creating-happiness', category: 'misc' },
    'creation-stories': { slug: 'creation-stories', category: 'misc' },
    'creative-braintrust': { slug: 'creative-braintrust', category: 'misc' },
    'creative-braintrust-test': {
      slug: 'creative-braintrust-test',
      category: 'misc'
    },
    'creative-calendar': { slug: 'creative-calendar', category: 'misc' },
    'creative-conversations': {
      slug: 'creative-conversations',
      category: 'misc'
    },
    'creative-counselor': { slug: 'creative-counselor', category: 'misc' },
    'creative-cultures': { slug: 'creative-cultures', category: 'misc' },
    'creative-defiance': { slug: 'creative-defiance', category: 'misc' },
    'creative-destination': { slug: 'creative-destination', category: 'misc' },
    'creativity-by-the-numbers': {
      slug: 'creativity-by-the-numbers',
      category: 'misc'
    },
    'creators-profile': { slug: 'creators-profile', category: 'misc' },
    'defining-moments-visualized': {
      slug: 'defining-moments-visualized',
      category: 'advertorial'
    },
    'design-50': { slug: 'design-50', category: 'misc' },
    'design-award': { slug: 'design-award', category: 'advertorial' },
    'design-crime': { slug: 'design-crime', category: 'misc' },
    'design-for-living': { slug: 'design-for-living', category: 'misc' },
    'design-moves': { slug: 'design-moves', category: 'misc' },
    'designed-for-success': {
      slug: 'designed-for-success',
      category: 'advertorial'
    },
    'designing-women': { slug: 'designing-women', category: 'misc' },
    'destination-design': {
      slug: 'destination-design',
      category: 'advertorial'
    },
    'destination-entrepreneurs': {
      slug: 'destination-entrepreneurs',
      category: 'misc'
    },
    'destinations-uncovered': {
      slug: 'destinations-uncovered',
      category: 'advertorial'
    },
    dialed: { slug: 'dialed', category: 'leadership' },
    'difficult-conversations': {
      slug: 'difficult-conversations',
      category: 'misc'
    },
    'digital-hollywood': { slug: 'digital-hollywood', category: 'misc' },
    'digital-trailblazers': {
      slug: 'digital-trailblazers',
      category: 'advertorial'
    },
    'dispatch-from': { slug: 'dispatch-from', category: 'advertorial' },
    'do-more': { slug: 'do-more', category: 'advertorial' },
    'drive-your-business-forward': {
      slug: 'drive-your-business-forward',
      category: 'advertorial'
    },
    'driving-innovation': {
      slug: 'driving-innovation',
      category: 'innovation'
    },
    'drone-vs': { slug: 'drone-vs', category: 'misc' },
    'dynamic-dialogues': { slug: 'dynamic-dialogues', category: 'advertorial' },
    elasticity: { slug: 'elasticity', category: 'misc' },
    'election-2016': { slug: 'election-2016', category: 'misc' },
    'electric-avenue': { slug: 'electric-avenue', category: 'misc' },
    'elevator-pitch': { slug: 'elevator-pitch', category: 'advertorial' },
    'engineering-creativity': {
      slug: 'engineering-creativity',
      category: 'advertorial'
    },
    'ethonomic-indicator': { slug: 'ethonomic-indicator', category: 'misc' },
    events: { slug: 'events', category: 'misc' },
    evidence: { slug: 'evidence', category: 'misc' },
    exclusive: { slug: 'exclusive', category: 'misc' },
    'exclusive-video': { slug: 'exclusive-video', category: 'misc' },
    experiments: { slug: 'experiments', category: 'misc' },
    exposure: { slug: 'exposure', category: 'misc' },
    'faces-of-founders': { slug: 'faces-of-founders', category: 'advertorial' },
    'fashion-forward': { slug: 'fashion-forward', category: 'misc' },
    'fast-cities': { slug: 'fast-cities', category: 'innovation' },
    'fast-company-live': { slug: 'fast-company-live', category: 'misc' },
    'fast-feed': { slug: 'fast-feed', category: 'misc' },
    'fast-forward': { slug: 'fast-forward', category: 'misc' },
    'fast-forward-workday': {
      slug: 'fast-forward-workday',
      category: 'advertorial'
    },
    'fast-take': { slug: 'fast-take', category: 'misc' },
    'fast-talk': { slug: 'fast-talk', category: 'misc' },
    fastcoworks: { slug: 'fastcoworks', category: 'misc' },
    'feeding-the-future': { slug: 'feeding-the-future', category: 'misc' },
    'find-your-values': { slug: 'find-your-values', category: 'leadership' },
    'first-look': { slug: 'first-look', category: 'misc' },
    'food-week': { slug: 'food-week', category: 'misc' },
    'fund-this': { slug: 'fund-this', category: 'innovation' },
    'future-forward': { slug: 'future-forward', category: 'misc' },
    'future-of-philanthropy': {
      slug: 'future-of-philanthropy',
      category: 'misc'
    },
    'future-of-retail': { slug: 'future-of-retail', category: 'technology' },
    'future-proof': { slug: 'future-proof', category: 'misc' },
    'futurist-forum': { slug: 'futurist-forum', category: 'innovation' },
    'generation-flux': { slug: 'generation-flux', category: 'technology' },
    'generosity-series': { slug: 'generosity-series', category: 'misc' },
    'genius-marketing': { slug: 'genius-marketing', category: 'misc' },
    'getting-funded': { slug: 'getting-funded', category: 'misc' },
    'gif-of-the-day': { slug: 'gif-of-the-day', category: 'misc' },
    'gift-guide': { slug: 'gift-guide', category: 'misc' },
    gigged: { slug: 'gigged', category: 'misc' },
    'good-design-is-good-business': {
      slug: 'good-design-is-good-business',
      category: 'innovation'
    },
    'greatest-geek-moment-in-history': {
      slug: 'greatest-geek-moment-in-history',
      category: 'misc'
    },
    'growth-hacking': { slug: 'growth-hacking', category: 'advertorial' },
    'growth-notes': { slug: 'growth-notes', category: 'advertorial' },
    'hackers-we-love': { slug: 'hackers-we-love', category: 'misc' },
    healthware: { slug: 'healthware', category: 'technology' },
    help: { slug: 'help', category: 'misc' },
    'heres-an-idea': { slug: 'heres-an-idea', category: 'innovation' },
    'hit-the-ground-running': {
      slug: 'hit-the-ground-running',
      category: 'misc'
    },
    'homebrew-news': { slug: 'homebrew-news', category: 'misc' },
    'hotel-revolution': { slug: 'hotel-revolution', category: 'advertorial' },
    'how-i-get-it-done': { slug: 'how-i-get-it-done', category: 'leadership' },
    'how-to-be-a-success-at-everything': {
      slug: 'how-to-be-a-success-at-everything',
      category: 'leadership'
    },
    'how-to-build-the-perfect-city': {
      slug: 'how-to-build-the-perfect-city',
      category: 'misc'
    },
    'hows-that-working-out-for-you': {
      slug: 'hows-that-working-out-for-you',
      category: 'misc'
    },
    hr: { slug: 'hr', category: 'misc' },
    ifive: { slug: 'ifive', category: 'misc' },
    'ignite-positive-change': {
      slug: 'ignite-positive-change',
      category: 'leadership'
    },
    'image-of-the-day': { slug: 'image-of-the-day', category: 'misc' },
    'industrial-internet': {
      slug: 'industrial-internet',
      category: 'advertorial'
    },
    'industries-to-watch': {
      slug: 'industries-to-watch',
      category: 'innovation'
    },
    'industry-pov': { slug: 'industry-pov', category: 'innovation' },
    'influence-project': { slug: 'influence-project', category: 'misc' },
    'influencer-collective': {
      slug: 'influencer-collective',
      category: 'misc'
    },
    'infographic-of-the-day': {
      slug: 'infographic-of-the-day',
      category: 'misc'
    },
    'innovation-agents': { slug: 'innovation-agents', category: 'misc' },
    'innovation-by-design': { slug: 'innovation-by-design', category: 'misc' },
    'innovation-by-design-2014': {
      slug: 'innovation-by-design-2014',
      category: 'misc'
    },
    'innovation-by-design-awards': {
      slug: 'innovation-by-design-awards',
      category: 'misc'
    },
    'innovation-by-design-awards-2014': {
      slug: 'innovation-by-design-awards-2014',
      category: 'misc'
    },
    'innovation-by-design-awards-2015': {
      slug: 'innovation-by-design-awards-2015',
      category: 'misc'
    },
    'innovation-by-design-awards-entries-2014': {
      slug: 'innovation-by-design-awards-entries-2014',
      category: 'misc'
    },
    'innovation-by-design-awards-entries-2015': {
      slug: 'innovation-by-design-awards-entries-2015',
      category: 'misc'
    },
    'innovation-by-design-conference': {
      slug: 'innovation-by-design-conference',
      category: 'misc'
    },
    'innovation-enabled': { slug: 'innovation-enabled', category: 'misc' },
    'innovation-engine': { slug: 'innovation-engine', category: 'misc' },
    'innovation-nation': { slug: 'innovation-nation', category: 'misc' },
    'innovation-pipeline': { slug: 'innovation-pipeline', category: 'misc' },
    'innovation-uncensored-sf-2014': {
      slug: 'innovation-uncensored-sf-2014',
      category: 'misc'
    },
    'insider-insight': { slug: 'insider-insight', category: 'misc' },
    'inspiration-and-impact': {
      slug: 'inspiration-and-impact',
      category: 'advertorial'
    },
    'inspired-ethonomics': { slug: 'inspired-ethonomics', category: 'misc' },
    'internet-of-things': { slug: 'internet-of-things', category: 'misc' },
    'isle-of-innovation': {
      slug: 'isle-of-innovation',
      category: 'advertorial'
    },
    'its-good-not-to-be-home': {
      slug: 'its-good-not-to-be-home',
      category: 'advertorial'
    },
    'know-it-all': { slug: 'know-it-all', category: 'misc' },
    'leadership-now': { slug: 'leadership-now', category: 'misc' },
    'league-of-extraordinary-women-2012': {
      slug: 'league-of-extraordinary-women-2012',
      category: 'leadership'
    },
    'lessons-learned': { slug: 'lessons-learned', category: 'innovation' },
    'let-it-fly': { slug: 'let-it-fly', category: 'advertorial' },
    'life-in-beta': { slug: 'life-in-beta', category: 'innovation' },
    'living-smarter': { slug: 'living-smarter', category: 'leadership' },
    'location-location-location': {
      slug: 'location-location-location',
      category: 'misc'
    },
    'lorem-ipsum': { slug: 'lorem-ipsum', category: 'misc' },
    'made-to-stick': { slug: 'made-to-stick', category: 'misc' },
    'make-a-name': { slug: 'make-a-name', category: 'misc' },
    'make-your-move': { slug: 'make-your-move', category: 'misc' },
    'making-it': { slug: 'making-it', category: 'innovation' },
    'making-your-workplace-work': {
      slug: 'making-your-workplace-work',
      category: 'misc'
    },
    maps: { slug: 'maps', category: 'misc' },
    'mark-bittman': { slug: 'mark-bittman', category: 'misc' },
    'master-class': { slug: 'master-class', category: 'misc' },
    'masters-of-design': { slug: 'masters-of-design', category: 'misc' },
    'masters-of-design-2005': {
      slug: 'masters-of-design-2005',
      category: 'misc'
    },
    'masters-of-design-2006': {
      slug: 'masters-of-design-2006',
      category: 'misc'
    },
    'masters-of-design-2007': {
      slug: 'masters-of-design-2007',
      category: 'misc'
    },
    'masters-of-design-2008': {
      slug: 'masters-of-design-2008',
      category: 'misc'
    },
    'masters-of-design-2009': {
      slug: 'masters-of-design-2009',
      category: 'misc'
    },
    'masters-of-design-2010': {
      slug: 'masters-of-design-2010',
      category: 'misc'
    },
    'masters-of-design-2011': {
      slug: 'masters-of-design-2011',
      category: 'misc'
    },
    'masters-of-marketing': { slug: 'masters-of-marketing', category: 'misc' },
    meme: { slug: 'meme', category: 'misc' },
    'mind-and-machine': { slug: 'mind-and-machine', category: 'misc' },
    mobilizing: { slug: 'mobilizing', category: 'misc' },
    'most-creative-people': {
      slug: 'most-creative-people',
      category: 'leadership'
    },
    'most-creative-people-2009': {
      slug: 'most-creative-people-2009',
      category: 'leadership'
    },
    'most-creative-people-2010': {
      slug: 'most-creative-people-2010',
      category: 'leadership'
    },
    'most-creative-people-2011': {
      slug: 'most-creative-people-2011',
      category: 'leadership'
    },
    'most-creative-people-2012': {
      slug: 'most-creative-people-2012',
      category: 'leadership'
    },
    'most-creative-people-2013': {
      slug: 'most-creative-people-2013',
      category: 'leadership'
    },
    'most-creative-people-2014': {
      slug: 'most-creative-people-2014',
      category: 'leadership'
    },
    'most-creative-people-2015': {
      slug: 'most-creative-people-2015',
      category: 'leadership'
    },
    'most-innovative-companies': {
      slug: 'most-innovative-companies',
      category: 'misc'
    },
    'most-innovative-moments': {
      slug: 'most-innovative-moments',
      category: 'innovation'
    },
    'moving-the-needle': { slug: 'moving-the-needle', category: 'innovation' },
    'my-creative-life': { slug: 'my-creative-life', category: 'misc' },
    'my-way': { slug: 'my-way', category: 'misc' },
    'new-heights': { slug: 'new-heights', category: 'misc' },
    'new-money': { slug: 'new-money', category: 'misc' },
    'next-design': { slug: 'next-design', category: 'innovation' },
    'next-gen-design': { slug: 'next-gen-design', category: 'advertorial' },
    'objet-dinternet': { slug: 'objet-dinternet', category: 'misc' },
    'olympics-2012': { slug: 'olympics-2012', category: 'misc' },
    'one-more-thing': { slug: 'one-more-thing', category: 'misc' },
    'open-company': { slug: 'open-company', category: 'misc' },
    'out-of-office-with': {
      slug: 'out-of-office-with',
      category: 'leadership'
    },
    'passion-to-profit': { slug: 'passion-to-profit', category: 'misc' },
    'pet-week': { slug: 'pet-week', category: 'misc' },
    'platform-wars': { slug: 'platform-wars', category: 'misc' },
    politechs: { slug: 'politechs', category: 'misc' },
    pov: { slug: 'pov', category: 'leadership' },
    'power-couples': { slug: 'power-couples', category: 'misc' },
    'power-of-ai': { slug: 'power-of-ai', category: 'advertorial' },
    'powering-the-future': {
      slug: 'powering-the-future',
      category: 'innovation'
    },
    'productivity-in-motion': {
      slug: 'productivity-in-motion',
      category: 'advertorial'
    },
    'progress-is-possible': {
      slug: 'progress-is-possible',
      category: 'advertorial'
    },
    'project-fusion': { slug: 'project-fusion', category: 'advertorial' },
    qa: { slug: 'qa', category: 'misc' },
    'quick-hit': { slug: 'quick-hit', category: 'misc' },
    'reading-list': { slug: 'reading-list', category: 'misc' },
    'rebranding-pot': { slug: 'rebranding-pot', category: 'misc' },
    'reinventing-music': { slug: 'reinventing-music', category: 'misc' },
    retrology: { slug: 'retrology', category: 'misc' },
    'reverse-engineered': { slug: 'reverse-engineered', category: 'misc' },
    'revision-history': { slug: 'revision-history', category: 'misc' },
    'revolutionizing-work': {
      slug: 'revolutionizing-work',
      category: 'advertorial'
    },
    'rhone-technology': { slug: 'rhone-technology', category: 'advertorial' },
    'risks-visualized': { slug: 'risks-visualized', category: 'advertorial' },
    'robot-revolution': { slug: 'robot-revolution', category: 'misc' },
    'running-lean': { slug: 'running-lean', category: 'misc' },
    'second-shift': { slug: 'second-shift', category: 'misc' },
    'secrets-of-the-most-productive-people': {
      slug: 'secrets-of-the-most-productive-people',
      category: 'misc'
    },
    'sector-forecasting': {
      slug: 'sector-forecasting',
      category: 'innovation'
    },
    'seth-bodnar-ge': { slug: 'seth-bodnar-ge', category: 'misc' },
    'show-up-differently': {
      slug: 'show-up-differently',
      category: 'advertorial'
    },
    'side-project': { slug: 'side-project', category: 'misc' },
    'signs-and-symbols': { slug: 'signs-and-symbols', category: 'leadership' },
    'silicon-valley-social-entrepreneurs': {
      slug: 'silicon-valley-social-entrepreneurs',
      category: 'misc'
    },
    'simple-genius': { slug: 'simple-genius', category: 'misc' },
    'sleep-week': { slug: 'sleep-week', category: 'misc' },
    'slicker-city': { slug: 'slicker-city', category: 'misc' },
    'solving-inequality': { slug: 'solving-inequality', category: 'misc' },
    'startup-report': { slug: 'startup-report', category: 'misc' },
    storytellers: { slug: 'storytellers', category: 'misc' },
    'strong-female-lead': { slug: 'strong-female-lead', category: 'misc' },
    'style-revolution': { slug: 'style-revolution', category: 'advertorial' },
    'super-bowl-50': { slug: 'super-bowl-50', category: 'misc' },
    'super-bowl-li': { slug: 'super-bowl-li', category: 'misc' },
    'super-bowl-xlix': { slug: 'super-bowl-xlix', category: 'misc' },
    'super-bowl-xlvi': { slug: 'super-bowl-xlvi', category: 'misc' },
    'super-bowl-xlvii': { slug: 'super-bowl-xlvii', category: 'misc' },
    'super-bowl-xlviii': { slug: 'super-bowl-xlviii', category: 'misc' },
    'superlatives-week': { slug: 'superlatives-week', category: 'misc' },
    'supertag-test-multiple-sites': {
      slug: 'supertag-test-multiple-sites',
      category: 'misc'
    },
    sxsw: { slug: 'sxsw', category: 'misc' },
    'sxsw-2016': { slug: 'sxsw-2016', category: 'misc' },
    'tech-edge': { slug: 'tech-edge', category: 'misc' },
    'tech-forecast': { slug: 'tech-forecast', category: 'misc' },
    technovore: { slug: 'technovore', category: 'misc' },
    techsocial: { slug: 'techsocial', category: 'misc' },
    'terminal-velocity': { slug: 'terminal-velocity', category: 'misc' },
    'the-29th-floor': { slug: 'the-29th-floor', category: 'misc' },
    'the-big-idea': { slug: 'the-big-idea', category: 'misc' },
    'the-big-story': { slug: 'the-big-story', category: 'misc' },
    'the-code-war': { slug: 'the-code-war', category: 'technology' },
    'the-creator-economy': { slug: 'the-creator-economy', category: 'misc' },
    'the-fast-company-innovation-festival': {
      slug: 'the-fast-company-innovation-festival',
      category: 'misc'
    },
    'the-future-of-collaboration': {
      slug: 'the-future-of-collaboration',
      category: 'misc'
    },
    'the-future-of-everything': {
      slug: 'the-future-of-everything',
      category: 'misc'
    },
    'the-future-of-policing': {
      slug: 'the-future-of-policing',
      category: 'misc'
    },
    'the-future-of-service-in-america': {
      slug: 'the-future-of-service-in-america',
      category: 'misc'
    },
    'the-future-of-work': { slug: 'the-future-of-work', category: 'misc' },
    'the-legacy-of-1995': { slug: 'the-legacy-of-1995', category: 'misc' },
    'the-misfit-economy': { slug: 'the-misfit-economy', category: 'misc' },
    'the-new-magic': { slug: 'the-new-magic', category: 'misc' },
    'the-new-rules-of-work': {
      slug: 'the-new-rules-of-work',
      category: 'misc'
    },
    'the-other-side': { slug: 'the-other-side', category: 'misc' },
    'the-pivot': { slug: 'the-pivot', category: 'misc' },
    'the-purposeful-ceo': { slug: 'the-purposeful-ceo', category: 'misc' },
    'the-recommender': { slug: 'the-recommender', category: 'misc' },
    'the-rules-of-social-media': {
      slug: 'the-rules-of-social-media',
      category: 'misc'
    },
    'the-science-of-work': { slug: 'the-science-of-work', category: 'misc' },
    'the-sensor-revolution': {
      slug: 'the-sensor-revolution',
      category: 'misc'
    },
    'the-thread': { slug: 'the-thread', category: 'misc' },
    'the-ultimate-urban-utility-bike': {
      slug: 'the-ultimate-urban-utility-bike',
      category: 'misc'
    },
    'the-valley': { slug: 'the-valley', category: 'misc' },
    'the-vow': { slug: 'the-vow', category: 'advertorial' },
    'the-walk-through': { slug: 'the-walk-through', category: 'misc' },
    'the-y-combinator-chronicles': {
      slug: 'the-y-combinator-chronicles',
      category: 'misc'
    },
    'the-year-in-post-truth': {
      slug: 'the-year-in-post-truth',
      category: 'misc'
    },
    'then-and-now': { slug: 'then-and-now', category: 'misc' },
    'tim-cooks-apple': { slug: 'tim-cooks-apple', category: 'misc' },
    'today-in-tabs': { slug: 'today-in-tabs', category: 'misc' },
    'top-5-ads': { slug: 'top-5-ads', category: 'misc' },
    'top-jobs': { slug: 'top-jobs', category: 'misc' },
    tracking: { slug: 'tracking', category: 'misc' },
    'travel-smarter': { slug: 'travel-smarter', category: 'misc' },
    'tribeca-film-festival': {
      slug: 'tribeca-film-festival',
      category: 'misc'
    },
    'united-states-of-innovation': {
      slug: 'united-states-of-innovation',
      category: 'technology'
    },
    unplug: { slug: 'unplug', category: 'misc' },
    unreasonables: { slug: 'unreasonables', category: 'misc' },
    upswing: { slug: 'upswing', category: 'misc' },
    'us-innovation': { slug: 'us-innovation', category: 'innovation' },
    visualized: { slug: 'visualized', category: 'misc' },
    visualizing: { slug: 'visualizing', category: 'misc' },
    'visualizing-success': { slug: 'visualizing-success', category: 'misc' },
    wanderlust: { slug: 'wanderlust', category: 'misc' },
    wanted: { slug: 'wanted', category: 'misc' },
    'wearable-computing': { slug: 'wearable-computing', category: 'misc' },
    'wearables-week': { slug: 'wearables-week', category: 'misc' },
    wears: { slug: 'wears', category: 'misc' },
    'weekly-top-5': { slug: 'weekly-top-5', category: 'misc' },
    'well-to-do': { slug: 'well-to-do', category: 'technology' },
    'where-are-they-now': { slug: 'where-are-they-now', category: 'misc' },
    'whos-next': { slug: 'whos-next', category: 'innovation' },
    'why-here': { slug: 'why-here', category: 'misc' },
    'why-youre-fat': { slug: 'why-youre-fat', category: 'misc' },
    'women-heroes': { slug: 'women-heroes', category: 'leadership' },
    'women-in-tech-2009': {
      slug: 'women-in-tech-2009',
      category: 'leadership'
    },
    'women-in-tech-2010': {
      slug: 'women-in-tech-2010',
      category: 'leadership'
    },
    'women-in-tech-2011': {
      slug: 'women-in-tech-2011',
      category: 'leadership'
    },
    'women-to-watch': { slug: 'women-to-watch', category: 'advertorial' },
    'work-mode': { slug: 'work-mode', category: 'leadership' },
    'work-smart': { slug: 'work-smart', category: 'leadership' },
    'working-while-female': {
      slug: 'working-while-female',
      category: 'leadership'
    },
    'workplace-evolution': {
      slug: 'workplace-evolution',
      category: 'leadership'
    },
    'world-changing-ideas': { slug: 'world-changing-ideas', category: 'misc' },
    'world-changing-ideas-2015': {
      slug: 'world-changing-ideas-2015',
      category: 'misc'
    },
    'worth-the-risk': { slug: 'worth-the-risk', category: 'advertorial' },
    wwdc: { slug: 'wwdc', category: 'misc' },
    'your-most-productive-self': {
      slug: 'your-most-productive-self',
      category: 'misc'
    }
  },
  definitions: {
    welcome: {
      size: [600, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[600, 400], [640, 480], [600, 600]] }, { viewport: [640, 0], slot: [[600, 400], [640, 480], [600, 600]] }, { viewport: [0, 0], slot: [[300, 250], [320, 250]] }]
    },
    flexiblebillboard: {
      size: [728, 90],
      sizeMapping: [{ viewport: [1024, 0], slot: [[728, 90], [970, 250], [3, 1]] }, { viewport: [640, 0], slot: [[728, 90], [3, 1]] }]
    },
    flexiblebillboard_1: {
      size: [728, 90],
      sizeMapping: [{ viewport: [1024, 0], slot: [[728, 90], [970, 250], [3, 1]] }, { viewport: [640, 0], slot: [[728, 90], [3, 1]] }]
    },
    flexiblebillboard_2: {
      size: [728, 90],
      sizeMapping: [{ viewport: [1024, 0], slot: [[728, 90], [970, 250], [3, 1]] }, { viewport: [640, 0], slot: [[728, 90], [3, 1]] }]
    },
    flexiblebillboard_3: {
      size: [728, 90],
      sizeMapping: [{ viewport: [1024, 0], slot: [[728, 90], [970, 250], [3, 1]] }, { viewport: [640, 0], slot: [[728, 90], [3, 1]] }]
    },
    flexiblebillboard_4: {
      size: [728, 90],
      sizeMapping: [{ viewport: [1024, 0], slot: [[728, 90], [970, 250], [3, 1]] }, { viewport: [640, 0], slot: [[728, 90], [3, 1]] }]
    },
    flexiblebillboard_5: {
      size: [728, 90],
      sizeMapping: [{ viewport: [1024, 0], slot: [[728, 90], [970, 250], [3, 1]] }, { viewport: [640, 0], slot: [[728, 90], [3, 1]] }]
    },
    flexiblepushdown: {
      size: [728, 90],
      sizeMapping: [{
        viewport: [1024, 0],
        slot: [[728, 90], [970, 90], [970, 250], [970, 415], [970, 600], [3, 1]]
      }, { viewport: [640, 0], slot: [[728, 90], [2, 2], [3, 1]] }]
    },
    flexiblehalfpage: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_1: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_2: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_3: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_4: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_5: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_6: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_7: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_8: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_9: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_10: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_11: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_12: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    slideshowhalfpage: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    fixedrectangle: {
      size: [300, 250],
      sizeMapping: [{ viewport: [1024, 0], slot: [300, 250] }, { viewport: [640, 0], slot: [300, 250] }]
    },
    fixedrectangle_2: {
      size: [300, 250],
      sizeMapping: [{ viewport: [1024, 0], slot: [300, 250] }, { viewport: [640, 0], slot: [300, 250] }]
    },
    fixedrectangle_3: {
      size: [300, 250],
      sizeMapping: [{ viewport: [1024, 0], slot: [300, 250] }, { viewport: [640, 0], slot: [300, 250] }]
    },
    slideshowrectangle: {
      size: [300, 250],
      sizeMapping: [{ viewport: [1024, 0], slot: [300, 250] }, { viewport: [640, 0], slot: [300, 250] }, { viewport: [0, 0], slot: [300, 250] }]
    },
    mobileparallax_1: {
      size: [300, 250],
      sizeMapping: [{
        viewport: [0, 0],
        slot: [[300, 250], [320, 250], [640, 1138], [3, 1]]
      }]
    },
    mobileparallax_2: {
      size: [300, 250],
      sizeMapping: [{
        viewport: [0, 0],
        slot: [[300, 250], [320, 250], [640, 1138], [3, 1]]
      }]
    },
    mobilerectangle: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_1: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_2: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_3: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_4: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_5: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_6: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_7: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_8: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_9: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_10: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_11: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_12: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobileleaderboard: {
      size: [320, 50],
      sizeMapping: [{
        viewport: [0, 0],
        slot: [[320, 50], [320, 100], [300, 250]]
      }]
    },
    mobileleaderboard_short: {
      size: [320, 50],
      sizeMapping: [{
        viewport: [0, 0],
        slot: [[320, 50], [300, 50], [320, 100]]
      }]
    },
    flexibleleaderboard: {
      size: [728, 90],
      sizeMapping: [{ viewport: [0, 0], slot: [[728, 90], [2, 2], [3, 1]] }, { viewport: [640, 0], slot: [[728, 90], [2, 2], [3, 1]] }]
    },
    slideshowleaderboard: {
      size: [728, 90],
      sizeMapping: [{ viewport: [640, 0], slot: [[728, 90], [2, 2], [3, 1]] }]
    },
    flexibleinterrupter: {
      size: [970, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[970, 415], [970, 600], [2, 2], [3, 1]] }, { viewport: [640, 0], slot: [[728, 90], [2, 2], [3, 1]] }]
    },
    flexiblelogo: {
      size: [120, 90],
      sizeMapping: [{ viewport: [0, 0], slot: [[88, 31], [120, 60], [120, 90]] }]
    },
    flexibleportrait: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_1: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_2: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_3: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_4: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_5: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_6: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_7: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_8: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_9: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_10: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_11: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_12: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    oop: {
      size: [1, 1],
      sizeMapping: [{ viewport: [0, 0], slot: [1, 1] }]
    },
    nativetile_1: {
      size: [3, 3],
      sizeMapping: [{ viewport: [3, 3], slot: [3, 3] }]
    },
    nativetile_2: {
      size: [3, 3],
      sizeMapping: [{ viewport: [3, 3], slot: [3, 3] }]
    },
    nativetile_3: {
      size: [3, 3],
      sizeMapping: [{ viewport: [3, 3], slot: [3, 3] }]
    },
    nativetile_4: {
      size: [3, 3],
      sizeMapping: [{ viewport: [3, 3], slot: [3, 3] }]
    },
    welcomemat: {
      size: [970, 415],
      sizeMapping: [{ viewport: [0, 0], slot: [970, 415] }]
    },
    welcome_ad_video_pixel: {
      size: [1, 1],
      sizeMapping: [{ viewport: [0, 0], slot: [1, 1] }]
    }
  }
};

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var fastcompany = {
  'fb:pages': '5942134076',
  'og:site_name': 'Fast Company',
  'fb:app_id': '178479832213933',
  'fb:admins': '100000062710915',
  'article:publisher': 'https://www.facebook.com/FastCompany',
  'twitter:site': '@FastCompany',
  'twitter:domain': 'fastcompany.com',
  imageUrl: 'https://a.fastcompany.net/image/upload/v1485296620/fcweb/fastcompany-seo.png'
};

var fastcodesign = {
  'fb:pages': '107619279310824',
  'og:site_name': 'Co.Design',
  'fb:app_id': '123388861116012',
  'fb:admins': '100000062710915',
  'article:publisher': 'https://www.facebook.com/FastCoDesign',
  'twitter:site': '@FastCoDesign',
  'twitter:domain': 'fastcodesign.com',
  imageUrl: 'https://a.fastcompany.net/image/upload/v1485296802/fcweb/codesign-seo.png'
};

exports.default = {
  fastcompany: fastcompany,
  fastcodesign: fastcodesign
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var site = data.site,
      siteConf = data.siteConf,
      type = data.type,
      rss = data.rss,
      _data$publisher = data.publisher,
      publisher = _data$publisher === undefined ? true : _data$publisher,
      _data$extend = data.extend,
      extend = _data$extend === undefined ? [] : _data$extend;

  var amp = (0, _get2.default)(data, 'config.amp');
  var fbia = (0, _get2.default)(data, 'config.fbia');
  var useSloganTitle = data.useSloganTitle,
      titleTruncated = data.titleTruncated,
      noPipe = data.noPipe;
  var title = data.title;

  var siteHumanReadable = (0, _get2.default)(siteConf, '[og:site_name]', '');
  var analytics = _identity2.default[site] || _identity2.default.fastcompany;
  var description = data.description || analytics.description || '';
  var url = data.url || analytics.url || '';
  var siteSlug = analytics.slug || '';
  var fbConfig = analytics.facebook || {};
  var image = data.image || analytics.logo;
  var imageWidth = data.image_width;
  var imageHeight = data.image_height;

  // title = original title from each seo util, titleSEO modified title base on page type, to be displayed in metatags
  // If titleTruncated exists, only apply it to <title> but keep social title untruncated

  // Default title | sitename
  var titleSEO = title + ' | ' + (0, _get2.default)(_identity2.default[site], 'siteName', '');

  // If this is set, usually on homepages, display slogan instead
  if (useSloganTitle === true) {
    titleSEO = title + ' | ' + (0, _get2.default)(_identity2.default[site], 'slogan', '');
  }

  // Pass this option to render no pipe on specific page type utils
  if (noPipe === true) {
    titleSEO = title;
  }

  var identitySite = _identity2.default[site] || 'fastcompany';

  var config = {
    title: titleTruncated || titleSEO,
    meta: [{
      'http-equiv': 'X-UA-Compatible',
      content: 'IE=edge,chrome=1'
    }, {
      property: 'fb:pages',
      content: '' + (0, _get2.default)(identitySite, 'facebook.fanpageId', '5942134076')
    }, {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
    }, {
      name: 'description',
      content: description
    }, {
      property: 'og:type',
      content: type || 'article'
    }, {
      property: 'og:title',
      content: titleSEO
    }, {
      property: 'og:url',
      content: url
    }, {
      property: 'og:locale',
      content: 'en_US'
    }, {
      property: 'og:description',
      content: description
    }, {
      property: 'og:image',
      content: image
    }, {
      property: 'og:site_name',
      content: siteHumanReadable
    }, {
      property: 'fb:app_id',
      content: '' + (0, _get2.default)(fbConfig, 'appId')
    }, {
      property: 'fb:admins',
      content: '' + (0, _get2.default)(fbConfig, 'appAdminId')
    }, {
      name: 'twitter:card',
      content: data.twitterCard || 'summary_large_image'
    }, {
      name: 'twitter:title',
      content: titleSEO
    }, {
      name: 'twitter:description',
      content: description
    }, {
      name: 'twitter:url',
      content: url
    }, {
      name: 'twitter:site',
      content: '@' + siteSlug
    }, {
      name: 'twitter:image',
      content: data.twitterImage || image
    }, {
      name: 'twitter:domain',
      content: siteSlug + '.com'
    }, {
      itemProp: 'name',
      content: titleSEO
    }, {
      itemProp: 'description',
      content: description
    }, {
      name: 'theme-color',
      content: '#ffffff'
    }],
    link: [{
      rel: 'canonical',
      href: url
    }, {
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: '/apple-touch-icon.png?v=2'
    }, {
      rel: 'icon',
      type: 'image/png',
      href: '/favicon-32x32.png',
      sizes: '32x32'
    }, {
      rel: 'icon',
      type: 'image/png',
      href: '/favicon-16x16.png',
      sizes: '16x16'
    }, {
      rel: 'manifest',
      href: '/manifest.json'
    }, {
      rel: 'mask-icon',
      href: '/safari-pinned-tab.svg',
      color: '#000000'
    }, {
      rel: 'shortcut icon',
      href: '/favicon.ico?v=4'
    }, {
      rel: 'alternate',
      href: url,
      hrefLang: 'en'
    }, {
      rel: 'prefetch',
      href: 'https://tpc.googlesyndication.com/safeframe/1-0-5/html/container.html'
    }],
    noscript: [],
    style: []
  };

  if (site === 'fastcompany') {
    config.meta.push({
      name: 'google-site-verification',
      content: 'rU5yl8EMHvPkTmEeqiqqeEVmNz4eTxaV_Zw8-tr26VA'
    });
  } else if (site === 'fastcodesign') {
    config.meta.push({
      name: 'google-site-verification',
      content: 'hEoYh9bBZQ_K6nUgOetsOet3PbXC8DxQaxc2muRShTA'
    });
  }

  if (publisher) {
    config.meta.push({
      property: 'article:publisher',
      content: siteConf['article:publisher'] || ''
    });
  }

  // we are testing removing this for a couple of weeks
  // to see if this data is being prepended to title for
  // google search results
  //
  // if (data.articleSection) {
  //   config.meta.push({
  //     property: 'article:section',
  //     content: data.articleSection
  //   });
  // }

  if (rss) {
    config.link.push({
      rel: 'alternate',
      type: 'application/rss+xml',
      title: 'RSS',
      href: rss
    });
  }

  if (image && imageWidth && imageHeight) {
    config.meta.push({
      property: 'og:image:width',
      content: imageWidth
    });

    config.meta.push({
      property: 'og:image:height',
      content: imageHeight
    });
  }

  if (amp) {
    config = {
      title: titleSEO,
      meta: [],
      link: [],
      extend: []
    };
  }

  if (fbia) {
    config = {
      title: titleSEO,
      meta: [],
      link: [],
      extend: []
    };
  }

  // Extend is used to add objects to the arrays in the config object.
  // For example if you would like to add another meta tag you can:
  // const data = baseSeoUtil({
  //   ...
  //   extend: [{
  //     meta: [{
  //       property: 'META_PROPERTY',
  //       content: 'META_CONTENT'
  //     }]
  //   }]
  // });

  extend.forEach(function (extras) {
    var key = Object.keys(extras).join('');
    var arr = extras[key];

    config[key] = config[key].concat(arr);
  });

  return config;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(17);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _exenv = __webpack_require__(4);

var serverCache = false;
var clientCache = false;

if (false) {
  // eslint-disable-next-line global-require
  serverCache = require('../server/services/redis_service');
} else {
  // eslint-disable-next-line global-require
  clientCache = __webpack_require__(234);
}

var cache = _exenv.canUseDOM ? clientCache : serverCache;

module.exports = cache;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _exenv = __webpack_require__(4);

var serverRequest = false;
var clientRequest = false;

if (false) {
  // eslint-disable-next-line global-require
  serverRequest = require('../server/utils/request_util');
} else {
  // eslint-disable-next-line global-require
  clientRequest = __webpack_require__(537);
}

var request = _exenv.canUseDOM ? clientRequest : serverRequest;

module.exports = request;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// TODO: dry up models
var BaseModel = function () {
  function BaseModel() {
    _classCallCheck(this, BaseModel);
  }

  _createClass(BaseModel, null, [{
    key: 'cleanParam',
    value: function cleanParam() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (!name) {
        return '';
      }
      return name.split('?')[0];
    }
  }]);

  return BaseModel;
}();

exports.default = BaseModel;

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (state) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';

  return {
    method: method,
    auth: {
      username: (0, _get2.default)(state, 'config.authUsername'),
      password: (0, _get2.default)(state, 'config.authPassword')
    }
  };
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  fastcompany: {
    siteName: 'Fast Company',
    slug: 'fastcompany',
    url: 'https://www.fastcompany.com',
    slogan: 'The future of business',
    description: "Fast Company is the world's leading progressive business media brand, with a unique editorial focus on innovation in technology, leadership, and design.",
    favicon: '/favicon.ico',
    logo: 'https://images.fastcompany.net/image/upload/v1480632834/fast-company-share-graphic.png',
    keywords: ['business', 'magazine', 'news', 'leadership', 'most innovative companies', 'most creative people', 'videos', 'innovation'],
    facebook: {
      fanpageId: '5942134076',
      appId: '178479832213933',
      appAdminId: '100000062710915'
    },
    krux: {
      id: 'J53aqF_f'
    },
    reCaptcha: {
      public: '6Lf59DoUAAAAAMImCMrNJRUIrtlnwN5sH_NOQ9D2'
    },
    omniture: {
      server: 'fastcompany',
      trackingPixel: '//grunerandjahr.112.2o7.net/b/ss/gjincfastcoprod/1/H.24.4--NS/0/5658306',
      scode: '//images.fastcompany.net/assets/js/vendor/omniture/omniture-scode-prod.js'
    },
    parsely: {
      domain: 'fastcompany.com'
    },
    facebookPixel: {
      id: 475240032660076
    },
    nielsen: {
      clientId: 'us-805310h'
    },
    googleAnalytics: {
      webPropertyId: 'UA-4300461-2',
      rollupPropertyId: 'UA-4300461-33'
    },
    googleAnalyticsIA: {
      webPropertyId: 'UA-4300461-40'
    },
    comscore: {
      c1: 2,
      c2: 6916907,
      publisherId: 6916907
    },
    chartbeat: {
      uid: 2768,
      domain: 'fastcompany.com'
    },
    pingdom: {
      id: '518c1737abe53dc44c000000'
    },
    magazineSubUrls: ['https://store.fastcompany.com/subscription-order/singlesku/1999-us']
  },
  fastcodesign: {
    siteName: 'Co.Design',
    slug: 'fastcodesign',
    url: 'https://www.fastcodesign.com',
    slogan: 'Where business and design collide',
    description: 'Inspiring stories about innovation and business, seen through the lens of design.',
    favicon: '/favicon.ico',
    logo: 'https://images.fastcompany.net/image/upload/v1481312788/fcweb/codesign-share-graphic.png',
    keywords: ['innovation', 'ethonomics', 'graphics', 'innovation by design', 'interactive', 'product', 'spaces', 'world changing ideas'],
    facebook: {
      fanpageId: '107619279310824',
      appId: '123388861116012',
      appAdminId: '100000062710915'
    },
    krux: {
      id: 'J53bAWi-'
    },
    omniture: {
      server: 'fastcodesign',
      trackingPixel: '//grunerandjahr.112.2o7.net/b/ss/gjincfastcoprod/1/H.24.4--NS/0/5658306',
      scode: '//images.fastcompany.net/assets/js/vendor/omniture/omniture-scode-prod.js'
    },
    parsely: {
      domain: 'fastcodesign.com'
    },
    facebookPixel: {
      id: 475240032660076
    },
    nielsen: {
      clientId: 'us-805310h'
    },
    googleAnalytics: {
      webPropertyId: 'UA-4300461-6',
      rollupPropertyId: 'UA-4300461-33'
    },
    googleAnalyticsIA: {
      webPropertyId: 'UA-4300461-41'
    },
    comscore: {
      c1: 2,
      c2: 6916907,
      publisherId: 6916907
    },
    chartbeat: {
      uid: 2768,
      domain: 'fastcodesign.com'
    },
    pingdom: {
      id: '51955434abe53d9a09000000'
    },
    magazineSubUrls: ['https://store.fastcompany.com/subscription-order/singlesku/1999-us']
  }
};

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Link = __webpack_require__(43);

var _Link2 = _interopRequireDefault(_Link);

var _urlParse = __webpack_require__(50);

var _urlParse2 = _interopRequireDefault(_urlParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FCLink = function (_Component) {
  _inherits(FCLink, _Component);

  function FCLink() {
    _classCallCheck(this, FCLink);

    return _possibleConstructorReturn(this, (FCLink.__proto__ || Object.getPrototypeOf(FCLink)).apply(this, arguments));
  }

  _createClass(FCLink, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          config = _props.config,
          to = _props.to,
          title = _props.title,
          children = _props.children,
          externalLink = _props.externalLink;
      var site = config.site,
          env = config.env,
          amp = config.amp;

      var development = env === 'development';
      var sameDomain = !amp && to.indexOf(site) !== -1;
      var external = externalLink || to.indexOf('/videos/list/') !== -1;
      var relativePath = void 0;
      var href = void 0;

      // Use local TLD with port if dev.
      if (development && !external) {
        href = to.replace(/http(s)?:\/\/(www.)?/, 'http://').replace('.com', '.local:8880');
      }

      // If we are on the current site use the link component to avoid page refresh.
      if (sameDomain && !external) {
        relativePath = (0, _urlParse2.default)(to, true).pathname;
        // Redirect MCP tag to MCP category.
        if (relativePath === '/section/most-creative-people') {
          relativePath = '/most-creative-people';
        }
      }

      if (relativePath) {
        return _react2.default.createElement(
          _Link2.default,
          { to: relativePath, title: title },
          children
        );
      }

      return _react2.default.createElement(
        'a',
        { href: href || to, title: title },
        children
      );
    }
  }]);

  return FCLink;
}(_react.Component);

exports.default = FCLink;


FCLink.defaultProps = {
  to: '',
  externalLink: false,
  title: ''
};

FCLink.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  to: _propTypes2.default.string,
  title: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
  externalLink: _propTypes2.default.bool
};

/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Slug = function (_Component) {
  _inherits(Slug, _Component);

  function Slug() {
    _classCallCheck(this, Slug);

    var _this = _possibleConstructorReturn(this, (Slug.__proto__ || Object.getPrototypeOf(Slug)).call(this));

    _this.renderTitle = _this.renderTitle.bind(_this);
    return _this;
  }

  _createClass(Slug, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.props.canUpdate;
    }
  }, {
    key: 'renderTitle',
    value: function renderTitle(title) {
      var classes = ['slug'];
      var _props = this.props,
          advertorial = _props.advertorial,
          className = _props.className;


      if (advertorial) {
        classes.push('slug--advertorial');
      }

      if (className) {
        classes.push(' ' + className + '__slug');
      }

      classes = classes.join(' ');

      if (className === 'tag-page' || className === 'tag-page-section') {
        return _react2.default.createElement(
          'h2',
          { className: classes },
          title
        );
      }

      if (className === 'category-page') {
        return _react2.default.createElement(
          'h1',
          { className: classes },
          title
        );
      }

      return _react2.default.createElement(
        'h2',
        { className: classes },
        title
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props) {
        return null;
      }

      var _props2 = this.props,
          slugName = _props2.slugName,
          className = _props2.className,
          linkTo = _props2.linkTo,
          archives = _props2.archives;

      var hasLink = linkTo ? linkTo.length : false;
      var slugClasses = 'slug-component' + (className ? ' ' + className + '__slug-component' : '');
      var title = slugName.replace(/\*/g, '').replace(/_/g, ' ');

      if (hasLink) {
        title = _react2.default.createElement(
          'a',
          { href: linkTo, className: 'slug__title-link' },
          title
        );
      }

      return _react2.default.createElement(
        'div',
        { className: slugClasses },
        this.renderTitle(title),
        archives.name && archives.url ? _react2.default.createElement(
          'a',
          { href: archives.url, className: 'slug__archives' },
          _react2.default.createElement(
            'span',
            null,
            archives.name
          )
        ) : null
      );
    }
  }]);

  return Slug;
}(_react.Component);

exports.default = Slug;


Slug.defaultProps = {
  slugName: '',
  className: '',
  linkTo: '',
  advertorial: false,
  archives: {
    name: '',
    url: ''
  },
  canUpdate: false
};

Slug.propTypes = {
  slugName: _propTypes2.default.string,
  className: _propTypes2.default.string,
  linkTo: _propTypes2.default.string,
  advertorial: _propTypes2.default.bool,
  archives: _propTypes2.default.shape({}),
  canUpdate: _propTypes2.default.bool
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Bling = __webpack_require__(157);

var _Bling2 = _interopRequireDefault(_Bling);

var _reactRedux = __webpack_require__(15);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isNumber = __webpack_require__(224);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _union = __webpack_require__(492);

var _union2 = _interopRequireDefault(_union);

var _exenv = __webpack_require__(4);

var _exenv2 = _interopRequireDefault(_exenv);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _url_util = __webpack_require__(133);

var _url_util2 = _interopRequireDefault(_url_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hasSetSafeFrameRefresh = false;
var adRefreshQueue = [];

if (_exenv2.default) {
  // Enable sync correlator value
  _Bling2.default.syncCorrelator();
}

/**
 *
 * @param {Array} keysArray a list of keys to clear from targetting
 */
function removeSlideshowAdKeyTargeting(keysArray) {
  var slots = window.parent.googletag.pubads().getSlots();
  // eslint-disable-next-line no-plusplus
  for (var i = slots.length; i--;) {
    // eslint-disable-next-line no-plusplus
    for (var j = keysArray.length; j--;) {
      slots[i].clearTargeting(keysArray[j]);
    }
  }
}

/**
 * Clears a list of key vals from targetting and refresh the
 * ad based on matching matching key val "slotid" and limit to flexibleportrait unit
 *
 * @param {Array} keysArray
 * @param {String} slotId
 */
function refreshSafeFrameSlot(keysArray, slotId) {
  var _window = window,
      googletag = _window.googletag;

  if (!googletag) {
    return;
  }

  if (slotId.indexOf('flexibleportrait') === -1 && slotId.indexOf('flexiblehalfpage') === -1) {
    return;
  }

  var slots = googletag.pubads().getSlots();
  // eslint-disable-next-line no-plusplus
  for (var i = slots.length; i--;) {
    var targetSlotID = (0, _get2.default)(slots[i].getTargeting('slotid'), '[0]');
    if (targetSlotID && targetSlotID === slotId) {
      // eslint-disable-next-line no-plusplus
      for (var j = keysArray.length; j--;) {
        slots[i].clearTargeting(keysArray[j]);
      }
      googletag.pubads().refresh([slots[i]], { changeCorrelator: false });
    }
  }
}

/**
 * Refreshes the queue of ads stored up from when the user is not active on the page
 */
function refreshAdQueue() {
  if (adRefreshQueue.length) {
    adRefreshQueue.forEach(function (slotId) {
      refreshSafeFrameSlot(['prebid_trigger', 'hb_bidder', 'hb_adid', 'hb_pb', 'hb_size', 'hb_deal'], slotId);
    });
    adRefreshQueue = [];
  }
}

/**
 * An Ad Component using Google Publisher Tags wrapped on top of react-gpt from NFL
 * https://github.com/nfl/react-gpt
 * https://developers.google.com/doubleclick-gpt/
 *
 * DEBUG MODE: Append ?debug to url to enable console logging of ad events
 * EXAMPLE USAGE:
 * const combinedAdModel = { ...AdConfig, ...AdContext };
 *     <Ad
 *      {...combinedAdModel}
 *       name="flexibleleaderboard"
 *     />
 * where combinedAdModel is an object merged from ad_context.json and config.json.
 * note: ad_context.json is a stub, in the real world,
 * that data would come from the page context model
 *
 */

var Ad = function (_Component) {
  _inherits(Ad, _Component);

  function Ad() {
    _classCallCheck(this, Ad);

    var _this = _possibleConstructorReturn(this, (Ad.__proto__ || Object.getPrototypeOf(Ad)).call(this));

    _this.addSlideShowAdRefreshListener = _this.addSlideShowAdRefreshListener.bind(_this);
    return _this;
  }

  _createClass(Ad, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.canRefresh) {
        window.removeEventListener('FC_REFRESH_EVENT', this.addSlideShowAdRefreshListener);
      }
    }
  }, {
    key: 'constructData',
    value: function constructData() {
      var _props = this.props,
          baseConfig = _props.baseConfig,
          definitions = _props.definitions,
          model = _props.model,
          name = _props.name,
          region = _props.region,
          slug = _props.slug,
          oop = _props.oop,
          pos = _props.pos,
          pageNum = _props.pageNum,
          noLazyLoad = _props.noLazyLoad,
          prebidTrigger = _props.prebidTrigger,
          readTime = _props.readTime;
      var adzoneOverride = this.props.adzoneOverride;

      var siteZones = (0, _get2.default)(baseConfig, 'siteZones', null);

      var defaultSizeMapping = [{
        slot: [],
        viewport: []
      }];

      if (!siteZones) {
        _logger_service2.default.error('No siteZones config object set');
        // Set a default for GPT lib, they need this value or else it will crash the app
        this.sizeMapping = defaultSizeMapping;
        return;
      }

      this.name = name;
      this.region = region;
      this.oop = oop;
      this.pos = pos === 'atf' ? 'atf' : 'btf'; // position defaults to below the fold

      // lazy load = atf, non-lazy load = btf
      this.pos = noLazyLoad ? 'btf' : 'atf';

      // Figure out adzone
      var companyID = (0, _get2.default)(baseConfig, 'companyID');
      var site = (0, _get2.default)(model, 'site') || 'fastcompany';
      var zone = (0, _get2.default)(model, 'adzone');

      // If querystring override is enabled then override the adzone
      var queryAdzoneOverride = (0, _url_util2.default)('adzone');

      if (queryAdzoneOverride) {
        adzoneOverride = queryAdzoneOverride;
      }

      this.constructAdZone(companyID, siteZones, zone, adzoneOverride, site, name);

      // Figure out size mapping
      this.sizeMapping = (0, _get2.default)(definitions[name], 'sizeMapping', defaultSizeMapping);

      // Figure out key val mapping, returns a key val pair object
      this.constructKeyVals(model, pageNum, name, readTime, prebidTrigger);

      // Optionally display "advertisement" label
      this.adLabel = slug === false ? '' : _react2.default.createElement(
        'div',
        { className: 'ad-wrapper__ad-slug' },
        'advertisement'
      );

      if (noLazyLoad) {
        this.noLazyLoad = true;
      }
    }
  }, {
    key: 'addSlideShowAdRefreshListener',
    value: function addSlideShowAdRefreshListener(event) {
      if (_exenv2.default) {
        window.addEventListener('FC_REFRESH_EVENT', function eventListener(e) {
          try {
            if (event.slot.getAdUnitPath().indexOf(e.detail) !== -1) {
              window.removeEventListener('FC_REFRESH_EVENT', eventListener);
              removeSlideshowAdKeyTargeting(['prebid_trigger', 'hb_bidder', 'hb_adid', 'hb_pb', 'hb_size', 'hb_deal']);
              _Bling2.default.refresh([event.slot]);
            }
          } catch (err) {
            _logger_service2.default.error(err, 'unable to refresh ad in from 3 slides.');
          }
        });
      }
    }

    /**
     * Use anti-fraud detection to add a window listener from
     * ad unit's post message safe frame.
     * AntiFraud Detection: If the user hasn't moved for x amount of seconds,
     * ad unit will not refresh even if it passed the time needed to refresh.
     * Refresh Logic: Listens to an event from ad's safeframe,
     * if the event is heard, and user is not inactive, then refresh the ad unit.
     */

  }, {
    key: 'attachSafeFrameRefreshEvent',
    value: function attachSafeFrameRefreshEvent() {
      if (hasSetSafeFrameRefresh === false) {
        var d = document || window.document;
        d.onload = refreshAdQueue;
        d.onmousemove = refreshAdQueue;
        d.onmousedown = refreshAdQueue;
        d.ontouchstart = refreshAdQueue;
        d.onclick = refreshAdQueue;
        d.onscroll = refreshAdQueue;
        d.onkeypress = refreshAdQueue;

        window.addEventListener('message', function (event) {
          var dataSource = (0, _get2.default)(event, 'data.source');
          var slotId = (0, _get2.default)(event, 'data.slotId');
          if (dataSource === 'fc_ad_refresh') {
            adRefreshQueue.push(slotId);
          }
        }, false);
        hasSetSafeFrameRefresh = true;
      }
    }
    /**
     *
     * Converts a url into a unique hash value, ported over from admanager
     */

  }, {
    key: 'constructCMSHash',
    value: function constructCMSHash(url) {
      var cmsQueryValue = (0, _url_util2.default)('cms');
      if (cmsQueryValue) {
        return cmsQueryValue;
      }

      var key = url;
      var hash = 0;
      var i = void 0;
      var chr = void 0;

      if (!key || key.length === 0) {
        return hash;
      }
      // eslint-disable-next-line no-plusplus
      for (i = 0; i < key.length; i++) {
        chr = key.charCodeAt(i);
        // eslint-disable-next-line no-bitwise
        hash = (hash << 5) - hash + chr;
        // eslint-disable-next-line
        hash &= hash;
      }
      hash = Math.abs(hash);
      hash = hash.toString(36);
      return hash;
    }

    /**
     *
     * Constructs an adzone string from metadata to be passed to the ad component
     */

  }, {
    key: 'constructAdZone',
    value: function constructAdZone(companyID, siteZones, zone, adzoneOverride) {
      var site = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'fastcompany';
      var name = arguments[5];

      var finalizedAdZone = zone;
      // Override the adzone param if it's passed
      if (adzoneOverride && adzoneOverride !== '') {
        finalizedAdZone = adzoneOverride + '/' + adzoneOverride;
      }

      this.adZone = '/' + companyID + '/' + siteZones[site] + '/' + finalizedAdZone + '/' + name;
    }

    /**
     *
     * Constructs key value pair for ad targetting, returns an key value paired object
     * c_type = content type (slideshow, article, video, homepage, category, tag, etc)
       cms = unique hash of current page url, query string unaffected
       vport = viewport
       cat = category
       tag = tags
       aut = author
       scroll = page number
       adslot = name of the ad unit
       vport = user vport size (large, medium small)
       pos = atf (above the fold) / btf (below the fold)
       video = boolean, is the post a video post (NOT IMPLEMENTED)
       login = is the VISITOR logged in (NOT IMPLEMENTED)
     */

  }, {
    key: 'constructKeyVals',
    value: function constructKeyVals(model) {
      var pageNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var zone = arguments[2];
      var readTime = arguments[3];
      var prebidTrigger = arguments[4];

      var pageLevelKeyvals = {};
      var name = model.name,
          kind = model.kind,
          tags = model.tags,
          topic = model.topic,
          type = model.type,
          url = model.url;

      var author = (0, _get2.default)(model, 'author', '');

      pageLevelKeyvals.c_type = kind || type;
      pageLevelKeyvals.cms = this.constructCMSHash(url);
      pageLevelKeyvals.cat = topic || name || '';

      if (tags && tags.length) {
        pageLevelKeyvals.tags = (0, _union2.default)(tags);
      } else {
        pageLevelKeyvals.tags = [name];
      }

      pageLevelKeyvals.aut = author ? author.toLowerCase().replace(/-/g, '') : '';
      pageLevelKeyvals.pos = this.pos;
      pageLevelKeyvals.adslot = this.name;
      pageLevelKeyvals.scroll = String(pageNum); // this needs to be converted to a string

      // CID value for bot activity tracking as per Adops request
      pageLevelKeyvals.CID = (0, _url_util2.default)('cid') || '0';

      pageLevelKeyvals.chn = [];
      if (topic) {
        pageLevelKeyvals.chn.push(topic);
      }

      if (readTime) {
        var readTimeSplit = readTime.split(' ')[0];
        var readTimeSanitized = (0, _isNumber2.default)(readTimeSplit) ? Number(readTimeSplit) : readTimeSplit;
        pageLevelKeyvals.artLength = readTimeSanitized;
      } else {
        pageLevelKeyvals.artLength = 'NA';
      }

      if (prebidTrigger) {
        pageLevelKeyvals.prebidTrigger = 'true';
      }

      if (window && window.innerWidth) {
        var userWidth = window.innerWidth;
        var vPort = void 0;
        if (userWidth >= 1024) {
          vPort = 'l';
        } else if (userWidth < 1024 && userWidth >= 640) {
          vPort = 'm';
        } else if (userWidth < 640) {
          this.userViewport = 'mobile';
          vPort = 's';
        }
        pageLevelKeyvals.vport = vPort;
      }

      pageLevelKeyvals.slotid = '' + zone + pageNum;
      pageLevelKeyvals.kuid = (0, _get2.default)(window, 'Krux.user');

      this.slotLevelKeyvals = pageLevelKeyvals;

      // Set keyval to a global obj to help Browsi
      window.fc_ads = {};
      window.fc_ads.keyVals = pageLevelKeyvals;
    }

    /**
     *
     * Constructs a class string BEM style with region be the modifier
     */

  }, {
    key: 'constructAdClass',
    value: function constructAdClass(adName, region) {
      var classNameFull = 'ad-wrapper ad-wrapper--' + adName;

      if (region && region !== '') {
        classNameFull += ' ad-wrapper--' + region;
      }
      return classNameFull;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.initialPageLoad) {
        // If there's a ?adfree=1 then don't render any ad
        var queryAdFree = (0, _url_util2.default)('adfree');
        if (queryAdFree) {
          return null;
        }

        // This here will determine whether to make the actual call or not on mobile
        var userViewportWidth = window.innerWidth;
        var adUnitName = (0, _get2.default)(this.props, 'name');
        if (adUnitName.indexOf('oop') === -1) {
          // do not show an ads when:
          // mobile ad unit name is not found and viewport > 1024
          if (adUnitName.indexOf('mobile') !== -1 && userViewportWidth >= 1024 || adUnitName.indexOf('mobile') === -1 && userViewportWidth < 1024) {
            return null;
          }
        }

        this.constructData();
        this.attachSafeFrameRefreshEvent();
        var viewableThreshold = 0;
        var renderWhenViewable = this.noLazyLoad === undefined;
        var collapseEmptyDiv = false;
        var viewableThresholdOverride = this.props.viewableThreshold;

        var viewableThresholdValues = {
          userViewport: this.userViewport ? this.userViewport : 'desktop',
          mobileValue: typeof (0, _get2.default)(viewableThresholdOverride, 'mobile') !== 'undefined' ? (0, _get2.default)(viewableThresholdOverride, 'mobile') : 350,
          desktopValue: typeof (0, _get2.default)(viewableThresholdOverride, 'desktop') !== 'undefined' ? (0, _get2.default)(viewableThresholdOverride, 'desktop') : 500
        };

        var adUnitClass = this.props.noBorder ? 'ad_unit' : 'ad-unit ad-unit__border';

        return _react2.default.createElement(
          'div',
          { className: this.constructAdClass(this.name, this.region) },
          _react2.default.createElement(
            'div',
            { className: 'ad-wrapper--ad-unit-wrap' },
            this.adLabel,
            _react2.default.createElement(
              'div',
              { className: adUnitClass },
              _react2.default.createElement(_Bling2.default, {
                adUnitPath: this.adZone,
                sizeMapping: this.sizeMapping,
                targeting: this.slotLevelKeyvals,
                viewableThreshold: viewableThreshold,
                renderWhenViewable: renderWhenViewable,
                collapseEmptyDiv: collapseEmptyDiv,
                outOfPage: this.oop,
                onSlotRenderEnded: this.props.canRefresh ? this.addSlideShowAdRefreshListener : null,
                viewableThresholdValues: viewableThresholdValues
              })
            )
          )
        );
      }
      return _react2.default.createElement(
        'div',
        {
          className: this.constructAdClass(this.props.name, this.props.region)
        },
        _react2.default.createElement(
          'div',
          { className: 'ad-wrapper--ad-unit-wrap' },
          this.props.slug === 'false' || this.props.name === 'oop' ? '' : _react2.default.createElement(
            'div',
            { className: 'ad-wrapper__ad-slug' },
            'advertisement'
          ),
          _react2.default.createElement('div', { className: 'ad-unit ad-unit__border' })
        )
      );
    }
  }]);

  return Ad;
}(_react.Component);

Ad.propTypes = {
  initialPageLoad: _propTypes2.default.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  baseConfig: _propTypes2.default.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  definitions: _propTypes2.default.object.isRequired,
  adzoneOverride: _propTypes2.default.string,
  // eslint-disable-next-line react/forbid-prop-types
  model: _propTypes2.default.object.isRequired,
  name: _propTypes2.default.string.isRequired,
  region: _propTypes2.default.string,
  slug: _propTypes2.default.bool,
  oop: _propTypes2.default.bool,
  pos: _propTypes2.default.string,
  pageNum: _propTypes2.default.number,
  noLazyLoad: _propTypes2.default.bool,
  noBorder: _propTypes2.default.bool,
  canRefresh: _propTypes2.default.bool,
  // eslint-disable-next-line react/forbid-prop-types
  viewableThreshold: _propTypes2.default.object,
  prebidTrigger: _propTypes2.default.bool,
  readTime: _propTypes2.default.string
};

Ad.defaultProps = {
  adzoneOverride: '', // Override an adzone
  region: '', // Specify a region
  slug: true, // Display the "advertisement" text or not
  oop: false, // Is this an Out-Of-Page unit?
  pos: 'btf', // Below the Fold or Above the Fold
  pageNum: 1, // For infinite scroll, what page we're on
  noLazyLoad: false,
  noBorder: false, // Display the border for the ad or not, good for when ad is loading
  canRefresh: false, // Whether this unit is eligible for refresh
  viewableThreshold: null, // Override viewable threshold params
  prebidTrigger: false, // When set to true, prebid ads won't show
  readTime: null // Article reading time as a keyval
};

function mapStateToProps(state) {
  var initialPageLoad = state.config.initialPageLoad;

  return {
    initialPageLoad: initialPageLoad
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Ad);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageSizesLookup = undefined;
;(buildAssetUrlWithSizes);
;(buildFBIAAsset);
;(buildAssetUrlWithAuto);
exports.buildSrcSet = buildSrcSet;
exports.makeHttps = makeHttps;
exports.buildAssetUrlWithPresets = buildAssetUrlWithPresets;
exports.changeAssetDomain = changeAssetDomain;
exports.convertGIFToVideoAssets = convertGIFToVideoAssets;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isUndefined = __webpack_require__(510);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _isString = __webpack_require__(92);

var _isString2 = _interopRequireDefault(_isString);

var _urlParse = __webpack_require__(50);

var _urlParse2 = _interopRequireDefault(_urlParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fcAssetsDomain = 'images.fastcompany.net';
var legacyAssetsDomain = 'assets.fastcompnay.com';
var cloudinaryDomain = 'fast-company-res.cloudinary.com';
var s3Domain = 'wp-cms-fastcompany-com.s3.amazonaws.com';

function buildAssetUrlWithSizes(assetUrl, size) {
  if (typeof assetUrl === 'string' && typeof size === 'string') {
    var matchData = size.match(/w_(\d*)/);
    var width = (0, _get2.default)(matchData, '1');

    return width ? assetUrl.replace('/upload/', '/upload/' + size + '/').replace('/fetch/', '/fetch/' + size + '/') + ' ' + width + 'w' : '';
  }

  return '';
}

function buildFBIAAsset(assetUrl, size) {
  if (typeof assetUrl === 'string') {
    var cloudinaryParams = 'w_' + size + ',f_auto,q_auto,fl_lossy/';
    return assetUrl.replace('/upload/', '/upload/' + cloudinaryParams).replace('/fetch/', '/fetch/' + cloudinaryParams);
  }
  return '';
}

function buildAssetUrlWithAuto(src) {
  return src && typeof src === 'string' ? src.replace('upload/', 'upload/w_auto,c_limit/') : '';
}

function buildSrcSet(assetSizes, propsToSrcSetForSize, src) {
  var srcSetItems = (0, _get2.default)(assetSizes, propsToSrcSetForSize) || [];
  return srcSetItems.map(function (item) {
    return buildAssetUrlWithSizes(src, item);
  }).join(', ');
}

function makeHttps(url) {
  if (!(0, _isString2.default)(url)) {
    return null;
  }
  var parsed = new _urlParse2.default(url);
  if (parsed.protocol !== 'https:') {
    parsed.set('protocol', 'https:');
    return parsed.toString();
  }

  return url;
}

function buildAssetUrlWithPresets(src, size, isDesktop) {
  var smallSizes = (0, _get2.default)(size, 'small.srcset');
  var smallSizesLength = (0, _get2.default)(smallSizes, 'length');
  var largestSmallPreset = (0, _get2.default)(smallSizes, '[' + (smallSizesLength - 1) + ']');

  var largeSizes = (0, _get2.default)(size, 'large.srcset');
  var largeSizesLength = (0, _get2.default)(largeSizes, 'length');
  var largestLargePreset = (0, _get2.default)(largeSizes, '[' + (largeSizesLength - 1) + ']');

  // this is to provide an asset size for gifs converted to videos
  // since they can't take an entire srcset string
  var presetSize = isDesktop ? largestLargePreset : largestSmallPreset;

  if (!(0, _isString2.default)(src)) {
    return null;
  }

  var parsed = new _urlParse2.default(src);

  if (parsed.host === cloudinaryDomain || parsed.host === legacyAssetsDomain || parsed.host === fcAssetsDomain) {
    parsed.set('pathname', parsed.pathname.replace('/upload/', '/upload/' + presetSize + '/').replace('/fetch/', '/fetch/' + presetSize + '/'));
    return parsed.toString();
  }

  return src;
}

function changeAssetDomain(url) {
  if (!(0, _isString2.default)(url)) {
    return null;
  }

  var parsed = new _urlParse2.default(url);

  // cloudinary fetch api must use cloudinary domain, otherwise, asset will 404
  var doesNotUseCloudinaryFetch = parsed.pathname.indexOf('/fetch/') === -1;
  if (parsed.host === cloudinaryDomain && doesNotUseCloudinaryFetch) {
    parsed.set('host', fcAssetsDomain);
    return parsed.toString();
  }

  if (parsed.host === s3Domain) {
    parsed.set('host', fcAssetsDomain);
    var pathname = parsed.pathname;

    parsed.set('pathname', '/image/upload/wp-cms' + pathname);
    return parsed.toString();
  }

  return url;
}

function convertGIFToVideoAssets(assetUrl) {
  if (!(0, _isString2.default)(assetUrl) || (0, _isUndefined2.default)(assetUrl)) {
    return null;
  }

  var parsed = new _urlParse2.default(assetUrl);
  var formats = ['jpg', 'webm', 'mp4'];
  var assets = {};
  if (parsed.host === fcAssetsDomain || parsed.host === cloudinaryDomain || parsed.host === legacyAssetsDomain) {
    formats.forEach(function createAssetUrlForEachFormat(format) {
      assets[format] = assetUrl.replace('f_auto', 'f_' + format);
      if (format === 'mp4' || format === 'webm') {
        assets[format] = assets[format].replace(',q_auto', ',q_70').replace(',q_auto', ',q_70');
      }
    });
    return assets;
  }

  return assetUrl;
}

// following breakpoints generated with http://www.responsivebreakpoints.com/ (size step 45kb on desktop, 25kb on mobile, max 5 image)
var imageSizesLookup = exports.imageSizesLookup = {
  column: {
    large: {
      sizes: 'calc(0.1666 * (100vw - 40px))',
      srcset: ['w_112,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_306,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(0.5 * (100vw - 20px))',
      srcset: ['w_141,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_236,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    }
  },
  4: {
    large: {
      sizes: 'calc(0.5 * (100vw - 20px))',
      srcset: ['w_216,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_560,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(0.5 * (100vw - 20px))',
      srcset: ['w_141,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_472,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    }
  },
  3: {
    large: {
      sizes: '33vw',
      srcset: ['w_301,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_772,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(0.5 * (100vw - 20px))',
      srcset: ['w_141,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_472,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    }
  },
  2: {
    large: {
      sizes: '50vw',
      srcset: ['w_491,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_900,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_1162,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_1200,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(0.5 * (100vw - 20px))',
      srcset: ['w_141,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_472,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    }
  },
  1: {
    large: {
      sizes: 'calc(0.666 * (100vw - 40px))',
      srcset: ['w_650,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_1045,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_1348,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_1557,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_1626,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(100vw - 20px)',
      srcset: ['w_300,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_638,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_800,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    }
  },
  poster: {
    large: {
      sizes: 'calc(0.58333 * (100vw - 40px))',
      srcset: ['w_562,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_937,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_1153,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_1379,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_1400,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(100vw - 20px)',
      srcset: ['w_300,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_638,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_800,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    }
  },
  meta: {
    large: {
      sizes: '100vw',
      srcset: ['w_1280,f_auto,q_auto,fl_lossy']
    }
  },
  slider: {
    large: {
      sizes: 'calc(0.58333 * (100vw - 40px))',
      srcset: ['w_562,c_limit,f_auto,q_auto,fl_lossy', 'w_937,c_limit,f_auto,q_auto,fl_lossy', 'w_1153,c_limit,f_auto,q_auto,fl_lossy', 'w_1379,c_limit,f_auto,q_auto,fl_lossy', 'w_1400,c_limit,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(100vw - 20px)',
      srcset: ['w_300,c_limit,f_auto,q_auto,fl_lossy', 'w_638,c_limit,f_auto,q_auto,fl_lossy', 'w_800,c_limit,f_auto,q_auto,fl_lossy']
    }
  },
  bigFirstMobile: {
    large: {
      sizes: 'calc(0.25 * (100vw - 40px))',
      srcset: ['w_772,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_302,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(100vw - 20px)',
      srcset: ['w_300,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_638,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_800,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    }
  },
  magazine: {
    large: {
      sizes: 'calc(0.25 * (100vw - 40px))',
      srcset: ['w_130,f_auto,q_auto,fl_lossy', 'w_750,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(0.5 * (100vw - 20px))',
      srcset: ['w_180,f_auto,q_auto,fl_lossy', 'w_589,f_auto,q_auto,fl_lossy', 'w_600,f_auto,q_auto,fl_lossy']
    }
  },
  mic2018Landscape: {
    large: {
      sizes: 'calc(0.25 * (100vw - 40px))',
      srcset: ['w_600,f_auto,q_auto,fl_lossy', 'w_1200,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(0.5 * (100vw - 20px))',
      srcset: ['w_400,f_auto,q_auto,fl_lossy', 'w_800,f_auto,q_auto,fl_lossy']
    }
  },
  mic2018Portrait: {
    large: {
      sizes: 'calc(0.25 * (100vw - 40px))',
      srcset: ['w_400,f_auto,q_auto,fl_lossy', 'w_800,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(0.5 * (100vw - 20px))',
      srcset: ['w_400,f_auto,q_auto,fl_lossy', 'w_800,f_auto,q_auto,fl_lossy']
    }
  }
};

/***/ }),
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadGATracker;
exports.trackGAEvent = trackGAEvent;

var _forEach = __webpack_require__(93);

var _forEach2 = _interopRequireDefault(_forEach);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _toNumber = __webpack_require__(65);

var _toNumber2 = _interopRequireDefault(_toNumber);

var _exenv = __webpack_require__(4);

var _identity = __webpack_require__(17);

var _identity2 = _interopRequireDefault(_identity);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loadGATracker(currentState) {
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  // https://developers.google.com/analytics/devguides/collection/analyticsjs/
  if (window.ga) {
    var _window = window,
        ga = _window.ga;

    var siteConfig = _identity2.default[(0, _get2.default)(currentState, 'context.site', 'fastcompany')];
    var siteSlug = (0, _get2.default)(siteConfig, 'slug');
    var context = (0, _get2.default)(currentState, 'context');

    var postData = context.postData,
        tagPageData = context.tagPageData,
        categoryPageData = context.categoryPageData,
        mostCreativePeoplePageData = context.mostCreativePeoplePageData,
        micSectorPageData = context.micSectorPageData,
        ibdPageData = context.ibdPageData,
        productPageData = context.productPageData,
        micPageData = context.micPageData,
        type = context.type;


    var _category = '';
    var _tag = '';

    if ((0, _get2.default)(currentState, 'config.featureFlags.gaCustomVarEnabled')) {
      // config here: https://analytics.google.com/analytics/web/#management/Settings/a45063514w75598220p78098335/%3Fm.page%3DPropertySettings/
      var legacyDomain = siteSlug;
      var customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'homepage' }, { dimension3: 'Unassigned' }, { dimension2: 'Unassigned' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
      var typeLookup = {
        post: function post() {
          _category = (0, _get2.default)(postData, 'categories[0].slug', 'technology');
          var tags = (0, _get2.default)(postData, 'tags');
          var eyeBrowText = (0, _ad_util.figureOutPriorityTag)(tags);

          var bylineAttribution = null;

          (0, _forEach2.default)(tags, function (tagObj) {
            if (tagObj.name.indexOf('byline_') !== -1 || tagObj.slug.indexOf('byline-') !== -1) {
              bylineAttribution = tagObj.name.replace('byline_', '');
            }
          });

          // For mapping of language, anaytics need to be consistent, language wise
          var pageType = 'unassigned';
          if ((0, _get2.default)(postData, 'posterSlideshow.length')) {
            pageType = 'slideshow';
          } else if ((0, _get2.default)(postData, 'hasVideoPoster') === true || (0, _get2.default)(postData, 'posterVideo.feedId')) {
            pageType = 'video';
          } else {
            pageType = 'article';
          }

          if (_category === 'ideas') {
            legacyDomain = 'Fastcoexist.com';
          } else if (_category === 'entertainment') {
            legacyDomain = 'FastcoCreate.com';
          } else if (_category === 'news') {
            legacyDomain = 'News';
          }

          var minutesRead = (0, _get2.default)(postData, 'readTime');
          if (minutesRead !== 'long') {
            minutesRead = (0, _toNumber2.default)(minutesRead.replace(' minute', '')) || '0';
          }

          customDimensions = [{ dimension1: legacyDomain }, { dimension2: _category }, { dimension6: (0, _get2.default)(postData, 'omnitureDate') }, { dimension7: pageType }, { dimension8: minutesRead }, {
            dimension9: pageNumber !== 0 ? pageNumber - 1 : pageNumber
          }];

          if (bylineAttribution) {
            customDimensions.push({ dimension4: bylineAttribution });
            customDimensions.push({
              dimension5: (0, _get2.default)(postData, 'author.name', 'Fast Company')
            });
          } else {
            customDimensions.push({
              dimension4: (0, _get2.default)(postData, 'author.name')
            });
            customDimensions.push({ dimension5: 'Fast Company' });
          }

          var eyeBrowTag = (0, _get2.default)(eyeBrowText, 'name');
          if (eyeBrowTag !== '') {
            customDimensions.push({ dimension3: eyeBrowTag });
          } else {
            customDimensions.push({ dimension3: 'notag' });
          }
        },
        category: function category() {
          _category = (0, _get2.default)(categoryPageData, 'slug');
          customDimensions = [{ dimension1: legacyDomain }, { dimension2: _category }, { dimension7: 'category page' }, { dimension3: 'notag' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
        },
        tag: function tag() {
          _tag = (0, _get2.default)(tagPageData, 'name');
          customDimensions = [{ dimension1: legacyDomain }, { dimension3: _tag }, { dimension7: 'section page' }, { dimension2: 'Unassigned' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
        },
        author: function author() {
          customDimensions = [{ dimension1: legacyDomain }, { dimension7: type }, { dimension3: 'Unassigned' }, { dimension2: 'Unassigned' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
        },
        search: function search() {
          customDimensions = [{ dimension1: legacyDomain }, { dimension7: type }, { dimension3: 'Unassigned' }, { dimension2: 'Unassigned' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
        },
        page: function page() {
          customDimensions = [{ dimension1: legacyDomain }, { dimension7: type }, { dimension3: 'Unassigned' }, { dimension2: 'Unassigned' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
        },
        personPage: function personPage() {
          customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'person page' }, { dimension3: 'Unassigned' }, { dimension2: 'person' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
        },
        personIndexSectionPage: function personIndexSectionPage() {
          customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'person index page' }, { dimension3: 'Unassigned' }, { dimension2: 'person' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
        },
        mostCreativePeoplePage: function mostCreativePeoplePage() {
          var year = (0, _get2.default)(mostCreativePeoplePageData, 'year', '');
          customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'mcp page' }, { dimension3: 'mcp' + year }, { dimension2: 'mcp' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
        },
        mostCreativePeopleCommunityPage: function mostCreativePeopleCommunityPage() {
          customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'mcp community page' }, { dimension3: 'Unassigned' }, { dimension2: 'mcp' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
        },
        micSectorPage: function micSectorPage() {
          var year = (0, _get2.default)(micSectorPageData, 'year', '');
          customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'mic sector page' }, { dimension3: 'mic' + year }, { dimension2: 'mic' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
        },
        companyIndexSectionPage: function companyIndexSectionPage() {
          customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'company sector index page' }, { dimension3: 'Unassigned' }, { dimension2: 'mic' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
        },
        ibdPage: function ibdPage() {
          var year = (0, _get2.default)(ibdPageData, 'year', '');
          customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'ibd page' }, { dimension3: 'ibd' + year }, { dimension2: 'ibd' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
        },
        companyPage: function companyPage() {
          customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'company page' }, { dimension3: 'company' }, { dimension2: 'company' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
        },
        productPage: function productPage() {
          var productName = (0, _get2.default)(productPageData, 'data.rows[0].name');
          customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'product page' }, { dimension3: 'product:' + productName }, { dimension2: 'product' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
        },
        micYearPage: function micYearPage() {
          var year = (0, _get2.default)(micPageData, 'year', '');
          customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'mic year page' }, { dimension3: 'mic' + year }, { dimension2: 'mic' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
        },
        magazineArchivePage: function magazineArchivePage() {
          customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'magazine archives page' }, { dimension3: 'magazine' }, { dimension2: 'magazine' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
        }
      };

      if (typeLookup[type]) {
        typeLookup[type]();
      }

      (0, _forEach2.default)(customDimensions, function (dimension) {
        if (!dimension) {
          return;
        }
        var key = Object.keys(dimension)[0];
        var dimensionKey = dimension[key];
        ga('rollup.set', '' + key, '' + dimensionKey);
      }).join('');
    }

    // Temporarly solution to figure out why ga.js is fired before head.js, we need head to set document.title first before ga fires in order for GA to collect the right title.
    setTimeout(function () {
      var pathname = window.location.pathname;

      ga('set', 'title', document.title);
      ga('set', 'page', pathname);
      ga('send', 'pageview');
      ga('rollup.set', 'page', pathname);
      ga('rollup.set', 'title', document.title);
      ga('rollup.send', 'pageview');
    }, 200);
  }
}

function trackGAEvent(eventParams) {
  if (_exenv.canUseDOM) {
    if (window && window.ga) {
      var eventCategory = eventParams.eventCategory,
          eventAction = eventParams.eventAction,
          _eventParams$eventLab = eventParams.eventLabel,
          eventLabel = _eventParams$eventLab === undefined ? null : _eventParams$eventLab;

      if (eventCategory && eventAction) {
        window.ga('send', 'event', eventCategory, eventAction, eventLabel);
        window.ga('rollup.send', 'event', eventCategory, eventAction, eventLabel);
      }
    }
  }
}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (status, action) {
  var store = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return {
    type: action,
    status: status,
    store: store
  };
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getAdvertorialEyebrow = getAdvertorialEyebrow;
exports.isAdvertorial = isAdvertorial;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ad = __webpack_require__(24);

var _ad2 = _interopRequireDefault(_ad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function generateTagData() {
  var tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var data = {};

  tags.forEach(function (tag) {
    var name = tag.name;

    var slicedName = name.slice(0, 1);

    // there are cases of no star, hence this does not always work
    if (!data.advertiser && slicedName === '*') {
      data.advertiser = name.slice(1).replace(/_/g, ' ').replace(/\s?advertorial/g, '').toUpperCase();
    } else if (!data.type && slicedName === '_') {
      data.type = name;
    }
  });

  return data;
}

function getAdvertorialEyebrow(tags) {
  var tagData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var data = tagData || generateTagData(tags);
  var copy = 'Created For and Commissioned By: ';

  if (!data.advertiser) {
    return 'Sponsored Content';
  }

  if (data.type === '_syndicated') {
    copy = 'Paid For And Posted By: ';
  }

  copy += data.advertiser;

  return copy;
}

function isAdvertorial() {
  var tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return !!tags.filter(function (tag) {
    return tag.slug === 'advertorial';
  }).length;
}

var Advertorial = function (_Component) {
  _inherits(Advertorial, _Component);

  function Advertorial() {
    _classCallCheck(this, Advertorial);

    return _possibleConstructorReturn(this, (Advertorial.__proto__ || Object.getPrototypeOf(Advertorial)).apply(this, arguments));
  }

  _createClass(Advertorial, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'getBranding',
    value: function getBranding(slot) {
      var type = void 0;

      switch (slot) {
        case '_custom':
          type = ['fast-co-works'];
          break;
        case '_brandview':
          type = ['fast-co-works', 'inc-brand-view'];
          break;
        case '_syndicated':
          type = _react2.default.createElement(_ad2.default, _extends({}, this.props.adModel, {
            noLazyLoad: true,
            slug: false,
            pos: 'atf',
            name: 'flexiblelogo'
          }));
          break;
        default:
          type = null;
          break;
      }

      if (Array.isArray(type)) {
        return _react2.default.createElement(
          'ul',
          { className: 'advertorial__list' },
          type.map(function (item) {
            return _react2.default.createElement('li', {
              key: item,
              className: 'advertorial__item advertorial__item--' + item
            });
          })
        );
      }

      return type;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          modifier = _props.modifier,
          tags = _props.tags,
          section = _props.section;

      var data = generateTagData(tags);
      var eyebrow = getAdvertorialEyebrow(tags, data);

      if (section) {
        return _react2.default.createElement(
          'h3',
          { className: 'advertorial__module-deck' },
          eyebrow
        );
      }

      return _react2.default.createElement(
        'div',
        {
          className: 'advertorial ' + (modifier ? 'advertorial--' + modifier : '')
        },
        data.type || data.advertiser ? _react2.default.createElement(
          'div',
          {
            className: 'advertorial__container ' + (modifier ? 'advertorial__container--' + modifier : '')
          },
          data.type && this.getBranding(data.type),
          data.advertiser ? _react2.default.createElement(
            'span',
            { className: 'advertorial__copy' },
            eyebrow
          ) : ''
        ) : null
      );
    }
  }]);

  return Advertorial;
}(_react.Component);

exports.default = Advertorial;


Advertorial.defaultProps = {
  modifier: '',
  section: '',
  adModel: {}
};

Advertorial.propTypes = {
  tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  modifier: _propTypes2.default.string,
  section: _propTypes2.default.string,
  adModel: _propTypes2.default.shape({})
};

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Card;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isEmpty = __webpack_require__(34);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _default_card = __webpack_require__(518);

var _default_card2 = _interopRequireDefault(_default_card);

var _featured_card = __webpack_require__(519);

var _featured_card2 = _interopRequireDefault(_featured_card);

var _all_feed_card = __webpack_require__(520);

var _all_feed_card2 = _interopRequireDefault(_all_feed_card);

var _video_card = __webpack_require__(521);

var _video_card2 = _interopRequireDefault(_video_card);

var _recirc_card = __webpack_require__(522);

var _recirc_card2 = _interopRequireDefault(_recirc_card);

var _small_card = __webpack_require__(523);

var _small_card2 = _interopRequireDefault(_small_card);

var _magazine_card = __webpack_require__(524);

var _magazine_card2 = _interopRequireDefault(_magazine_card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Card(props) {
  var type = props.type,
      metadata = props.metadata;


  if ((0, _isEmpty2.default)(metadata)) {
    return null;
  }

  switch (type) {
    case 'featured':
      return _react2.default.createElement(_featured_card2.default, props);
    case 'video':
      return _react2.default.createElement(_video_card2.default, props);
    case 'all-feed':
      return _react2.default.createElement(_all_feed_card2.default, props);
    case 'recirc':
      return _react2.default.createElement(_recirc_card2.default, props);
    case 'small':
      return _react2.default.createElement(_small_card2.default, props);
    case 'magazine':
      return _react2.default.createElement(_magazine_card2.default, props);
    default:
      return _react2.default.createElement(_default_card2.default, props);
  }
}

Card.defaultProps = {
  type: ''
};

Card.propTypes = {
  type: _propTypes2.default.string,
  metadata: _propTypes2.default.shape({}).isRequired
};

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = matchMediaDesktop;
function matchMediaDesktop() {
  var minWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '40em';

  return window.matchMedia('(min-width: ' + minWidth + ')').matches;
}

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NotFound;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotFound(_ref) {
  var message = _ref.message,
      statusCode = _ref.statusCode;

  return _react2.default.createElement(
    'div',
    { className: 'not-found' },
    _react2.default.createElement(
      'h2',
      { className: 'not-found__title' },
      statusCode,
      ': ',
      message
    ),
    _react2.default.createElement(
      'h3',
      { className: 'not-found__subtitle' },
      'Please enjoy these suggestions:'
    )
  );
}

NotFound.defaultProps = {
  message: 'the page you are looking for cannot be found',
  statusCode: 404
};

NotFound.propTypes = {
  message: _propTypes2.default.string,
  statusCode: _propTypes2.default.number
};

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Poster;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _image = __webpack_require__(61);

var _image2 = _interopRequireDefault(_image);

var _gif_converter = __webpack_require__(227);

var _gif_converter2 = _interopRequireDefault(_gif_converter);

var _create_class_list_util = __webpack_require__(134);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Poster(props) {
  var metadata = props.metadata,
      className = props.className,
      generateClasses = props.generateClasses;

  var image = (0, _get2.default)(metadata, 'featured_image.source');

  if (metadata.allowNoImage && !image || metadata.layout === 'short' && metadata.hasVideoPoster === false) {
    return null;
  }

  var assignedImage = image || 'https://images.fastcompany.net/image/upload/v1485990651/fcweb/fastcompanyimagedefault.jpg';
  var posterClasses = className;
  if (generateClasses) {
    posterClasses = (0, _create_class_list_util.createPosterClasses)(metadata.tags, metadata.events, className, metadata.hasVideoPoster, metadata.isPlayerVideo);
  }
  var isGif = /.gif$/.test(assignedImage);
  var markup = _react2.default.createElement(_image2.default, {
    alt: metadata.title,
    src: assignedImage,
    noLazy: metadata.noLazy,
    assetSizes: metadata.assetSizes
  });

  if (isGif) {
    markup = _react2.default.createElement(_gif_converter2.default, {
      alt: metadata.title,
      src: assignedImage,
      noLazy: metadata.noLazy,
      assetSizes: metadata.assetSizes
    });
  }

  return _react2.default.createElement(
    'figure',
    { className: posterClasses },
    markup
  );
}

// NOTE: generateClasses will be removed once we kill createPosterClasses
Poster.defaultProps = {
  className: '',
  generateClasses: true
};

Poster.propTypes = {
  metadata: _propTypes2.default.shape({}).isRequired,
  className: _propTypes2.default.string,
  generateClasses: _propTypes2.default.bool
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Eyebrow;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Link = __webpack_require__(43);

var _Link2 = _interopRequireDefault(_Link);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(34);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _advertorial = __webpack_require__(29);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function showLive(live) {
  if (live) {
    return _react2.default.createElement(
      'li',
      { className: 'eyebrow__item eyebrow__item--live' },
      _react2.default.createElement(
        'span',
        { className: 'eyebrow__live' },
        'Live'
      )
    );
  }

  return null;
}

function renderTag(tags) {
  var eyeBrowText = (0, _ad_util.figureOutPriorityTag)(tags);
  var slug = eyeBrowText.slug;
  var name = eyeBrowText.name;


  if (!slug || !name) {
    return null;
  }

  name = name.replace(/\*/g, '').replace(/_/g, ' ').replace(/\s?advertorial/g, '');

  var to = '/section/' + slug;

  if (to === '/section/most-creative-people') {
    to = '/most-creative-people';
  }

  return _react2.default.createElement(
    'li',
    { className: 'eyebrow__item' },
    (0, _advertorial.isAdvertorial)(tags) ? name : _react2.default.createElement(
      _Link2.default,
      { to: to },
      name
    )
  );
}

function shouldShowTime(post) {
  var showTime = (0, _get2.default)(post, 'showTime');
  if (!showTime) return null;
  return _react2.default.createElement(
    'li',
    { className: 'eyebrow__item' },
    (0, _get2.default)(post, 'timePublished'),
    ' '
  );
}

function Eyebrow(props) {
  if (!props) {
    return null;
  }

  var metadata = props.metadata,
      post = props.post,
      tags = props.tags,
      modifier = props.modifier,
      live = props.live;


  if (!(0, _isEmpty2.default)(metadata)) {
    var cardTags = metadata.tags || [];
    var category = (0, _get2.default)(metadata, 'categories[0].name');
    var eyebrow = metadata.site || category || null;

    if (!eyebrow && metadata.dateFormatted && metadata.timePublished) {
      eyebrow = metadata.dateFormatted + ' | ' + metadata.timePublished;
    }

    if ((0, _advertorial.isAdvertorial)(cardTags)) {
      eyebrow = 'Sponsored Content';
    }

    // When it's a News story, it has category Uncategorized
    // we don't want to show that to the user, use date instead
    if (eyebrow === 'Uncategorized') {
      eyebrow = metadata.timePublished;
    }

    if (metadata.customEyebrowText) {
      eyebrow = metadata.customEyebrowText;
    }

    return eyebrow && _react2.default.createElement(
      'span',
      { className: 'eyebrow eyebrow--' + modifier },
      eyebrow
    );
  }

  if (!(0, _isEmpty2.default)(post)) {
    return _react2.default.createElement(
      'ul',
      { className: 'eyebrow' },
      showLive(live),
      _react2.default.createElement(
        'li',
        { className: 'eyebrow__item' },
        _react2.default.createElement(
          'time',
          { dateTime: (0, _get2.default)(post, 'structuredData.published') },
          (0, _get2.default)(post, 'dateFormatted')
        )
      ),
      shouldShowTime(post),
      renderTag(tags)
    );
  }

  return null;
}

Eyebrow.defaultProps = {
  post: {},
  metadata: {},
  modifier: '',
  live: false
};

Eyebrow.propTypes = {
  post: _propTypes2.default.shape({}),
  // eslint-disable-next-line react/require-default-props
  tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  metadata: _propTypes2.default.shape({}),
  modifier: _propTypes2.default.string,
  live: _propTypes2.default.bool
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchRecircModule;
exports.hideRecircAction = hideRecircAction;

var _recirc_feed_action_creators = __webpack_require__(538);

var recircFeedActions = _interopRequireWildcard(_recirc_feed_action_creators);

var _recirc_module = __webpack_require__(539);

var _recirc_module2 = _interopRequireDefault(_recirc_module);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchRecircModule(params, store) {
  return function firstDispatchRecirc(dispatch) {
    dispatch(recircFeedActions.recircFeedLoading({}, store));
    return _recirc_module2.default.fetch(params, store).then(function handleRecircModuleData(resp) {
      dispatch(recircFeedActions.recircFeedLoaded(resp.data, store));
    }).catch(function handleRecircError(err) {
      dispatch(recircFeedActions.recircFeedLoadError(err, store));
      _logger_service2.default.error(err, 'Error in recirc feed actions, message: ' + err.message);
    });
  };
}

function hideRecircAction(dispatch) {
  return function hide() {
    dispatch(recircFeedActions.hideRecircFeed());
  };
}

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(34);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _cloudinary_asset_util = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Image = function (_Component) {
  _inherits(Image, _Component);

  function Image() {
    _classCallCheck(this, Image);

    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
  }

  _createClass(Image, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          alt = _props.alt,
          src = _props.src,
          assetSizes = _props.assetSizes,
          noLazy = _props.noLazy,
          baseClass = _props.baseClass,
          modifier = _props.modifier;

      var secureSrc = (0, _cloudinary_asset_util.makeHttps)(src);
      var fcDomainAsset = (0, _cloudinary_asset_util.changeAssetDomain)(secureSrc);
      var sourceAttribs = {
        media: '(max-width: 40em)',
        'data-sizes': (0, _get2.default)(assetSizes, 'small.sizes'),
        'data-srcset': (0, _cloudinary_asset_util.buildSrcSet)(assetSizes, 'small.srcset', fcDomainAsset)
      };
      var imgAttribs = {
        'data-sizes': (0, _get2.default)(assetSizes, 'large.sizes'),
        'data-srcset': (0, _cloudinary_asset_util.buildSrcSet)(assetSizes, 'large.srcset', fcDomainAsset),
        className: (noLazy ? '' : 'lazyload') + ' ' + baseClass + ' ' + baseClass + '--' + modifier
      };

      function removeData(str) {
        return str.replace('data-', '');
      }

      function removeDataAttrs(obj) {
        var correctedParams = (0, _assign2.default)({}, obj);
        // eslint-disable-next-line no-restricted-syntax
        for (var attr in correctedParams) {
          if (/^data-/.test(attr)) {
            correctedParams[removeData(attr)] = correctedParams[attr];
            delete correctedParams[attr];
          }
        }

        return correctedParams;
      }

      if (noLazy) {
        imgAttribs = removeDataAttrs(imgAttribs);
        sourceAttribs = removeDataAttrs(sourceAttribs);
      }

      if (src && !(0, _isEmpty2.default)(assetSizes)) {
        return _react2.default.createElement(
          'picture',
          null,
          _react2.default.createElement('source', {
            media: sourceAttribs.media,
            sizes: sourceAttribs.sizes,
            srcSet: sourceAttribs.srcset
          }),
          noLazy ? _react2.default.createElement('img', {
            media: imgAttribs.media,
            sizes: imgAttribs.sizes,
            srcSet: imgAttribs.srcset,
            alt: alt
          }) : _react2.default.createElement('img', _extends({}, imgAttribs, { alt: alt }))
        );
      }

      return _react2.default.createElement(
        'picture',
        null,
        _react2.default.createElement('img', {
          alt: alt,
          'data-src': src,
          className: '' + (noLazy ? '' : 'lazyload')
        })
      );
    }
  }]);

  return Image;
}(_react.Component);

exports.default = Image;


Image.defaultProps = {
  noLazy: false,
  assetSizes: {},
  baseClass: '',
  modifier: ''
};

Image.propTypes = {
  alt: _propTypes2.default.string.isRequired,
  baseClass: _propTypes2.default.string,
  modifier: _propTypes2.default.string,
  src: _propTypes2.default.string.isRequired,
  noLazy: _propTypes2.default.bool,
  assetSizes: _propTypes2.default.shape({
    large: _propTypes2.default.shape({
      sizes: _propTypes2.default.string,
      srcset: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }),
    small: _propTypes2.default.shape({
      sizes: _propTypes2.default.string,
      srcset: _propTypes2.default.arrayOf(_propTypes2.default.string)
    })
  })
};

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _set = __webpack_require__(42);

var _set2 = _interopRequireDefault(_set);

var _async_category_page_actions = __webpack_require__(565);

var _async_category_page_actions2 = _interopRequireDefault(_async_category_page_actions);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store, override, isTag) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;


    if (override) {
      (0, _set2.default)(nextState, 'params.category', override);
    }

    // run async
    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_category_page_actions2.default)(nextState.params, store, isTag)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_category_page_actions2.default)(nextState.params, store, isTag)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(15);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _set = __webpack_require__(42);

var _set2 = _interopRequireDefault(_set);

var _isEmpty = __webpack_require__(34);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _throttle = __webpack_require__(72);

var _throttle2 = _interopRequireDefault(_throttle);

var _jsCookie = __webpack_require__(100);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _ad = __webpack_require__(24);

var _ad2 = _interopRequireDefault(_ad);

var _container = __webpack_require__(150);

var _container2 = _interopRequireDefault(_container);

var _moreStoriesComponent = __webpack_require__(231);

var _moreStoriesComponent2 = _interopRequireDefault(_moreStoriesComponent);

var _video_module = __webpack_require__(73);

var _video_module2 = _interopRequireDefault(_video_module);

var _revcontent = __webpack_require__(241);

var _revcontent2 = _interopRequireDefault(_revcontent);

var _not_found_component = __webpack_require__(49);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _trackThirdPartyJS = __webpack_require__(140);

var _trackThirdPartyJS2 = _interopRequireDefault(_trackThirdPartyJS);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

var _client_util = __webpack_require__(40);

var _client_util2 = _interopRequireDefault(_client_util);

var _postpage_action_creators = __webpack_require__(242);

var _async_post_finite_actions = __webpack_require__(633);

var _async_post_finite_actions2 = _interopRequireDefault(_async_post_finite_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var scriptjs = false;

if (_exenv.canUseDOM) {
  // eslint-disable-next-line global-require
  scriptjs = __webpack_require__(37);
}

var PostPage = function (_Component) {
  _inherits(PostPage, _Component);

  function PostPage(props) {
    _classCallCheck(this, PostPage);

    var _this = _possibleConstructorReturn(this, (PostPage.__proto__ || Object.getPrototypeOf(PostPage)).call(this, props));

    var live = props.post.live;


    _this.finiteScrollDepth = null;
    _this.setScrollEvents = (0, _throttle2.default)(function () {
      var _this$window = _this.window,
          scrollY = _this$window.scrollY,
          innerHeight = _this$window.innerHeight;

      _this.setFiniteScrollDepth(scrollY, innerHeight);
      _this.setInviewPostUrl(scrollY, innerHeight);
    }, 100);
    _this.generateAdData = _this.generateAdData.bind(_this);
    _this.state = {
      finitePosts: []
    };
    _this.playerScriptIds = ['QV73eWiB', '4h5SWQPt', 'Pafg29um', '27mBLzWL', 'i70nsZ8K', 'Lrp0YsKC', 'wGNMZweZ', 'kMmGs8qw', 'WXJihrBk', 'iqio3VCM', 'OolwHeKf', 'FsIzKJce', 'r04h3Jdn', 'RvGXj7in', 'flarUGPa', 'HzdTLaau', 'gAy6i1bi', 'RqEFED7X', 'vp2iCnvh', 'b2BPV4nc'];
    _this.live = (0, _get2.default)(live, 'enabled', false) && !!(0, _get2.default)(live, 'posts.length', 0);
    return _this;
  }

  _createClass(PostPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          statusCode = _props.statusCode,
          config = _props.config,
          post = _props.post;


      this.window = window;
      this.body = document.body;
      this.activePost = (0, _get2.default)(post, 'id') || (0, _get2.default)(this.props, 'match.params.id');
      this.lazyThresholdFromBottom = 400;
      this.stickySidebar = (0, _client_util2.default)();
      this.trackedPosts = [];

      this.setActiveSocial();
      this.refreshSocialEmbeds();

      if (!this.live) {
        this.window.addEventListener('scroll', this.setScrollEvents);
      }

      if (statusCode !== 404 && statusCode !== 403 && statusCode !== 500) {
        var postId = (0, _get2.default)(this.props, 'match.params.id');
        this.props.dispatchPostFinite(postId, config);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var live = (0, _get2.default)(this.props, 'post.live');
      this.live = (0, _get2.default)(live, 'enabled', false) && !!(0, _get2.default)(live, 'posts.length', 0);
      this.refreshSocialEmbeds();

      this.posts = this.getPostElements();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!this.live) {
        this.window.removeEventListener('scroll', this.setScrollEvents);
      }
    }
  }, {
    key: 'getPostElements',
    value: function getPostElements() {
      return document.querySelectorAll('.post__body');
    }
  }, {
    key: 'setActiveSocial',
    value: function setActiveSocial(post) {
      var activeClass = 'social--active';
      var activeSocial = document.querySelector('.' + activeClass);

      if (activeSocial) {
        activeSocial.classList.remove(activeClass);
      }

      var activePost = post || document.querySelector('.post__wrapper');
      if (activePost) {
        activePost.querySelector('.social').classList.add(activeClass);
      }
    }
  }, {
    key: 'setFiniteScrollDepth',
    value: function setFiniteScrollDepth(windowPosition, screenHeight) {
      var postFinite = this.props.postFinite;

      var RECIRC_OFFSET = 300;
      var bottomOfScreen = windowPosition + screenHeight;
      var recircPosition = document.querySelector('.recirc').offsetTop;
      var triggerPoint = recircPosition - RECIRC_OFFSET;

      if (triggerPoint < bottomOfScreen && postFinite.length) {
        this.setState({
          finitePosts: [].concat(_toConsumableArray(this.state.finitePosts), [postFinite.shift()])
        });
      }
    }
  }, {
    key: 'setInviewPostUrl',
    value: function setInviewPostUrl(windowPosition, screenHeight) {
      if (!this.posts || !this.posts.length) {
        return false;
      }
      var triggerPoint = windowPosition + screenHeight / 2;
      for (var i = 1; i <= this.posts.length; i += 1) {
        var post = this.posts[i - 1];
        var sectionTopPosition = post.offsetTop;
        var sectionBottomPosition = sectionTopPosition + post.clientHeight;
        var postId = parseFloat(post.dataset.id);

        if (this.activePost !== postId && sectionTopPosition <= triggerPoint && sectionBottomPosition > triggerPoint) {
          this.activePost = postId;
          // const postData = post.dataset;
          var postData = i === 1 ? this.props.post : this.state.finitePosts[i - 2];

          // React router redux does not support replace state without page refresh.
          this.props.dispatchInfiniteScrollUrlChange();

          var replacedURL = '/' + postData.id + '/' + postData.slug;

          if ((0, _get2.default)(postData, 'isVideoPermalink')) {
            replacedURL = '/video/' + postData.slug + '/' + (0, _get2.default)(postData, 'posterVideo.feedId');
          }

          window.history.replaceState({}, '', replacedURL);

          // Only track this again on first post onwards
          if (i > 1 && this.trackedPosts.indexOf(this.activePost) === -1) {
            this.trackedPosts.push(this.activePost);
            this.refreshThirdPartyTrackers(postData, i);
          }

          this.setActiveSocial(post);
        }
      }
      return false;
    }
  }, {
    key: 'refreshSocialEmbeds',
    value: function refreshSocialEmbeds() {
      if (_exenv.canUseDOM) {
        if (!window.instgrm) {
          scriptjs('//platform.instagram.com/en_US/embeds.js', function () {
            window.instgrm.Embeds.process();
          });
        } else {
          window.instgrm.Embeds.process();
        }

        if (!window.twttr) {
          scriptjs('//platform.twitter.com/widgets.js', function () {
            window.twttr.widgets.load();
          });
        } else {
          window.twttr.widgets.load();
        }
      }
    }
  }, {
    key: 'refreshThirdPartyTrackers',
    value: function refreshThirdPartyTrackers(postData, pageNumber) {
      var config = this.props.config;

      var currentActivePostState = {
        context: {
          site: (0, _get2.default)(config, 'site'),
          type: 'post',
          postData: postData
        },
        config: config
      };
      (0, _trackThirdPartyJS2.default)(currentActivePostState, pageNumber);
    }
  }, {
    key: 'generateAdData',
    value: function generateAdData(postData) {
      var config = this.props.config;

      var site = (0, _get2.default)(config, 'site') || 'fastcompany';
      var adData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, postData, 'postPage');

      return (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') || {} }, { definitions: (0, _get2.default)(adData, 'config.definitions') || {} }, { model: adData.model || {} });
    }
  }, {
    key: 'renderRevContentOrMoreStories',
    value: function renderRevContentOrMoreStories() {
      var _props2 = this.props,
          config = _props2.config,
          postAfterbodyRecircModuleType = _props2.postAfterbodyRecircModuleType;

      var initialPageLoad = (0, _get2.default)(config, 'initialPageLoad');
      var moduleType = (0, _get2.default)(postAfterbodyRecircModuleType, 'type');

      if (config.featureFlags.revContentJSWidgetEnabled) {
        if (!initialPageLoad && _exenv.canUseDOM) {
          if (_jsCookie2.default.get('fc_rev_content')) {
            return _react2.default.createElement(_revcontent2.default, {
              initialPageLoad: initialPageLoad,
              site: (0, _get2.default)(config, 'site')
            });
          }
        }
      }

      // Hard return more stories for test
      if (moduleType === 'More Stories') {
        return this.renderMoreStories();
      }

      return _react2.default.createElement(_revcontent2.default, {
        initialPageLoad: (0, _get2.default)(config, 'initialPageLoad'),
        site: (0, _get2.default)(config, 'site')
      });
    }
  }, {
    key: 'renderVideo',
    value: function renderVideo() {
      var _props3 = this.props,
          postVideo = _props3.postVideo,
          config = _props3.config,
          post = _props3.post;

      var feedID = (0, _get2.default)(post, 'posterVideo.feedId');

      // Do not display video module when on a video post
      if (config.featureFlags.videoPagesEnabled && feedID) {
        return '';
      }

      if (!(0, _isEmpty2.default)(postVideo)) {
        var currentSite = (0, _get2.default)(this.props, 'config.site');
        (0, _get2.default)(config, 'site');
        return _react2.default.createElement(_video_module2.default, {
          config: config,
          data: postVideo,
          playerid: 'MyQ2uJQ0',
          stories: this.props.postVideo.playlist,
          currentSite: currentSite,
          isPost: true,
          readTime: (0, _get2.default)(post, 'readTime')
        });
      }

      return null;
    }
  }, {
    key: 'renderMoreStories',
    value: function renderMoreStories() {
      var postMoreStories = (0, _get2.default)(this.props, 'postMoreStories.posts');

      if (postMoreStories && postMoreStories.length && this.props.postFinite.length && _exenv.canUseDOM) {
        return _react2.default.createElement(_moreStoriesComponent2.default, {
          metadata: postMoreStories,
          isPost: true,
          config: this.props.config
        });
      }

      return null;
    }
  }, {
    key: 'renderPostFinite',
    value: function renderPostFinite(postFinite, related, sticky, config, playerIds) {
      var _this2 = this;

      if (!postFinite.length) {
        return null;
      }

      return postFinite.map(function (postData, index) {
        if (postData.isVideoPermalink || (0, _get2.default)(postData, 'posterVideo.feedId')) {
          if (!playerIds[index + 1]) {
            (0, _set2.default)(postData, 'playerScriptId', 'G2hQKLvX');
          } else {
            (0, _set2.default)(postData, 'playerScriptId', playerIds[index + 1]);
          }
        }

        return _react2.default.createElement(_container2.default, {
          key: (0, _get2.default)(postData, 'id'),
          posts: [postData],
          related: related,
          isDesktop: sticky,
          pageNum: index + 1,
          combinedAdModel: _this2.generateAdData(postData),
          config: config,
          videoAdData: (0, _get2.default)(_this2.props.postpage, 'ads.model', {}),
          updateCorrelator: true
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          config = _props4.config,
          statusCode = _props4.statusCode,
          post = _props4.post,
          related = _props4.related,
          postpage = _props4.postpage;


      if (postpage.isLoading && statusCode === 200) {
        return _react2.default.createElement(
          'section',
          { className: 'post-page' },
          _react2.default.createElement(
            'article',
            { className: 'post__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      if (postpage.error || (0, _isEmpty2.default)(post)) {
        return _react2.default.createElement(
          'section',
          { className: 'post-page' },
          _react2.default.createElement(
            'article',
            { className: 'post__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, {
              statusCode: statusCode,
              message: statusCode === 403 ? 'Post is not available.' : ''
            })
          )
        );
      }

      var sticky = this.stickySidebar;

      var combinedAdModel = this.generateAdData(post);
      if (post.isVideoPermalink || (0, _get2.default)(post, 'posterVideo.feedId')) {
        (0, _set2.default)(post, 'playerScriptId', this.playerScriptIds[0]);
      }

      return _react2.default.createElement(
        'section',
        { className: 'post-page' },
        _react2.default.createElement(_container2.default, {
          config: this.props.config,
          posts: [post],
          combinedAdModel: combinedAdModel,
          pageNum: 0,
          related: related,
          isDesktop: sticky,
          isFirstPost: true,
          videoAdData: (0, _get2.default)(postpage, 'ads.model', {}),
          live: this.live
        }),
        this.live ? _react2.default.createElement(
          'div',
          { className: 'post__article-top-ad-wrapper' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
            name: 'flexiblebillboard',
            region: 'articlebottom',
            pageNum: 1
          })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
            name: 'mobileleaderboard',
            region: 'articlebottom',
            pageNum: 1
          }))
        ) : _react2.default.createElement(
          'div',
          null,
          this.renderRevContentOrMoreStories(),
          this.renderVideo(),
          this.renderPostFinite(this.state.finitePosts, related, sticky, config, this.playerScriptIds)
        )
      );
    }
  }]);

  return PostPage;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    statusCode: (0, _get2.default)(state, 'status.code'),
    config: state.config,
    postpage: state.postpage,
    post: (0, _get2.default)(state, 'post.data.post') || {},
    related: (0, _get2.default)(state, 'post.data.related') || [],
    postVideo: (0, _get2.default)(state, 'postVideo.data') || {
      feedid: '',
      playlist: [],
      title: ''
    },
    postAfterbodyRecircModuleType: (0, _get2.default)(state, 'postAfterbodyRecircModuleType.data'),
    postMoreStories: (0, _get2.default)(state, 'postMoreStories.data'),
    postFinite: (0, _get2.default)(state, 'postFinite.data.posts') || []
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchInfiniteScrollUrlChange: function dispatchInfiniteScrollUrlChange() {
      dispatch((0, _postpage_action_creators.infiniteScrollUrlChange)());
    },
    dispatchPostFinite: function dispatchPostFinite(id, config) {
      return (0, _async_post_finite_actions2.default)(dispatch, id, config);
    }
  };
}

PostPage.defaultProps = {
  postAfterbodyRecircModuleType: {
    type: 'More Stories'
  }
};

PostPage.propTypes = {
  statusCode: _propTypes2.default.number.isRequired,
  config: _propTypes2.default.shape({}).isRequired,
  dispatchInfiniteScrollUrlChange: _propTypes2.default.func.isRequired,
  dispatchPostFinite: _propTypes2.default.func.isRequired,
  post: _propTypes2.default.shape({}).isRequired,
  related: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  postpage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string,
    postScrollDepth: _propTypes2.default.number
  }).isRequired,
  postVideo: _propTypes2.default.shape({
    feedid: _propTypes2.default.string,
    playlist: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    title: _propTypes2.default.string
  }).isRequired,
  postFinite: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  postAfterbodyRecircModuleType: _propTypes2.default.shape({
    type: _propTypes2.default.string
  })
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PostPage);

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_postpage_actions = __webpack_require__(638);

var _async_postpage_actions2 = _interopRequireDefault(_async_postpage_actions);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;
    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_postpage_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_postpage_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        if (callback) {
          return callback();
        }
        return false;
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _reactSlick = __webpack_require__(60);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _video_module_ads = __webpack_require__(97);

var _video_module_ads2 = _interopRequireDefault(_video_module_ads);

var _video_module_autoplay = __webpack_require__(533);

var _video_module_autoplay2 = _interopRequireDefault(_video_module_autoplay);

var _slug = __webpack_require__(23);

var _slug2 = _interopRequireDefault(_slug);

var _card = __webpack_require__(36);

var _card2 = _interopRequireDefault(_card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var scriptjs = false;
if (_exenv.canUseDOM) {
  // eslint-disable-next-line global-require
  scriptjs = __webpack_require__(37);
}

var Video = function (_Component) {
  _inherits(Video, _Component);

  function Video() {
    _classCallCheck(this, Video);

    var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this));

    _this.state = {
      playingIndex: 0,
      activeTitle: ''
    };

    // lookup for PERCENT INVIEW THRESHOLD for AUTOPLAY
    _this.siteToPercentView = {
      fastcompany: 50,
      fastcodesign: 50
    };

    _this.autoplay = null;
    _this.videoCardClick = _this.videoCardClick.bind(_this);
    _this.updateTitle = _this.updateTitle.bind(_this);
    _this.setCaptions = _this.setCaptions.bind(_this);
    _this.setNextVideo = _this.setNextVideo.bind(_this);
    _this.setMoatTracking = _this.setMoatTracking.bind(_this);
    return _this;
  }

  _createClass(Video, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        settings: {
          arrows: false,
          infinite: false,
          responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 2.3,
              slidesToScroll: 2,
              slide: '.video-slide'
            }
          }, {
            breakpoint: 100000,
            settings: 'unslick'
          }]
        }
      });

      if (scriptjs) {
        var data = this.props.data;
        var playerid = this.props.playerid;

        // When we're testing, use a dev specific video player so we can override adzone

        if (window && window.location.href.indexOf('adzone=qa') !== -1) {
          playerid = 'wip8TrhU';
        }

        scriptjs(['//content.jwplatform.com/libraries/' + playerid + '.js', 'https://z.moatads.com/jwplayerplugin0938452/moatplugin.js'], function () {
          _this2.player = window.jwplayer('video-module__player');
          _this2.adTagGenerator = new _video_module_ads2.default((0, _get2.default)(data, 'title'), _this2.props.type);
          _this2.initPlayer();
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var updateSettings = !this.state.settings;
      var updatePlayingIndex = this.state.playingIndex !== nextState.playingIndex;
      var updateActiveTitle = this.state.activeTitle !== nextState.activeTitle;

      return updateSettings || updatePlayingIndex || updateActiveTitle;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if ((0, _get2.default)(this, 'player.remove')) this.player.remove();
      if (this.autoplay !== null) this.autoplay.off();

      if (_exenv.canUseDOM) {
        if (window.moatjw) {
          window.moatjw.removeAll();
        }
      }
    }
  }, {
    key: 'getVideoImage',
    value: function getVideoImage(image) {
      if (!image) return '';
      var fastlyCloudinaryFetchEnabled = (0, _get2.default)(this.props, 'config.featureFlags.fastlyCloudinaryFetchEnabled');

      if (fastlyCloudinaryFetchEnabled) {
        return 'https://images.fastcompany.net/image/fetch/w_280,ar_16:9,c_fill,g_auto,q_auto,f_auto,fl_lossy/' + image;
      }

      return '//fast-company-res.cloudinary.com/image/fetch/w_280,ar_16:9,c_fill,g_auto,q_auto,f_auto,fl_lossy/' + image;
    }
  }, {
    key: 'getVideoList',
    value: function getVideoList() {
      var _this3 = this;

      var stories = this.props.stories;


      return stories.map(function (video, index) {
        return {
          id: video.mediaid,
          title: video.title,
          link: video.link,
          featured_image: {
            source: _this3.getVideoImage((0, _get2.default)(video, 'image'))
          },
          isPlayerVideo: true,
          isVideoActive: _this3.state.playingIndex === index,
          index: index
        };
      });
    }
  }, {
    key: 'setCaptions',
    value: function setCaptions() {
      var caption = this.player.getMute() ? 1 : 0;
      return this.player.setCurrentCaptions(caption);
    }
  }, {
    key: 'setNextVideo',
    value: function setNextVideo() {
      var playingIndex = this.state.playingIndex + 1;
      this.setState({ playingIndex: playingIndex });
    }
  }, {
    key: 'setMoatTracking',
    value: function setMoatTracking(event) {
      if (window.moatjw) {
        window.moatjw.add({
          partnerCode: 'mansuetojwint127635890115',
          player: this.player,
          adImpressionEvent: event
        });
      }
    }
  }, {
    key: 'updateTitle',
    value: function updateTitle() {
      var video = this.player.getPlaylistItem();
      this.setState({ activeTitle: video.title });
    }
  }, {
    key: 'initPlayer',
    value: function initPlayer() {
      var _this4 = this;

      // we will want to pass in playerid to ad tag
      var _props = this.props,
          data = _props.data,
          config = _props.config;


      var options = {
        playlist: '//content.jwplatform.com/feeds/' + data.feedid + '.json',
        autostart: 'viewable',
        sharing: {
          link: 'https://www.' + config.site + '.com/video/share/MEDIAID'
        }
      };

      // example where homepage is setup https://dashboard.jwplayer.com/#/players/basic_setup?property=c08f27a0-75f3-11e6-8d4f-0a55b80e2f57&player_key=76APbejE
      options.advertising = {
        client: 'googima',
        tag: this.adTagGenerator.adTag,
        vpaidcontrols: true
      };

      this.player.setup(options);

      this.player.on('ready', function () {
        _this4.player.setMute(true);
        _this4.autoplay = new _video_module_autoplay2.default({
          player: _this4.player,
          percentInView: _this4.siteToPercentView[(0, _get2.default)(config, 'site', 'fastcompany')]
        });
        _this4.autoplay.on();
        _this4.player.on('playlistItem', _this4.updateTitle);
        _this4.player.on('play', _this4.setCaptions);
        _this4.player.on('mute', _this4.setCaptions);
        _this4.player.on('complete', _this4.setNextVideo);
        _this4.player.on('adImpression', _this4.setMoatTracking);
      });
    }
  }, {
    key: 'videoCardClick',
    value: function videoCardClick(event, index) {
      this.setState({ playingIndex: index });
      this.player.playlistItem(index);
    }
  }, {
    key: 'renderSlides',
    value: function renderSlides() {
      var _this5 = this;

      var settings = this.state.settings;
      var config = this.props.config;

      if (settings) {
        var stories = this.getVideoList();
        return _react2.default.createElement(
          'div',
          { className: 'video-module-playlist' },
          _react2.default.createElement(
            _reactSlick2.default,
            settings,
            stories.map(function (item) {
              return _react2.default.createElement(
                'div',
                { className: 'video-slide video-slide--vertical', key: item.id },
                _react2.default.createElement(_card2.default, {
                  type: 'video',
                  config: config,
                  metadata: item,
                  cardEvent: _this5.videoCardClick,
                  hasLink: false
                })
              );
            })
          )
        );
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          slugName = _props2.slugName,
          isPost = _props2.isPost;


      return _react2.default.createElement(
        'section',
        { className: 'video-row ' + (isPost ? 'video-row--post' : '') },
        _react2.default.createElement(_slug2.default, { linkTo: '//fastcompany.com/videos', slugName: slugName }),
        _react2.default.createElement(
          'div',
          { className: 'video-module' },
          _react2.default.createElement(
            'div',
            { className: 'video-module__player-container' },
            _react2.default.createElement('div', { id: 'video-module__player' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'video-module__title' },
            this.state.activeTitle
          )
        ),
        this.renderSlides()
      );
    }
  }]);

  return Video;
}(_react.Component);

exports.default = Video;


Video.defaultProps = {
  stories: [],
  data: {},
  slugName: 'Video',
  isPost: false
};

Video.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  stories: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  data: _propTypes2.default.shape({}),
  playerid: _propTypes2.default.string.isRequired,
  slugName: _propTypes2.default.string,
  isPost: _propTypes2.default.bool,
  type: _propTypes2.default.string.isRequired
};

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Social;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStickynode = __webpack_require__(71);

var _reactStickynode2 = _interopRequireDefault(_reactStickynode);

var _social_models = __webpack_require__(530);

var _social_models2 = _interopRequireDefault(_social_models);

var _share_util = __webpack_require__(229);

var _parsely = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function handleClick(event, url, popup, socialShare) {
  if (socialShare.action !== 'email') {
    event.preventDefault();
  }

  if (popup) {
    (0, _share_util.popupCenter)(event, url, 560, 725);
  }

  if (socialShare) {
    (0, _share_util.trackSocial)(socialShare.platform, socialShare.action);
    (0, _parsely.trainParselyProfile)();
  }
}

function renderSocialList(empty, properties) {
  return _react2.default.createElement(
    'ul',
    { className: 'social__list ' + (empty ? 'social__list--post-empty' : '') },
    properties.map(function (sharer) {
      var property = sharer.property,
          url = sharer.url,
          _sharer$icon = sharer.icon,
          icon = _sharer$icon === undefined ? '' : _sharer$icon,
          popup = sharer.popup,
          socialShare = sharer.socialShare;


      return _react2.default.createElement(
        'li',
        {
          key: property,
          className: 'social__item ' + (empty ? 'social__item--empty' : '')
        },
        _react2.default.createElement(
          'a',
          {
            className: 'social__link social__link--' + property,
            href: url,
            onClick: function onClick(e) {
              return handleClick(e, url, popup, socialShare);
            },
            rel: 'noopener noreferrer'
          },
          _react2.default.createElement('i', { className: 'icon-' + (icon || property) })
        )
      );
    })
  );
}

function Social(props) {
  if (!props) {
    return null;
  }

  var encodedPostUrl = props.uri;
  var encodedTitle = props.text || props.socialText;
  var properties = (0, _social_models2.default)(encodedPostUrl, encodedTitle);
  var classes = ['social', 'social--' + props.modifier];

  return _react2.default.createElement(
    'div',
    { className: classes.join(' '), id: props.encapsulateId },
    _react2.default.createElement(
      _reactStickynode2.default,
      {
        top: props.topValue,
        bottomBoundary: props.bottomBoundary,
        enabled: props.enableSticky
      },
      renderSocialList(props.empty, properties)
    )
  );
}

Social.defaultProps = {
  uri: 'https://www.fastcompany.com',
  text: 'Fast Company is the world&#x27;s leading progressive business media brand, with a unique editorial focus on innovation in technology, leadership, and design.',
  modifier: 'default',
  topValue: 56,
  bottomBoundary: 0,
  encapsulateId: '',
  empty: false,
  enableSticky: false
};

Social.propTypes = {
  empty: _propTypes2.default.bool,
  enableSticky: _propTypes2.default.bool,
  modifier: _propTypes2.default.string,
  uri: _propTypes2.default.string,
  text: _propTypes2.default.string,
  // eslint-disable-next-line react/require-default-props
  socialText: _propTypes2.default.shape({
    twitter: _propTypes2.default.string,
    linkedin: _propTypes2.default.string,
    email: _propTypes2.default.string
  }),
  bottomBoundary: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  encapsulateId: _propTypes2.default.string,
  topValue: _propTypes2.default.number
};

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _exenv2 = _interopRequireDefault(_exenv);

var _isNumber = __webpack_require__(224);

var _isNumber2 = _interopRequireDefault(_isNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class(playerTitle, type, adslot, readTime, pos) {
    _classCallCheck(this, _class);

    this.title = this.sanitizeTitle(playerTitle, type);
    this.adZoneSite = this.getSite();
    this.adZone = this.buildAdZone();
    this.adTag = this.buildAdURL(adslot, readTime, pos);
  }

  _createClass(_class, [{
    key: 'getParameterByName',
    value: function getParameterByName(name) {
      var paramName = name;
      var url = window.location.href;
      paramName = paramName.replace(/[[\]]/g, '\\$&');

      var regex = new RegExp('[?&]' + paramName + '(=([^&#]*)|&|#|$)');
      var results = regex.exec(url);

      if (!results) {
        return null;
      }
      if (!results[2]) {
        return '';
      }

      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  }, {
    key: 'buildAdURL',
    value: function buildAdURL(adslot, readTime, pos) {
      var adZoneParam = this.getParameterByName('adzone');
      var cmsValueParam = this.getParameterByName('cms');
      var CIDValueParam = this.getParameterByName('cid') || '0';
      var customParams = 'video_tags%3D__item-tags__%26vport%3D' + this.getViewport() + '%26video_id%3D__item-mediaid__';

      if (_exenv2.default) {
        // adzone override, add ?adzone=test to url to activate
        if (adZoneParam) {
          this.adZone = '/4160/mv.fc/' + adZoneParam;
        }

        // custom param override, add ?cms=test to url to activate
        if (cmsValueParam) {
          customParams = customParams + '%26cms%3D' + cmsValueParam;
        }

        if (CIDValueParam) {
          customParams = customParams + '%26CID%3D' + CIDValueParam;
        }
      }

      if (adslot) {
        customParams = customParams + '%26adslot%3D' + adslot;
      } else {
        customParams = customParams + '%26adslot%3Dpreroll_' + this.title;
      }

      if (readTime) {
        var readTimeSplit = readTime.split(' ')[0];
        var readTimeSanitized = (0, _isNumber2.default)(readTimeSplit) ? Number(readTimeSplit) : readTimeSplit;
        customParams = customParams + '%26artLength%3D' + readTimeSanitized;
      } else {
        customParams = customParams + '%26artLength%3DNA';
      }

      if (pos) {
        customParams = customParams + '%26pos%3D' + pos;
      }

      // prettier-ignore
      var tag = '' + ('//pubads.g.doubleclick.net/gampad/ads?' + 'sz=640x360' + '&impl=s' + '&gdfp_req=1' + '&env=vp' + '&output=vast' + '&unviewed_position_start=1' + '&vad_type=linear' + '&vpos=preroll' + '&correlator=') + Date.now() + '&iu=' + this.adZone
      // Custom Params:
      // TESTING:
      // }&cust_params=cms%3Ddfp_video_test` +
      // PRODUCTION:
      + '&cust_params=' + customParams;

      return tag;
    }
  }, {
    key: 'sanitizeTitle',
    value: function sanitizeTitle(title, type) {
      if (type) {
        return type;
      }
      switch (true) {
        case title.match(/Homepage/) !== null:
          return 'homepage';
        case title.match(/Infinite/) !== null:
          return 'infinitescroll';
        default:
          return 'homepage';
      }
    }
  }, {
    key: 'buildAdZone',
    value: function buildAdZone() {
      var adZoneArray = ['', '4160', this.adZoneSite, '__item-category__', '__item-series__', 'preroll_' + this.title];
      return adZoneArray.join('/');
    }
  }, {
    key: 'getSite',
    value: function getSite() {
      if (_exenv2.default) {
        var loc = window.location.href;
        switch (true) {
          case loc.match(/fastcompany/) !== null:
            return 'mv.fc';
          case loc.match(/fastcodesign/) !== null:
            return 'mv.fcdesign';
          default:
            return 'mv.fc';
        }
      }
      return 'mv.fc';
    }
  }, {
    key: 'getViewport',
    value: function getViewport() {
      if (_exenv2.default) {
        var w = window.innerWidth;

        if (w > 1023) {
          return 'l';
        }

        if (w < 640) {
          return 's';
        }

        return 'm';
      }
      return 'undefined';
    }
  }]);

  return _class;
}();

exports.default = _class;

/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addQuotes = addQuotes;
exports.default = deSlugify;
exports.capitalize = capitalize;
function addQuotes(text) {
  return '"' + text + '"';
}

function deSlugify(text) {
  if (text) {
    return text.replace(/-/g, '');
  }
  return '';
}

function capitalize(string) {
  return typeof string === 'string' ? '' + string.charAt(0).toUpperCase() + string.slice(1) : '';
}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _scriptjs = __webpack_require__(37);

var _scriptjs2 = _interopRequireDefault(_scriptjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var logglyLoaded = false;

// import $ from 'jquery';
// import circularJSON from 'circular-json';
/**
 * Send log request to site.
 * @param {string} level The log level.
 * @param {Object} data The log data.
 * @param {string} message The log message.
 * @private
 * @returns {Promise}
 */
function log(level) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var message = arguments[2];

  var jsonData = {};

  // if (data.message && data.stack) {
  //   return $.getScript('https://cdnjs.cloudflare.com/ajax/libs/stacktrace.js/1.3.1/stacktrace.min.js',
  //     () => {
  //       window.StackTrace.fromError(data)
  //         .then((dataWithStackTraces) => {
  //           jsonData.message = data.message;
  //           jsonData.stack = dataWithStackTraces;
  //           return axios({
  //             url: '/api/v1/log', // TODO: talk with team to make api absorb these logs?
  //             method: 'POST',
  //             dataType: 'json',
  //             data: {
  //               level,
  //               data: circularJSON.stringify(jsonData),
  //               message
  //             }
  //           });
  //         })
  //         .catch(function handleErrorGracefully(lerr) {
  //           // TODO: track in ga here
  // eslint-disable-next-line no-console
  //           console.error(lerr);
  //         });
  //     });
  // }

  (0, _extend2.default)(jsonData, data);
  if (!logglyLoaded) {
    return (0, _scriptjs2.default)('//cloudfront.loggly.com/js/loggly.tracker-2.1.min.js', function () {
      logglyLoaded = true;
    });
  }
  // eslint-disable-next-line no-underscore-dangle
  return window._LTracker.push({
    level: level,
    data: {
      message: jsonData.message,
      stack: jsonData.stack
    },
    message: message
  });
}

/**
 * Send log request to server side.
 * @typedef {function} logMethod
 * @param {Object|string} data The log data or message.
 * @param {string=} message The log message if the log data was specified.
 * @returns {Promise}
 */

/**
 * Methods: trace, debug, info, warn, error, fatal.
 *
 * See methods API: https://github.com/trentm/node-bunyan#log-method-api
 *
 * @example
 *   var log = require('./services/logger');
 *   log.error({ stack: err.stack }, 'Descriptive Error message' );
 *
 * @module services/logger
 */

var Logger = function () {
  function Logger() {
    _classCallCheck(this, Logger);

    (0, _extend2.default)(this, {
      /**
       * @name module:services/logger.trace
       * @type {logMethod}
       */
      trace: this.createLogFn('trace'),

      /**
       * @name module:services/logger.debug
       * @type {logMethod}
       */
      debug: this.createLogFn('debug'),

      /**
       * @name module:services/logger.info
       * @type {logMethod}
       */
      info: this.createLogFn('info'),

      /**
       * @name module:services/logger.warn
       * @type {logMethod}
       */
      warn: this.createLogFn('warn'),

      /**
       * @name module:services/logger.error
       * @type {logMethod}
       */
      error: this.createLogFn('error'),

      /**
       * @name module:services/logger.fatal
       * @type {logMethod}
       */
      fatal: this.createLogFn('fatal')
    });
  }

  /**
   * Factory to create log methods.
   * @param {string} level The log level method name.
   * @private
   * @returns {function}
   */


  _createClass(Logger, [{
    key: 'createLogFn',
    value: function createLogFn(level) {
      return function logFn(data, message) {
        if (!data && !message) {
          // console error if in development
          return false;
        }

        // TODO: clean up here
        var prodLog = level === 'trace' || level === 'debug' || level === 'info' || level === 'warn';

        if (this.env === 'production' && prodLog) {
          return false;
        }

        var currentInfo = {
          current_location: window.location.href
        };

        if (typeof data === 'string') {
          return log(level, (0, _extend2.default)({}, this.data, currentInfo), data);
        }

        if (this.env === 'development') {
          if (data.stack && data.message) {
            // eslint-disable-next-line no-console
            console.error(data);
          }
        }

        return log(level, (0, _extend2.default)(data, this.data, currentInfo), message);
      };
    }
  }, {
    key: 'initialize',
    value: function initialize(conf) {
      this.env = (0, _get2.default)(conf, 'config.env');
      this.data = (0, _extend2.default)({}, {
        site: (0, _get2.default)(conf, 'config.site'),
        userAgent: window.navigator.userAgent
      });
    }
  }]);

  return Logger;
}();

exports.default = new Logger();

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getQueryParameterByName;
exports.correctSubDomain = correctSubDomain;
exports.resolveHost = resolveHost;

var _exenv = __webpack_require__(4);

var _urlParse = __webpack_require__(50);

var _urlParse2 = _interopRequireDefault(_urlParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getQueryParameterByName(queryName) {
  if (_exenv.canUseDOM) {
    var name = queryName;
    // eslint-disable-next-line no-useless-escape
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(window.location.href);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  return null;
}

function correctSubDomain(url) {
  if (url && url.indexOf('https://www.') === -1 && typeof url === 'string') {
    return url.replace('https://', 'https://www.');
  }

  return url;
}

function resolveHost(url) {
  if (!url) {
    // todo: log error
    return '';
  }

  if (/\/wp.fastcompany.com\/fastcodesign/.test(url)) {
    return 'fastcodesign.com';
  }

  if (/\/wp.fastcompany.com\/fastcocreate/.test(url)) {
    return 'fastcocreate.com';
  }

  if (/\/wp.fastcompany.com\/fastcoexist/.test(url)) {
    return 'fastcoexist.com';
  }

  var _parse = (0, _urlParse2.default)(url, true),
      host = _parse.host;

  if (host === 'wp.fastcompany.com') {
    return 'fastcompany.com';
  }

  return host;
}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setModifierClass = setModifierClass;
exports.setElementClass = setElementClass;
exports.createPosterClasses = createPosterClasses;

var _advertorial = __webpack_require__(29);

function setModifierClass(condition, baseClass, modifier) {
  if (!condition || !baseClass || !modifier) return '';
  return baseClass + '--' + modifier;
}

function setElementClass(elementName, baseClass) {
  if (!elementName || !baseClass) return '';
  return elementName + '__' + baseClass;
}

function createPosterClasses(tags, events, className, hasVideoPoster) {
  var posterClass = 'poster';
  var advertorial = setModifierClass((0, _advertorial.isAdvertorial)(tags), posterClass, 'advertorial');
  var isEventCard = setModifierClass(events, posterClass, 'event-card');
  var hasClassName = setElementClass(className, posterClass);
  var requiresVideoOverlay = setModifierClass(hasVideoPoster, posterClass, 'video');
  var allClasses = [posterClass, advertorial, isEventCard, hasClassName, requiresVideoOverlay];

  return allClasses.filter(function (element) {
    return element;
  }).join(' ');
}

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(15);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _feature_feed = __webpack_require__(145);

var _feature_feed2 = _interopRequireDefault(_feature_feed);

var _ad = __webpack_require__(24);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(49);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _all_feed = __webpack_require__(141);

var _all_feed2 = _interopRequireDefault(_all_feed);

var _video_module = __webpack_require__(73);

var _video_module2 = _interopRequireDefault(_video_module);

var _magazine_archive = __webpack_require__(149);

var _magazine_archive2 = _interopRequireDefault(_magazine_archive);

var _slug = __webpack_require__(23);

var _slug2 = _interopRequireDefault(_slug);

var _franchise_showcase = __webpack_require__(534);

var _franchise_showcase2 = _interopRequireDefault(_franchise_showcase);

var _moreStoriesComponent = __webpack_require__(231);

var _moreStoriesComponent2 = _interopRequireDefault(_moreStoriesComponent);

var _async_is_all_feed_actions = __webpack_require__(536);

var _async_is_all_feed_actions2 = _interopRequireDefault(_async_is_all_feed_actions);

var _async_recirc_feed_actions = __webpack_require__(58);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var Homepage = function (_Component) {
  _inherits(Homepage, _Component);

  function Homepage() {
    _classCallCheck(this, Homepage);

    return _possibleConstructorReturn(this, (Homepage.__proto__ || Object.getPrototypeOf(Homepage)).apply(this, arguments));
  }

  _createClass(Homepage, [{
    key: 'mergeArchiveData',
    value: function mergeArchiveData() {
      var magazineLatestIssuePosts = this.props.magazineLatestIssuePosts;

      var currentIssue = (0, _get2.default)(magazineLatestIssuePosts, 'data.issue', {});
      var pastIssues = (0, _get2.default)(magazineLatestIssuePosts, 'data.magazineArchive', []);

      return [currentIssue].concat(_toConsumableArray(pastIssues.slice(0, 3)));
    }
  }, {
    key: 'render',
    value: function render() {
      var page = (0, _get2.default)(this.props, 'allFeed.page');
      var pageParam = (0, _get2.default)(this.props, 'match.params.page', false);
      var totalPages = (0, _get2.default)(this.props, 'allFeed.totalPages');
      var isLastPage = Number(page) >= totalPages;

      var _props = this.props,
          config = _props.config,
          homepageTag = _props.homepageTag;

      var tags = (0, _get2.default)(homepageTag, 'posts[0].tags') || [];

      if (this.props.homepage.error) {
        return _react2.default.createElement(
          'section',
          { className: 'homepage-page' },
          _react2.default.createElement(
            'article',
            { className: 'homepage-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.homepage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'homepage-page' },
          _react2.default.createElement(
            'article',
            { className: 'homepage-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var adData = (0, _get2.default)(this.props, 'homepage.ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      if (!pageParam && (0, _get2.default)(this.props, 'location.pathname') === '/') {
        return _react2.default.createElement(
          'section',
          { className: 'homepage-page' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true })),
          _react2.default.createElement(_feature_feed2.default, {
            featuredFeed: this.props.featuredFeed,
            promoBanner: this.props.promoBanner,
            scrollingModule: this.props.scrollingModule,
            combinedAdModel: combinedAdModel,
            page: 'homepage',
            featuredSponsoredCard: this.props.featuredSponsoredCard,
            config: config
          }),
          (0, _get2.default)(this.props, 'featuredFeed.top').length >= 2 ? _react2.default.createElement(
            'div',
            { className: 'homepage-page__ff-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_2' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
          ) : '',
          _react2.default.createElement(
            'section',
            { className: 'homepage-tag' },
            _react2.default.createElement(_moreStoriesComponent2.default, {
              metadata: (0, _get2.default)(this.props, 'homepageTag.posts'),
              slugData: (0, _get2.default)(this.props, 'homepageTag.tags[0]'),
              tags: tags,
              config: config
            })
          ),
          (0, _get2.default)(this.props, 'homepageTag.posts').length ? _react2.default.createElement(
            'div',
            { className: 'homepage-page__tag-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_4' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobileparallax_2' }))
          ) : '',
          _react2.default.createElement(_magazine_archive2.default, {
            magazines: this.mergeArchiveData(),
            eventCategory: 'Home Page',
            config: config
          }),
          _react2.default.createElement(_video_module2.default, {
            config: config,
            data: this.props.homepageVideo,
            playerid: '76APbejE',
            stories: this.props.homepageVideo.playlist
          }),
          (0, _get2.default)(this.props, 'homepageVideo.playlist').length ? _react2.default.createElement(
            'div',
            { className: 'homepage-page__video-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_3' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_2' }))
          ) : '',
          _react2.default.createElement(_franchise_showcase2.default, { config: config }),
          !(0, _get2.default)(this.props, 'homepageVideo.playlist').length ? _react2.default.createElement(
            'div',
            { className: 'homepage-page__video-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_3' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_2' }))
          ) : _react2.default.createElement(
            'div',
            { className: 'homepage-page__video-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_4' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_3' }))
          ),
          _react2.default.createElement(_all_feed2.default, {
            hasSlug: true,
            adModel: combinedAdModel,
            stories: (0, _get2.default)(this.props, 'allFeed.posts'),
            allRendered: (0, _get2.default)(this.props, 'allFeed.allRendered'),
            paginationEnabled: true,
            totalPages: totalPages,
            page: page,
            section: 'all',
            type: 'homepage',
            isLastPage: isLastPage,
            infiniteScrollEnabled: config.featureFlags.infiniteScrollAllFeed,
            infiniteScrollAllFeedFetch: this.props.allISFeedActions,
            infiniteScrollLoading: (0, _get2.default)(this.props, 'allFeed.isLoading'),
            config: config,
            hideRecircFeed: this.props.hideRecircFeed,
            mobileAdCount: [4, null, 5]
          }),
          (0, _get2.default)(this.props, 'allFeed.isLoading') && _react2.default.createElement(_loading_spinner2.default, null),
          this.props.allFeed.posts.length ? _react2.default.createElement(
            'div',
            { className: 'homepage-page__all-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_5' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_6' }))
          ) : ''
        );
      }
      return _react2.default.createElement(
        'section',
        { className: 'homepage-page' },
        _react2.default.createElement(
          'section',
          { className: 'page-title' },
          _react2.default.createElement(_slug2.default, { slugName: 'All Stories', className: 'all-page', linkTo: '/all' })
        ),
        _react2.default.createElement(_all_feed2.default, {
          config: config,
          hasSlug: false,
          adModel: combinedAdModel,
          stories: (0, _get2.default)(this.props, 'allFeed.posts'),
          allRendered: (0, _get2.default)(this.props, 'allFeed.allRendered'),
          paginationEnabled: true,
          page: page + 1,
          section: 'all',
          type: 'homepage',
          isLastPage: isLastPage
        }),
        this.props.allFeed.posts.length ? _react2.default.createElement(
          'div',
          { className: 'homepage-page__all-ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_5' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_4' }))
        ) : ''
      );
    }
  }]);

  return Homepage;
}(_react.Component);

function mapDispatchToProps(dispatch) {
  return {
    allISFeedActions: (0, _async_is_all_feed_actions2.default)(dispatch),
    hideRecircFeed: (0, _async_recirc_feed_actions.hideRecircAction)(dispatch)
  };
}

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config,
    scrollingModule: (0, _get2.default)(state, 'scrollingModule.data') || {},
    promoBanner: (0, _get2.default)(state, 'promoBanner.data') || {},
    featuredSponsoredCard: (0, _get2.default)(state, 'featuredSponsoredCard.data') || {},
    allFeed: {
      isLoading: (0, _get2.default)(state, 'allFeed.isLoading', false),
      allRendered: (0, _get2.default)(state, 'allFeed.allRendered', false),
      posts: (0, _get2.default)(state, 'allFeed.data.posts', []),
      page: (0, _get2.default)(state, 'allFeed.data.page'),
      totalPages: (0, _get2.default)(state, 'allFeed.data.totalPages')
    },
    homepageVideo: {
      playlist: (0, _get2.default)(state, 'homepageVideo.data.playlist', []),
      title: (0, _get2.default)(state, 'homepageVideo.data.title', ''),
      feedid: (0, _get2.default)(state, 'homepageVideo.data.feedid', '')
    },
    featuredFeed: {
      source: (0, _get2.default)(state, 'featuredFeed.data.source', ''),
      top: (0, _get2.default)(state, 'featuredFeed.data.top', []),
      featured: (0, _get2.default)(state, 'featuredFeed.data.featured', [])
    },
    homepageTag: {
      tags: (0, _get2.default)(state, 'homepageTag.data.tags', []),
      posts: (0, _get2.default)(state, 'homepageTag.data.posts', [])
    },
    homepage: state.homepage || {},
    magazineLatestIssuePosts: (0, _get2.default)(state, 'magazineLatestIssuePosts') || {}
  };
}

Homepage.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  homepage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    error: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  homepageVideo: _propTypes2.default.shape({
    playlist: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    feedid: _propTypes2.default.string,
    title: _propTypes2.default.string
  }).isRequired,
  homepageTag: _propTypes2.default.shape({
    tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
  }).isRequired,
  scrollingModule: _propTypes2.default.shape({}).isRequired,
  promoBanner: _propTypes2.default.shape({}).isRequired,
  featuredSponsoredCard: _propTypes2.default.shape({}).isRequired,
  allFeed: _propTypes2.default.shape({
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    allRendered: _propTypes2.default.bool
  }).isRequired,
  featuredFeed: _propTypes2.default.shape({
    source: _propTypes2.default.string,
    featured: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    top: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
  }).isRequired,
  allISFeedActions: _propTypes2.default.func.isRequired,
  hideRecircFeed: _propTypes2.default.func.isRequired,
  magazineLatestIssuePosts: _propTypes2.default.shape({}).isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Homepage);

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadParselyTracker;
exports.trainParselyProfile = trainParselyProfile;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _axios = __webpack_require__(44);

var _axios2 = _interopRequireDefault(_axios);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loadParselyTracker(currentState) {
  if (window.PARSELY && window.PARSELY.beacon) {
    // Sometimes multiple entries of same post appear on dashboard with weird query strings, this is to filter our all query strings.
    var url = window.location.href.split('?');
    url = (0, _get2.default)(url, '[0]', window.location.href);

    var navHistory = (0, _get2.default)(currentState, 'config.navHistory') || [];
    window.PARSELY.beacon.trackPageView({
      url: url,
      urlref: navHistory[navHistory.length - 1],
      js: 1
    });
  }
}

// Builds a profile of the user's recommendation list, doc https://www.parse.ly/help/api/recommendations/#get-related
function trainParselyProfile(url) {
  if (window.PARSELY && window.PARSELY.config) {
    var profileURL = url || window.location.href;
    var uuid = (0, _get2.default)(window, 'PARSELY.config.uuid');

    // Train user base on UUID and post
    _axios2.default.get('https://api.parsely.com/v2/profile?apikey=fastcompany.com&url=' + profileURL + '&uuid=' + uuid).catch(function (error) {
      _logger_service2.default.error('Parsely profile trainer error', error);
    });
  }
}

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _set = __webpack_require__(42);

var _set2 = _interopRequireDefault(_set);

var _exenv = __webpack_require__(4);

var _async_homepage_actions = __webpack_require__(540);

var _async_homepage_actions2 = _interopRequireDefault(_async_homepage_actions);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store, isAllIndex) {
  return function fetchData(nextState, replace, callback) {
    if (isAllIndex) {
      (0, _set2.default)(nextState.params, 'page', 1);
    }

    var dispatch = store.dispatch;
    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_homepage_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_homepage_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback();
      }
      return false;
    });
  };
}

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _withRouter = __webpack_require__(59);

var _withRouter2 = _interopRequireDefault(_withRouter);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(15);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _feature_feed = __webpack_require__(145);

var _feature_feed2 = _interopRequireDefault(_feature_feed);

var _ad = __webpack_require__(24);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(49);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _slug = __webpack_require__(23);

var _slug2 = _interopRequireDefault(_slug);

var _video_module = __webpack_require__(73);

var _video_module2 = _interopRequireDefault(_video_module);

var _all_feed = __webpack_require__(141);

var _all_feed2 = _interopRequireDefault(_all_feed);

var _category_all_feed_action_creators = __webpack_require__(236);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var Category = function (_Component) {
  _inherits(Category, _Component);

  function Category() {
    _classCallCheck(this, Category);

    return _possibleConstructorReturn(this, (Category.__proto__ || Object.getPrototypeOf(Category)).apply(this, arguments));
  }

  _createClass(Category, [{
    key: 'render',
    value: function render() {
      if (this.props.categoryPage.error || this.props.categoryFeaturedFeed.error || this.props.status === 404) {
        return _react2.default.createElement(
          'section',
          { className: 'category-page' },
          _react2.default.createElement(
            'article',
            { className: 'category-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.categoryPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'category-page' },
          _react2.default.createElement(
            'article',
            { className: 'category-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var adData = (0, _get2.default)(this.props, 'categoryPage.ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      var config = (0, _get2.default)(this.props, 'config');
      var tag = (0, _get2.default)(this.props, 'categoryAllFeed.tag.name');
      var category = (0, _get2.default)(this.props, 'categoryFeaturedFeed.category.name', '');
      var description = tag ? (0, _get2.default)(this.props, 'categoryAllFeed.tag.description') : (0, _get2.default)(this.props, 'categoryFeaturedFeed.category.description');
      var page = (0, _get2.default)(this.props, 'match.params.page', false);
      var totalPages = (0, _get2.default)(this.props, 'categoryAllFeed.totalPages');
      var hrefOverride = tag ? '/' + (0, _get2.default)(this.props, 'categoryFeaturedFeed.category.slug') + '/' + (0, _get2.default)(this.props, 'categoryAllFeed.tag.slug') + '/' : '';
      var type = tag ? 'category_tag' : 'category';
      var isLastPage = Number(page) === totalPages;

      if (!page) {
        if (totalPages === 1) {
          isLastPage = true;
        }
        return _react2.default.createElement(
          'section',
          { className: 'category-page' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true })),
          _react2.default.createElement(
            'section',
            { className: 'page-title' },
            _react2.default.createElement(_slug2.default, {
              slugName: tag ? category + ' : ' + tag : category,
              className: 'category-page'
            }),
            description ? _react2.default.createElement('h3', {
              className: 'page-description',
              dangerouslySetInnerHTML: { __html: description }
            }) : ''
          ),
          _react2.default.createElement(_feature_feed2.default, {
            config: config,
            featuredFeed: this.props.categoryFeaturedFeed,
            promoBanner: this.props.categoryPromoBanner,
            scrollingModule: this.props.categoryScrollingModule,
            combinedAdModel: combinedAdModel,
            page: 'category',
            featuredSponsoredCard: this.props.featuredSponsoredCard
          }),
          (0, _get2.default)(this.props, 'categoryFeaturedFeed.top').length >= 2 ? _react2.default.createElement(
            'div',
            { className: 'category-page__ff-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_2' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
          ) : '',
          _react2.default.createElement(_video_module2.default, {
            config: config,
            type: 'category',
            data: this.props.categoryVideo,
            playerid: 'HliaKwd3',
            stories: this.props.categoryVideo.playlist
          }),
          (0, _get2.default)(this.props, 'categoryVideo.playlist').length ? _react2.default.createElement(
            'div',
            { className: 'category-page__video-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_3' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_2' }))
          ) : '',
          _react2.default.createElement(_all_feed2.default, {
            config: config,
            adModel: combinedAdModel,
            stories: (0, _get2.default)(this.props, 'categoryAllFeed.posts'),
            allRendered: (0, _get2.default)(this.props, 'categoryAllFeed.allRendered'),
            updateAction: _category_all_feed_action_creators.categoryAllFeedAllStoriesRendered,
            paginationEnabled: true,
            page: Number((0, _get2.default)(this.props, 'match.params.page', '1')) + 1,
            section: category ? category.toLowerCase() : '',
            type: type,
            hrefOverride: hrefOverride,
            isLastPage: isLastPage,
            titleOverride: 'All ' + (tag ? category + ' : ' + tag : category) + ' Stories'
          }),
          this.props.categoryAllFeed.posts.length ? _react2.default.createElement(
            'div',
            { className: 'category-page__all-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_5' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobileparallax_2' }))
          ) : ''
        );
      }
      return _react2.default.createElement(
        'section',
        { className: 'category-page' },
        _react2.default.createElement(
          'section',
          { className: 'page-title page-title--paginated' },
          _react2.default.createElement(_slug2.default, {
            slugName: '' + (tag ? category + ' : ' + tag : category),
            className: 'category-page'
          }),
          description ? _react2.default.createElement(
            'h3',
            { className: 'page-description' },
            description
          ) : ''
        ),
        _react2.default.createElement(_all_feed2.default, {
          config: config,
          hasSlug: false,
          adModel: combinedAdModel,
          stories: (0, _get2.default)(this.props, 'categoryAllFeed.posts'),
          allRendered: (0, _get2.default)(this.props, 'categoryAllFeed.allRendered'),
          updateAction: _category_all_feed_action_creators.categoryAllFeedAllStoriesRendered,
          paginationEnabled: true,
          page: Number((0, _get2.default)(this.props, 'match.params.page', '1')) + 1,
          section: category.toLowerCase(),
          type: type,
          isLastPage: isLastPage,
          paginationPath: '' + category,
          hrefOverride: hrefOverride
        }),
        this.props.categoryAllFeed.posts.length ? _react2.default.createElement(
          'div',
          { className: 'category-page__all-ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_5' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobileparallax_2' }))
        ) : ''
      );
    }
  }]);

  return Category;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    categoryFeaturedFeed: {
      source: (0, _get2.default)(state, 'categoryFeaturedFeed.source', ''),
      featured: (0, _get2.default)(state, 'categoryFeaturedFeed.featured', []),
      top: (0, _get2.default)(state, 'categoryFeaturedFeed.top', []),
      category: (0, _get2.default)(state, 'categoryFeaturedFeed.category', {}),
      error: (0, _get2.default)(state, 'categoryFeaturedFeed.error', false)
    },
    categoryVideo: {
      playlist: (0, _get2.default)(state, 'categoryVideo.data.playlist', []),
      title: (0, _get2.default)(state, 'categoryVideo.data.title', ''),
      feedid: (0, _get2.default)(state, 'categoryVideo.data.feedid', '')
    },
    categoryPage: (0, _get2.default)(state, 'categoryPage', {}),
    categoryScrollingModule: (0, _get2.default)(state, 'categoryScrollingModule.data', {}),
    categoryPromoBanner: (0, _get2.default)(state, 'categoryPromoBanner.data', {}),
    featuredSponsoredCard: (0, _get2.default)(state, 'featuredSponsoredCard.data', {}),
    categoryAllFeed: {
      allRendered: (0, _get2.default)(state, 'categoryAllFeed.data.allRendered', false),
      posts: (0, _get2.default)(state, 'categoryAllFeed.data.posts', []),
      totalPages: (0, _get2.default)(state, 'categoryAllFeed.data.totalPages', 0),
      totalPosts: (0, _get2.default)(state, 'categoryAllFeed.data.totalPosts', 0),
      tag: (0, _get2.default)(state, 'categoryAllFeed.data.tag')
    }
  };
}

Category.propTypes = {
  status: _propTypes2.default.number.isRequired,
  categoryPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  categoryFeaturedFeed: _propTypes2.default.shape({
    source: _propTypes2.default.string,
    featured: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    top: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    category: _propTypes2.default.object,
    error: _propTypes2.default.bool
  }).isRequired,
  categoryVideo: _propTypes2.default.shape({
    playlist: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    feedid: _propTypes2.default.string,
    title: _propTypes2.default.string
  }).isRequired,
  categoryScrollingModule: _propTypes2.default.shape({}).isRequired,
  categoryPromoBanner: _propTypes2.default.shape({}).isRequired,
  featuredSponsoredCard: _propTypes2.default.shape({}).isRequired,
  categoryAllFeed: _propTypes2.default.shape({
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    allRendered: _propTypes2.default.bool,
    totalPages: _propTypes2.default.number,
    totalPosts: _propTypes2.default.number,
    tag: _propTypes2.default.shape({})
  }).isRequired
};

exports.default = (0, _withRouter2.default)((0, _reactRedux.connect)(mapStateToProps)(Category));

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  // Ad ops uses this to measure users w/o js
  adOpsIframe: false,
  // Currently only enabled on author pages
  infiniteScrollAllFeed: true,
  // Video Permalinks Pages /video/slug/id
  videoPagesEnabled: true,
  // Ad on top of nav, marketing team test
  topNavAdEnabled: false,
  // Omniture replacement, adops test
  gaCustomVarEnabled: true,
  // newletter preferences page
  newsletterPreferencesPageEnabled: true,
  // Revcontent raw js widget
  revContentJSWidgetEnabled: true,
  // Dianomi widget
  dianomiStoriesEnabled: false,
  // fbia
  fbiaEnabled: true,
  // personalized recommendations widget on post pages
  postPersonalizedRecommendationsEnabled: true,
  // Lift igniter
  liftIgniterEnabled: false,
  fastlyCloudinaryFetchEnabled: true,
  rightRailPlayer: true,
  pmxMetrics: true
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trackThirdPartyJS;

var _exenv = __webpack_require__(4);

var _ga = __webpack_require__(27);

var _ga2 = _interopRequireDefault(_ga);

var _facebook = __webpack_require__(603);

var _facebook2 = _interopRequireDefault(_facebook);

var _omniture = __webpack_require__(239);

var _omniture2 = _interopRequireDefault(_omniture);

var _comscore = __webpack_require__(240);

var _comscore2 = _interopRequireDefault(_comscore);

var _nielsen = __webpack_require__(604);

var _nielsen2 = _interopRequireDefault(_nielsen);

var _krux = __webpack_require__(605);

var _krux2 = _interopRequireDefault(_krux);

var _parsely = __webpack_require__(136);

var _parsely2 = _interopRequireDefault(_parsely);

var _liftIgniter = __webpack_require__(606);

var _liftIgniter2 = _interopRequireDefault(_liftIgniter);

var _feature_flags = __webpack_require__(139);

var _feature_flags2 = _interopRequireDefault(_feature_flags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The following trackers are executed on CLIENT SIDE ONLY
// Usually during single page app's "pageview" action
function trackThirdPartyJS(currentState, pageNumber) {
  if (_exenv.canUseDOM) {
    var trackers = [(0, _ga2.default)(currentState, pageNumber), (0, _facebook2.default)(currentState), (0, _omniture2.default)(currentState, pageNumber), (0, _comscore2.default)(currentState), (0, _nielsen2.default)(), (0, _krux2.default)(currentState), (0, _parsely2.default)(currentState)];

    if (_feature_flags2.default.liftIgniterEnabled) {
      trackers.push((0, _liftIgniter2.default)(currentState));
    }

    return Promise.all(trackers);
  }
  return Promise.resolve([]);
}

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStickynode = __webpack_require__(71);

var _reactStickynode2 = _interopRequireDefault(_reactStickynode);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _chunk = __webpack_require__(143);

var _chunk2 = _interopRequireDefault(_chunk);

var _isEmpty = __webpack_require__(34);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _debounce = __webpack_require__(117);

var _debounce2 = _interopRequireDefault(_debounce);

var _striptags = __webpack_require__(35);

var _striptags2 = _interopRequireDefault(_striptags);

var _card = __webpack_require__(36);

var _card2 = _interopRequireDefault(_card);

var _ad = __webpack_require__(24);

var _ad2 = _interopRequireDefault(_ad);

var _slug = __webpack_require__(23);

var _slug2 = _interopRequireDefault(_slug);

var _fc_link = __webpack_require__(21);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _get_site_from_uri_util = __webpack_require__(532);

var _get_site_from_uri_util2 = _interopRequireDefault(_get_site_from_uri_util);

var _client_util = __webpack_require__(40);

var _client_util2 = _interopRequireDefault(_client_util);

var _cloudinary_asset_util = __webpack_require__(25);

var _ga = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function noop() {}

var AllFeed = function (_Component) {
  _inherits(AllFeed, _Component);

  function AllFeed(props) {
    _classCallCheck(this, AllFeed);

    var _this = _possibleConstructorReturn(this, (AllFeed.__proto__ || Object.getPrototypeOf(AllFeed)).call(this, props));

    _this.renderMoreButton = _this.renderMoreButton.bind(_this);
    _this.enableInfiniteScroll = _this.enableInfiniteScroll.bind(_this);
    _this.handleScroll = (0, _debounce2.default)(_this.handleScroll.bind(_this), 100);
    return _this;
  }

  _createClass(AllFeed, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.isDesktop = (0, _client_util2.default)();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeEvents();
    }
  }, {
    key: 'getAllStories',
    value: function getAllStories() {
      var formattedStories = this.props.stories.map(function (post, i) {
        return (0, _assign2.default)(post, {
          site: (0, _get_site_from_uri_util2.default)((0, _get2.default)(post, 'link')),
          assetSizes: i === 0 ? _cloudinary_asset_util.imageSizesLookup.bigFirstMobile : _cloudinary_asset_util.imageSizesLookup[3],
          allowNoImage: true,
          excerpt: (0, _striptags2.default)(post.excerpt || '')
        });
      });

      if (this.props.allRendered || this.props.paginationEnabled || this.props.infiniteScrollEnabled) {
        return formattedStories;
      }

      return this.props.stories.length >= 10 ? formattedStories.slice(0, 10) : formattedStories;
    }
  }, {
    key: 'getSections',
    value: function getSections() {
      var sections = (0, _chunk2.default)(this.getAllStories(), 10);

      return sections.map(function (section, index) {
        return {
          id: 'section-' + (index + 1),
          stories: section
        };
      });
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'enableInfiniteScroll',
    value: function enableInfiniteScroll(e) {
      var _this2 = this;

      e.preventDefault();
      this.infiniteScrollInitialized = true;
      this.props.hideRecircFeed();
      this.props.infiniteScrollAllFeedFetch({
        page: this.props.page + 1,
        slug: this.props.section
      }, this.props.config).then(function () {
        window.addEventListener('scroll', _this2.handleScroll);
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      if (!this.props.infiniteScrollLoading) {
        if (this.props.totalPages < this.props.page) {
          return this.removeEvents();
        }
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 3000) {
          return this.props.infiniteScrollAllFeedFetch({
            page: this.props.page + 1,
            slug: this.props.section
          }, this.props.config);
        }
      }
      return false;
    }
  }, {
    key: 'renderMoreButton',
    value: function renderMoreButton(index, allFeedLength, isLastSection, isLastPage, config) {
      if (this.props.infiniteScrollEnabled) {
        if (this.infiniteScrollInitialized) {
          return null;
        }

        if (this.props.totalPages === 1 || this.props.infiniteScrollLoading && !isLastSection) {
          return null;
        }

        if (isLastSection) {
          var page = this.props.page + 1;
          var href = this.props.type === 'homepage' ? '/all/' + page : '/' + this.props.type + '/' + this.props.section + '/' + page;

          if (this.props.hrefOverride) {
            href = '' + this.props.hrefOverride + page;
          }
          return _react2.default.createElement(
            'a',
            {
              title: 'See More ' + this.props.section + ' on page ' + this.props.page,
              href: href,
              className: 'all-feed__more'
            },
            _react2.default.createElement(
              'button',
              { onClick: this.enableInfiniteScroll },
              'See More Stories'
            )
          );
        }
      }

      if (this.props.paginationEnabled) {
        if (isLastPage) {
          return null;
        }
        if (isLastSection) {
          var _page = this.props.page;

          var _href = this.props.type === 'homepage' ? '/all/' + _page : '/' + this.props.type + '/' + this.props.section + '/' + _page;

          if (this.props.hrefOverride) {
            _href = '' + this.props.hrefOverride + _page;
          }
          return _react2.default.createElement(
            'div',
            {
              className: 'all-feed__button all-feed__button--' + (0, _get2.default)(config, 'site', '') + ' ' + (this.props.mobileSeeMoreHidden ? 'all-feed__button--mobile-hidden' : '')
            },
            _react2.default.createElement(
              _fc_link2.default,
              {
                title: 'See More ' + this.props.section + ' on page ' + (this.props.page + 1),
                to: _href,
                config: config
              },
              _react2.default.createElement(
                'button',
                null,
                'See More Stories'
              )
            )
          );
        }
        return null;
      }

      if (index !== 1 || this.props.allRendered || this.props.disableMore) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        {
          className: 'all-feed__button all-feed__button--' + (0, _get2.default)(config, 'site', '') + ' ' + (this.props.mobileSeeMoreHidden ? 'all-feed__button--mobile-hidden' : '')
        },
        _react2.default.createElement(
          'button',
          { onClick: this.props.setAllLoadedState },
          'See More Stories'
        )
      );
    }
  }, {
    key: 'renderMobileAd',
    value: function renderMobileAd(index) {
      if (index === 1) {
        return null;
      }
      // WARNING: This is a hack. mobilerectangle needs to be suffixed with
      // a dynamic count on the index page. we pass an array of suffixes that
      // reflect that count that mirrors the index in this scope. So since we
      // we return null for index of 1, we provide an array as an argument that
      // looks like [4, null, 5]. If not argument is provided, we just render
      // mobilerectangle with no suffix`
      var adCount = this.props.mobileAdCount[index];
      var adSuffix = adCount ? '_' + adCount : '';
      return _react2.default.createElement(
        'div',
        { className: 'all-feed__mobile-ad-container' },
        _react2.default.createElement(_ad2.default, _extends({}, this.props.adModel, { name: 'mobilerectangle' + adSuffix }))
      );
    }
  }, {
    key: 'renderSlugOrName',
    value: function renderSlugOrName(props) {
      if (!props || !props.hasSlug) {
        return null;
      }

      if (props.authorPage) {
        if ((0, _isEmpty2.default)(props.author)) return '';

        return _react2.default.createElement(
          'h2',
          { className: 'author-page__all-feed-title' },
          'Stories by ' + (0, _get2.default)(props.author, 'name'),
          _react2.default.createElement(
            'span',
            { className: 'author-page__all-feed-title-rss' },
            _react2.default.createElement(
              'a',
              { href: '/user/' + (0, _get2.default)(props.author, 'slug') + '/rss' },
              'RSS'
            )
          )
        );
      }

      if (!(0, _isEmpty2.default)(props.advertorialSlugs)) {
        return _react2.default.createElement(_slug2.default, {
          slugName: (0, _get2.default)(props.advertorialSlugs, 'name'),
          className: 'tag-page',
          advertorial: true
        });
      }

      var archives = {};
      if (props.titleOverride.indexOf('Magazine') > -1) {
        archives = {
          name: 'See Archives',
          url: '/magazine/archive'
        };
      }

      return _react2.default.createElement(_slug2.default, {
        linkTo: '//www.fastcompany.com',
        slugName: (0, _get2.default)(props, 'titleOverride') || 'All Stories',
        archives: archives
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          config = _props.config,
          advertorialSlugs = _props.advertorialSlugs,
          authorPage = _props.authorPage,
          author = _props.author,
          hasSlug = _props.hasSlug,
          titleOverride = _props.titleOverride,
          isLastPage = _props.isLastPage;
      var modifier = this.props.modifier;


      if (!modifier && !hasSlug) {
        modifier = 'no-slug';
      }

      var fullPageAdvertorial = modifier === 'advertorial';

      var allFeedLength = (0, _get2.default)(this.props, 'stories', []).length;

      return _react2.default.createElement(
        'section',
        { className: 'all-feed' },
        this.renderSlugOrName({
          advertorialSlugs: advertorialSlugs,
          authorPage: authorPage,
          author: author,
          hasSlug: hasSlug,
          titleOverride: titleOverride
        }),
        _react2.default.createElement(
          'div',
          {
            className: 'all-feed__wrapper ' + (modifier ? 'all-feed__wrapper--' + modifier : '')
          },
          this.getSections().map(function (section, sectionIndex) {
            var isLastSection = _this3.getSections().length === sectionIndex + 1;
            var adCounter = sectionIndex + 1 > 10 ? 10 : sectionIndex + 1;

            return _react2.default.createElement(
              'div',
              { key: section.id, className: 'all-feed__section' },
              _react2.default.createElement(
                'div',
                { className: 'all-feed__posts' },
                section.stories.map(function (story, cardIndex) {
                  return _react2.default.createElement(_card2.default, {
                    type: 'all-feed',
                    key: story.id || story.mediaid,
                    metadata: story,
                    config: config,
                    hasExcerpt: story.layout === 'long',
                    fullPageAdvertorial: fullPageAdvertorial,
                    top: sectionIndex === 0 && cardIndex === 0,
                    cardEvent: function cardEvent() {
                      (0, _ga.trackGAEvent)({
                        eventCategory: 'Engagement',
                        eventAction: 'AllFeed:Pos-' + (cardIndex + 1),
                        eventLabel: (0, _get2.default)(story, 'link')
                      });
                    }
                  });
                }),
                _this3.renderMobileAd(sectionIndex),
                _this3.renderMoreButton(sectionIndex, allFeedLength, isLastSection, isLastPage, config)
              ),
              _react2.default.createElement(
                'div',
                { className: 'all-feed__sidebar' },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'all-feed__promotion',
                    id: 'sidebar-ad-' + sectionIndex
                  },
                  _react2.default.createElement(
                    _reactStickynode2.default,
                    {
                      top: 100,
                      bottomBoundary: '#sidebar-ad-' + sectionIndex,
                      enabled: _this3.isDesktop
                    },
                    _react2.default.createElement(_ad2.default, _extends({}, _this3.props.adModel, {
                      name: 'flexiblehalfpage_' + adCounter
                    }))
                  )
                )
              )
            );
          })
        )
      );
    }
  }]);

  return AllFeed;
}(_react.Component);

AllFeed.defaultProps = {
  stories: [],
  allRendered: false,
  modifier: '',
  mobileSeeMoreHidden: false,
  advertorialSlugs: {},
  authorPage: false,
  author: {},
  hasSlug: true,
  disableMore: false,
  titleOverride: '',
  paginationEnabled: false,
  totalPages: 0,
  page: 0,
  section: '',
  type: '',
  isLastPage: false,
  infiniteScrollEnabled: false,
  infiniteScrollAllFeedFetch: noop,
  hideRecircFeed: noop,
  setAllLoadedState: noop,
  infiniteScrollLoading: false,
  hrefOverride: '',
  mobileAdCount: []
};

AllFeed.propTypes = {
  stories: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  adModel: _propTypes2.default.shape({}).isRequired,
  allRendered: _propTypes2.default.bool,
  setAllLoadedState: _propTypes2.default.func,
  modifier: _propTypes2.default.string,
  mobileSeeMoreHidden: _propTypes2.default.bool,
  advertorialSlugs: _propTypes2.default.shape({}),
  authorPage: _propTypes2.default.bool,
  author: _propTypes2.default.shape({}),
  hasSlug: _propTypes2.default.bool,
  disableMore: _propTypes2.default.bool,
  titleOverride: _propTypes2.default.string,
  paginationEnabled: _propTypes2.default.bool,
  type: _propTypes2.default.string,
  section: _propTypes2.default.string,
  page: _propTypes2.default.number,
  totalPages: _propTypes2.default.number,
  isLastPage: _propTypes2.default.bool,
  infiniteScrollLoading: _propTypes2.default.bool,
  infiniteScrollEnabled: _propTypes2.default.bool,
  infiniteScrollAllFeedFetch: _propTypes2.default.func,
  hideRecircFeed: _propTypes2.default.func,
  config: _propTypes2.default.shape({}).isRequired,
  hrefOverride: _propTypes2.default.string,
  mobileAdCount: _propTypes2.default.arrayOf(_propTypes2.default.number)
};

exports.default = AllFeed;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollToEl;

var _exenv = __webpack_require__(4);

function scrollLoop(element, duration, navHeight) {
  if (duration <= 0) return;

  var difference = element.offsetTop - document.body.scrollTop - navHeight;
  var perTick = difference / duration * 10;

  setTimeout(function () {
    // eslint-disable-next-line no-param-reassign
    document.body.scrollTop += perTick;
    return scrollLoop(element, duration - 10, navHeight);
  }, 10);
}

function scrollToEl(querySelector, duration) {
  if (_exenv.canUseDOM && querySelector && duration && duration > 0) {
    var el = document.querySelector(querySelector + ':not(.scrolled)');
    var navHeight = window.innerWidth > 640 ? 90 : 0;
    if (el) {
      scrollLoop(el, duration, navHeight);
      el.classList.add('scrolled');
    }
  }
}

/***/ }),
/* 143 */,
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _featured_sponsored_card_action_creators = __webpack_require__(559);

var featuredSponsoredCardActions = _interopRequireWildcard(_featured_sponsored_card_action_creators);

var _featured_sponsored_card_module = __webpack_require__(560);

var _featured_sponsored_card_module2 = _interopRequireDefault(_featured_sponsored_card_module);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store, isTag) {
  return function firstDispatch(dispatch) {
    dispatch(featuredSponsoredCardActions.featuredSponsoredCardLoading({}, store));
    return _featured_sponsored_card_module2.default.fetch(params, store, isTag).then(function handlePostDetailData(resp) {
      dispatch(featuredSponsoredCardActions.featuredSponsoredCardLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(featuredSponsoredCardActions.featuredSponsoredCardLoadError(err, store));
      _logger_service2.default.error(err, 'Error in featured sponsored card actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = FeatureFeed;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(34);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _cloudinary_asset_util = __webpack_require__(25);

var _format_post_object = __webpack_require__(251);

var _format_post_object2 = _interopRequireDefault(_format_post_object);

var _ad = __webpack_require__(24);

var _ad2 = _interopRequireDefault(_ad);

var _card = __webpack_require__(36);

var _card2 = _interopRequireDefault(_card);

var _scroll = __webpack_require__(528);

var _scroll2 = _interopRequireDefault(_scroll);

var _social = __webpack_require__(94);

var _social2 = _interopRequireDefault(_social);

var _newsletterSignup = __webpack_require__(230);

var _newsletterSignup2 = _interopRequireDefault(_newsletterSignup);

var _ga = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildActiveSponsoredCardDataObject(props) {
  var featuredSponsoredCard = (0, _get2.default)(props, 'featuredSponsoredCard');
  var cardMetadata = (0, _get2.default)(props, 'featuredSponsoredCard.meta');
  var featuredSponsoredCardType = (0, _get2.default)(featuredSponsoredCard, 'type');
  if (!featuredSponsoredCard || !cardMetadata) {
    return [{
      newsletter: true,
      poster: 'https://images.fastcompany.net/image/upload/v1488227009/fcweb/fj7ll7zhfiwfdlhgpe5g.png',
      noLazy: true
    }];
  }

  var parsedCardMetadata = JSON.parse(cardMetadata);
  var featuredSponsoredCardData = {
    Event: function Event() {
      return [{
        id: '12345',
        topic: 'Events',
        title: (0, _get2.default)(parsedCardMetadata, 'title'),
        link: (0, _get2.default)(parsedCardMetadata, 'link'),
        featured_image: {
          source: (0, _get2.default)(parsedCardMetadata, 'image')
        },
        external: true,
        currentSite: (0, _get2.default)(props, 'config.site'),
        events: true,
        customEyebrowText: (0, _get2.default)(parsedCardMetadata, 'eyebrow'),
        buttonText: (0, _get2.default)(parsedCardMetadata, 'buttonText'),
        assetSizes: _cloudinary_asset_util.imageSizesLookup.bigFirstMobile,
        noLazy: true
      }];
    },

    'Sponsored Story': function sponsoredStory() {
      return [{
        id: '12345',
        categories: [{
          name: 'Sponsored Content'
        }],
        title: (0, _get2.default)(parsedCardMetadata, 'title'),
        link: (0, _get2.default)(parsedCardMetadata, 'link'),
        featured_image: {
          source: (0, _get2.default)(parsedCardMetadata, 'image')
        },
        currentSite: (0, _get2.default)(props, 'config.site'),
        tags: [{ name: 'advertorial', slug: 'advertorial' }],
        events: false,
        assetSizes: _cloudinary_asset_util.imageSizesLookup.bigFirstMobile,
        noLazy: true,
        sponsored: true,
        external: true
      }];
    },
    'Email Signup': function emailSignup() {
      return [{
        newsletter: true,
        title: (0, _get2.default)(parsedCardMetadata, 'title'),
        deck: (0, _get2.default)(parsedCardMetadata, 'deck'),
        poster: (0, _get2.default)(parsedCardMetadata, 'image'),
        noLazy: true
      }];
    },
    'Franchise Promo': function franchisePromo() {
      return [{
        title: (0, _get2.default)(parsedCardMetadata, 'title'),
        deck: (0, _get2.default)(parsedCardMetadata, 'deck'),
        poster: (0, _get2.default)(parsedCardMetadata, 'image'),
        noLazy: true
      }];
    }
  };
  // figure out which card type it is, and send relevant metadata
  return featuredSponsoredCardData[featuredSponsoredCardType]();
}

function getFeaturedStory(props, post) {
  return (0, _format_post_object2.default)({
    props: props,
    post: post,
    imgSize: _cloudinary_asset_util.imageSizesLookup[1],
    allowTextOnly: true
  });
}

function getScrollingModule(props, scrollingModule) {
  var scrollingModuleTag = (0, _get2.default)(scrollingModule, 'tag', null);
  var newsStories = (0, _get2.default)(scrollingModule, 'posts', []).map(function (post) {
    return (0, _format_post_object2.default)({
      props: props,
      post: post,
      imgSize: _cloudinary_asset_util.imageSizesLookup.column,
      allowNoImage: true,
      deck: false
    });
  });
  var newsFeed = newsStories.length ? { stories: newsStories, tag: scrollingModuleTag } : null;

  return newsFeed;
}

function renderSponsoredCard(props) {
  var item = buildActiveSponsoredCardDataObject(props)[0];

  if (!item.newsletter) {
    return _react2.default.createElement(_card2.default, {
      metadata: item,
      config: (0, _get2.default)(props, 'config'),
      cardEvent: function cardEvent() {
        (0, _ga.trackGAEvent)({
          eventCategory: 'Engagement',
          eventAction: 'FeaturedFeed:Pos-4:sponsored',
          eventLabel: (0, _get2.default)(item, 'link')
        });
      }
    });
  }

  return _react2.default.createElement(
    'div',
    { className: 'card card--default' },
    _react2.default.createElement(_newsletterSignup2.default, {
      hideCheckBox: true,
      modifier: 'homepage',
      title: item.title || '',
      deck: item.deck || '',
      poster: item.poster || 'https://fast-company-res.cloudinary.com/image/upload/v1488227009/fcweb/fj7ll7zhfiwfdlhgpe5g.png',
      newsletters: [{ list: 'fastcompany', default: true }]
    })
  );
}

function FeatureFeed(props) {
  var featuredFeed = props.featuredFeed,
      scrollingModule = props.scrollingModule,
      social = props.social,
      config = props.config;

  var featured = (0, _get2.default)(featuredFeed, 'featured[0]', {});
  var topStories = (0, _get2.default)(featuredFeed, 'top', []);
  var totalTopStories = topStories.length;
  var hasSocial = !(0, _isEmpty2.default)(social) && 'row--social';
  var featuredStory = getFeaturedStory(props, featured);

  return _react2.default.createElement(
    'section',
    { className: 'featured-feed featured-feed--' + props.page },
    _react2.default.createElement(
      'div',
      { className: 'row ' + hasSocial },
      hasSocial ? _react2.default.createElement(_social2.default, social) : '',
      _react2.default.createElement(_card2.default, {
        type: 'featured',
        metadata: featuredStory,
        config: config,
        cardEvent: function cardEvent() {
          (0, _ga.trackGAEvent)({
            eventCategory: 'Engagement',
            eventAction: 'FeaturedFeed:Pos-1',
            eventLabel: (0, _get2.default)(featuredStory, 'link')
          });
        }
      }),
      _react2.default.createElement(_scroll2.default, {
        config: config,
        metadata: getScrollingModule(props, scrollingModule),
        promoBanner: props.promoBanner,
        className: 'news-column'
      })
    ),
    (0, _get2.default)(props, 'featuredFeed.featured').length ? _react2.default.createElement(
      'div',
      { className: props.page + '-page__ff-ad-container' },
      _react2.default.createElement(_ad2.default, _extends({}, props.combinedAdModel, {
        noLazyLoad: true,
        pos: 'atf',
        name: 'flexiblebillboard_1'
      })),
      _react2.default.createElement(_ad2.default, _extends({}, props.combinedAdModel, {
        noLazyLoad: true,
        pos: 'atf',
        name: 'mobileparallax_1'
      }))
    ) : '',
    totalTopStories >= 2 ? _react2.default.createElement(
      'div',
      { className: 'row' },
      topStories.slice(0, 2).map(function (post, i, arr) {
        return _react2.default.createElement(_card2.default, {
          key: post.id,
          metadata: (0, _format_post_object2.default)({
            props: props,
            post: post,
            imgSize: _cloudinary_asset_util.imageSizesLookup[arr.length + 1],
            allowTextOnly: true
          }),
          config: config,
          totalCards: arr.length + 1,
          cardEvent: function cardEvent() {
            (0, _ga.trackGAEvent)({
              eventCategory: 'Engagement',
              eventAction: 'FeaturedFeed:Pos-' + (i + 2),
              eventLabel: (0, _get2.default)(post, 'link')
            });
          }
        });
      }),
      renderSponsoredCard(props)
    ) : null,
    totalTopStories >= 4 ? _react2.default.createElement(
      'div',
      { className: 'row' },
      topStories.slice(2, 4).map(function (post, i, arr) {
        return _react2.default.createElement(_card2.default, {
          key: post.id,
          metadata: (0, _format_post_object2.default)({
            props: props,
            post: post,
            imgSize: _cloudinary_asset_util.imageSizesLookup[arr.length],
            allowTextOnly: true
          }),
          config: config,
          totalCards: arr.length,
          cardEvent: function cardEvent() {
            (0, _ga.trackGAEvent)({
              eventCategory: 'Engagement',
              eventAction: 'FeaturedFeed:Pos-' + (i + 5),
              eventLabel: (0, _get2.default)(post, 'link')
            });
          }
        });
      })
    ) : null
  );
}

FeatureFeed.defaultProps = {
  isPromoting: false,
  social: {},
  promoBanner: {}
};

FeatureFeed.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  featuredFeed: _propTypes2.default.shape({
    source: _propTypes2.default.string,
    featured: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    top: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
  }).isRequired,
  scrollingModule: _propTypes2.default.shape({}).isRequired,
  combinedAdModel: _propTypes2.default.shape({}).isRequired,
  page: _propTypes2.default.string.isRequired,
  promoBanner: _propTypes2.default.shape({}),
  social: _propTypes2.default.shape({})
};

/***/ }),
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _slug = __webpack_require__(23);

var _slug2 = _interopRequireDefault(_slug);

var _card = __webpack_require__(36);

var _card2 = _interopRequireDefault(_card);

var _ga = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MagazineArchive = function (_Component) {
  _inherits(MagazineArchive, _Component);

  function MagazineArchive(props) {
    _classCallCheck(this, MagazineArchive);

    var _this = _possibleConstructorReturn(this, (MagazineArchive.__proto__ || Object.getPrototypeOf(MagazineArchive)).call(this, props));

    _this.totalMagazines = (0, _get2.default)(props, 'magazines.length', 0);
    _this.state = {
      limit: props.limit
    };

    _this.showAllMagazines = _this.showAllMagazines.bind(_this);
    return _this;
  }

  _createClass(MagazineArchive, [{
    key: 'showAllMagazines',
    value: function showAllMagazines() {
      this.setState({
        limit: this.totalMagazines
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          config = _props.config,
          title = _props.title,
          description = _props.description,
          eventCategory = _props.eventCategory;

      var magazines = (0, _get2.default)(this.props, 'magazines', []);

      return _react2.default.createElement(
        'div',
        { className: 'magazine-archive' },
        _react2.default.createElement(_slug2.default, { slugName: title, linkTo: 'https://www.fastcompany.com/magazine' }),
        _react2.default.createElement(
          'h3',
          { className: 'page-description' },
          description
        ),
        _react2.default.createElement(
          'div',
          { className: 'row row--magazine' },
          magazines.slice(0, this.state.limit).map(function (issue) {
            if (!issue) {
              return null;
            }

            return _react2.default.createElement(_card2.default, {
              config: config,
              key: issue.issue,
              type: 'magazine',
              metadata: issue,
              cardEvent: function cardEvent() {
                if (eventCategory) {
                  (0, _ga.trackGAEvent)({
                    eventCategory: eventCategory,
                    eventAction: 'Magazine',
                    eventLabel: 'Issue ' + issue.issue
                  });
                }
              }
            });
          })
        ),
        this.state.limit !== this.totalMagazines ? _react2.default.createElement(
          'div',
          { className: 'magazine-archive__see-more' },
          _react2.default.createElement(
            'button',
            {
              className: 'magazine-archive__button',
              onClick: this.showAllMagazines
            },
            'See More Magazine Issues'
          )
        ) : null
      );
    }
  }]);

  return MagazineArchive;
}(_react.Component);

exports.default = MagazineArchive;


MagazineArchive.defaultProps = {
  title: 'Fast Company Magazine',
  description: 'Browse Our Most Current Issues',
  eventCategory: '',
  limit: 4
};

MagazineArchive.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  title: _propTypes2.default.string,
  description: _propTypes2.default.string,
  eventCategory: _propTypes2.default.string,
  // eslint-disable-next-line react/no-unused-prop-types
  magazines: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  limit: _propTypes2.default.number
};

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _exenv = __webpack_require__(4);

var _ad = __webpack_require__(24);

var _ad2 = _interopRequireDefault(_ad);

var _body = __webpack_require__(584);

var _body2 = _interopRequireDefault(_body);

var _sidebar = __webpack_require__(253);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _advertorial = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PostsContainer = function (_Component) {
  _inherits(PostsContainer, _Component);

  function PostsContainer() {
    _classCallCheck(this, PostsContainer);

    return _possibleConstructorReturn(this, (PostsContainer.__proto__ || Object.getPrototypeOf(PostsContainer)).apply(this, arguments));
  }

  _createClass(PostsContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.updateCorrelator && _exenv.canUseDOM && window.googletag) {
        window.googletag.pubads().updateCorrelator();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.rendered = true;

      this.renderTrackers();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      var props = this.props,
          rendered = this.rendered;
      // initialPageLoad is needed for the first post to enable sticky ads.

      var isInitLoad = props.config.initialPageLoad;

      return !rendered || isInitLoad;
    }
  }, {
    key: 'setWrapperClasses',
    value: function setWrapperClasses(advertorial) {
      var classNames = ['post__wrapper'];

      if (advertorial) {
        classNames.push('post__wrapper--advertorial');
      }

      return classNames.join(' ');
    }
  }, {
    key: 'renderPostBody',
    value: function renderPostBody(post, index, advertorial, related) {
      var _props = this.props,
          posts = _props.posts,
          config = _props.config,
          isDesktop = _props.isDesktop,
          isFirstPost = _props.isFirstPost,
          videoAdData = _props.videoAdData,
          combinedAdModel = _props.combinedAdModel,
          pageNum = _props.pageNum,
          live = _props.live;

      var totalPosts = posts.length;
      var hasNewsletter = true;
      var isLongPost = post.layout === 'long';
      var isVideoPost = false;

      if (totalPosts > 1) {
        hasNewsletter = isFirstPost && index === totalPosts - 1;
      }

      if (config.featureFlags.videoPagesEnabled) {
        isVideoPost = post.layout === 'video';
        if (isVideoPost) {
          hasNewsletter = false;
        }
      }

      return _react2.default.createElement(_body2.default, {
        key: post.id,
        post: post,
        advertorial: advertorial,
        combinedAdModel: combinedAdModel,
        isFirstPost: isFirstPost,
        config: config,
        isDesktop: isDesktop,
        videoAdData: videoAdData,
        pageNum: pageNum,
        isLongPost: isLongPost,
        isVideoPost: isVideoPost,
        hasNewsletter: hasNewsletter,
        related: related,
        live: live
      });
    }
  }, {
    key: 'renderTrackers',
    value: function renderTrackers() {
      var posts = this.props.posts;

      var postId = (0, _get2.default)(posts, '[0].id', 0);

      if (postId === 40504669 || postId === 40537786) {
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = !0;
        s.src = 'https://adserver.pressboard.ca/v3/embedder?media=134218';
        var d = document.getElementsByTagName('script')[0];
        d.parentNode.insertBefore(s, d);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          config = _props2.config,
          posts = _props2.posts,
          related = _props2.related,
          isDesktop = _props2.isDesktop,
          isFirstPost = _props2.isFirstPost,
          combinedAdModel = _props2.combinedAdModel,
          pageNum = _props2.pageNum;

      var firstPost = (0, _get2.default)(posts, '[0]');
      var tags = (0, _get2.default)(firstPost, 'tags');
      var advertorial = (0, _advertorial.isAdvertorial)(tags);
      var readTime = (0, _get2.default)(firstPost, 'readTime');

      var adName = isFirstPost ? 'flexiblepushdown' : 'flexiblebillboard';
      var isLongPost = firstPost.layout === 'long';

      var isVideoPost = false;
      if (!firstPost) return null;

      if (config.featureFlags.videoPagesEnabled) {
        isVideoPost = (0, _get2.default)(firstPost, 'layout', false) === 'video';
      }

      return _react2.default.createElement(
        'div',
        { className: this.setWrapperClasses(advertorial) },
        _react2.default.createElement(
          'div',
          { className: 'post__article-top-ad-wrapper' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
            name: adName,
            region: 'articletop',
            pageNum: pageNum,
            readTime: readTime
          })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
            name: 'mobileleaderboard',
            region: 'articletop',
            pageNum: pageNum,
            readTime: readTime
          })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
            name: 'oop',
            slug: false,
            oop: true,
            pageNum: pageNum,
            readTime: readTime
          }))
        ),
        _react2.default.createElement(
          'div',
          { className: 'post ' + (isVideoPost ? 'post--video' : '') },
          _react2.default.createElement(
            'div',
            { className: 'post__main' },
            posts.map(function (post, index) {
              return _this2.renderPostBody(post, index, advertorial, related);
            })
          ),
          _react2.default.createElement(_sidebar2.default, {
            config: config,
            post: firstPost,
            related: related,
            isFirstPost: isFirstPost,
            combinedAdModel: combinedAdModel,
            isDesktop: isDesktop,
            pageNum: pageNum,
            fullPageAdvertorial: advertorial,
            isLongPost: isLongPost,
            isVideoPost: isVideoPost
          })
        )
      );
    }
  }]);

  return PostsContainer;
}(_react.Component);

exports.default = PostsContainer;


PostsContainer.defaultProps = {
  isDesktop: false,
  isFirstPost: false,
  related: [],
  updateCorrelator: false,
  live: false
};

PostsContainer.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  related: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  combinedAdModel: _propTypes2.default.shape({}).isRequired,
  isDesktop: _propTypes2.default.bool,
  isFirstPost: _propTypes2.default.bool,
  videoAdData: _propTypes2.default.shape({}).isRequired,
  pageNum: _propTypes2.default.number.isRequired,
  updateCorrelator: _propTypes2.default.bool,
  live: _propTypes2.default.bool
};

/***/ }),
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getRoutesWithStore;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _web_layout = __webpack_require__(489);

var _web_layout2 = _interopRequireDefault(_web_layout);

var _homepage_route = __webpack_require__(527);

var _homepage_route2 = _interopRequireDefault(_homepage_route);

var _homepage_all_route = __webpack_require__(561);

var _homepage_all_route2 = _interopRequireDefault(_homepage_all_route);

var _homepage_all_index_route = __webpack_require__(562);

var _homepage_all_index_route2 = _interopRequireDefault(_homepage_all_index_route);

var _author_route = __webpack_require__(563);

var _author_route2 = _interopRequireDefault(_author_route);

var _category_route = __webpack_require__(564);

var _category_route2 = _interopRequireDefault(_category_route);

var _category_paginated_route = __webpack_require__(581);

var _category_paginated_route2 = _interopRequireDefault(_category_paginated_route);

var _news_category_route = __webpack_require__(582);

var _news_category_route2 = _interopRequireDefault(_news_category_route);

var _magazine_category_route = __webpack_require__(607);

var _magazine_category_route2 = _interopRequireDefault(_magazine_category_route);

var _community_route = __webpack_require__(609);

var _community_route2 = _interopRequireDefault(_community_route);

var _html_sitemap_index_route = __webpack_require__(610);

var _html_sitemap_index_route2 = _interopRequireDefault(_html_sitemap_index_route);

var _html_sitemap_year_route = __webpack_require__(611);

var _html_sitemap_year_route2 = _interopRequireDefault(_html_sitemap_year_route);

var _html_sitemap_post_route = __webpack_require__(612);

var _html_sitemap_post_route2 = _interopRequireDefault(_html_sitemap_post_route);

var _wp_page_route = __webpack_require__(613);

var _wp_page_route2 = _interopRequireDefault(_wp_page_route);

var _apply_route = __webpack_require__(614);

var _apply_route2 = _interopRequireDefault(_apply_route);

var _search_route = __webpack_require__(615);

var _search_route2 = _interopRequireDefault(_search_route);

var _tag_page_route = __webpack_require__(616);

var _tag_page_route2 = _interopRequireDefault(_tag_page_route);

var _living_smarter_tag_page_route = __webpack_require__(617);

var _living_smarter_tag_page_route2 = _interopRequireDefault(_living_smarter_tag_page_route);

var _urban_x_tag_page_route = __webpack_require__(618);

var _urban_x_tag_page_route2 = _interopRequireDefault(_urban_x_tag_page_route);

var _magazine_tag_page_route = __webpack_require__(619);

var _magazine_tag_page_route2 = _interopRequireDefault(_magazine_tag_page_route);

var _product_route = __webpack_require__(620);

var _product_route2 = _interopRequireDefault(_product_route);

var _product_index_route = __webpack_require__(621);

var _product_index_route2 = _interopRequireDefault(_product_index_route);

var _person_index_route = __webpack_require__(622);

var _person_index_route2 = _interopRequireDefault(_person_index_route);

var _ibd_route = __webpack_require__(623);

var _ibd_route2 = _interopRequireDefault(_ibd_route);

var _ibd_category_route = __webpack_require__(625);

var _ibd_category_route2 = _interopRequireDefault(_ibd_category_route);

var _mcp_community_route = __webpack_require__(626);

var _mcp_community_route2 = _interopRequireDefault(_mcp_community_route);

var _most_creative_people_route = __webpack_require__(627);

var _most_creative_people_route2 = _interopRequireDefault(_most_creative_people_route);

var _company_route = __webpack_require__(628);

var _company_route2 = _interopRequireDefault(_company_route);

var _company_index_route = __webpack_require__(629);

var _company_index_route2 = _interopRequireDefault(_company_index_route);

var _mic_year_route = __webpack_require__(630);

var _mic_year_route2 = _interopRequireDefault(_mic_year_route);

var _person_route = __webpack_require__(631);

var _person_route2 = _interopRequireDefault(_person_route);

var _post_route = __webpack_require__(632);

var _post_route2 = _interopRequireDefault(_post_route);

var _post_section_route = __webpack_require__(651);

var _post_section_route2 = _interopRequireDefault(_post_section_route);

var _post_paginated_slideshow_route = __webpack_require__(652);

var _post_paginated_slideshow_route2 = _interopRequireDefault(_post_paginated_slideshow_route);

var _post_preview_route = __webpack_require__(653);

var _post_preview_route2 = _interopRequireDefault(_post_preview_route);

var _post_preview_section_route = __webpack_require__(654);

var _post_preview_section_route2 = _interopRequireDefault(_post_preview_section_route);

var _not_found_route = __webpack_require__(655);

var _not_found_route2 = _interopRequireDefault(_not_found_route);

var _video_route = __webpack_require__(656);

var _video_route2 = _interopRequireDefault(_video_route);

var _video_playlist_index_route = __webpack_require__(657);

var _video_playlist_index_route2 = _interopRequireDefault(_video_playlist_index_route);

var _video_index_route = __webpack_require__(658);

var _video_index_route2 = _interopRequireDefault(_video_index_route);

var _video_playlist_page_route = __webpack_require__(659);

var _video_playlist_page_route2 = _interopRequireDefault(_video_playlist_page_route);

var _newsletters_route = __webpack_require__(660);

var _newsletters_route2 = _interopRequireDefault(_newsletters_route);

var _newsletters_preferences_page_route = __webpack_require__(661);

var _newsletters_preferences_page_route2 = _interopRequireDefault(_newsletters_preferences_page_route);

var _category_tag_route = __webpack_require__(662);

var _category_tag_route2 = _interopRequireDefault(_category_tag_route);

var _gift_guide_route = __webpack_require__(663);

var _gift_guide_route2 = _interopRequireDefault(_gift_guide_route);

var _gift_guide_category_route = __webpack_require__(672);

var _gift_guide_category_route2 = _interopRequireDefault(_gift_guide_category_route);

var _gift_route = __webpack_require__(673);

var _gift_route2 = _interopRequireDefault(_gift_route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function getRoutesWithStore(store) {
  var state = store.getState();
  var routeConfig = [{
    component: _web_layout2.default,
    routes: [(0, _video_route2.default)(store), (0, _video_index_route2.default)(store), (0, _video_playlist_index_route2.default)(store), (0, _video_playlist_page_route2.default)(store), (0, _homepage_all_index_route2.default)(store), (0, _homepage_all_route2.default)(store), (0, _community_route2.default)(store), (0, _wp_page_route2.default)(store), (0, _apply_route2.default)(store), (0, _newsletters_route2.default)(store), (0, _search_route2.default)(store), (0, _html_sitemap_index_route2.default)(store), (0, _html_sitemap_year_route2.default)(store), (0, _html_sitemap_post_route2.default)(store), (0, _living_smarter_tag_page_route2.default)(store), (0, _urban_x_tag_page_route2.default)(store), (0, _tag_page_route2.default)(store)].concat(_toConsumableArray((0, _magazine_tag_page_route2.default)(store)), [(0, _product_index_route2.default)(store), (0, _product_route2.default)(store), (0, _ibd_category_route2.default)(store), (0, _ibd_route2.default)(store), (0, _gift_guide_route2.default)(store), (0, _gift_guide_category_route2.default)(store), (0, _gift_route2.default)(store), (0, _person_route2.default)(store), (0, _person_index_route2.default)(store), (0, _mcp_community_route2.default)(store), (0, _person_route2.default)(store), (0, _most_creative_people_route2.default)(store), (0, _company_route2.default)(store), (0, _company_index_route2.default)(store)], _toConsumableArray((0, _mic_year_route2.default)(store)), [(0, _author_route2.default)(store), (0, _post_preview_route2.default)(store), (0, _post_preview_section_route2.default)(store), (0, _magazine_category_route2.default)(store), (0, _news_category_route2.default)(store), (0, _category_paginated_route2.default)(store), (0, _category_route2.default)(store)], _toConsumableArray((0, _category_tag_route2.default)(store)), [(0, _post_route2.default)(store), (0, _post_section_route2.default)(store), (0, _post_paginated_slideshow_route2.default)(store), (0, _homepage_route2.default)(store), (0, _not_found_route2.default)(store)])
  }];

  if ((0, _get2.default)(state, 'config.featureFlags.newsletterPreferencesPageEnabled')) {
    routeConfig[0].routes.unshift((0, _newsletters_preferences_page_route2.default)(store));
  }

  return routeConfig;
}

/***/ }),
/* 224 */,
/* 225 */,
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Merge content body together, it is used for post content field
function mergeContent(content) {
  var html = '';

  content.forEach(function (markup) {
    html += markup.join('');
  });

  return html;
}

exports.default = mergeContent;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isString = __webpack_require__(92);

var _isString2 = _interopRequireDefault(_isString);

var _cloudinary_asset_util = __webpack_require__(25);

var _image = __webpack_require__(61);

var _image2 = _interopRequireDefault(_image);

var _client_util = __webpack_require__(40);

var _client_util2 = _interopRequireDefault(_client_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GifConverter = function (_Component) {
  _inherits(GifConverter, _Component);

  function GifConverter() {
    _classCallCheck(this, GifConverter);

    var _this = _possibleConstructorReturn(this, (GifConverter.__proto__ || Object.getPrototypeOf(GifConverter)).call(this));

    _this.state = {
      renderVideo: false
    };
    return _this;
  }

  _createClass(GifConverter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          assetSizes = _props.assetSizes,
          src = _props.src;

      var isDesktop = (0, _client_util2.default)();
      var secureSrc = (0, _cloudinary_asset_util.makeHttps)(src);
      var fcDomainAsset = (0, _cloudinary_asset_util.changeAssetDomain)(secureSrc);
      var assetsWithPresets = (0, _cloudinary_asset_util.buildAssetUrlWithPresets)(fcDomainAsset, assetSizes, isDesktop);
      this.formats = (0, _cloudinary_asset_util.convertGIFToVideoAssets)(assetsWithPresets);

      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ renderVideo: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          alt = _props2.alt,
          src = _props2.src,
          assetSizes = _props2.assetSizes;

      var videoFormats = this.formats;
      var tag = _react2.default.createElement(_image2.default, {
        alt: alt,
        src: (0, _isString2.default)(src) ? src.replace(/.gif$/, '.jpg') : null,
        assetSizes: assetSizes
      });

      if (this.state.renderVideo) {
        /* eslint-disable jsx-a11y/media-has-caption */
        tag = _react2.default.createElement(
          'video',
          {
            className: 'video',
            poster: (0, _get2.default)(videoFormats, 'jpg'),
            playsInline: true,
            loop: true,
            preload: true,
            autoPlay: true,
            muted: true
          },
          _react2.default.createElement('source', { type: 'video/webm', src: (0, _get2.default)(videoFormats, 'webm') }),
          _react2.default.createElement('source', { type: 'video/mp4', src: (0, _get2.default)(videoFormats, 'mp4') })
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        tag
      );
    }
  }]);

  return GifConverter;
}(_react.Component);

GifConverter.defaultProps = {
  // noLazy: false,
  assetSizes: {}
};

GifConverter.propTypes = {
  alt: _propTypes2.default.string.isRequired,
  src: _propTypes2.default.string.isRequired,
  // noLazy: PropTypes.bool,
  assetSizes: _propTypes2.default.shape({
    large: _propTypes2.default.shape({
      sizes: _propTypes2.default.string,
      srcset: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }),
    small: _propTypes2.default.shape({
      sizes: _propTypes2.default.string,
      srcset: _propTypes2.default.arrayOf(_propTypes2.default.string)
    })
  })
};

exports.default = GifConverter;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Script;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Script(_ref) {
  var innerHtml = _ref.innerHtml,
      type = _ref.type,
      src = _ref.src;

  if (innerHtml) {
    return _react2.default.createElement('script', { type: type, dangerouslySetInnerHTML: { __html: innerHtml } });
  }
  return _react2.default.createElement('script', { type: type, src: src });
}

Script.defaultProps = {
  innerHtml: '',
  src: ''
};

Script.propTypes = {
  innerHtml: _propTypes2.default.string,
  type: _propTypes2.default.string.isRequired,
  src: _propTypes2.default.string
};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popupCenter = popupCenter;
exports.trackSocial = trackSocial;

var _exenv = __webpack_require__(4);

function popupCenter(event, url, w, h) {
  if (_exenv.canUseDOM) {
    event.preventDefault();

    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top;
    var width = window.innerWidth;
    var height = window.innerHeight;

    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;

    // https://developer.mozilla.org/en-US/docs/Web/API/Window/open
    var newWindow = window.open(url, 'FC Share', 'scrollbars=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
      newWindow.focus();
    }
  }
}

/**
 * Sends a social event to GA to track user share activity
 * @param {String} socialPlatform (Facebook, Twitter, etc)
 * @param {String} action (Share, Tweet, etc)
 */
function trackSocial(socialPlatform, action) {
  if (_exenv.canUseDOM && window.ga) {
    window.ga('send', 'social', socialPlatform, action, window.location.href);
    window.ga('rollup.send', 'social', socialPlatform, action, window.location.href);
  }
}

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(15);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _poster = __webpack_require__(56);

var _poster2 = _interopRequireDefault(_poster);

var _cloudinary_asset_util = __webpack_require__(25);

var _create_class_list_util = __webpack_require__(134);

var _newsletter_subscriber = __webpack_require__(258);

var _newsletter_subscriber2 = _interopRequireDefault(_newsletter_subscriber);

var _recaptcha = __webpack_require__(252);

var _recaptcha2 = _interopRequireDefault(_recaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import identityConfig from '../../../config/identity';

var NewsletterSignup = function (_NewsletterSubscriber) {
  _inherits(NewsletterSignup, _NewsletterSubscriber);

  function NewsletterSignup() {
    _classCallCheck(this, NewsletterSignup);

    return _possibleConstructorReturn(this, (NewsletterSignup.__proto__ || Object.getPrototypeOf(NewsletterSignup)).apply(this, arguments));
  }

  _createClass(NewsletterSignup, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var state = this.state;

      var hasError = nextState.error;
      var hasStatusChange = nextState.message !== state.message;
      var isLoading = nextState.disabled !== state.disabled;
      var hasEmailInputChange = nextState.email !== state.email;
      var shouldDisplayCaptchaChange = this.state.shouldDisplayReCaptcha !== nextState.shouldDisplayReCaptcha;
      return hasError || hasStatusChange || isLoading || hasEmailInputChange || shouldDisplayCaptchaChange;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          assignedNewsletters = _props.assignedNewsletters,
          id = _props.id;

      var currentSite = this.props.config.site;
      var isPost = this.props.modifier === 'post';

      var newsletterTitle = (0, _get2.default)(this.props, 'title') || (0, _get2.default)(assignedNewsletters, '[0].listName') + ' Newsletter';
      var newsletterDeck = (0, _get2.default)(this.props, 'deck') ? ' ' + (0, _get2.default)(this.props, 'deck') : ' ' + (0, _get2.default)(assignedNewsletters, '[0].message');

      var metadata = {
        title: 'Newsletter Signup',
        featured_image: { source: this.props.poster },
        noLazy: true,
        assetSizes: _cloudinary_asset_util.imageSizesLookup[3]
      };

      return _react2.default.createElement(
        'form',
        {
          onSubmit: this.handleSubmit,
          className: 'newsletter-signup newsletter-signup--' + this.props.modifier
        },
        _react2.default.createElement(
          'div',
          { className: 'newsletter-signup__container' },
          this.props.poster ? _react2.default.createElement(_poster2.default, { metadata: metadata }) : '',
          _react2.default.createElement(
            'p',
            { className: 'newsletter-signup__copy' },
            _react2.default.createElement(
              'strong',
              {
                className: isPost ? (0, _create_class_list_util.setElementClass)('newsletter-signup', 'copy-title--post') : (0, _create_class_list_util.setElementClass)('newsletter-signup', 'copy-title--homepage')
              },
              newsletterTitle
            ),
            isPost ? '' : newsletterDeck
          ),
          _react2.default.createElement('input', {
            className: 'newsletter-signup__input\n              ' + (this.state.error ? 'newsletter-signup__input--error' : '') + '\n              ' + (this.state.status ? 'newsletter-signup__input--success' : '') + '\n              ' + (this.state.disabled ? 'newsletter-signup__input--loading' : '') + '\n              ',
            name: 'email',
            type: 'email',
            onFocus: this.handleInputFocus,
            onChange: this.handleEmailUpdate,
            value: this.state.email,
            disabled: this.state.disabled,
            placeholder: (0, _get2.default)(this.statusMessages, [this.state.status]) || 'YOUR EMAIL ADDRESS'
          }),
          _react2.default.createElement(
            'button',
            {
              className: 'newsletter-signup__button ' + (isPost ? 'newsletter-signup__button--post' : '') + ' newsletter-signup__button--' + currentSite + '\n              ' + (this.state.disabled ? 'newsletter-signup__button--loading' : '') + '\n              ',
              disabled: this.state.disabled
            },
            'Sign Up'
          ),
          this.state.shouldDisplayReCaptcha ? _react2.default.createElement(
            'div',
            { className: 'newsletter-signup__recaptcha' },
            _react2.default.createElement(_recaptcha2.default, {
              verifyCallback: this.handleVerify,
              id: id || 'fastcompanyhomepage'
            })
          ) : '',
          this.props.hideCheckBox || assignedNewsletters.length < 2 ? '' : _react2.default.createElement(
            'div',
            { className: 'newsletter-signup__checkbox-option' },
            _react2.default.createElement(
              'div',
              { className: 'newsletter-signup__checkbox-container' },
              _react2.default.createElement(
                'div',
                { className: 'newsletter-signup__checkbox-wrapper' },
                _react2.default.createElement('input', {
                  className: 'newsletter-signup__checkbox',
                  type: 'checkbox',
                  id: 'special-offers',
                  name: (0, _get2.default)(assignedNewsletters, '[1].listId'),
                  onChange: this.handleUpdate,
                  defaultChecked: true
                })
              ),
              _react2.default.createElement(
                'label',
                {
                  className: 'newsletter-signup__label',
                  htmlFor: 'special-offers'
                },
                (0, _get2.default)(assignedNewsletters, '[1].message')
              )
            ),
            _react2.default.createElement(
              'a',
              {
                href: '//www.fastcompany.com/newsletters',
                className: 'newsletter-signup__newsletter-page-link'
              },
              'See All Newsletters'
            )
          )
        )
      );
    }
  }]);

  return NewsletterSignup;
}(_newsletter_subscriber2.default);

NewsletterSignup.defaultProps = {
  modifier: '',
  poster: '',
  hideCheckBox: false,
  id: ''
};

NewsletterSignup.propTypes = {
  modifier: _propTypes2.default.string,
  currentSite: _propTypes2.default.string.isRequired,
  assignedNewsletters: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  poster: _propTypes2.default.string,
  hideCheckBox: _propTypes2.default.bool,
  id: _propTypes2.default.string
};

function mapStateToProps(state, ownProps) {
  var newslettersConfig = (0, _get2.default)(state, 'config.newsletters');
  var newslettersBySlug = (0, _get2.default)(newslettersConfig, 'listsBySlug');
  var newsletterDictionary = (0, _get2.default)(newslettersConfig, 'listsById');

  var assignedNewsletters = ownProps.newsletters;
  return {
    config: state.config,
    currentSite: state.config.site,
    assignedNewsletters: assignedNewsletters.map(function processAssignedNewsletters(newsletter) {
      var newsletterNameProp = newsletter.list;
      var listId = (0, _get2.default)(newslettersBySlug, newsletterNameProp);
      var found = newsletterDictionary[listId];
      return {
        listName: (0, _get2.default)(found, 'listName'),
        listId: listId,
        message: (0, _get2.default)(found, 'short')
      };
    })
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(NewsletterSignup);

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MoreStories;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _cloudinary_asset_util = __webpack_require__(25);

var _create_class_list_util = __webpack_require__(134);

var _slug = __webpack_require__(23);

var _slug2 = _interopRequireDefault(_slug);

var _card = __webpack_require__(36);

var _card2 = _interopRequireDefault(_card);

var _advertorial = __webpack_require__(29);

var _advertorial2 = _interopRequireDefault(_advertorial);

var _ga = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildSlugWrapperClass(advertorial) {
  var className = 'homepage-tag__advertorial-title-container';
  // TODO: change class modifier on setModifierClass
  var slugTitle = (0, _create_class_list_util.setModifierClass)(advertorial, className, 'advertorial') || className;
  return slugTitle;
}

function renderSlug(data, tags, advertorial) {
  var pageLink = (0, _get2.default)(data, 'slug') ? '/section/' + (0, _get2.default)(data, 'slug') : '';
  var slugName = (0, _get2.default)(data, 'name') || 'more stories';

  return _react2.default.createElement(
    'div',
    { className: buildSlugWrapperClass(advertorial) },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_slug2.default, { slugName: slugName, linkTo: pageLink }),
      advertorial ? _react2.default.createElement(_advertorial2.default, {
        modifier: 'homepage-deck',
        tags: tags,
        section: 'homepage'
      }) : ''
    )
  );
}

function MoreStories(props) {
  if (!props) {
    return null;
  }

  var config = props.config,
      metadata = props.metadata,
      slugData = props.slugData,
      tags = props.tags,
      isPost = props.isPost;

  var advertorial = (0, _advertorial.isAdvertorial)(tags);

  return _react2.default.createElement(
    'section',
    { className: isPost ? 'post-more-stories' : 'more-stories-module' },
    renderSlug(slugData, tags, advertorial),
    _react2.default.createElement(
      'div',
      { className: 'row' },
      metadata.map(function (post, i, arr) {
        return _react2.default.createElement(_card2.default, {
          key: post.id,
          metadata: (0, _assign2.default)(post, {
            assetSizes: i === 0 ? _cloudinary_asset_util.imageSizesLookup.bigFirstMobile : _cloudinary_asset_util.imageSizesLookup[arr.length]
          }),
          config: config,
          totalCards: arr.length,
          cardEvent: function cardEvent() {
            (0, _ga.trackGAEvent)({
              eventCategory: 'Engagement',
              eventAction: 'HomepageTag:Pos-' + (i + 1),
              eventLabel: (0, _get2.default)(post, 'link')
            });
          }
        });
      })
    )
  );
}

MoreStories.defaultProps = {
  tags: [],
  isPost: false,
  slugData: {}
};

MoreStories.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  metadata: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  slugData: _propTypes2.default.shape({}),
  tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  isPost: _propTypes2.default.bool
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allFeedLoading = allFeedLoading;
exports.allFeedLoaded = allFeedLoaded;
exports.allFeedLoadError = allFeedLoadError;
exports.allFeedAllStoriesRendered = allFeedAllStoriesRendered;
exports.allFeedISLoading = allFeedISLoading;
exports.allFeedISLoaded = allFeedISLoaded;
exports.allFeedISError = allFeedISError;

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function allFeedLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'ALL_FEED_LOADING',
    allFeed: resp,
    store: store
  };
}

function allFeedLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'ALL_FEED_LOADED',
    allFeed: resp,
    store: store
  };
}

function allFeedLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'ALL_FEED_ERROR',
    allFeed: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

function allFeedAllStoriesRendered() {
  return {
    type: 'ALL_FEED_ALL_STORIES_RENDERED',
    allRendered: true
  };
}

function allFeedISLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var config = arguments[1];

  return {
    type: 'ALL_FEED_IS_LOADING',
    allFeed: (0, _extend2.default)({ isLoading: true }, resp),
    config: config
  };
}

function allFeedISLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var config = arguments[1];

  return {
    type: 'ALL_FEED_IS_LOADED',
    allFeed: resp,
    config: config
  };
}

function allFeedISError() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var config = arguments[1];

  return {
    type: 'ALL_FEED_IS_ERROR',
    allFeed: resp,
    config: config
  };
}

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _exenv = __webpack_require__(4);

var _auth_util = __webpack_require__(16);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AllFeed = function (_Base) {
  _inherits(AllFeed, _Base);

  function AllFeed() {
    _classCallCheck(this, AllFeed);

    return _possibleConstructorReturn(this, (AllFeed.__proto__ || Object.getPrototypeOf(AllFeed)).apply(this, arguments));
  }

  _createClass(AllFeed, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var page = _ref.page;

      var state = store.getState();
      var pageParams = page ? '&page=' + page : '';
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled') || false;
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }
      var cacheKeyUrl = '' + protocol + host + '/api/v3/all-feed?total=10' + pageParams;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }, {
    key: 'fetchAllFeedIS',
    value: function fetchAllFeedIS(_ref2, config) {
      var page = _ref2.page;

      var state = config;
      var pageParams = page ? '&page=' + page : '';
      var total = 20;
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled') || false;
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }
      var cacheKeyUrl = '' + protocol + host + '/api/v3/all-feed?total=' + total + pageParams;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return AllFeed;
}(_base_model2.default);

exports.default = AllFeed;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CachingService = function () {
  function CachingService() {
    _classCallCheck(this, CachingService);

    this.cache = {};
  }

  _createClass(CachingService, [{
    key: 'initialize',
    value: function initialize(_ref) {
      var _ref$enabled = _ref.enabled,
          enabled = _ref$enabled === undefined ? false : _ref$enabled,
          _ref$cacheClearInterv = _ref.cacheClearInterval,
          cacheClearInterval = _ref$cacheClearInterv === undefined ? 20000 : _ref$cacheClearInterv;

      if (_exenv2.default) {
        if (enabled) {
          this.cacheClearInterval = setInterval(function clearCache() {
            this.cache = {};
          }.bind(this), cacheClearInterval);
        }
      }
    }
  }, {
    key: 'getAsync',
    value: function getAsync(key) {
      return Promise.resolve(this.cache[key]);
    }
  }, {
    key: 'setex',
    value: function setex(key, expire, val) {
      this.cache[key] = val;
    }
  }]);

  return CachingService;
}();

exports.default = new CachingService();

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchMagazineLatestIssuePosts;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _magazine_latest_issue_posts_action_creators = __webpack_require__(557);

var magazineLatestIssuePostsActions = _interopRequireWildcard(_magazine_latest_issue_posts_action_creators);

var _not_found_status_action_creator = __webpack_require__(28);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _magazine_latest_issue_posts_model = __webpack_require__(558);

var _magazine_latest_issue_posts_model2 = _interopRequireDefault(_magazine_latest_issue_posts_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchMagazineLatestIssuePosts(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(magazineLatestIssuePostsActions.magazineLatestIssuePostsLoading({}, store));
    return _magazine_latest_issue_posts_model2.default.fetch(params, store).then(function handleMagazineLatestIssuePostsData(magazineLatestIssuePostsData) {
      dispatch(magazineLatestIssuePostsActions.magazineLatestIssuePostsLoaded(magazineLatestIssuePostsData.data, store));
    }).catch(function handleMagazineLatestIssuePostsError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(magazineLatestIssuePostsActions.magazineLatestIssuePostsError(err.data, store));
      _logger_service2.default.error(err, 'Error in fetchMagazineLatestIssuePosts actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryAllFeedLoading = categoryAllFeedLoading;
exports.categoryAllFeedLoaded = categoryAllFeedLoaded;
exports.categoryAllFeedLoadError = categoryAllFeedLoadError;
exports.categoryAllFeedAllStoriesRendered = categoryAllFeedAllStoriesRendered;
// import { canUseDOM } from 'exenv';

function categoryAllFeedLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_ALL_FEED_LOADING',
    categoryAllFeed: resp,
    store: store
  };
}

function categoryAllFeedLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_ALL_FEED_LOADED',
    categoryAllFeed: resp,
    store: store
  };
}

function categoryAllFeedLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_ALL_FEED_ERROR',
    categoryAllFeed: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

function categoryAllFeedAllStoriesRendered() {
  return {
    type: 'CATEGORY_ALL_FEED_ALL_STORIES_RENDERED',
    allRendered: true
  };
}

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSlick = __webpack_require__(60);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isString = __webpack_require__(92);

var _isString2 = _interopRequireDefault(_isString);

var _striptags = __webpack_require__(35);

var _striptags2 = _interopRequireDefault(_striptags);

var _exenv = __webpack_require__(4);

var _cloudinary_asset_util = __webpack_require__(25);

var _image = __webpack_require__(61);

var _image2 = _interopRequireDefault(_image);

var _gif_converter = __webpack_require__(227);

var _gif_converter2 = _interopRequireDefault(_gif_converter);

var _arrow = __webpack_require__(238);

var _arrow2 = _interopRequireDefault(_arrow);

var _custom_event_util = __webpack_require__(587);

var _custom_event_util2 = _interopRequireDefault(_custom_event_util);

var _omniture = __webpack_require__(239);

var _comscore = __webpack_require__(240);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var prevArrow = _react2.default.createElement(
  'svg',
  { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 41 40' },
  _react2.default.createElement(
    'g',
    { fill: 'none', fillRule: 'evenodd' },
    _react2.default.createElement('path', {
      fill: '#CCC',
      d: 'M.47 20c0 11.045 8.952 20 20 20 11.045 0 20-8.955 20-20s-8.955-20-20-20C9.42 0 .47 8.955.47 20z'
    }),
    _react2.default.createElement('path', { fill: '#000', d: 'M12.527 19.998l7.5 3.75v-7.5' }),
    _react2.default.createElement('path', { stroke: '#000', d: 'M19.5 20h8.438' })
  )
);

var nextArrow = _react2.default.createElement(
  'svg',
  { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 41 40' },
  _react2.default.createElement(
    'g',
    { fill: 'none', fillRule: 'evenodd' },
    _react2.default.createElement('path', {
      fill: '#CCC',
      d: 'M.47 20c0 11.045 8.952 20 20 20 11.045 0 20-8.955 20-20s-8.955-20-20-20C9.42 0 .47 8.955.47 20z'
    }),
    _react2.default.createElement('path', { fill: '#000', d: 'M27.027 19.998l-7.5-3.75v7.5' }),
    _react2.default.createElement('path', { stroke: '#000', d: 'M12.5 20h8.438' })
  )
);

var settings = {
  prevArrow: _react2.default.createElement(_arrow2.default, { markup: prevArrow }),
  nextArrow: _react2.default.createElement(_arrow2.default, { markup: nextArrow }),
  accessibility: true,
  fade: true,
  swipe: false,
  lazyLoad: true,
  responsive: [{
    breakpoint: 640,
    settings: {
      fade: false,
      swipe: true
    }
  }]
};

var FCSlider = function (_Component) {
  _inherits(FCSlider, _Component);

  function FCSlider(props) {
    _classCallCheck(this, FCSlider);

    var _this = _possibleConstructorReturn(this, (FCSlider.__proto__ || Object.getPrototypeOf(FCSlider)).call(this));

    _this.counter = 0;
    _this.onBeforeChange = _this.onBeforeChange.bind(_this);
    _this.captions = props.slideShowData.map(function (slideData, index, arr) {
      return '<span class="header-slideshow__slide-curr">' + (index + 1) + '</span><span class="header-slideshow__slide-total">/' + arr.length + '</span> ' + (slideData.caption ? slideData.caption : '');
    });
    _this.mediaItems = props.slideShowData;
    _this.state = {
      readyToMount: false
    };
    return _this;
  }

  _createClass(FCSlider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.applyImagesOrientations();
      this.changeCaption(0);
    }
  }, {
    key: 'onBeforeChange',
    value: function onBeforeChange(currentSlideIndex, nextSlideIndex) {
      if (this.props.location === 'header') {
        this.triggerSlideshowRefresh();
        this.trackSlideshowEventOmn(currentSlideIndex, nextSlideIndex);
      }

      this.changeCaption(nextSlideIndex);
    }
  }, {
    key: 'applyImagesOrientations',
    value: function applyImagesOrientations() {
      var _this2 = this;

      var parentBounds = this.wrapperDimensions.getBoundingClientRect();
      var parentWidth = parentBounds.width;
      var parentHeight = parentBounds.height;
      var parentAspect = parentWidth / parentHeight;

      return this.mediaItems.forEach(function (item, i, arr) {
        if (item.imgUrl && (0, _isString2.default)(item.imgUrl)) {
          var image = new Image();
          var src = item.imgUrl.replace('wp-cms-fastcompany-com.s3.amazonaws.com', 'images.fastcompany.net/image/upload/wp-cms').replace('upload/', 'upload/w_100,q_auto:low,f_auto,fl_lossy/').replace('fast-company-res.cloudinary.com', 'images.fastcompany.net').replace('http://', 'https://');

          if (/.gif$/.test(src)) {
            src = src.replace('f_auto', 'f_jpg');
          }

          image.src = src;

          image.onload = function assignImageOrientation() {
            var width = image.width,
                height = image.height;


            var myAspect = width / height;

            if (height >= width || myAspect < parentAspect) {
              // eslint-disable-next-line no-param-reassign
              item.modifier = 'portrait';
            } else if (height < width) {
              // eslint-disable-next-line no-param-reassign
              item.modifier = 'landscape';
            }

            if (i === arr.length - 1) {
              this.setState({ readyToMount: true });
            }
          }.bind(_this2);
        } else if (i === arr.length - 1) {
          _this2.setState({ readyToMount: true });
        }
      });
    }
  }, {
    key: 'trackSlideshowEventOmn',
    value: function trackSlideshowEventOmn(currentSlideIndex, nextSlideIndex) {
      if (_exenv.canUseDOM) {
        var trackCurrent = currentSlideIndex + 1;
        if (currentSlideIndex !== undefined && nextSlideIndex !== undefined) {
          if (currentSlideIndex === 0 && currentSlideIndex - nextSlideIndex < -1) {
            (0, _omniture.trackOmniture)('event30', trackCurrent);
            (0, _comscore.sendComscoreCandidatePing)();
          } else {
            if (currentSlideIndex - nextSlideIndex > 1) {
              (0, _omniture.trackOmniture)('event29', trackCurrent);
              (0, _comscore.sendComscoreCandidatePing)();
            }
            if (nextSlideIndex - currentSlideIndex < 0 && Math.abs(nextSlideIndex - currentSlideIndex) === 1) {
              (0, _omniture.trackOmniture)('event30', trackCurrent);
              (0, _comscore.sendComscoreCandidatePing)();
            }
            if (nextSlideIndex - currentSlideIndex > 0 && Math.abs(nextSlideIndex - currentSlideIndex) === 1) {
              (0, _omniture.trackOmniture)('event29', trackCurrent);
              (0, _comscore.sendComscoreCandidatePing)();
            }
          }
        }
      }
    }
  }, {
    key: 'triggerSlideshowRefresh',
    value: function triggerSlideshowRefresh() {
      if (_exenv.canUseDOM) {
        this.counter += 1;
        if (this.counter === 3) {
          this.counter = 0;
          (0, _custom_event_util2.default)('FC_REFRESH_EVENT', { detail: 'slideshowhalfpage' }, window);
        }
      }
    }
  }, {
    key: 'changeCaption',
    value: function changeCaption(index) {
      var hasCaption = !!this.captions[index];

      this.setState({
        currentCaption: '' + (hasCaption ? this.captions[index] : '')
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var slideShowData = this.mediaItems || [];
      var location = this.props.location;


      settings.className = location + '-slideshow';

      return this.state.readyToMount ? _react2.default.createElement(
        'div',
        null,
        ' ',
        _react2.default.createElement(
          _reactSlick2.default,
          _extends({}, settings, { beforeChange: this.onBeforeChange }),
          slideShowData.map(function (slideData) {
            return _react2.default.createElement(
              'figure',
              {
                className: location + '-slideshow__slide',
                key: JSON.stringify(slideData)
              },
              ' ',
              /.gif$/.test(slideData.imgUrl) ? _react2.default.createElement(_gif_converter2.default, {
                src: (0, _get2.default)(slideData, 'imgUrl'),
                assetSizes: _cloudinary_asset_util.imageSizesLookup.slider,
                alt: (0, _get2.default)(slideData, 'caption') ? (0, _striptags2.default)((0, _get2.default)(slideData, 'caption') || '') : _this3.props.title
              }) : _react2.default.createElement(_image2.default, {
                baseClass: location + '-slideshow__image',
                modifier: (0, _get2.default)(slideData, 'modifier'),
                src: (0, _get2.default)(slideData, 'imgUrl'),
                assetSizes: _cloudinary_asset_util.imageSizesLookup.slider,
                alt: (0, _get2.default)(slideData, 'caption') ? (0, _striptags2.default)((0, _get2.default)(slideData, 'caption') || '') : _this3.props.title
              })
            );
          })
        ),
        _react2.default.createElement('div', {
          className: location + '-slideshow__caption',
          dangerouslySetInnerHTML: { __html: this.state.currentCaption }
        })
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', {
          className: 'big-card__poster',
          ref: function ref(node) {
            _this3.wrapperDimensions = node;
          }
        }),
        _react2.default.createElement('div', { className: location + '-slideshow__caption' })
      );
    }
  }]);

  return FCSlider;
}(_react.Component);

FCSlider.defaultProps = {
  slideShowData: [],
  title: '',
  location: 'header'
};

FCSlider.propTypes = {
  slideShowData: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    imgUrl: _propTypes2.default.string,
    caption: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool])
  })),
  title: _propTypes2.default.string,
  location: _propTypes2.default.string
};

exports.default = FCSlider;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Arrow;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omit = __webpack_require__(123);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Arrow(props) {
  return _react2.default.createElement(
    'button',
    _extends({
      type: 'button'
    }, (0, _omit2.default)(props, ['currentSlide', 'slideCount', 'markup'])),
    props.markup
  );
}

Arrow.propTypes = {
  markup: _propTypes2.default.element.isRequired
};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadOmnitureTracker;
exports.trackOmniture = trackOmniture;

var _exenv = __webpack_require__(4);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _capitalize = __webpack_require__(128);

var _capitalize2 = _interopRequireDefault(_capitalize);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _map = __webpack_require__(588);

var _map2 = _interopRequireDefault(_map);

var _identity = __webpack_require__(17);

var _identity2 = _interopRequireDefault(_identity);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loadOmnitureTracker(currentState) {
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (window.fastco_s) {
    var siteConfig = _identity2.default[(0, _get2.default)(currentState, 'context.site')];
    var siteSlug = (0, _get2.default)(siteConfig, 'slug');
    var context = (0, _get2.default)(currentState, 'context');

    var postData = context.postData,
        tagPageData = context.tagPageData,
        categoryPageData = context.categoryPageData,
        authorPageData = context.authorPageData,
        searchPageData = context.searchPageData,
        staticPageData = context.staticPageData,
        mostCreativePeoplePageData = context.mostCreativePeoplePageData,
        personPageData = context.personPageData,
        ibdPageData = context.ibdPageData,
        companyPageData = context.companyPageData,
        micPageData = context.micPageData,
        micSectorPageData = context.micSectorPageData,
        videoPageData = context.videoPageData,
        playlistAllFeedData = context.playlistAllFeedData,
        productPageData = context.productPageData,
        type = context.type;


    var _category = '';
    var _tag = '';
    // Omniture data structure, defaults to homepage value
    // it will be further extended depend on page type
    var omniture = {
      server: siteSlug,
      channel: 'homepage',
      pageName: siteSlug + ':homepage:front',
      pageURL: (0, _get2.default)(siteConfig, 'url'),
      events: 'event9',
      prop1: '',
      prop2: '',
      prop3: '',
      prop4: (0, _get2.default)(siteConfig, 'url'),
      prop5: '',
      prop6: '',
      prop7: '',
      prop8: '',
      prop9: '',
      prop10: '',
      prop11: '',
      prop13: 1,
      prop21: 'anonymous',
      prop22: 'anonymous:' + siteSlug + ':homepage:front',
      prop23: 'anonymous',
      prop28: '',
      prop31: '',
      prop32: '',
      prop33: '',
      prop34: '',
      eVar49: 1
    };

    var typeLookup = {
      post: function post() {
        _category = (0, _get2.default)(postData, 'categories[0].slug');
        var tags = (0, _get2.default)(postData, 'tags');
        var eyeBrowText = (0, _ad_util.figureOutPriorityTag)(tags);
        var postID = (0, _get2.default)(postData, 'id');
        var postSlug = (0, _get2.default)(postData, 'slug');

        var pageType = 'article';
        if ((0, _get2.default)(postData, 'posterSlideshow.length')) {
          pageType = 'slideshow';
        } else if ((0, _get2.default)(postData, 'hasVideoPoster') === true || (0, _get2.default)(postData, 'posterVideo.feedId')) {
          pageType = 'video';
        }

        // Extend original omniture variable
        omniture = (0, _extend2.default)({}, omniture, {
          pageName: siteSlug + ':' + postID + ':' + postSlug,
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/' + postID + '/' + postSlug,
          channel: '',
          prop1: _category,
          prop2: _category,
          prop3: (0, _get2.default)(postData, 'title'),
          prop4: (0, _get2.default)(postData, 'link'),
          prop5: (0, _get2.default)(eyeBrowText, 'slug') !== '' ? (0, _get2.default)(eyeBrowText, 'slug') : 'misc',
          prop6: (0, _get2.default)(eyeBrowText, 'slug') !== '' ? (0, _get2.default)(eyeBrowText, 'slug') : 'misc',
          prop7: '',
          prop8: (0, _get2.default)(postData, 'author.name'),
          prop9: (0, _get2.default)(postData, 'omnitureDate'),
          prop10: postID,
          prop11: (0, _get2.default)(postData, 'author.name'),
          prop22: 'anonymous:' + siteSlug + ':' + postID + ':' + postSlug,
          prop28: pageType,
          prop31: '',
          prop32: '',
          prop33: (0, _capitalize2.default)(_category),
          prop34: (0, _get2.default)(postData, 'readTime')
        });
      },
      category: function category() {
        _category = (0, _get2.default)(categoryPageData, 'slug', '');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: _category,
          pageName: siteSlug + ':' + _category + ':front',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/' + _category,
          url: (0, _get2.default)(siteConfig, 'url') + '/' + _category,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/' + _category,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':' + _category + ':front',
          prop28: '',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      tag: function tag() {
        _tag = (0, _get2.default)(tagPageData, 'slug', '');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: _tag,
          pageName: siteSlug + ':taxonomy:' + _tag,
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/section/' + _tag,
          url: (0, _get2.default)(siteConfig, 'url') + '/section/' + _tag,
          prop1: '',
          prop2: '',
          prop3: (0, _get2.default)(tagPageData, 'name'),
          prop4: (0, _get2.default)(siteConfig, 'url') + '/section/' + _tag,
          prop5: _tag,
          prop6: _tag,
          prop7: '',
          prop8: 'Fast Company Contributor',
          prop9: '',
          prop10: '',
          prop11: 'Fast Company Contributor',
          prop22: 'anonymous:' + siteSlug + ':taxonomy:' + _tag,
          prop28: 'tag',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      author: function author() {
        var authorSlug = (0, _get2.default)(authorPageData, 'slug', 'fastcompany-staff');
        var authorName = (0, _get2.default)(authorPageData, 'name', 'Fastcompany Staff');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: '',
          pageName: siteSlug + ':user:' + authorSlug,
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/user/' + authorSlug,
          url: (0, _get2.default)(siteConfig, 'url') + '/user/' + authorSlug,
          prop1: '',
          prop2: '',
          prop3: authorName,
          prop4: (0, _get2.default)(siteConfig, 'url') + '/user/' + authorSlug,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: authorName,
          prop9: '',
          prop10: '',
          prop11: authorName,
          prop22: 'anonymous:' + siteSlug + ':user:' + authorSlug,
          prop28: 'user',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      search: function search() {
        var searchQuery = (0, _get2.default)(searchPageData, 'query.queryString', '');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: '',
          pageName: siteSlug + ':search:' + searchQuery,
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/search/' + searchQuery,
          prop1: '',
          prop2: '',
          prop3: searchQuery,
          prop4: (0, _get2.default)(siteConfig, 'url') + '/search/' + searchQuery,
          prop5: searchQuery,
          prop6: searchQuery,
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':search:' + searchQuery,
          prop28: 'search',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      page: function page() {
        var pageSlug = (0, _get2.default)(staticPageData, 'slug', '');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: '',
          pageName: siteSlug + ':page:' + pageSlug,
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/' + pageSlug,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/' + pageSlug,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':page:' + pageSlug,
          prop28: 'page',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      personPage: function personPage() {
        var personSlug = (0, _get2.default)(personPageData, 'data.rows[0].url');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'mcp',
          pageName: siteSlug + ':person:' + personSlug,
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/person/' + personSlug,
          url: (0, _get2.default)(siteConfig, 'url') + '/person/' + personSlug,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/person/' + personSlug,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':person:' + personSlug,
          prop28: '',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      personIndexSectionPage: function personIndexSectionPage() {
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'person',
          pageName: siteSlug + ':person-index',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/person',
          url: (0, _get2.default)(siteConfig, 'url') + '/person',
          prop1: '',
          prop2: '',
          prop3: 'Person Index',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/person',
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':person-index',
          prop28: 'person',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      mostCreativePeoplePage: function mostCreativePeoplePage() {
        var year = (0, _get2.default)(mostCreativePeoplePageData, 'year', '');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'mcp',
          pageName: year ? siteSlug + ':mcp:' + year : siteSlug + ':mcp:front',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/most-creative-people/' + year,
          url: (0, _get2.default)(siteConfig, 'url') + '/most-creative-people/' + year,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/most-creative-people/' + year,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':page:mcp',
          prop28: 'mcp',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      mostCreativePeopleCommunityPage: function mostCreativePeopleCommunityPage() {
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'MCP',
          pageName: siteSlug + ':most-creative-people-community',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/most-creative-people-community',
          url: (0, _get2.default)(siteConfig, 'url') + '/most-creative-people-community',
          prop1: '',
          prop2: '',
          prop3: 'Most Creative People Community Page',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/most-creative-people-community',
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':mcp:community',
          prop28: 'mcp',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      ibdPage: function ibdPage() {
        var year = (0, _get2.default)(ibdPageData, 'year', '');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'ibd',
          pageName: year ? siteSlug + ':ibd:' + year : siteSlug + ':ibd:front',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/innovation-by-design/' + year,
          url: (0, _get2.default)(siteConfig, 'url') + '/innovation-by-design/' + year,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/innovation-by-design/' + year,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':page:ibd',
          prop28: 'ibd',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      productIndexSectionPage: function productIndexSectionPage() {
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'product',
          pageName: 'product:homepage:front',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/stuff',
          url: (0, _get2.default)(siteConfig, 'url') + '/stuff',
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/stuff',
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:ibd:homepage:front',
          prop28: 'product',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      productIndexPage: function productIndexPage() {
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'product',
          pageName: 'product:homepage:front',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/stuff',
          url: (0, _get2.default)(siteConfig, 'url') + '/stuff',
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/stuff',
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:ibd:homepage:front',
          prop28: 'product',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      productPage: function productPage() {
        var productName = (0, _get2.default)(productPageData, 'data.rows[0].name');
        var productSlug = (0, _get2.default)(productPageData, 'data.rows[0].url');

        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'product',
          pageName: 'product:' + productSlug,
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/product/' + productSlug,
          url: (0, _get2.default)(siteConfig, 'url') + '/product/' + productSlug,
          prop1: '',
          prop2: '',
          prop3: 'Product: ' + productName,
          prop4: (0, _get2.default)(siteConfig, 'url') + '/product/' + productSlug,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:product:' + productSlug,
          prop28: 'product',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      companyPage: function companyPage() {
        var companyURL = (0, _get2.default)(companyPageData, 'data.rows[0].url', '');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'company',
          pageName: 'anonymous:company:profile:' + companyURL,
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/company/' + companyURL,
          url: (0, _get2.default)(siteConfig, 'url') + '/company/' + companyURL,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/company/' + companyURL,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:company:profile:' + companyURL,
          prop28: 'company',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      companyIndexSectionPage: function companyIndexSectionPage() {
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'company',
          pageName: 'company:index',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/company',
          url: (0, _get2.default)(siteConfig, 'url') + '/company',
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/company',
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:company:index',
          prop28: 'company',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      micYearPage: function micYearPage() {
        var year = (0, _get2.default)(micPageData, 'year', '');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'mic',
          pageName: year ? siteSlug + ':mic:' + year : siteSlug + ':mic:front',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/most-innovative-companies/' + year,
          url: (0, _get2.default)(siteConfig, 'url') + '/most-innovative-companies/' + year,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/most-innovative-companies/' + year,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':mic',
          prop28: 'mic',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      micSectorPage: function micSectorPage() {
        var year = (0, _get2.default)(micSectorPageData, 'year', '');
        var sector = (0, _get2.default)(micSectorPageData, 'sector', '');

        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'mic',
          pageName: siteSlug + ':mic:' + year + ':' + sector,
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/most-innovative-companies/' + year + '/' + sector,
          url: (0, _get2.default)(siteConfig, 'url') + '/most-innovative-companies/' + year + '/' + sector,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/most-innovative-companies/' + year + '/' + sector,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':mic:' + year + ':' + sector,
          prop28: 'mic',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      videoPage: function videoPage() {
        var currentVideoData = (0, _get2.default)(videoPageData, 'data.playlist[0]', null);
        if (!currentVideoData) {
          return;
        }

        var videoPageTag = (0, _get2.default)(currentVideoData, 'category');
        var postID = (0, _get2.default)(currentVideoData, 'id');

        // Extend original omniture variable
        omniture = (0, _extend2.default)({}, omniture, {
          pageName: siteSlug + ':' + postID + ':' + (0, _get2.default)(currentVideoData, 'slug'),
          channel: 'video',
          prop1: 'video',
          prop2: 'video',
          prop3: (0, _get2.default)(currentVideoData, 'title'),
          prop4: (0, _get2.default)(currentVideoData, 'link'),
          prop5: videoPageTag,
          prop6: videoPageTag,
          prop7: '',
          prop8: 'FastCo Studios',
          prop9: (0, _get2.default)(currentVideoData, 'omnitureDate'),
          prop10: postID,
          prop11: 'FastCo Studios',
          prop22: 'anonymous:' + siteSlug + ':' + postID + ':' + (0, _get2.default)(currentVideoData, 'slug'),
          prop28: 'video',
          prop31: '',
          prop32: '',
          prop33: (0, _capitalize2.default)('video'),
          prop34: ''
        });
      },
      videoIndexPage: function videoIndexPage() {
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'video',
          pageName: 'fastcompany:video:front',
          pageURL: 'https://www.fastcompany.com/videos',
          url: 'https://www.fastcompany.com/videos',
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: 'https://www.fastcompany.com/videos',
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:fastcompany:video:front',
          prop28: '',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      videoPlaylistPage: function videoPlaylistPage() {
        var feedid = playlistAllFeedData.feedid,
            slug = playlistAllFeedData.slug;

        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'video',
          pageName: 'fastcompany:video-playlist:' + slug,
          pageURL: 'https://www.fastcompany.com/videos/playlist/' + slug + '/' + feedid,
          url: 'https://www.fastcompany.com/videos/playlist/' + slug + '/' + feedid,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: 'https://www.fastcompany.com/videos/playlist/' + slug + '/' + feedid,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:fastcompany:video-playlist:' + slug,
          prop28: '',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      magazineArchivePage: function magazineArchivePage() {
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'magazine',
          pageName: 'magazine:magazine-archives:front',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/magazine/archives',
          url: (0, _get2.default)(siteConfig, 'url') + '/magazine/archives',
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/magazine/archives',
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:magazine:archives:front',
          prop28: 'magazine',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      }
    };

    if (typeLookup[type]) {
      typeLookup[type]();
    }

    (0, _map2.default)(omniture, function (value, key) {
      window.fastco_s[key] = value;
    });

    // Track page number
    if (pageNumber) {
      // sEvent needs to be in proper format, example event24 where 24 is the number corresponding to event set up in Omniture reporting
      window.fastco_s.linkTrackVars = 'events';
      window.fastco_s.linkTrackEvents = 'event31';
      window.fastco_s.events = 'event31';
      window.fastco_s.tl(this, 'o', pageNumber);
    }

    window.fastco_s.t();
  }
}

function trackOmniture(sEvent, sValue) {
  if (_exenv.canUseDOM) {
    if (!window.fastco_s) {
      // console.error('Omniture not initialized, please include omniture s_code.js');
      return;
    }

    if (!sEvent || !sValue) {
      // console.error('Tracking parameters not provided');
      return;
    }

    // sEvent needs to be in proper format, example event24 where 24 is the number corresponding to event set up in Omniture reporting
    window.fastco_s.linkTrackVars = 'events';
    window.fastco_s.linkTrackEvents = sEvent;
    window.fastco_s.events = sEvent;
    window.fastco_s.tl(this, 'o', sValue);
  }
}

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadComscoreTracker;
exports.sendComscoreCandidatePing = sendComscoreCandidatePing;

var _axios = __webpack_require__(44);

var _axios2 = _interopRequireDefault(_axios);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(17);

var _identity2 = _interopRequireDefault(_identity);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loadComscoreTracker(currentState) {
  var site = (0, _get2.default)(currentState, 'context.site', 'fastcompany');
  var comscoreConfig = (0, _get2.default)(_identity2.default[site], 'comscore');
  var c1 = comscoreConfig.c1,
      c2 = comscoreConfig.c2;

  if (site) {
    site = site.toUpperCase();
  } else {
    site = window.location.hostname;
  }
  // reset COMSCORE
  if (window.COMSCORE && window.COMSCORE.beacon) {
    window.COMSCORE.beacon({
      c1: c1,
      c2: c2,
      options: {
        url_append: 'comscorekw=' + site
      }
    });
    _axios2.default.get('/comscore_ping').catch(function (error) {
      _logger_service2.default.error(error, 'Comscore page view candidate failed');
    });
  }
}

function sendComscoreCandidatePing() {
  // figure out domain site name and deal with subdomains etc
  var hostNameSplit = window.location.hostname.split('.');
  var site = hostNameSplit.length === 2 ? hostNameSplit[0] : hostNameSplit[1];
  var comscoreConfig = (0, _get2.default)(_identity2.default[site], 'comscore', {});
  var c1 = comscoreConfig.c1,
      c2 = comscoreConfig.c2;


  if (site) {
    site = site.toUpperCase();
  }
  // reset COMSCORE
  if (window.COMSCORE && window.COMSCORE.beacon) {
    window.COMSCORE.beacon({
      c1: c1,
      c2: c2,
      options: {
        url_append: 'comscorekw=' + site
      }
    });
    _axios2.default.get('/comscore_ping').catch(function (error) {
      _logger_service2.default.error(error, 'Comscore page view candidate failed');
    });
  }
}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jsonp = __webpack_require__(154);

var _jsonp2 = _interopRequireDefault(_jsonp);

var _exenv = __webpack_require__(4);

var _exenv2 = _interopRequireDefault(_exenv);

var _url_util = __webpack_require__(133);

var _url_util2 = _interopRequireDefault(_url_util);

var _feature_flags = __webpack_require__(139);

var _feature_flags2 = _interopRequireDefault(_feature_flags);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RevContent = function (_PureComponent) {
  _inherits(RevContent, _PureComponent);

  function RevContent(props) {
    _classCallCheck(this, RevContent);

    var _this = _possibleConstructorReturn(this, (RevContent.__proto__ || Object.getPrototypeOf(RevContent)).call(this, props));

    _this.state = {
      revcontentStories: null
    };
    _this.storiesRequested = false;
    _this.revDiv = null;
    return _this;
  }

  _createClass(RevContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.state.revcontentStories && !this.storiesRequested && !_feature_flags2.default.revContentJSWidgetEnabled) {
        this.getRCData();
        this.storiesRequested = true;
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      if (_feature_flags2.default.revContentJSWidgetEnabled) {
        if (!this.props.initialPageLoad && _exenv2.default && this.storiesRequested === false) {
          if ((0, _url_util2.default)('adzone') === 'qa') {
            return null;
          }

          var widgetID = this.props.site === 'fastcompany' ? '77613' : '85314';

          /* eslint-disable */
          var referer = '';
          try {
            if (referer = document.referrer, typeof referer === 'undefined') throw 'undefined';
          } catch (exception) {
            referer = document.location.href, (referer == '' || typeof referer === 'undefined') && (referer = document.URL);
          }
          referer = referer.substr(0, 700);
          var rcel = document.createElement('script');
          rcel.id = 'rc_' + Math.floor(Math.random() * 1000);
          rcel.type = 'text/javascript';
          rcel.src = 'https://trends.revcontent.com/serve.js.php?w=' + widgetID + '&t=' + rcel.id + '&c=' + new Date().getTime() + '&width=' + (window.outerWidth || document.documentElement.clientWidth) + '&referer=' + referer;
          rcel.async = true;
          this.revDiv.innerHTML = '';
          this.revDiv.appendChild(rcel);
          /* eslint-enable */

          this.storiesRequested = true;
        }
      }

      // eslint-disable-next-line
      return;
    }
  }, {
    key: 'getRCData',
    value: function getRCData() {
      var _this2 = this;

      if (!this.state.revcontentStories && !this.storiesRequested) {
        var site = this.props.site;

        var widgetID = site === 'fastcompany' ? '65657' : '65662';
        var domainID = site + '.com';

        var rcURL = '//trends.revcontent.com/api/v1/?' + 'api_key=573921e5aacb705a54512738b54b0f0bceb4cf94' + '&pub_id=6590' + ('&widget_id=' + widgetID) + ('&domain=' + encodeURI(domainID)) + ('&referer=' + encodeURI(window.location.href)) + '&format=json' + '&sponsored_count=4' + '&sponsored_offset=0' + '&internal_count=0' + '&internal_offset=0';

        (0, _jsonp2.default)(rcURL, null, function (err, data) {
          if (err) {
            _logger_service2.default.error(err.message, 'Unable to fetch revcontent stories');
          } else {
            _this2.setState({
              revcontentStories: data
            });
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (_feature_flags2.default.revContentJSWidgetEnabled) {
        if (!this.props.initialPageLoad && _exenv2.default) {
          return _react2.default.createElement(
            'section',
            { className: 'post-more-stories post-more-stories--revcontent' },
            _react2.default.createElement('div', {
              id: 'rcjsload_a3c485',
              ref: function ref(revDiv) {
                _this3.revDiv = revDiv;
              }
            })
          );
        }
        return null;
      }

      if (!this.state.revcontentStories) {
        return null;
      }

      return _react2.default.createElement(
        'section',
        { className: 'post-more-stories post-more-stories--revcontent' },
        _react2.default.createElement(
          'div',
          { className: 'homepage-tag__advertorial-title-container' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'slug-component' },
              _react2.default.createElement(
                'h2',
                { className: 'slug category-page__slug' },
                'From Around The Web'
              )
            ),
            _react2.default.createElement(
              'h3',
              { className: 'page-description' },
              'Powered by RevContent'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row row--revcontent' },
          this.state.revcontentStories.map(function (story) {
            return _react2.default.createElement(
              'div',
              { key: story.url, className: 'card-wrapper card-wrapper--4' },
              _react2.default.createElement(
                'article',
                { className: 'card' },
                _react2.default.createElement(
                  'a',
                  { href: story.url, title: story.headline },
                  _react2.default.createElement(
                    'figure',
                    { className: 'poster' },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement('img', { src: story.image, alt: story.headline })
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'text-wrapper' },
                    _react2.default.createElement(
                      'span',
                      { className: 'eyebrow' },
                      story.brand
                    ),
                    _react2.default.createElement(
                      'h2',
                      { className: 'title' },
                      story.headline
                    )
                  )
                )
              )
            );
          })
        )
      );
    }
  }]);

  return RevContent;
}(_react.PureComponent);

exports.default = RevContent;


RevContent.defaultProps = {
  site: 'fastcompany'
};

RevContent.propTypes = {
  site: _propTypes2.default.string,
  initialPageLoad: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postpageLoading = postpageLoading;
exports.postpageLoaded = postpageLoaded;
exports.postpageLoadError = postpageLoadError;
exports.infiniteScrollUrlChange = infiniteScrollUrlChange;
// import { canUseDOM } from 'exenv';

function postpageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POSTPAGE_LOADING',
    postpage: resp,
    store: store
  };
}

function postpageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POSTPAGE_LOADED',
    postpage: resp,
    store: store
  };
}

function postpageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POSTPAGE_ERROR',
    postpage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

function infiniteScrollUrlChange() {
  return {
    type: 'INFINITE_SCROLLPAGE_LOADED'
  };
}

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(15);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _withRouter = __webpack_require__(59);

var _withRouter2 = _interopRequireDefault(_withRouter);

var _ad = __webpack_require__(24);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(49);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _slug = __webpack_require__(23);

var _slug2 = _interopRequireDefault(_slug);

var _ibd_category = __webpack_require__(267);

var _ibd_category2 = _interopRequireDefault(_ibd_category);

var _client_util = __webpack_require__(40);

var _client_util2 = _interopRequireDefault(_client_util);

var _franchise_intro = __webpack_require__(254);

var _franchise_intro2 = _interopRequireDefault(_franchise_intro);

var _scroll_to_el_util = __webpack_require__(142);

var _scroll_to_el_util2 = _interopRequireDefault(_scroll_to_el_util);

var _gift_guide_page_state_manager = __webpack_require__(244);

var _gift_guide_page_state_manager2 = _interopRequireDefault(_gift_guide_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GiftGuide = function (_Component) {
  _inherits(GiftGuide, _Component);

  function GiftGuide() {
    _classCallCheck(this, GiftGuide);

    return _possibleConstructorReturn(this, (GiftGuide.__proto__ || Object.getPrototypeOf(GiftGuide)).apply(this, arguments));
  }

  _createClass(GiftGuide, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.isDesktop = (0, _client_util2.default)('64em');
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      (0, _scroll_to_el_util2.default)('.ibd-category--active', 150);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.giftGuidePage.error || this.props.status === 404) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }
      if (this.props.giftGuidePage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'innovation-by-design-page' },
          _react2.default.createElement(
            'article',
            { className: 'innovation-by-design-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var adData = (0, _get2.default)(this.props, 'giftGuidePage.ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      var _props = this.props,
          giftGuide = _props.giftGuide,
          giftGuideDetail = _props.giftGuideDetail;

      var year = (0, _get2.default)(this.props.match, 'params.year');
      var category = (0, _get2.default)(this.props.match, 'params.category');
      var sectionTitle = 'Browse By Categories';
      var slugParam = (0, _get2.default)(this.props, 'match.params.slug', '');

      // TODO: this needs to be updated.
      var encodedText = encodeURIComponent("Browse Co.Design's 2017 holiday gift guide, a meticulously curated list of the latest, most innovative, most thoughtful design objects available in 12 categories.");
      var uri = 'https://www.fastcodesign.com/gift-guide/' + slugParam;
      var specialText = "Browse @fastcodesign's 2017 holiday gift guide, a meticulously curated list of the most thoughtful design objects.";

      return _react2.default.createElement(
        'section',
        { className: 'innovation-by-design-page gift-guide-page' },
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true })),
        _react2.default.createElement(
          'div',
          { className: 'ad-container ad-container--gray ad-container--hide-for-small' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_1' }))
        ),
        _react2.default.createElement(
          'div',
          { className: 'ad-container ad-container--hide-for-medium-up post__article-top-ad-wrapper' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobileleaderboard' }))
        ),
        _react2.default.createElement(_franchise_intro2.default, {
          poster: (0, _get2.default)(giftGuideDetail, 'logo_url'),
          title: (0, _get2.default)(giftGuideDetail, 'title'),
          desc: (0, _get2.default)(giftGuideDetail, 'intro'),
          social: {
            enableSticky: false,
            modifier: 'feature-feed',
            text: '',
            socialText: {
              twitter: specialText,
              linkedin: encodedText,
              email: encodedText
            },
            uri: uri
          },
          giftGuide: true
        }),
        _react2.default.createElement(
          'section',
          { className: 'ibd-list' },
          _react2.default.createElement(_slug2.default, { slugName: sectionTitle, className: 'ibd-list' })
        ),
        _react2.default.createElement(
          'section',
          { className: 'innovation-by-design-page__category-container' },
          giftGuide.map(function (cat, idx) {
            return _react2.default.createElement(_ibd_category2.default, {
              combinedAdModel: combinedAdModel,
              category: cat,
              key: (0, _get2.default)(cat, 'category_name'),
              index: String(idx),
              year: year,
              active: category === (0, _get2.default)(cat, 'url'),
              slug: 'gift-guide',
              slugParam: slugParam
            });
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_2' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
        )
      );
    }
  }], [{
    key: 'loadData',
    value: function loadData(store) {
      return (0, _gift_guide_page_state_manager2.default)(store);
    }
  }]);

  return GiftGuide;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var ggData = (0, _get2.default)(state, 'giftGuide.data.rows');
  var ggDetail = (0, _get2.default)(state, 'giftGuideDetail.data.rows[0]');

  return {
    config: state.config || {},
    status: state.status.code,
    giftGuidePage: (0, _get2.default)(state, 'giftGuidePage') || {
      error: true
    },
    giftGuide: ggData || [],
    giftGuideDetail: ggDetail || ''
  };
}

GiftGuide.defaultProps = {
  status: 200
};

GiftGuide.propTypes = {
  status: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  match: _propTypes2.default.shape({}).isRequired,
  giftGuidePage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  giftGuide: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  giftGuideDetail: _propTypes2.default.shape({}).isRequired
};

exports.default = (0, _withRouter2.default)((0, _reactRedux.connect)(mapStateToProps)(GiftGuide));

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_gift_guide_page_actions = __webpack_require__(664);

var _async_gift_guide_page_actions2 = _interopRequireDefault(_async_gift_guide_page_actions);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;

    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_gift_guide_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_gift_guide_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CriticalStyles = function (_Component) {
  _inherits(CriticalStyles, _Component);

  function CriticalStyles() {
    _classCallCheck(this, CriticalStyles);

    return _possibleConstructorReturn(this, (CriticalStyles.__proto__ || Object.getPrototypeOf(CriticalStyles)).apply(this, arguments));
  }

  _createClass(CriticalStyles, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.amp === true) {
        return _react2.default.createElement('style', {
          'amp-custom': '',
          dangerouslySetInnerHTML: { __html: '' + this.props.css }
        });
      }

      if (!this.props.shouldRender) {
        return null;
      }

      return _react2.default.createElement('style', {
        className: 'critical-css',
        dangerouslySetInnerHTML: { __html: '' + this.props.css }
      });
    }
  }]);

  return CriticalStyles;
}(_react.Component);

CriticalStyles.propTypes = {
  css: _propTypes2.default.string.isRequired,
  shouldRender: _propTypes2.default.bool.isRequired,
  amp: _propTypes2.default.bool.isRequired
};

function mapStateToProps(state) {
  return {
    shouldRender: state.config.env !== 'development',
    css: state.config.criticalCss || '',
    amp: state.config.amp
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CriticalStyles);

/***/ }),
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatPostObject;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatPostObject(config) {
  var post = config.post,
      imgSize = config.imgSize,
      _config$allowNoImage = config.allowNoImage,
      allowNoImage = _config$allowNoImage === undefined ? true : _config$allowNoImage,
      _config$allowTextOnly = config.allowTextOnly,
      allowTextOnly = _config$allowTextOnly === undefined ? false : _config$allowTextOnly;

  var formattedPost = {
    assetSizes: imgSize,
    allowNoImage: allowNoImage,
    noLazy: true,
    allowTextOnly: allowTextOnly
  };

  formattedPost = (0, _assign2.default)(formattedPost, post, {
    excerpt: ''
  });

  return formattedPost;
}

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRecaptcha = __webpack_require__(164);

var _reactRecaptcha2 = _interopRequireDefault(_reactRecaptcha);

var _identity = __webpack_require__(17);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var scriptjs = void 0;

var ReCaptcha = function (_PureComponent) {
  _inherits(ReCaptcha, _PureComponent);

  function ReCaptcha() {
    _classCallCheck(this, ReCaptcha);

    return _possibleConstructorReturn(this, (ReCaptcha.__proto__ || Object.getPrototypeOf(ReCaptcha)).apply(this, arguments));
  }

  _createClass(ReCaptcha, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!window.IS_RECAPTCHA_SCRIPT_LOADED) {
        scriptjs = __webpack_require__(37); // eslint-disable-line global-require
        scriptjs('https://www.google.com/recaptcha/api.js');
        window.IS_RECAPTCHA_SCRIPT_LOADED = true;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_reactRecaptcha2.default, {
        sitekey: _identity2.default.fastcompany.reCaptcha.public,
        render: 'explicit',
        verifyCallback: this.props.verifyCallback,
        onloadCallback: function onloadCallback() {},
        elementID: this.props.id
      });
    }
  }]);

  return ReCaptcha;
}(_react.PureComponent);

ReCaptcha.propTypes = {
  verifyCallback: _propTypes2.default.func.isRequired,
  id: _propTypes2.default.string.isRequired
};

exports.default = ReCaptcha;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStickynode = __webpack_require__(71);

var _reactStickynode2 = _interopRequireDefault(_reactStickynode);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _jsCookie = __webpack_require__(100);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _client_util = __webpack_require__(40);

var _client_util2 = _interopRequireDefault(_client_util);

var _ad = __webpack_require__(24);

var _ad2 = _interopRequireDefault(_ad);

var _recommender = __webpack_require__(600);

var _recommender2 = _interopRequireDefault(_recommender);

var _siderail_video_module_reactjw = __webpack_require__(602);

var _siderail_video_module_reactjw2 = _interopRequireDefault(_siderail_video_module_reactjw);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Sidebar = function (_Component) {
  _inherits(Sidebar, _Component);

  function Sidebar() {
    _classCallCheck(this, Sidebar);

    var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this));

    _this.sidebarVideo = false;
    _this.buildClassName = _this.buildClassName.bind(_this);
    return _this;
  }

  _createClass(Sidebar, [{
    key: 'buildClassName',
    value: function buildClassName() {
      var _props = this.props,
          fullPageAdvertorial = _props.fullPageAdvertorial,
          isVideoPost = _props.isVideoPost;

      var className = ['post__promotion'];

      if (isVideoPost) {
        className.push('post__promotion--video');
      }

      if (fullPageAdvertorial) {
        className.push('post__promotion--advertorial');
      }

      return className.join(' ');
    }
  }, {
    key: 'renderSidebar',
    value: function renderSidebar() {
      var _props2 = this.props,
          config = _props2.config,
          post = _props2.post,
          isFirstPost = _props2.isFirstPost,
          combinedAdModel = _props2.combinedAdModel,
          isDesktop = _props2.isDesktop,
          totalAdCount = _props2.totalAdCount,
          isLongPost = _props2.isLongPost,
          isVideoPost = _props2.isVideoPost;

      var totalAds = isLongPost && !isVideoPost ? totalAdCount : 1;
      var ads = [];
      var readTime = (0, _get2.default)(post, 'readTime');
      var hasPosterVideo = (0, _get2.default)(post, 'posterVideo.feedId');

      if (config.initialPageLoad || !_exenv.canUseDOM || !(0, _client_util2.default)()) {
        return null;
      }

      // Note: having fc_rev_content means the user is from international
      var videoSidebar = config.featureFlags.rightRailPlayer && !hasPosterVideo && !_jsCookie2.default.get('alreadySeenRightRailPlayer') && !_jsCookie2.default.get('fc_rev_content') && !isVideoPost;

      if (videoSidebar) {
        _jsCookie2.default.set('alreadySeenRightRailPlayer', '1', { expires: 7 });
        this.sidebarVideo = true;

        ads.push(_react2.default.createElement(
          'div',
          { className: 'post__promotion post__promotion--non-sticky' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
            noLazyLoad: true,
            pos: 'atf',
            name: 'flexibleportrait',
            canRefresh: true,
            readTime: readTime,
            pageNum: (0, _get2.default)(this.props, 'pageNum')
          }))
        ), _react2.default.createElement(
          'div',
          { className: 'post__promotion', id: 'post-ad-' + post.id + '-1' },
          _react2.default.createElement(
            _reactStickynode2.default,
            {
              top: 100,
              bottomBoundary: '#post-ad-' + post.id + '-1',
              enabled: isDesktop || false
            },
            _react2.default.createElement(
              _react.Fragment,
              null,
              _react2.default.createElement(
                'div',
                { className: 'post__relative' },
                _react2.default.createElement(_siderail_video_module_reactjw2.default, {
                  config: config,
                  type: 'rightrail',
                  playerid: '2fyG0pBE',
                  playlistId: 'PTvgvDm1',
                  readTime: readTime
                })
              ),
              ' ',
              _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
                noLazyLoad: false,
                pos: 'btf',
                name: 'flexiblehalfpage_1',
                canRefresh: true,
                readTime: readTime,
                pageNum: (0, _get2.default)(this.props, 'pageNum')
              }))
            )
          )
        ));
      } else {
        for (var i = 0; i < totalAds; i += 1) {
          ads.push(_react2.default.createElement(
            'div',
            {
              key: i,
              className: this.buildClassName(),
              id: 'post-ad-' + post.id + '-' + i
            },
            _react2.default.createElement(
              _reactStickynode2.default,
              {
                top: 100,
                bottomBoundary: '#post-ad-' + post.id + '-' + i,
                enabled: isDesktop || false
              },
              _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
                noLazyLoad: i === 0 && isFirstPost,
                pos: i === 0 ? 'atf' : 'btf',
                name: i === 0 && (0, _get2.default)(this.props, 'post.posterSlideshow') ? 'slideshowhalfpage' : i === 0 ? 'flexibleportrait' : 'flexiblehalfpage_' + i,
                canRefresh: !!(0, _get2.default)(this.props, 'post.posterSlideshow'),
                readTime: readTime,
                pageNum: (0, _get2.default)(this.props, 'pageNum')
              })),
              i === 0 && isLongPost && !isVideoPost ? _react2.default.createElement(
                'div',
                { className: 'post__relative post__relative--recommender' },
                _react2.default.createElement(_recommender2.default, { initialPageLoad: config.initialPageLoad })
              ) : null
            )
          ));
        }
      }

      return ads;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        {
          className: 'post__sidebar ' + (this.props.isVideoPost ? 'post__sidebar--video' : '')
        },
        this.renderSidebar()
      );
    }
  }]);

  return Sidebar;
}(_react.Component);

exports.default = Sidebar;


Sidebar.defaultProps = {
  related: [],
  isDesktop: false,
  fullPageAdvertorial: false,
  totalAdCount: 2
};

Sidebar.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  post: _propTypes2.default.shape({}).isRequired,
  isFirstPost: _propTypes2.default.bool.isRequired,
  related: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  combinedAdModel: _propTypes2.default.shape({}).isRequired,
  isDesktop: _propTypes2.default.bool,
  fullPageAdvertorial: _propTypes2.default.bool,
  totalAdCount: _propTypes2.default.number,
  isLongPost: _propTypes2.default.bool.isRequired,
  isVideoPost: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _social = __webpack_require__(94);

var _social2 = _interopRequireDefault(_social);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FranchiseIntro = function (_Component) {
  _inherits(FranchiseIntro, _Component);

  function FranchiseIntro(props) {
    _classCallCheck(this, FranchiseIntro);

    var _this = _possibleConstructorReturn(this, (FranchiseIntro.__proto__ || Object.getPrototypeOf(FranchiseIntro)).call(this, props));

    _this.state = { introText: _this.props.desc };
    return _this;
  }

  _createClass(FranchiseIntro, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // PATCH: React 16 is not rehydrating correctly the dangerouslySetInnerHTML html. It seems like there is
      // a difference between the client and server value and the text is removed in the client side.
      // Probably related to this: https://github.com/facebook/react/issues/10993
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ introText: this.props.desc + '<noscript></noscript>' });
    }
  }, {
    key: 'render',
    value: function render() {
      var isGiftGuide = this.props.giftGuide;
      var imageCol = isGiftGuide ? 6 : 4;
      var descCol = isGiftGuide ? 4 : 6;
      return _react2.default.createElement(
        'div',
        { className: 'franchise-intro' },
        _react2.default.createElement(_social2.default, this.props.social),
        _react2.default.createElement(
          'div',
          { className: 'franchise-intro__col--' + imageCol },
          _react2.default.createElement('img', { src: this.props.poster, alt: this.props.title })
        ),
        _react2.default.createElement(
          'div',
          { className: 'franchise-intro__col--' + descCol },
          _react2.default.createElement(
            'h1',
            { className: 'franchise-intro__title' },
            this.props.title
          ),
          _react2.default.createElement('p', {
            className: 'franchise-intro__desc',
            dangerouslySetInnerHTML: { __html: this.state.introText }
          })
        )
      );
    }
  }]);

  return FranchiseIntro;
}(_react.Component);

FranchiseIntro.defaultProps = {
  poster: '',
  title: '',
  desc: '',
  social: {},
  giftGuide: false
};

FranchiseIntro.propTypes = {
  poster: _propTypes2.default.string,
  title: _propTypes2.default.string,
  desc: _propTypes2.default.string,
  social: _propTypes2.default.shape({}),
  giftGuide: _propTypes2.default.bool
};

exports.default = FranchiseIntro;

/***/ }),
/* 255 */,
/* 256 */,
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(15);

var _reactRouterRedux = __webpack_require__(51);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Search = function (_Component) {
  _inherits(Search, _Component);

  function Search() {
    _classCallCheck(this, Search);

    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this));

    _this.handleSearchSubmit = _this.handleSearchSubmit.bind(_this);
    _this.clearSearch = _this.clearSearch.bind(_this);
    return _this;
  }

  _createClass(Search, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.active !== nextProps.active;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.active) {
        this.q.focus();
      }
    }
  }, {
    key: 'setFormClasses',
    value: function setFormClasses() {
      var _props = this.props,
          active = _props.active,
          modifier = _props.modifier,
          skin = _props.skin,
          modal = _props.modal;

      var baseClass = 'search-form';
      var classNames = baseClass + ' ' + baseClass + '--' + skin;

      if (modal) {
        classNames += ' ' + baseClass + '--modal';
      }

      if (modifier) {
        classNames += ' ' + baseClass + '--' + modifier;
      }

      if (active) {
        classNames += ' ' + baseClass + '--active';
      }

      return classNames;
    }
  }, {
    key: 'handleSearchSubmit',
    value: function handleSearchSubmit(event) {
      event.preventDefault();

      var _props2 = this.props,
          modal = _props2.modal,
          closeModal = _props2.closeModal;


      if (modal && closeModal) {
        closeModal(false);
      }

      this.props.search('/search/' + this.q.value);
      this.clearSearch(event);
    }
  }, {
    key: 'clearSearch',
    value: function clearSearch(event) {
      var input = this.q;

      var action = event && event.type === 'click' ? 'focus' : 'blur';
      var delay = event && event.type === 'submit' ? 200 : 0;

      setTimeout(function () {
        input.value = '';
      }, delay);

      input[action]();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var modal = this.props.modal;


      return _react2.default.createElement(
        'form',
        {
          className: this.setFormClasses(),
          onSubmit: this.handleSearchSubmit
        },
        _react2.default.createElement(
          'div',
          {
            className: 'search-form__wrapper ' + (modal ? 'search-form__wrapper--modal' : '')
          },
          _react2.default.createElement('input', {
            name: 'q',
            className: 'search-form__input  ' + (modal ? 'search-form__input--modal' : 'search-form__input--in-page'),
            defaultValue: (0, _get2.default)(this.props, 'searchTerm'),
            placeholder: 'Search',
            type: 'text',
            ref: function ref(input) {
              _this2.q = input;
            }
          }),
          _react2.default.createElement('button', {
            type: 'button',
            className: 'search-form__clear-input icon-close',
            onClick: this.clearSearch
          })
        )
      );
    }
  }]);

  return Search;
}(_react.Component);

Search.defaultProps = {
  modifier: '',
  active: false,
  modal: false,
  closeModal: function closeModal() {}
};

Search.propTypes = {
  skin: _propTypes2.default.string.isRequired,
  modifier: _propTypes2.default.string,
  active: _propTypes2.default.bool,
  modal: _propTypes2.default.bool,
  closeModal: _propTypes2.default.func,
  search: _propTypes2.default.func.isRequired
};

function mapStateToProps(state) {
  return state;
}

function mapDispatchToProps(dispatch) {
  return {
    search: function search(location) {
      dispatch((0, _reactRouterRedux.push)(location));
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Search);

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _assign2 = __webpack_require__(18);

var _assign3 = _interopRequireDefault(_assign2);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _newsletter_module = __webpack_require__(259);

var _newsletter_module2 = _interopRequireDefault(_newsletter_module);

var _newsletter_ga_util = __webpack_require__(531);

var _newsletter_ga_util2 = _interopRequireDefault(_newsletter_ga_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// let scriptjs;

var NewsletterSubscriber = function (_Component) {
  _inherits(NewsletterSubscriber, _Component);

  function NewsletterSubscriber(props) {
    _classCallCheck(this, NewsletterSubscriber);

    var _this = _possibleConstructorReturn(this, (NewsletterSubscriber.__proto__ || Object.getPrototypeOf(NewsletterSubscriber)).call(this));

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleUpdate = _this.handleUpdate.bind(_this);
    _this.handleEmailUpdate = _this.handleEmailUpdate.bind(_this);
    _this.handleVerify = _this.handleVerify.bind(_this);
    _this.handleInputFocus = _this.handleInputFocus.bind(_this);

    _this.statusMessages = {
      normal: "You're subscribed",
      error: 'There was an error.',
      loading: 'Loading'
    };

    var config = (0, _get2.default)(props, 'config');
    var allNewsletterData = (0, _get2.default)(config, 'newsletters.listsBySlug');
    var newslettersState = {};
    var newsletterIds = props.newsletterIds || [];
    props.newsletters.forEach(function mapPropsToState(newsletterObj) {
      var listPropName = (0, _get2.default)(newsletterObj, 'list');
      var listId = (0, _get2.default)(allNewsletterData, listPropName);

      newslettersState[listId] = !!newsletterObj.default;
    });

    // hack until i refactor this
    newsletterIds.forEach(function mapPropsToState(id) {
      newslettersState[id] = false;
    });
    _this.state = {
      email: '',
      newsletters: newslettersState,
      shouldDisplayReCaptcha: false
    };
    return _this;
  }

  _createClass(NewsletterSubscriber, [{
    key: 'handleInputFocus',
    value: function handleInputFocus() {
      if (!this.state.shouldDisplayReCaptcha) {
        this.setState({
          shouldDisplayReCaptcha: true
        });
      }
    }
  }, {
    key: 'handleUpdate',
    value: function handleUpdate(e) {
      var target = e.target;
      var value = target.value,
          name = target.name;

      var newNewsletterState = (0, _assign3.default)({}, this.state.newsletters, _defineProperty({}, name, value));

      this.setState({
        newsletters: newNewsletterState
      });
    }
  }, {
    key: 'handleEmailUpdate',
    value: function handleEmailUpdate(e) {
      var target = e.target;
      var value = target.value;

      this.setState({
        email: value
      });
    }
  }, {
    key: 'handleVerify',
    value: function handleVerify(value) {
      this.setState({ recaptcha: value });
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      var savedEmail = this.state.email;
      this.setState({ disabled: true, status: 'loading', email: '' }, // eslint-disable-line react/no-unused-state
      function disbaledSetStateCallback() {
        var newsletters = Object.keys(this.state.newsletters) || [];
        var selectedNewsletters = newsletters.filter(function filterNewsletterList(listId) {
          return this.state.newsletters[listId];
        }.bind(this));
        var currUrl = (0, _get2.default)(this.props.config, 'navHistory[0]');
        var data = {
          email: savedEmail,
          lists: selectedNewsletters,
          sourceDescription: currUrl,
          recaptcha: this.state.recaptcha
        };
        new _newsletter_module2.default().post(data, this.props.config).then(function receiveResponse(response) {
          (0, _newsletter_ga_util2.default)(data.lists, this.props.config.newsletters);
          this.setState({
            disabled: false, // eslint-disable-line react/no-unused-state
            status: (0, _get2.default)(response, 'data.[0].status', '').toLowerCase() // eslint-disable-line react/no-unused-state
          });
        }.bind(this)).catch(function handleUserError() {
          // change this to err.status after 400 issue is fixed
          this.setState({ disabled: false, status: 'error', error: true }); // eslint-disable-line react/no-unused-state
        }.bind(this));
      }.bind(this));
    }
  }]);

  return NewsletterSubscriber;
}(_react.Component);

NewsletterSubscriber.defaultProps = {
  newsletters: [],
  newsletterIds: []
};

NewsletterSubscriber.propTypes = {
  newsletters: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  newsletterIds: _propTypes2.default.arrayOf(_propTypes2.default.number),
  config: _propTypes2.default.shape({
    newsletters: _propTypes2.default.shape({}).isRequired
  }).isRequired
};

exports.default = NewsletterSubscriber;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__(44);

var _axios2 = _interopRequireDefault(_axios);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(16);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Newsletter = function () {
  function Newsletter() {
    _classCallCheck(this, Newsletter);
  }

  _createClass(Newsletter, [{
    key: 'post',
    value: function post(args, config) {
      var _buildRequestObj = this.buildRequestObj(args, config, 'post'),
          url = _buildRequestObj.url,
          options = _buildRequestObj.options;

      return _axios2.default.post(url, options);
    }
  }, {
    key: 'put',
    value: function put(args, config) {
      var _buildRequestObj2 = this.buildRequestObj(args, config, 'put'),
          url = _buildRequestObj2.url,
          options = _buildRequestObj2.options;

      return _axios2.default.post(url, options);
    }
  }, {
    key: 'buildRequestObj',
    value: function buildRequestObj(args, config, method) {
      var host = (0, _get2.default)(config, 'apiEndpoint');
      var protocol = (0, _get2.default)(config, 'protocol');
      var options = (0, _extend2.default)({}, args);
      var base = '' + protocol + host + '/api/v2/newsletter';

      var urls = {
        post: base,
        put: base + '-email'
      };

      // api has auth in beta
      if ((0, _get2.default)(config, 'authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(config, 'post'));
      }
      var url = urls[method];
      if (!_exenv.canUseDOM) {
        _logger_service2.default.info('Requesting: ' + url + ' from model.');
      }

      return { url: url, options: options };
    }
  }]);

  return Newsletter;
}();

exports.default = Newsletter;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = allFeedAction;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _all_feed_action_creators = __webpack_require__(232);

var allFeedActions = _interopRequireWildcard(_all_feed_action_creators);

var _all_feed_module = __webpack_require__(233);

var _all_feed_module2 = _interopRequireDefault(_all_feed_module);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _not_found_status_action_creator = __webpack_require__(28);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function allFeedAction(params, store) {
  return function allFeedDispatch(dispatch) {
    dispatch(allFeedActions.allFeedLoading(store));
    return _all_feed_module2.default.fetch(params, store).then(function handleAllFeedData(resp) {
      if (params.page && !(0, _get2.default)(resp, 'data.posts.length')) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }
      dispatch(allFeedActions.allFeedLoaded(resp.data, store));
    }).catch(function handleAllFeedError(err) {
      dispatch(allFeedActions.allFeedLoadError(err, store));
      _logger_service2.default.error(err, 'Error in all feed actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSlick = __webpack_require__(60);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _arrow = __webpack_require__(238);

var _arrow2 = _interopRequireDefault(_arrow);

var _card = __webpack_require__(36);

var _card2 = _interopRequireDefault(_card);

var _slug = __webpack_require__(23);

var _slug2 = _interopRequireDefault(_slug);

var _cloudinary_asset_util = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var prevArrow = _react2.default.createElement(
  'div',
  null,
  _react2.default.createElement(
    'svg',
    {
      width: '23',
      height: '52',
      viewBox: '0 0 23 52',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    _react2.default.createElement('path', {
      d: 'M22 51L2 26 22 1',
      strokeWidth: '2',
      stroke: '#CCC',
      fill: 'none',
      fillRule: 'evenodd'
    })
  )
);

var nextArrow = _react2.default.createElement(
  'div',
  null,
  _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '23',
      height: '52',
      viewBox: '0 0 23 52'
    },
    _react2.default.createElement('path', {
      d: 'M1 1l20 25L1 51',
      strokeWidth: '2',
      stroke: '#CCC',
      fill: 'none',
      fillRule: 'evenodd'
    })
  )
);

var RelatedSlider = function (_Component) {
  _inherits(RelatedSlider, _Component);

  function RelatedSlider(props) {
    _classCallCheck(this, RelatedSlider);

    var _this = _possibleConstructorReturn(this, (RelatedSlider.__proto__ || Object.getPrototypeOf(RelatedSlider)).call(this));

    _this.renderRelatedCard = _this.renderRelatedCard.bind(_this);
    _this.generateClassNames = _this.generateClassNames.bind(_this);
    _this.handleSlideChange = _this.handleSlideChange.bind(_this);
    _this.slidesToScroll = (0, _get2.default)(props, 'responsive[1].settings.slidesToScroll') || 3;

    _this.settings = {
      prevArrow: _react2.default.createElement(_arrow2.default, { markup: prevArrow }),
      nextArrow: _react2.default.createElement(_arrow2.default, { markup: nextArrow }),
      accessibility: true,
      slide: '.video-slide--no-border',
      infinite: false,
      responsive: props.responsive ? props.responsive : [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 100000,
        settings: {
          slidesToShow: 3.3,
          slidesToScroll: _this.slidesToScroll
        }
      }]
    };

    var slideCount = props.related.length;
    _this.maxNext = Math.floor(slideCount / _this.slidesToScroll);
    return _this;
  }

  _createClass(RelatedSlider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-did-mount-set-state, react/no-unused-state
      this.setState({ settings: this.settings, paddlesToShow: [0, 1] });
    }
  }, {
    key: 'generateClassNames',
    value: function generateClassNames() {
      var classnames = ['related-slider'];
      if (this.props.classNames) {
        classnames = classnames.concat(this.props.classNames);
      }

      if (!(0, _get2.default)(this.state, 'paddlesToShow[0]')) {
        classnames.push('related-slider--initial');
      }

      if (!(0, _get2.default)(this.state, 'paddlesToShow[1]')) {
        classnames.push('related-slider--end');
      }

      return classnames.join(' ');
    }
  }, {
    key: 'handleSlideChange',
    value: function handleSlideChange(index) {
      if (index === 0) {
        return this.setState({
          paddlesToShow: [0, 1]
        });
      }

      if (index / this.slidesToScroll >= this.maxNext) {
        return this.setState({
          paddlesToShow: [1, 0]
        });
      }

      if (!this.state.paddlesToShow.reduce(function (accum, currVal) {
        return accum && currVal;
      })) {
        return this.setState({
          paddlesToShow: [1, 1]
        });
      }

      return true;
    }
  }, {
    key: 'renderRelatedCard',
    value: function renderRelatedCard(relatedVid) {
      var _this2 = this;

      var config = this.props.config;

      var post = (0, _assign2.default)({}, relatedVid, {
        assetSizes: _cloudinary_asset_util.imageSizesLookup.column
      });

      var generateClassNames = function generateClassNames() {
        var classes = ['video-slide'];

        if (_this2.props.slideClassNames) {
          classes = [].concat(_toConsumableArray(classes), _toConsumableArray(_this2.props.slideClassNames));
        }

        return classes.join(' ');
      };

      return _react2.default.createElement(
        'div',
        { className: generateClassNames(), key: post.id },
        _react2.default.createElement(_card2.default, { type: 'video', metadata: post, config: config })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.generateClassNames() },
        _react2.default.createElement(_slug2.default, {
          slugName: this.props.title,
          className: 'related-slider',
          hasLink: true,
          linkTo: this.props.playlistId ? 'videos/playlist/' + this.props.slug + '/' + this.props.playlistId + '/1' : ''
        }),
        _react2.default.createElement(
          'div',
          null,
          this.state ? _react2.default.createElement(
            _reactSlick2.default,
            _extends({}, (0, _get2.default)(this.state, 'settings', {}), {
              afterChange: this.handleSlideChange
            }),
            this.props.related.map(this.renderRelatedCard)
          ) : ''
        )
      );
    }
  }]);

  return RelatedSlider;
}(_react.Component);

exports.default = RelatedSlider;


RelatedSlider.defaultProps = {
  title: 'Related',
  classNames: [],
  responsive: null,
  slideClassNames: '',
  playlistId: '',
  // slug is slugified version of
  // jwplaylist title
  slug: ''
};

RelatedSlider.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  related: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  title: _propTypes2.default.string,
  playlistId: _propTypes2.default.string,
  classNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
  responsive: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  slideClassNames: _propTypes2.default.string,
  slug: _propTypes2.default.string
};

/***/ }),
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(43);

var _Link2 = _interopRequireDefault(_Link);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _striptags = __webpack_require__(35);

var _striptags2 = _interopRequireDefault(_striptags);

var _show_more = __webpack_require__(624);

var _show_more2 = _interopRequireDefault(_show_more);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function processAssetServerImage(imgSrc) {
  var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'https://images.fastcompany.net/image/upload/w_387,h_218,c_fill,q_auto,f_auto,fl_lossy,o_30/v1498077352/fcweb/ibd_a2ubg2.jpg';

  var updatedImgSrc = imgSrc;

  // https://fast-company-res.cloudinary.com/image/fetch/w_599,q_auto,f_auto,fl_lossy/https://a.fastcompany.net/multisite_files/fastcompany/people/2017/11/21/p-1-dazzleship-el6sdb.jpg

  if (typeof imgSrc !== 'string' || imgSrc.length === 0) {
    updatedImgSrc = placeholder;
  }

  return 'https://a.fastcompany.net/image/fetch/w_599,q_auto,f_auto,fl_lossy/https:' + updatedImgSrc;
}

var IBDCategory = function (_Component) {
  _inherits(IBDCategory, _Component);

  function IBDCategory() {
    _classCallCheck(this, IBDCategory);

    return _possibleConstructorReturn(this, (IBDCategory.__proto__ || Object.getPrototypeOf(IBDCategory)).apply(this, arguments));
  }

  _createClass(IBDCategory, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.active !== nextProps.active;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          category = _props.category,
          index = _props.index,
          year = _props.year,
          active = _props.active,
          slug = _props.slug,
          slugParam = _props.slugParam;


      var categoryName = (0, _get2.default)(category, 'category_name');
      var url = (0, _get2.default)(category, 'url');
      var judges = (0, _get2.default)(category, 'judges_people');
      var list = (0, _get2.default)(category, 'products.list');
      var winners = (0, _get2.default)(category, 'products.winners');
      var finalists = (0, _get2.default)(category, 'products.finalists');
      var mentions = (0, _get2.default)(category, 'products.mentions', []);
      var productFieldToDisplay = year >= 2017 ? 'description' : 'why';
      var param = slug === 'gift-guide' ? slugParam : year;
      var link = active ? '/' + slug + '/' + param : '/' + slug + '/' + param + '/category/' + url;

      return _react2.default.createElement(
        'section',
        {
          className: 'ibd-category ibd-category--' + index + ' ' + (active ? 'ibd-category--active' : '')
        },
        _react2.default.createElement(
          'div',
          { className: 'ibd-category__row ibd-category__row--' + index },
          _react2.default.createElement(
            _Link2.default,
            {
              className: 'ibd-category__header ' + (active ? 'ibd-category__header--active' : ''),
              to: link
            },
            _react2.default.createElement(
              'h2',
              { className: 'ibd-category__title' },
              categoryName
            ),
            _react2.default.createElement('img', {
              className: 'ibd-category__title-icon\n              ' + (active ? ' ibd-category__title-icon--active' : ''),
              src: '//images.fastcompany.net/image/upload/q_auto,fl_lossy/v1495723987/arrow-list-down-fix.svg',
              alt: 'arrow icon',
              title: 'arrow icon'
            })
          ),
          active ? _react2.default.createElement(
            'div',
            { className: 'ibd-category__dek' },
            _react2.default.createElement(
              'div',
              { className: 'ibd-category__category-description' },
              (0, _striptags2.default)(category.category_description || '')
            ),
            judges.length ? _react2.default.createElement(
              'div',
              { className: 'ibd-category__judges' },
              _react2.default.createElement(
                'span',
                { className: 'bold' },
                'Judges:'
              ),
              ' ',
              judges.map(function (judge) {
                return judge.name;
              }).join(', ')
            ) : ''
          ) : ''
        ),
        active ? _react2.default.createElement(
          'div',
          {
            className: 'ibd-category__accordion ibd-category__accordion--' + index
          },
          list && list.length ? _react2.default.createElement(
            'div',
            { className: 'ibd-category__accordion-section ibd-category__accordion-section--list' },
            list.map(function (product) {
              return _react2.default.createElement(
                'div',
                { className: 'ibd-category__product-item' },
                _react2.default.createElement(
                  _Link2.default,
                  { to: '/gift/' + product.url },
                  _react2.default.createElement(
                    'figure',
                    { className: 'ibd-category__product-poster ibd-category__product-poster--item' },
                    _react2.default.createElement('img', {
                      alt: product.name,
                      src: processAssetServerImage((0, _get2.default)(product, 'image'))
                    })
                  ),
                  _react2.default.createElement(
                    'h4',
                    { className: 'ibd-category__product-name ibd-category__product-name--item' },
                    product.name
                  ),
                  _react2.default.createElement(
                    'h4',
                    { className: 'ibd-category__product-description ibd-category__product-description--item' },
                    (0, _striptags2.default)(product.description)
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'ibd-category__product-price' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '$',
                    product.price
                  ),
                  _react2.default.createElement(
                    'a',
                    { href: product.affiliate_link, target: '_blank' },
                    'Buy Now'
                  )
                )
              );
            })
          ) : null,
          winners && winners.length ? _react2.default.createElement(
            'div',
            { className: 'ibd-category__accordion-section ibd-category__accordion-section--winners' },
            _react2.default.createElement(
              'h3',
              { className: 'ibd-category__accordion-section-title' },
              _react2.default.createElement(
                'span',
                null,
                'Winners'
              )
            ),
            winners.map(function (winner) {
              return _react2.default.createElement(
                'div',
                { className: 'ibd-category__product-winner' },
                _react2.default.createElement(
                  'figure',
                  { className: 'ibd-category__product-poster ibd-category__product-poster--winner' },
                  _react2.default.createElement('img', {
                    alt: winner.name,
                    src: processAssetServerImage((0, _get2.default)(winner, 'image'))
                  })
                ),
                _react2.default.createElement(
                  'h4',
                  { className: 'ibd-category__product-name ibd-category__product-name--winner' },
                  winner.name
                ),
                winner[productFieldToDisplay] ? _react2.default.createElement(
                  'h4',
                  { className: 'ibd-category__product-description ibd-category__product-description--winner' },
                  (0, _striptags2.default)(winner[productFieldToDisplay])
                ) : '',
                winner.body ? _react2.default.createElement(
                  'div',
                  { className: 'ibd-category__credit' },
                  _react2.default.createElement(_show_more2.default, {
                    initialText: 'See Credits',
                    data: winner.body
                  })
                ) : ''
              );
            })
          ) : null,
          finalists && finalists.length ? _react2.default.createElement(
            'div',
            { className: 'ibd-category__accordion-section ibd-category__accordion-section--finalists' },
            _react2.default.createElement(
              'h3',
              { className: 'ibd-category__accordion-section-title' },
              _react2.default.createElement(
                'span',
                null,
                'Finalists'
              )
            ),
            finalists.map(function (product) {
              return _react2.default.createElement(
                'div',
                { className: 'ibd-category__product-finalists-and-mentions' },
                _react2.default.createElement(
                  'figure',
                  { className: 'ibd-category__product-poster' },
                  _react2.default.createElement('img', {
                    alt: product.name,
                    src: processAssetServerImage((0, _get2.default)(product, 'image'))
                  })
                ),
                _react2.default.createElement(
                  'h4',
                  { className: 'ibd-category__product-name' },
                  product.name
                ),
                product[productFieldToDisplay] ? _react2.default.createElement(
                  'h4',
                  { className: 'ibd-category__product-description' },
                  _react2.default.createElement('div', {
                    dangerouslySetInnerHTML: {
                      __html: (0, _striptags2.default)(product[productFieldToDisplay])
                    }
                  })
                ) : '',
                product.body ? _react2.default.createElement(
                  'div',
                  { className: 'ibd-category__credit' },
                  _react2.default.createElement(_show_more2.default, {
                    initialText: 'See Credits',
                    data: product.body
                  })
                ) : ''
              );
            })
          ) : null,
          mentions && mentions.length ? _react2.default.createElement(
            'div',
            { className: 'ibd-category__accordion-section ibd-category__accordion-section--mentions' },
            _react2.default.createElement(
              'h3',
              { className: 'ibd-category__accordion-section-title' },
              _react2.default.createElement(
                'span',
                null,
                'Honorable Mentions'
              )
            ),
            mentions.map(function (product) {
              return _react2.default.createElement(
                'div',
                { className: 'ibd-category__product-finalists-and-mentions' },
                _react2.default.createElement(
                  'figure',
                  { className: 'ibd-category__product-poster' },
                  _react2.default.createElement('img', {
                    alt: product.name,
                    src: processAssetServerImage((0, _get2.default)(product, 'image'))
                  })
                ),
                _react2.default.createElement(
                  'h4',
                  { className: 'ibd-category__product-name' },
                  product.name
                ),
                product[productFieldToDisplay] ? _react2.default.createElement(
                  'h4',
                  { className: 'ibd-category__product-description' },
                  _react2.default.createElement('div', {
                    dangerouslySetInnerHTML: {
                      __html: (0, _striptags2.default)((0, _striptags2.default)(product[productFieldToDisplay]))
                    }
                  })
                ) : '',
                product.body ? _react2.default.createElement(
                  'div',
                  { className: 'ibd-category__credit' },
                  _react2.default.createElement(_show_more2.default, {
                    initialText: 'See Credits',
                    data: product.body
                  })
                ) : ''
              );
            })
          ) : ''
        ) : ''
      );
    }
  }]);

  return IBDCategory;
}(_react.Component);

exports.default = IBDCategory;


IBDCategory.defaultProps = {
  slug: 'innovation-by-design',
  year: '',
  slugParam: ''
};

IBDCategory.propTypes = {
  category: _propTypes2.default.shape({}).isRequired,
  index: _propTypes2.default.string.isRequired,
  year: _propTypes2.default.string,
  active: _propTypes2.default.bool.isRequired,
  slug: _propTypes2.default.string,
  slugParam: _propTypes2.default.string
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = redirectPostUrl;
function redirectPostUrl() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: 'REDIRECT_POST_URL',
    status: resp.status,
    redirect: resp.redirect
  };
}

/***/ }),
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promisePolyfill = __webpack_require__(151);

var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

__webpack_require__(155);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(45);

var _createBrowserHistory = __webpack_require__(195);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _matchRoutes = __webpack_require__(221);

var _matchRoutes2 = _interopRequireDefault(_matchRoutes);

var _scriptjs = __webpack_require__(37);

var _scriptjs2 = _interopRequireDefault(_scriptjs);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _root_container = __webpack_require__(488);

var _root_container2 = _interopRequireDefault(_root_container);

__webpack_require__(681);

__webpack_require__(682);

var _store = __webpack_require__(683);

var _store2 = _interopRequireDefault(_store);

var _react_router = __webpack_require__(223);

var _react_router2 = _interopRequireDefault(_react_router);

var _initializer_util = __webpack_require__(819);

var _initializer_util2 = _interopRequireDefault(_initializer_util);

var _initial_load_action_creator = __webpack_require__(821);

var _initial_load_action_creator2 = _interopRequireDefault(_initial_load_action_creator);

var _logger_service = __webpack_require__(132);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _caching_service = __webpack_require__(234);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _picture_polyfill_util = __webpack_require__(822);

var _picture_polyfill_util2 = _interopRequireDefault(_picture_polyfill_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://github.com/reactjs/react-router/blob/master/docs/guides/ServerRendering.md
// https://github.com/reactjs/react-router-redux/blob/master/examples/server/client.js
if (!window.Promise) {
  window.Promise = _promisePolyfill2.default;
}

if (!Object.assign) {
  Object.assign = _assign2.default;
}

// eslint-disable-next-line import/extensions
// import 'autotrack/autotrack.js';


// eslint-disable-next-line no-underscore-dangle
window.__forceSmoothScrollPolyfill__ = true;
__webpack_require__(220).polyfill();

(0, _initializer_util2.default)().catch(function logError(err) {
  _logger_service2.default.error(err, 'Caught error in initialize.');
});

function bootReact() {
  var browserHistory = (0, _createBrowserHistory2.default)();

  var originalHash = browserHistory.location.hash;

  browserHistory.location.hash = '';

  // get json here
  var bootstrappedConfig = false;
  var env = false;

  try {
    bootstrappedConfig = window.appState;
    env = (0, _get2.default)(bootstrappedConfig, 'config.env');
    if (env !== 'development') {
      var criticalCss = document.querySelector('.critical-css');
      bootstrappedConfig.config.criticalCss = criticalCss.innerHTML;
    }
    _caching_service2.default.initialize(bootstrappedConfig.config.cacheEnabled);
    _logger_service2.default.initialize(bootstrappedConfig); // TODO: send, site etc for errors
    browserHistory.location.key = bootstrappedConfig.routing.location.key;
  } catch (error) {
    _logger_service2.default.fatal(error, 'Fatal error parsing bootstrap json.');
  }

  if (!bootstrappedConfig) {
    bootstrappedConfig = {}; // TODO: default bootstrap to handle errors
  }
  var store = (0, _store2.default)(browserHistory, bootstrappedConfig, env);

  var routesToMatch = (0, _react_router2.default)(store);

  // eslint-disable-next-line no-restricted-globals
  var preloadChunks = (0, _matchRoutes2.default)(routesToMatch, location.pathname).reduce(function matchReduce(list, _ref) {
    var route = _ref.route;

    if (route.preloadChunk) {
      list.push(route.preloadChunk);
    }
    return list;
  }, []);

  (0, _picture_polyfill_util2.default)();

  browserHistory.listen(function (location /* , action */) {
    var url = '' + location.pathname;
    var branch = (0, _matchRoutes2.default)(routesToMatch, url);
    branch.map(function matchMap(_ref2) {
      var route = _ref2.route,
          match = _ref2.match;

      if (route.preloadChunk) {
        return route.preloadChunk().then(function () {
          if (route.loadData) {
            if (!route.autoScrollOff) {
              window.scrollTo(0, 0);
            }
            return route.loadData(match);
          }
          return Promise.resolve(null);
        });
      }
      if (route.loadData) {
        if (!route.autoScrollOff) {
          window.scrollTo(0, 0);
        }
        return route.loadData(match);
      }
      return Promise.resolve(null);
    });

    if (window.googletag) {
      window.googletag.pubads().updateCorrelator();
    }
  });

  function renderedApp() {
    store.dispatch((0, _initial_load_action_creator2.default)());
    browserHistory.location.hash = originalHash;
    (0, _scriptjs2.default)('https://cdnjs.cloudflare.com/ajax/libs/autotrack/2.2.0/autotrack.js');
    document.documentElement.className += document.documentElement.className === '' ? 'hydrated' : ' hydrated';
  }

  if (!preloadChunks.length) {
    (0, _reactDom.hydrate)(_react2.default.createElement(_root_container2.default, { store: store, history: browserHistory }), window.document, renderedApp);
  } else {
    Promise.all(preloadChunks.map(function (chunk) {
      return chunk();
    })).then(function () {
      (0, _reactDom.hydrate)(_react2.default.createElement(_root_container2.default, { store: store, history: browserHistory }), window.document, renderedApp);
    });
  }

  if (false) {
    module.hot.accept(['../react_router/react_router', '../views/containers/root_container'], function () {
      // eslint-disable-next-line global-require
      var HotLoadRoot = require('../views/containers/root_container').default;
      (0, _reactDom.render)(_react2.default.createElement(HotLoadRoot, { store: store, history: browserHistory }), window.document);
    });
  }
}

// TODO: add image polyfill util here
if (!window.Map || !window.Set || !window.requestAnimationFrame) {
  (0, _scriptjs2.default)(['https://cdnjs.cloudflare.com/ajax/libs/babel-polyfill/6.26.0/polyfill.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/dom4/1.8.3/dom4.js'], bootReact);
} else {
  bootReact();
}

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _renderRoutes = __webpack_require__(222);

var _renderRoutes2 = _interopRequireDefault(_renderRoutes);

var _reactRouterRedux = __webpack_require__(51);

var _reactRedux = __webpack_require__(15);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _react_router = __webpack_require__(223);

var _react_router2 = _interopRequireDefault(_react_router);

var _head = __webpack_require__(674);

var _head2 = _interopRequireDefault(_head);

var _amp_head = __webpack_require__(678);

var _amp_head2 = _interopRequireDefault(_amp_head);

var _fbia_head = __webpack_require__(680);

var _fbia_head2 = _interopRequireDefault(_fbia_head);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Root(_ref) {
  var store = _ref.store,
      history = _ref.history,
      getRoutes = _ref.getRoutes;

  var state = store.getState();
  var amp = (0, _get2.default)(state, 'config.amp');
  var fbia = (0, _get2.default)(state, 'config.fbia');

  if (amp) {
    return _react2.default.createElement(
      _reactRedux.Provider,
      { store: store },
      _react2.default.createElement(
        _reactRouterRedux.ConnectedRouter,
        { history: history },
        _react2.default.createElement(
          'html',
          { amp: '', lang: 'en-US', className: 'fonts-loaded' },
          _react2.default.createElement(_amp_head2.default, null),
          (0, _renderRoutes2.default)(getRoutes(store))
        )
      )
    );
  }

  if (fbia) {
    return _react2.default.createElement(
      _reactRedux.Provider,
      { store: store },
      _react2.default.createElement(
        _reactRouterRedux.ConnectedRouter,
        { history: history },
        _react2.default.createElement(
          'html',
          { lang: 'en-US', prefix: 'op: http://media.facebook.com/op#' },
          _react2.default.createElement(_fbia_head2.default, null),
          (0, _renderRoutes2.default)(getRoutes(store))
        )
      )
    );
  }

  return _react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(
      _reactRouterRedux.ConnectedRouter,
      { history: history },
      _react2.default.createElement(
        'html',
        { lang: 'en-US' },
        _react2.default.createElement(_head2.default, null),
        (0, _renderRoutes2.default)((0, _react_router2.default)(store))
      )
    )
  );
}

Root.defaultProps = {
  getRoutes: undefined
};

Root.propTypes = {
  store: _propTypes2.default.shape({}).isRequired,
  history: _propTypes2.default.shape({}).isRequired,
  getRoutes: _propTypes2.default.func
};

exports.default = Root;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(15);

var _renderRoutes = __webpack_require__(222);

var _renderRoutes2 = _interopRequireDefault(_renderRoutes);

var _matchRoutes = __webpack_require__(221);

var _matchRoutes2 = _interopRequireDefault(_matchRoutes);

var _withRouter = __webpack_require__(59);

var _withRouter2 = _interopRequireDefault(_withRouter);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _error_boundary = __webpack_require__(490);

var _error_boundary2 = _interopRequireDefault(_error_boundary);

var _default_error = __webpack_require__(491);

var _default_error2 = _interopRequireDefault(_default_error);

var _ad_util = __webpack_require__(5);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _client_util = __webpack_require__(40);

var _client_util2 = _interopRequireDefault(_client_util);

var _ad = __webpack_require__(24);

var _ad2 = _interopRequireDefault(_ad);

var _analytics = __webpack_require__(494);

var _analytics2 = _interopRequireDefault(_analytics);

var _nav = __webpack_require__(513);

var _nav2 = _interopRequireDefault(_nav);

var _nav_data = __webpack_require__(516);

var _nav_data2 = _interopRequireDefault(_nav_data);

var _recirc = __webpack_require__(517);

var _recirc2 = _interopRequireDefault(_recirc);

var _footer = __webpack_require__(525);

var _footer2 = _interopRequireDefault(_footer);

var _config = __webpack_require__(526);

var _config2 = _interopRequireDefault(_config);

var _script = __webpack_require__(228);

var _script2 = _interopRequireDefault(_script);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Layout = function (_Component) {
  _inherits(Layout, _Component);

  function Layout(props) {
    _classCallCheck(this, Layout);

    var _this = _possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).call(this));

    var adzoneParam = (0, _get2.default)(props, 'config.initialQueryParams.adzone');
    _this.IS_QA_ADZONE = adzoneParam === 'qa';
    _this.hasFooter = true;
    var routes = (0, _get2.default)(props, 'route.routes');
    var pathname = (0, _get2.default)(props, 'location.pathname');
    // console.log(matchRoutes(routes, pathname));
    if (routes && pathname) {
      _this.chunks = (0, _matchRoutes2.default)(routes, pathname).reduce(function matchMap(list, item) {
        if ((0, _get2.default)(item, 'route.chunk')) {
          list.push(item.route.chunk);
        }
        return list;
      }, []);
    } else {
      _this.chunks = [];
    }
    return _this;
  }

  _createClass(Layout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.IS_QA_ADZONE) {
        this.browsiScript();
      }
    }
  }, {
    key: 'livereload',
    value: function livereload(env) {
      if (env === 'development') {
        return _react2.default.createElement('script', { src: '//localhost:35729/livereload.js', defer: true });
      }
      return '';
    }
  }, {
    key: 'scriptbundle',
    value: function scriptbundle(env) {
      if (env === 'development') {
        return [_react2.default.createElement('script', { key: 'vendor', src: '//localhost:3001/static/vendor.js', defer: true }), _react2.default.createElement('script', { key: 'bundle', src: '//localhost:3001/static/bundle.js', defer: true })];
      }

      if (env === 'test') {
        return [_react2.default.createElement('script', {
          key: 'vendor',
          src: '/js/' + this.props.manifestJSON['vendor.js'],
          defer: true
        }), _react2.default.createElement('script', {
          key: 'bundle',
          src: '/js/' + this.props.manifestJSON['app.js'],
          defer: true
        })];
      }

      return [_react2.default.createElement('script', {
        key: 'vendor',
        src: this.props.staticVendorUrl + '/' + this.props.manifestJSON['vendor.js'],
        defer: true
      }), _react2.default.createElement('script', {
        key: 'bundle',
        src: this.props.staticBundleUrl + '/js/' + this.props.manifestJSON['app.js'],
        defer: true
      })];
    }
  }, {
    key: 'scriptChunks',
    value: function scriptChunks(env) {
      var _this2 = this;

      if (env === 'development') {
        return null;
      }

      if (env === 'test') {
        return this.chunks.map(function (chunk) {
          return _react2.default.createElement('script', {
            key: chunk,
            src: '/js/' + _this2.props.manifestJSON[chunk + '.js'],
            defer: true
          });
        });
      }

      // dhm3b9kzksoul.cloudfront.net/bundle/js/23.bundle.948afa47006e5ca983f3.js
      return this.chunks.map(function (chunk) {
        return _react2.default.createElement('script', {
          key: chunk,
          src: _this2.props.staticBundleUrl + '/js/' + _this2.props.manifestJSON[chunk + '.js'],
          defer: true
        });
      });
    }
  }, {
    key: 'browsiScript',
    value: function browsiScript() {
      if (!(0, _client_util2.default)() && !document.querySelector('#browsi-tag')) {
        var script = document.createElement('script');
        script.src = 'https://middycdn-a.akamaihd.net/bootstrap/bootstrap.js';
        script.id = 'browsi-tag';
        script.setAttribute('data-pubkey', 'mansueto');
        script.setAttribute('data-sitekey', (0, _get2.default)(this.props, 'config.site', ''));

        document.querySelector('body').appendChild(script);
      }
    }
  }, {
    key: 'adIframe',
    value: function adIframe(site) {
      if ((0, _get2.default)(this.props, 'config.featureFlags.adOpsIframe')) {
        // Used by adops to check if js is enabled
        var adSite = site === 'fastcompany' ? 'fc' : 'fcdesign';
        var iframeSrc = 'https://pubads.g.doubleclick.net/gampad/adx?iu=/4160/mv.' + adSite + '/javascript_disabled&sz=1x1';
        var innerHtml = '<iframe width="1" height="1" frameBorder="0" scrolling="no" src="' + iframeSrc + '" />';

        return _react2.default.createElement('noscript', { dangerouslySetInnerHTML: { __html: innerHtml } });
      }
      return null;
    }
  }, {
    key: 'topNavAd',
    value: function topNavAd(location, site) {
      if (location.pathname !== '/') {
        return null;
      }
      var adData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, null, 'homepage');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      return _react2.default.createElement(
        'div',
        { className: 'homepage-page__ff-ad-container homepage-page__ff-ad-container--navtop' },
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'welcomemat' }))
      );
    }
  }, {
    key: 'analyticsHeader',
    value: function analyticsHeader() {
      // eslint-disable-next-line class-methods-use-this
      var listOfAnalytics = ['krux', 'comscore', 'nielsen', 'googleAnalytics', 'facebookPixel'];
      return _react2.default.createElement(_analytics2.default, { location: 'header', listOfAnalytics: listOfAnalytics });
    }
  }, {
    key: 'analyticsFooter',
    value: function analyticsFooter(featureFlags) {
      // eslint-disable-next-line class-methods-use-this
      var listOfAnalytics = ['comscore', 'nielsen', 'omniture', 'parsely', 'structuredData', 'moatad'];

      if (featureFlags.liftIgniterEnabled) {
        listOfAnalytics.push('liftIgniter');
      }
      return _react2.default.createElement(_analytics2.default, { location: 'footer', listOfAnalytics: listOfAnalytics });
    }
  }, {
    key: 'postUp',
    value: function postUp() {
      return _react2.default.createElement(_script2.default, {
        type: 'text/javascript',
        innerHtml: "(function () {window.setTimeout(function() {var e = document.createElement('script'); e.type = 'text/javascript'; e.async = true; e.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'www.lightboxcdn.com/vendor/252af0a6-c9ae-4612-9dbe-5d1552fad623/lightbox_inline.js?mb=' + (new Date().getTime()); var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(e, s);}, 500);})();"
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          pageType = _props.pageType,
          recircFeed = _props.recircFeed,
          config = _props.config;

      var featureFlags = (0, _get2.default)(config, 'featureFlags');
      var env = (0, _get2.default)(config, 'env', '');
      var site = (0, _get2.default)(config, 'site', '');

      var activeCategory = '';

      if (this.props.pageType === 'category' || this.props.pageType === 'videoIndexPage') {
        activeCategory = location.pathname;
      }
      var hasTopNavAd = featureFlags.topNavAdEnabled && location.pathname === '/';

      return _react2.default.createElement(
        'body',
        {
          className: 'layout ' + (pageType ? 'layout--' + pageType : '') + ' ' + (hasTopNavAd ? 'layout--has-top-nav-ad' : '') + ' ' + site
        },
        this.analyticsHeader(),
        featureFlags.topNavAdEnabled ? this.topNavAd(location, site) : null,
        _react2.default.createElement(_nav2.default, _extends({
          isHome: location.pathname === '/',
          activeCategory: activeCategory,
          modifier: site,
          config: config
        }, _nav_data2.default[site])),
        _react2.default.createElement(
          'section',
          { className: 'main', role: 'main' },
          _react2.default.createElement(
            _error_boundary2.default,
            {
              onError: function onError(error, info) {
                _logger_service2.default.error(info, error);
              },
              errorComponent: _react2.default.createElement(_default_error2.default, null)
            },
            (0, _renderRoutes2.default)(this.props.route.routes)
          ),
          !(0, _get2.default)(this.props, 'recircFeed.hide') && _react2.default.createElement(_recirc2.default, { config: config, feed: recircFeed })
        ),
        _react2.default.createElement(_footer2.default, null),
        this.analyticsFooter(featureFlags),
        this.livereload(env),
        _react2.default.createElement(_config2.default, null),
        this.scriptbundle(env),
        this.scriptChunks(env),
        this.IS_QA_ADZONE ? '' : this.postUp(),
        this.adIframe(site)
      );
    }
  }]);

  return Layout;
}(_react.Component);

function mapStateToProps(state) {
  return {
    config: state.config,
    manifestJSON: state.config.manifestJSON,
    staticVendorUrl: state.config.staticVendorUrl,
    staticBundleUrl: state.config.staticBundleUrl,
    pageType: state.context.type || '',
    recircFeed: {
      hide: (0, _get2.default)(state, 'recircFeed.hide'),
      fastcompany: (0, _get2.default)(state, 'recircFeed.data.fastcompany') || [],
      fastcodesign: (0, _get2.default)(state, 'recircFeed.data.fastcodesign') || [],
      fastcocreate: (0, _get2.default)(state, 'recircFeed.data.fastcocreate') || [],
      fastcoexist: (0, _get2.default)(state, 'recircFeed.data.fastcoexist') || []
    },
    postFinite: (0, _get2.default)(state, 'postFinite.data.posts') || []
  };
}

Layout.propTypes = {
  route: _propTypes2.default.shape({
    routes: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
  }).isRequired,
  config: _propTypes2.default.shape({}).isRequired,
  manifestJSON: _propTypes2.default.shape({
    'vendor.js': _propTypes2.default.string,
    'app.js': _propTypes2.default.string
  }).isRequired,
  staticBundleUrl: _propTypes2.default.string.isRequired,
  staticVendorUrl: _propTypes2.default.string.isRequired,
  pageType: _propTypes2.default.string.isRequired,
  location: _propTypes2.default.shape({ pathname: _propTypes2.default.string }).isRequired,
  recircFeed: _propTypes2.default.shape({
    hide: _propTypes2.default.bool,
    fastcompany: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    fastcocreate: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    fastcodesign: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    fastcoexist: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
  }).isRequired
};

exports.default = (0, _withRouter2.default)((0, _reactRedux.connect)(mapStateToProps)(Layout));

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorBoundary = function (_Component) {
  _inherits(ErrorBoundary, _Component);

  function ErrorBoundary() {
    _classCallCheck(this, ErrorBoundary);

    var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this));

    _this.state = {
      hasError: false
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: 'componentDidCatch',
    value: function componentDidCatch(error, info) {
      this.setState({ hasError: true });
      this.props.onError(error, info);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          errorComponent = _props.errorComponent;


      if (this.state.hasError) {
        return errorComponent;
      }

      return children;
    }
  }]);

  return ErrorBoundary;
}(_react.Component);

ErrorBoundary.defaultProps = {
  onError: function onError() {}
};

ErrorBoundary.propTypes = {
  onError: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired,
  errorComponent: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired
};

exports.default = ErrorBoundary;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DefaultError() {
  return _react2.default.createElement(
    "div",
    { className: "error-boundary" },
    _react2.default.createElement(
      "p",
      { className: "error-boundary__message" },
      "We have a problem..."
    )
  );
}

exports.default = DefaultError;

/***/ }),
/* 492 */,
/* 493 */,
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(15);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _last = __webpack_require__(124);

var _last2 = _interopRequireDefault(_last);

var _isFunction = __webpack_require__(104);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _comscore = __webpack_require__(495);

var _comscore2 = _interopRequireDefault(_comscore);

var _facebookpixel = __webpack_require__(496);

var _facebookpixel2 = _interopRequireDefault(_facebookpixel);

var _ga = __webpack_require__(497);

var _ga2 = _interopRequireDefault(_ga);

var _krux = __webpack_require__(503);

var _krux2 = _interopRequireDefault(_krux);

var _moatad = __webpack_require__(504);

var _moatad2 = _interopRequireDefault(_moatad);

var _nielsen = __webpack_require__(505);

var _nielsen2 = _interopRequireDefault(_nielsen);

var _omniture = __webpack_require__(506);

var _omniture2 = _interopRequireDefault(_omniture);

var _parsely = __webpack_require__(507);

var _parsely2 = _interopRequireDefault(_parsely);

var _pingdom = __webpack_require__(508);

var _pingdom2 = _interopRequireDefault(_pingdom);

var _structured_data = __webpack_require__(509);

var _structured_data2 = _interopRequireDefault(_structured_data);

var _trackjs = __webpack_require__(511);

var _trackjs2 = _interopRequireDefault(_trackjs);

var _lift_igniter = __webpack_require__(512);

var _lift_igniter2 = _interopRequireDefault(_lift_igniter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// Trackers


/**
 * An analytics component that's broken up to 2 sections, header and footer
 * Pass in the name of the tags you want to display in props
 * and the system will determine what to render
 */
var Analytics = function (_Component) {
  _inherits(Analytics, _Component);

  function Analytics(props) {
    _classCallCheck(this, Analytics);

    var _this = _possibleConstructorReturn(this, (Analytics.__proto__ || Object.getPrototypeOf(Analytics)).call(this, props));

    _this.comscore = _comscore2.default;
    _this.facebookPixel = _facebookpixel2.default;
    _this.googleAnalytics = _ga2.default;
    _this.krux = _krux2.default;
    _this.moatad = _moatad2.default;
    _this.nielsen = _nielsen2.default;
    _this.omniture = _omniture2.default;
    _this.parsely = _parsely2.default;
    _this.pingdom = _pingdom2.default;
    _this.structuredData = _structured_data2.default;
    _this.trackjs = _trackjs2.default;
    _this.liftIgniter = _lift_igniter2.default;
    return _this;
  }

  _createClass(Analytics, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'renderAnalyticsDangerously',
    value: function renderAnalyticsDangerously(context, location, listOfAnalytics, firstLoad, url, isFBIA) {
      var _this2 = this;

      // Create a string of all analytics code
      var combinedAnalytics = '';

      if (!isFBIA) {
        combinedAnalytics = '<!-- ANALYTICS ' + location.toUpperCase() + ' START -->';
      }

      listOfAnalytics.forEach(function (analyticTag) {
        if ((0, _isFunction2.default)(_this2[analyticTag])) {
          combinedAnalytics += _this2[analyticTag](context, location, firstLoad, url, isFBIA);
        }
      });

      if (!isFBIA) {
        combinedAnalytics += '<!-- ANALYTICS ' + location.toUpperCase() + ' END -->';
      }
      return { __html: combinedAnalytics };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          listOfAnalytics = _props.listOfAnalytics;

      var firstLoad = this.props.initialPageLoad;
      var context = null;

      if (firstLoad) {
        try {
          var currentState = JSON.parse((0, _get2.default)(this.props, 'state'));
          var top = (0, _get2.default)(currentState, 'featuredFeed.data.top') || [];
          var featured = (0, _get2.default)(currentState, 'featuredFeed.data.featured') || [];
          var homeList = top.concat(featured);

          var categoryTop = (0, _get2.default)(currentState, 'categoryFeaturedFeed.top') || [];
          var categoryFeatured = (0, _get2.default)(currentState, 'categoryFeaturedFeed.featured') || [];
          var categoryHomeList = categoryTop.concat(categoryFeatured);

          var tagTop = (0, _get2.default)(currentState, 'tagFeaturedFeed.top') || [];
          var tagFeatured = (0, _get2.default)(currentState, 'tagFeaturedFeed.featured') || [];
          var tagHomeList = tagTop.concat(tagFeatured);

          var playlistAllFeedData = (0, _get2.default)(currentState, 'playlistAllFeed') || [];
          context = (0, _get2.default)(currentState, 'context');

          context.config = (0, _get2.default)(currentState, 'config');
          context.postData = (0, _get2.default)(currentState, 'post.data.post', null) || (0, _get2.default)(currentState, 'previewPost.data.post', null);
          context.tagPageData = (0, _get2.default)(currentState, 'tagFeaturedFeed.tag', null);
          context.categoryPageData = (0, _get2.default)(currentState, 'categoryFeaturedFeed.category', null);
          context.authorPageData = (0, _get2.default)(currentState, 'author.data', null);
          context.playlistAllFeedData = playlistAllFeedData;

          context.authorAllFeed = (0, _get2.default)(currentState, 'authorAllFeed.data.posts', []);
          context.searchPageData = (0, _get2.default)(currentState, 'search.data', null);
          context.staticPageData = (0, _get2.default)(currentState, 'customPage.data.page[0]', null);
          context.statusCode = (0, _get2.default)(currentState, 'status.code');
          context.homeList = homeList || null;
          context.categoryHomeList = categoryHomeList || null;
          context.tagHomeList = tagHomeList || null;
          context.mostCreativePeoplePageData = (0, _get2.default)(currentState, 'mostCreativePeople', null);
          context.personPageData = (0, _get2.default)(currentState, 'person', null);
          context.ibdPageData = (0, _get2.default)(currentState, 'innovationByDesign', null);
          context.giftGuideData = (0, _get2.default)(currentState, 'giftGuide', null);
          context.companyPageData = (0, _get2.default)(currentState, 'tagAllFeed', null);
          context.micYearPageData = (0, _get2.default)(currentState, 'micYear', null);
          context.micSectorPageData = (0, _get2.default)(currentState, 'micSector', null);
          context.videoPageData = (0, _get2.default)(currentState, 'jwVideo', null);
          context.videoIndexPageData = (0, _get2.default)(currentState, 'jwVideoIndex', null);

          context.magazineArchivePageData = (0, _get2.default)(currentState, 'magazineArchivePage', null);
          context.productPageData = (0, _get2.default)(currentState, 'product', null);
        } catch (e) {
          _logger_service2.default.error(e, 'Unable to parse context for the page');
        }
        /* eslint-disable */

        return _react2.default.createElement('div', {
          dangerouslySetInnerHTML: this.renderAnalyticsDangerously(context, location, listOfAnalytics, firstLoad, this.props.url, this.props.isFBIA)
        });
        /* eslint-enable */
      }
      return null;
    }
  }]);

  return Analytics;
}(_react.Component);

Analytics.defaultProps = {
  isFBIA: false
};

Analytics.propTypes = {
  initialPageLoad: _propTypes2.default.bool.isRequired,
  location: _propTypes2.default.string.isRequired,
  listOfAnalytics: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  isFBIA: _propTypes2.default.bool
};

function mapStateToProps(state) {
  var initialPageLoad = state.config.initialPageLoad;

  var currentState = initialPageLoad ? JSON.stringify(state) : '';
  return {
    url: (0, _last2.default)((0, _get2.default)(state, 'config.navHistory', [])),
    state: currentState,
    initialPageLoad: initialPageLoad
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Analytics);

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = comscore;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(17);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function comscore(context, location) {
  var siteConfig = _identity2.default[context.site];

  if (siteConfig === undefined) {
    return '';
  }

  var comscoreConfig = (0, _get2.default)(siteConfig, 'comscore');
  var c1 = comscoreConfig.c1,
      publisherId = comscoreConfig.publisherId;


  if (location === 'header') {
    return '\n      <script>\n        var _comscore = _comscore || [];\n        _comscore.push({ c1: "' + c1 + '", c2: "' + publisherId + '" });\n        (function() {\n        var s = document.createElement("script"), el = document.getElementsByTagName("script")[0]; s.async = true;\n        s.src = (document.location.protocol == "https:" ? "https://sb" : "http://b") + ".scorecardresearch.com/beacon.js";\n        el.parentNode.insertBefore(s, el);\n        })();\n      </script>\n    ';
  }

  return '<noscript><img src="http://b.scorecardresearch.com/p?c1=' + c1 + '&c2=' + publisherId + '&cv=2.0&cj=1" /></noscript>';
}

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = facebookpixel;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(17);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function facebookpixel(context) {
  var siteConfig = _identity2.default[context.site];

  if (siteConfig === undefined) {
    return '';
  }

  var facebookConfig = (0, _get2.default)(siteConfig, 'facebookPixel');
  var id = facebookConfig.id;


  return '\n    <script>\n      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n              n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;\n          n.push=n;n.loaded=!0;n.version=\'2.0\';n.queue=[];t=b.createElement(e);t.async=!0;\n          t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,\n              document,\'script\',\'//connect.facebook.net/en_US/fbevents.js\');\n      fbq(\'init\', \'' + id + '\');\n      fbq(\'track\', "PageView");\n    </script>\n  <noscript><img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=' + id + '&ev=PageView&noscript=1" /></noscript>\n  ';
}

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ga;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _forEach = __webpack_require__(93);

var _forEach2 = _interopRequireDefault(_forEach);

var _toNumber = __webpack_require__(65);

var _toNumber2 = _interopRequireDefault(_toNumber);

var _ad_util = __webpack_require__(5);

var _identity = __webpack_require__(17);

var _identity2 = _interopRequireDefault(_identity);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ga(context, location, firstLoad, url, isFBIA) {
  var siteConfig = _identity2.default[context.site];

  if (siteConfig === undefined) {
    _logger_service2.default.error('GA IS NOT LOADING ON THIS PAGE TYPE ' + (0, _get2.default)(context, 'type') + ' BECAUSE SITECONFIG IS UNDEFINED');
    return '';
  }

  var gaConfig = (0, _get2.default)(siteConfig, 'googleAnalytics');
  var webPropertyId = (0, _get2.default)(gaConfig, 'webPropertyId', 'UA-4300461-40');
  var rollupPropertyId = gaConfig.rollupPropertyId;

  var siteSlug = (0, _get2.default)(siteConfig, 'slug', 'fastcompany');

  if ((0, _get2.default)(context, 'config.featureFlags.gaCustomVarEnabled')) {
    var postData = context.postData,
        tagPageData = context.tagPageData,
        categoryPageData = context.categoryPageData,
        mostCreativePeoplePageData = context.mostCreativePeoplePageData,
        micSectorPageData = context.micSectorPageData,
        ibdPageData = context.ibdPageData,
        productPageData = context.productPageData,
        micPageData = context.micPageData,
        type = context.type;


    var _category = '';
    var _tag = '';

    var legacyDomain = siteSlug;
    var customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'homepage' }, { dimension3: 'Unassigned' }, { dimension2: 'Unassigned' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];

    var typeLookup = {
      post: function post() {
        _category = (0, _get2.default)(postData, 'categories[0].slug');
        var tags = (0, _get2.default)(postData, 'tags');
        var eyeBrowText = (0, _ad_util.figureOutPriorityTag)(tags);

        var bylineAttribution = null;

        (0, _forEach2.default)(tags, function (tagObj) {
          if (tagObj.name.indexOf('byline_') !== -1 || tagObj.slug.indexOf('byline-') !== -1) {
            bylineAttribution = tagObj.name.replace('byline_', '');
          }
        });

        // For mapping of language, anaytics need to be consistent, language wise
        var pageType = 'unassigned';
        if ((0, _get2.default)(postData, 'posterSlideshow.length')) {
          pageType = 'slideshow';
        } else if ((0, _get2.default)(postData, 'hasVideoPoster') === true || (0, _get2.default)(postData, 'posterVideo.feedId')) {
          pageType = 'video';
        } else {
          pageType = 'article';
        }

        if (_category === 'ideas') {
          legacyDomain = 'Fastcoexist.com';
        } else if (_category === 'entertainment') {
          legacyDomain = 'FastcoCreate.com';
        } else if (_category === 'news') {
          legacyDomain = 'News';
        }

        var minutesRead = (0, _get2.default)(postData, 'readTime');
        if (minutesRead !== 'long') {
          minutesRead = (0, _toNumber2.default)(minutesRead.replace(' minute', '')) || '0';
        }

        customDimensions = [{ dimension1: legacyDomain }, { dimension2: _category }, { dimension6: (0, _get2.default)(postData, 'omnitureDate') }, { dimension7: pageType }, { dimension8: minutesRead }, { dimension9: 0 }];

        if (bylineAttribution) {
          customDimensions.push({ dimension4: bylineAttribution });
          customDimensions.push({
            dimension5: (0, _get2.default)(postData, 'author.name', 'Fast Company')
          });
        } else {
          customDimensions.push({ dimension4: (0, _get2.default)(postData, 'author.name') });
          customDimensions.push({ dimension5: 'Fast Company' });
        }

        var eyeBrowTag = (0, _get2.default)(eyeBrowText, 'name');
        if (eyeBrowTag !== '') {
          customDimensions.push({ dimension3: eyeBrowTag });
        } else {
          customDimensions.push({ dimension3: 'notag' });
        }
      },
      category: function category() {
        _category = (0, _get2.default)(categoryPageData, 'slug');
        customDimensions = [{ dimension1: legacyDomain }, { dimension2: _category }, { dimension7: 'category page' }, { dimension3: 'notag' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
      },
      tag: function tag() {
        _tag = (0, _get2.default)(tagPageData, 'name');
        customDimensions = [{ dimension1: legacyDomain }, { dimension3: _tag }, { dimension7: 'section page' }, { dimension2: 'Unassigned' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
      },
      author: function author() {
        customDimensions = [{ dimension1: legacyDomain }, { dimension7: type }, { dimension3: 'Unassigned' }, { dimension2: 'Unassigned' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
      },
      search: function search() {
        customDimensions = [{ dimension1: legacyDomain }, { dimension7: type }, { dimension3: 'Unassigned' }, { dimension2: 'Unassigned' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
      },
      page: function page() {
        customDimensions = [{ dimension1: legacyDomain }, { dimension7: type }, { dimension3: 'Unassigned' }, { dimension2: 'Unassigned' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
      },
      personPage: function personPage() {
        customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'person page' }, { dimension3: 'Unassigned' }, { dimension2: 'person' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
      },
      personIndexSectionPage: function personIndexSectionPage() {
        customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'person index page' }, { dimension3: 'Unassigned' }, { dimension2: 'person' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
      },
      productPage: function productPage() {
        var productName = (0, _get2.default)(productPageData, 'data.rows[0].name');
        customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'product page' }, { dimension3: 'product:' + productName }, { dimension2: 'product' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
      },
      mostCreativePeoplePage: function mostCreativePeoplePage() {
        var year = (0, _get2.default)(mostCreativePeoplePageData, 'year', '');
        customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'mcp page' }, { dimension3: 'mcp' + year }, { dimension2: 'mcp' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
      },
      mostCreativePeopleCommunityPage: function mostCreativePeopleCommunityPage() {
        customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'mcp community page' }, { dimension3: 'Unassigned' }, { dimension2: 'mcp' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
      },
      ibdPage: function ibdPage() {
        var year = (0, _get2.default)(ibdPageData, 'year', '');
        customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'ibd page' }, { dimension3: 'ibd' + year }, { dimension2: 'ibd' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
      },
      companyPage: function companyPage() {
        customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'company page' }, { dimension3: 'company' }, { dimension2: 'company' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
      },
      micYearPage: function micYearPage() {
        var year = (0, _get2.default)(micPageData, 'year', '');
        customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'mic year page' }, { dimension3: 'mic' + year }, { dimension2: 'mic' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
      },
      companyIndexSectionPage: function companyIndexSectionPage() {
        customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'company sector index page' }, { dimension3: 'Unassigned' }, { dimension2: 'mic' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
      },
      micSectorPage: function micSectorPage() {
        var year = (0, _get2.default)(micSectorPageData, 'year', '');
        customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'mic sector page' }, { dimension3: 'mic' + year }, { dimension2: 'mic' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
      },
      magazineArchivePage: function magazineArchivePage() {
        customDimensions = [{ dimension1: legacyDomain }, { dimension7: 'magazine archives page' }, { dimension3: 'magazine' }, { dimension2: 'magazine' }, { dimension4: 'Fast Company' }, { dimension5: 'Fast Company' }, { dimension6: '1/1/1990' }, { dimension8: 0 }, { dimension9: 0 }];
      }
    };

    if (typeLookup[type]) {
      typeLookup[type]();
    }

    var gaDimensionTracker = customDimensions.map(function (dimension) {
      if (!dimension) {
        return '';
      }
      var key = Object.keys(dimension)[0];
      return '\n        ga(\'rollup.set\', \'' + key + '\', \'' + dimension[key] + '\');\n      ';
    }).join('');

    return '\n    <script>\n      (function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){\n      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n      })(window,document,\'script\',\'//www.google-analytics.com/analytics.js\',\'ga\');\n\n      ga(\'create\', \'' + webPropertyId + '\', \'auto\');\n      ga(\'create\', \'' + rollupPropertyId + '\', \'auto\', {\'name\': \'rollup\'});\n      ' + gaDimensionTracker + '\n      ' + (isFBIA ? 'ga(\'set\', \'campaignSource\', \'Facebook\');\n      ga(\'set\', \'campaignMedium\', \'Social Instant Article\');\n      ga(\'rollup.set\', \'campaignSource\', \'Facebook\');\n      ga(\'rollup.set\', \'campaignMedium\', \'Social Instant Article\');' : '') + '\n      ga(\'send\', \'pageview\');\n      ga(\'rollup.send\', \'pageview\');\n      ga(\'require\', \'eventTracker\');\n      ga(\'require\', \'cleanUrlTracker\');\n      ga(\'require\', \'impressionTracker\');\n      ga(\'require\', \'mediaQueryTracker\');\n      ga(\'require\', \'outboundFormTracker\');\n      ga(\'require\', \'outboundLinkTracker\');\n      ga(\'require\', \'pageVisibilityTracker\');\n      ga(\'require\', \'socialWidgetTracker\');\n      ga(\'require\', \'urlChangeTracker\');\n    </script>';
  }

  return '\n  <script>\n    (function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){\n    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n    })(window,document,\'script\',\'//www.google-analytics.com/analytics.js\',\'ga\');\n\n    ga(\'create\', \'' + webPropertyId + '\', \'auto\');\n    ga(\'create\', \'' + rollupPropertyId + '\', \'auto\', {\'name\': \'rollup\'});\n    ga(\'send\', \'pageview\');\n    ga(\'rollup.send\', \'pageview\');\n    ga(\'require\', \'eventTracker\');\n    ga(\'require\', \'cleanUrlTracker\');\n    ga(\'require\', \'impressionTracker\');\n    ga(\'require\', \'mediaQueryTracker\');\n    ga(\'require\', \'outboundFormTracker\');\n    ga(\'require\', \'outboundLinkTracker\');\n    ga(\'require\', \'pageVisibilityTracker\');\n    ga(\'require\', \'socialWidgetTracker\');\n    ga(\'require\', \'urlChangeTracker\');\n    ' + (isFBIA ? 'ga(\'set\', \'campaignSource\', \'Facebook\');\n    ga(\'set\', \'campaignMedium\', \'Social Instant Article\');\n    ga(\'rollup.set\', \'campaignSource\', \'Facebook\');\n    ga(\'rollup.set\', \'campaignMedium\', \'Social Instant Article\');' : '') + '\n  </script>';
}

/***/ }),
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = krux;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(17);

var _identity2 = _interopRequireDefault(_identity);

var _string_util = __webpack_require__(131);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function krux(context) {
  var postData = context.postData,
      type = context.type;

  var siteConfig = _identity2.default[context.site];
  if (siteConfig === undefined) {
    return '';
  }
  var kruxConfig = (0, _get2.default)(siteConfig, 'krux');
  var keywords = (0, _get2.default)(siteConfig, 'keywords') || [];
  var siteName = (0, _get2.default)(siteConfig, 'siteName') || '';
  var KruxID = (0, _get2.default)(kruxConfig, 'id');
  var topicList = [];
  var category = '';
  var authorName = '';
  var articleId = null;
  var contentType = type;

  if (type === 'post') {
    topicList = (0, _get2.default)(postData, 'tags');
    category = (0, _get2.default)(postData, 'categories[0].slug');
    authorName = (0, _get2.default)(postData, 'author.name');
    articleId = (0, _get2.default)(postData, 'id');

    contentType = 'article';
    if ((0, _get2.default)(postData, 'posterSlideshow.length')) {
      contentType = 'slideshow';
    } else if ((0, _get2.default)(postData, 'hasVideoPoster') === true || (0, _get2.default)(postData, 'posterVideo.feedId')) {
      contentType = 'video';
    }
  }

  // On topic pages category is being passed in as the third param
  var tags = '';

  if (topicList) {
    topicList.forEach(function (tag, index) {
      if (index !== topicList.length - 1) {
        tags += '"' + tag.name + '",';
      } else {
        tags += '"' + tag.name + '"';
      }
    });
  }

  var KruxPreScript = '<script class="kxct" data-id="' + KruxID + '" data-timing="async" data-version="1.9" type="text/javascript"> window.Krux||((Krux=function(){Krux.q.push(arguments)}).q=[]); (function(){ var k=document.createElement("script");k.type="text/javascript";k.async=true; var m,src=(m=location.href.match(/\\bkxsrc=([^&]+)/))&&decodeURIComponent(m[1]); k.src = /^https?:\\/\\/([a-z0-9_\\-\\.]+\\.)?krxd\\.net(:\\d{1,5})?\\//i.test(src) ? src : src === "disable" ? "" : (location.protocol==="https:"?"https:":"http:")+"//cdn.krxd.net/controltag?confid=' + KruxID + '" ; var s=document.getElementsByTagName("script")[0];s.parentNode.insertBefore(k,s); }()); </script>';

  return '\n  ' + KruxPreScript + '\n  <script>\n      FC_Krux_FPA = {\n          author: null,\n          channels: null,\n          subChannels: null,\n          contentType: null,\n          keywords: null,\n          socialTags: null,\n          siteName: null,\n          referrerUrl: null,\n          url: location.origin + location.pathname,\n          querystring: null\n      };\n      FC_Krux_FPA[\'Read Length\'] = null;\n      FC_Krux_FPA[\'Article ID\'] = ' + articleId + ';\n      FC_Krux_FPA[\'Subchannel\'] = ' + (category ? (0, _string_util.addQuotes)(category.toString()) : null) + ';\n      FC_Krux_FPA[\'Channel\'] = ' + (category ? (0, _string_util.addQuotes)(category.toString()) : null) + ';\n\n      if(location.search !== \'\') {\n          FC_Krux_FPA.querystring = location.search;\n      }\n\n      if(document.referrer) {\n          FC_Krux_FPA.referrerUrl = document.referrer;\n      }\n\n      FC_Krux_FPA.channels = "' + keywords + '".split(\',\');\n      FC_Krux_FPA.siteName = ' + (siteName ? (0, _string_util.addQuotes)(siteName.toString()) : null) + ';\n\n      FC_Krux_FPA.author = ' + (authorName ? (0, _string_util.addQuotes)(authorName.toString()) : null) + ';\n      FC_Krux_FPA.subChannels = ' + (category ? (0, _string_util.addQuotes)(category.toString()) : null) + ';\n      FC_Krux_FPA.keywords = [' + tags + '];\n      FC_Krux_FPA.socialTags = [' + tags + '];\n      FC_Krux_FPA.contentType = ' + (contentType ? (0, _string_util.addQuotes)(contentType.toString()) : null) + ';\n\n      window.FC_Krux_FPA = FC_Krux_FPA;\n  </script>\n  <script> window.Krux||((Krux=function(){Krux.q.push(arguments);}).q=[]); (function(){ function retrieve(n){ var m, k=\'kxmansueto_\'+n; if(window.localStorage){ return window.localStorage[k] || ""; }else if(navigator.cookieEnabled){ m = document.cookie.match(k+\'=([^;]*)\'); return (m && unescape(m[1])) || ""; }else{ return \'\'; } } Krux.user = retrieve(\'user\');})();\n  </script>';
}

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = moatad;
function moatad() {
  return "<script> (function(){function t(){for(var a=[8],e=1;1>=e;e++)a.push(8+e),a.push(8-e);a=a[Math.floor(Math.random()*a.length)];return{b:a,a:0==Math.floor(Math.random()*a)}}function k(a){var e=a=a.replace(\":\",\"\");try{for(var b=0;100>b&&(a=decodeURIComponent(a),e!=a)&&!a.match(/^http(s)?\\:/);b++)e=a}catch(c){}return a.replace(/(^\\s+|\\s+$)/g,\"\")}try{if(!location||!location.hostname||!location.pathname)return!1;var c=document.location.hostname.replace(/^www\\./,\"\"),u=function(){for(var a,b=document.getElementsByTagName(\"meta\"), c,d=0,f=b.length;d<f;d++)if(c=b[d],\"og:title\"===c.getAttribute(\"property\")){a=c.getAttribute(\"content\");break}a||(a=document.title||\"Untitled\");return a}(),b={},b=function(a,b,c){a.l1=b;a.l2=c;a.l3=\"__page__\";a.l4=\"-\";return a}(b,c,u),l=(new Date).getTime(),m=Math.floor(Math.random()*Math.pow(10,12)),d,f;f=t();f.a?d=f.b:d=0;b.zmoatab_cm=d;b.t=l;b.de=m;b.zMoatAB_SNPT=!0;var g;d?g=d:g=1;var n;n=f?f.a?!0:!1:!0;var c=[],p=[k(b.l1),k(b.l2),k(b.l3),k(b.l4)].join(\":\"),v=\"https://aqoqxo4wxfum-a.akamaihd.net/z.gif?e=17&d=\"+ encodeURIComponent(p)+\"&de=\"+m+\"&t=\"+l+\"&i=MANSUETOCONTENT1&cm=\"+g+\"&mp=1&ac=1&pl=1&bq=10&vc=2&cs=0\",w=\"https://px.moatads.com/pixel.gif?e=17&d=\"+encodeURIComponent(p)+\"&de=\"+m+\"&t=\"+l+\"&i=MANSUETOCONTENT1&cm=\"+g+\"&mp=0&ac=1&pl=1&bq=10&ad_type=img&vc=2&cs=0\",x=\"https://px.moatads.com/pixel.gif?e=17&d=\"+encodeURIComponent(p)+\"&de=\"+m+\"&t=\"+l+\"&i=MANSUETOCONTENT1&cm=\"+g+\"&ku=1&ac=1&pl=1&bq=10&ad_type=img&vc=2&cs=0\";n&&((new Image).src=v,(new Image).src=w);for(var q in b)c.push(q+\"=\"+encodeURIComponent(b[q])); var c=c.join(\"&\"),c=c+\"&vc=2\",h=document.createElement(\"script\");h.type=\"text/javascript\";h.async=!0;n&&(h.onerror=function(){(new Image).src=x});var r=document.getElementsByTagName(\"script\")[0];r.parentNode.insertBefore(h,r);h.src=\"https://z.moatads.com/mansuetocontent806566985637/moatcontent.js#\"+c}catch(a){try{var y=\"//pixel.moatads.com/pixel.gif?e=24&d=data%3Adata%3Adata%3Adata&i=MOATCONTENTABSNIPPET1&vc=2&ac=1&k=\"+encodeURIComponent(a)+\"&j=\"+encodeURIComponent(document.referrer)+\"&cs=\"+(new Date).getTime(); (new Image).src=y}catch(e){}}})();\n  </script>";
}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = nielsen;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(17);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function nielsen(context, location) {
  var siteConfig = _identity2.default[context.site];
  if (siteConfig === undefined) {
    return '';
  }
  var nielsenConfig = (0, _get2.default)(siteConfig, 'nielsen');
  var clientId = nielsenConfig.clientId;


  if (location === 'header') {
    return '\n      <script type="text/javascript">\n        (function () {\n          var d = new Image(1, 1);\n          d.onerror = d.onload = function () {\n          d.onerror = d.onload = null;\n          };\n          d.src = ["//secure-us.imrworldwide.com/cgi-bin/m?ci=' + clientId + '&cg=0&cc=1&si=", escape(window.location.href), "&rp=", escape(document.referrer), "&ts=compact&rnd=", (new Date()).getTime()].join(\'\');\n        })();\n\n        function Nielsen_Event() {\n          var d = new Image(1, 1);\n          d.onerror = d.onload = function () { d.onerror = d.onload = null; };\n          d.src = ["//secure-us.imrworldwide.com/cgi-bin/m?ci=' + clientId + '&cg=0&cc=1&si=", escape(window.location.href),\n          "&rp=", escape(document.referrer),\n          "&ts=compact&c0=usergen,1&rnd=",(new Date()).getTime()].join(\'\');\n        };\n      </script>\n    ';
  }

  return '<noscript><div><img src="//secure-us.imrworldwide.com/cgi-bin/m?ci=' + clientId + '&amp;cg=0&amp;cc=1&amp;ts=noscript" width="1" height="1" alt="" /></div></noscript>';
}

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = omniture;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _capitalize = __webpack_require__(128);

var _capitalize2 = _interopRequireDefault(_capitalize);

var _identity = __webpack_require__(17);

var _identity2 = _interopRequireDefault(_identity);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function omniture(context, location, firstLoad, url, isFBIA) {
  var siteConfig = _identity2.default[context.site];
  var disableOmniture = (0, _get2.default)(context, 'config.navHistory[0]') ? (0, _get2.default)(context, 'config.navHistory[0]').indexOf('?omniture=false') !== -1 : false;

  if (siteConfig === undefined || disableOmniture) {
    return '';
  }
  var omnitureConfig = (0, _get2.default)(siteConfig, 'omniture');
  var siteSlug = (0, _get2.default)(siteConfig, 'slug');

  var postData = context.postData,
      tagPageData = context.tagPageData,
      categoryPageData = context.categoryPageData,
      authorPageData = context.authorPageData,
      searchPageData = context.searchPageData,
      staticPageData = context.staticPageData,
      mostCreativePeoplePageData = context.mostCreativePeoplePageData,
      personPageData = context.personPageData,
      statusCode = context.statusCode,
      ibdPageData = context.ibdPageData,
      companyPageData = context.companyPageData,
      micYearPageData = context.micYearPageData,
      micSectorPageData = context.micSectorPageData,
      videoPageData = context.videoPageData,
      productPageData = context.productPageData,
      playlistAllFeedData = context.playlistAllFeedData,
      type = context.type;

  var _category = '';
  var _tag = '';

  // Omniture data structure, defaults to homepage value
  // it will be further extended depend on page type
  var omnitureMapping = {
    server: isFBIA ? siteSlug + ' FBIA' : siteSlug,
    channel: 'homepage',
    pageName: siteSlug + ':homepage:front',
    events: 'event9',
    prop1: '',
    prop2: '',
    prop3: '',
    prop4: (0, _get2.default)(siteConfig, 'url'),
    prop5: '',
    prop6: '',
    prop7: '',
    prop8: '',
    prop9: '',
    prop10: '',
    prop11: '',
    prop13: 1,
    prop21: 'anonymous',
    prop22: 'anonymous:' + siteSlug + ':homepage:front',
    prop23: 'anonymous',
    prop28: '',
    prop31: '',
    prop32: '',
    prop33: '',
    prop34: '',
    eVar49: 1
  };

  var typeLookup = {
    post: function post() {
      _category = (0, _get2.default)(postData, 'categories[0].slug');
      var postID = (0, _get2.default)(postData, 'id');
      var postSlug = (0, _get2.default)(postData, 'slug');
      var tags = (0, _get2.default)(postData, 'tags');
      var eyeBrowText = (0, _ad_util.figureOutPriorityTag)(tags);

      var pageType = 'article';
      if ((0, _get2.default)(postData, 'posterSlideshow.length')) {
        pageType = 'slideshow';
      } else if ((0, _get2.default)(postData, 'hasVideoPoster') === true || (0, _get2.default)(postData, 'posterVideo.feedId')) {
        pageType = 'video';
      }

      return (0, _extend2.default)({}, omnitureMapping, {
        pageName: siteSlug + ':' + postID + ':' + postSlug,
        channel: '',
        prop1: _category,
        prop2: _category,
        prop3: (0, _get2.default)(postData, 'title'),
        prop4: (0, _get2.default)(postData, 'link'),
        prop5: (0, _get2.default)(eyeBrowText, 'slug') !== '' ? (0, _get2.default)(eyeBrowText, 'slug') : 'misc',
        prop6: (0, _get2.default)(eyeBrowText, 'slug') !== '' ? (0, _get2.default)(eyeBrowText, 'slug') : 'misc',
        prop8: (0, _get2.default)(postData, 'author.name'),
        prop9: (0, _get2.default)(postData, 'omnitureDate'),
        prop10: postID,
        prop11: (0, _get2.default)(postData, 'author.name'),
        prop22: 'anonymous:' + siteSlug + ':' + postID + ':' + postSlug,
        prop28: isFBIA ? 'fbia_' + pageType : pageType,
        prop33: (0, _capitalize2.default)(_category),
        prop34: (0, _get2.default)(postData, 'readTime')
      });
    },
    category: function category() {
      _category = (0, _get2.default)(categoryPageData, 'slug', 'news');
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: _category,
        pageName: siteSlug + ':' + _category + ':front',
        prop4: (0, _get2.default)(siteConfig, 'url') + '/' + _category,
        prop22: 'anonymous:' + siteSlug + ':' + _category + ':front'
      });
    },
    tag: function tag() {
      _tag = (0, _get2.default)(tagPageData, 'slug', 'tag');
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: _tag,
        pageName: siteSlug + ':taxonomy:' + _tag,
        prop3: (0, _get2.default)(tagPageData, 'name'),
        prop4: (0, _get2.default)(siteConfig, 'url') + '/section/' + _tag,
        prop5: _tag,
        prop6: _tag,
        prop8: 'Fast Company Contributor',
        prop11: 'Fast Company Contributor',
        prop22: 'anonymous:' + siteSlug + ':taxonomy:' + _tag,
        prop28: 'collection'
      });
    },
    author: function author() {
      var authorSlug = (0, _get2.default)(authorPageData, 'slug', 'fastcompany-staff');
      var authorName = (0, _get2.default)(authorPageData, 'name', 'Fastcompany Staff');

      return (0, _extend2.default)({}, omnitureMapping, {
        channel: '',
        pageName: siteSlug + ':user:' + authorSlug,
        prop3: authorName,
        prop4: (0, _get2.default)(siteConfig, 'url') + '/user/' + authorSlug,
        prop8: authorName,
        prop11: authorName,
        prop22: 'anonymous:' + siteSlug + ':user:' + authorSlug,
        prop28: 'user'
      });
    },
    search: function search() {
      var searchQuery = (0, _get2.default)(searchPageData, 'query.queryString', '');
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: '',
        pageName: siteSlug + ':search:' + searchQuery,
        prop3: searchQuery,
        prop4: (0, _get2.default)(siteConfig, 'url') + '/search/' + searchQuery,
        prop5: searchQuery,
        prop6: searchQuery,
        prop22: 'anonymous:' + siteSlug + ':search:' + searchQuery,
        prop28: 'search'
      });
    },
    page: function page() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: '',
        pageName: siteSlug + ':page:' + (0, _get2.default)(staticPageData, 'slug'),
        prop4: (0, _get2.default)(siteConfig, 'url') + '/' + (0, _get2.default)(staticPageData, 'slug'),
        prop22: 'anonymous:' + siteSlug + ':page:' + (0, _get2.default)(staticPageData, 'slug'),
        prop28: 'page'
      });
    },
    sitemapIndexPage: function sitemapIndexPage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'sitemap',
        pageName: siteSlug + ':sitemapIndexPage',
        prop4: (0, _get2.default)(siteConfig, 'url') + '/sitemap',
        prop22: 'anonymous:' + siteSlug + ':page:sitemapIndexPage',
        prop28: 'sitemap'
      });
    },
    sitemapPostPage: function sitemapPostPage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'sitemap',
        pageName: siteSlug + ':sitemapPostPage',
        prop4: (0, _get2.default)(siteConfig, 'url') + '/sitemap/posts',
        prop22: 'anonymous:' + siteSlug + ':page:sitemapPostPage',
        prop28: 'sitemap'
      });
    },
    personPage: function personPage() {
      var personSlug = (0, _get2.default)(personPageData, 'data.rows[0].url', '');
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'person',
        pageName: siteSlug + ':person:' + personSlug,
        prop3: personSlug,
        prop4: (0, _get2.default)(siteConfig, 'url') + '/person/' + personSlug,
        prop22: 'anonymous:' + siteSlug + ':person:' + personSlug,
        prop28: 'article'
      });
    },
    personIndexSectionPage: function personIndexSectionPage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'person',
        pageName: siteSlug + ':person-index',
        prop3: 'Person Index',
        prop4: (0, _get2.default)(siteConfig, 'url') + '/person',
        prop22: 'anonymous:' + siteSlug + ':person-index',
        prop28: 'person'
      });
    },
    mostCreativePeoplePage: function mostCreativePeoplePage() {
      var year = (0, _get2.default)(mostCreativePeoplePageData, 'year', '');
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'MCP',
        pageName: year ? siteSlug + ':mcp:' + year : siteSlug + ':mcp:front', // front of year
        prop3: 'MCP LIST',
        prop4: year ? (0, _get2.default)(siteConfig, 'url') + '/most-creative-people/' + year : (0, _get2.default)(siteConfig, 'url') + '/most-creative-people',
        prop22: 'anonymous:' + siteSlug + ':page:mcp',
        prop28: 'mcp'
      });
    },
    mostCreativePeopleCommunityPage: function mostCreativePeopleCommunityPage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'MCP',
        pageName: siteSlug + ':most-creative-people-community',
        prop3: 'Most Creative People Community Page',
        prop4: (0, _get2.default)(siteConfig, 'url') + '/most-creative-people-community',
        prop22: 'anonymous:' + siteSlug + ':mcp:community',
        prop28: 'mcp'
      });
    },
    ibdPage: function ibdPage() {
      var year = (0, _get2.default)(ibdPageData, 'year', '');
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'IBD',
        pageName: year ? siteSlug + ':ibd:' + year : siteSlug + ':ibd:front', // front of year
        prop3: 'Innovation By Design Awards ' + year,
        prop4: year ? (0, _get2.default)(siteConfig, 'url') + '/innovation-by-design/' + year : (0, _get2.default)(siteConfig, 'url') + '/innovation-by-design',
        prop22: 'anonymous:' + siteSlug + ':page:ibd',
        prop28: 'ibd'
      });
    },
    productIndexSectionPage: function productIndexSectionPage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'product',
        pageName: 'product:homepage:front', // front of year
        prop3: 'Product Index Page',
        prop4: 'https://www.fastcodesign.com/stuff',
        prop22: 'anonymous:product:homepage:front',
        prop28: 'product'
      });
    },
    productIndexPage: function productIndexPage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'product',
        pageName: 'product:homepage:front', // front of year
        prop3: 'Product Index Page',
        prop4: 'https://www.fastcodesign.com/stuff',
        prop22: 'anonymous:product:homepage:front',
        prop28: 'product'
      });
    },
    productPage: function productPage() {
      var productName = (0, _get2.default)(productPageData, 'data.rows[0].name');
      var productSlug = (0, _get2.default)(productPageData, 'data.rows[0].url');
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'product',
        pageName: 'product:' + productSlug, // front of year
        prop3: 'Product: ' + productName,
        prop4: (0, _get2.default)(siteConfig, 'url') + '/product/' + productSlug,
        prop22: 'anonymous:product:' + productSlug,
        prop28: 'product'
      });
    },
    companyPage: function companyPage() {
      var companyURL = (0, _get2.default)(companyPageData, 'data.rows[0].url', '');
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'company',
        pageName: 'company:profile:' + companyURL, // front of year
        prop3: 'Company Profile Page',
        prop4: (0, _get2.default)(siteConfig, 'url') + '/company/' + companyURL,
        prop22: 'anonymous:company:profile:' + companyURL,
        prop28: 'company'
      });
    },
    companyIndexSectionPage: function companyIndexSectionPage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'company',
        pageName: 'company:index',
        prop3: 'Company Index Page',
        prop4: (0, _get2.default)(siteConfig, 'url') + '/company',
        prop22: 'anonymous:company:index',
        prop28: 'company'
      });
    },
    micYearPage: function micYearPage() {
      var year = (0, _get2.default)(micYearPageData, 'year', '');
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'mic',
        pageName: year ? siteSlug + ':mic:' + year : siteSlug + ':mic:front', // front of year
        prop3: 'Most Innovative Companies ' + year,
        prop4: year ? (0, _get2.default)(siteConfig, 'url') + '/most-innovative-companies/' + year : (0, _get2.default)(siteConfig, 'url') + '/most-innovative-companies',
        prop22: 'anonymous:' + siteSlug + ':mic',
        prop28: 'mic'
      });
    },
    micSectorPage: function micSectorPage() {
      var year = (0, _get2.default)(micSectorPageData, 'year', '');
      var sector = (0, _get2.default)(micSectorPageData, 'sector', '');

      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'mic',
        pageName: siteSlug + ':mic:' + year + ':' + sector,
        prop3: 'Most Innovative Companies ' + year + ' ' + sector,
        prop4: (0, _get2.default)(siteConfig, 'url') + '/most-innovative-companies/' + year + '/' + sector,
        prop22: 'anonymous:' + siteSlug + ':mic:' + year + ':' + sector,
        prop28: 'mic'
      });
    },
    videoPage: function videoPage() {
      var currentVideoData = (0, _get2.default)(videoPageData, 'data.playlist[0]', null);
      if (!currentVideoData) {
        return {};
      }

      var videoTag = (0, _get2.default)(currentVideoData, 'category');
      var postID = (0, _get2.default)(currentVideoData, 'id');

      // Extend original omniture variable
      return (0, _extend2.default)({}, omnitureMapping, {
        pageName: siteSlug + ':' + postID + ':' + (0, _get2.default)(currentVideoData, 'slug'),
        channel: 'video',
        prop1: 'video',
        prop2: 'video',
        prop3: (0, _get2.default)(currentVideoData, 'title'),
        prop4: (0, _get2.default)(currentVideoData, 'link'),
        prop5: videoTag,
        prop6: videoTag,
        prop8: 'FastCo Studios',
        prop9: (0, _get2.default)(currentVideoData, 'omnitureDate'),
        prop10: postID,
        prop11: 'FastCo Studios',
        prop22: 'anonymous:' + siteSlug + ':' + postID + ':' + (0, _get2.default)(currentVideoData, 'slug'),
        prop28: 'video',
        prop33: (0, _capitalize2.default)('video')
      });
    },
    videoIndexPage: function videoIndexPage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'video',
        pageName: siteSlug + ':video:front',
        prop4: (0, _get2.default)(siteConfig, 'url') + '/videos',
        prop22: 'anonymous:' + siteSlug + ':video:front'
      });
    },
    videoPlaylistPage: function videoPlaylistPage() {
      var feedid = (0, _get2.default)(playlistAllFeedData, 'data.feedid');
      var slug = (0, _get2.default)(playlistAllFeedData, 'data.slug');
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'video',
        pageName: 'fastcompany:video-playlist:' + slug,
        pageURL: 'https://www.fastcompany.com/videos/playlist/' + slug + '/' + feedid,
        url: 'https://www.fastcompany.com/videos/playlist/' + slug + '/' + feedid,
        prop1: '',
        prop2: '',
        prop3: '',
        prop4: 'https://www.fastcompany.com/videos/playlist/' + slug + '/' + feedid,
        prop5: '',
        prop6: '',
        prop7: '',
        prop8: '',
        prop9: '',
        prop10: '',
        prop11: '',
        prop22: 'anonymous:fastcompany:video-playlist:' + slug,
        prop28: '',
        prop31: '',
        prop32: '',
        prop33: '',
        prop34: ''
      });
    },
    magazineArchivePage: function magazineArchivePage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'magazine',
        pageName: 'magazine:magazine-archives:front', // front of year
        prop3: 'Magazine Archives Page',
        prop4: (0, _get2.default)(siteConfig, 'url') + '/magazine/archives',
        prop22: 'anonymous:magazine:archives:front',
        prop28: 'magazine'
      });
    },
    newslettersPreferencesPage: function newslettersPreferencesPage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'newsletters',
        pageName: 'newsletters:newsletters-preferences:front', // front of year
        prop3: 'Fast Company Newsletters Preferences Page',
        prop4: 'https://www.fastcompany.com/newsletters-preferences',
        prop22: 'anonymous:newsletters:newsletters-preferences:front',
        prop28: 'newsletters'
      });
    }
  };

  if (statusCode && statusCode === 404) {
    omnitureMapping = (0, _extend2.default)({}, omnitureMapping, {
      channel: 'Error Page',
      pageType: 'errorPage',
      pageName: '',
      events: '',
      prop1: '',
      prop2: '',
      prop3: '',
      prop4: (0, _get2.default)(siteConfig, 'url'),
      prop5: '',
      prop6: '',
      prop7: '',
      prop8: '',
      prop9: '',
      prop10: '',
      prop11: '',
      prop13: 1,
      prop21: '',
      prop22: '',
      prop23: '',
      prop31: true,
      prop32: 404,
      prop33: '',
      prop34: ''
    });
  }

  if (typeLookup[type]) {
    omnitureMapping = typeLookup[type]();
  }

  return '\n    <script type="text/javascript">\n    (function (global, oDOC, handler) {\n    var head = oDOC.head || oDOC.getElementsByTagName("head");\n    function LABjsLoaded() {\n        window.fastco_s = window.fastco_s || {};\n        window.fastco_s.server="' + (0, _get2.default)(omnitureMapping, 'server') + '";\n        window.fastco_s.channel="' + (0, _get2.default)(omnitureMapping, 'channel') + '";\n        window.fastco_s.pageName="' + (0, _get2.default)(omnitureMapping, 'pageName') + '";\n        window.fastco_s.events="' + (0, _get2.default)(omnitureMapping, 'events') + '";\n        window.fastco_s.prop1="' + (0, _get2.default)(omnitureMapping, 'prop1') + '";\n        window.fastco_s.prop2="' + (0, _get2.default)(omnitureMapping, 'prop2') + '";\n        window.fastco_s.prop3="' + (0, _get2.default)(omnitureMapping, 'prop3') + '";\n        window.fastco_s.prop4="' + (0, _get2.default)(omnitureMapping, 'prop4') + '";\n        window.fastco_s.prop5="' + (0, _get2.default)(omnitureMapping, 'prop5') + '";\n        window.fastco_s.prop6="' + (0, _get2.default)(omnitureMapping, 'prop6') + '";\n        window.fastco_s.prop7="' + (0, _get2.default)(omnitureMapping, 'prop7') + '";\n        window.fastco_s.prop8="' + (0, _get2.default)(omnitureMapping, 'prop8') + '";\n        window.fastco_s.prop9="' + (0, _get2.default)(omnitureMapping, 'prop9') + '";\n        window.fastco_s.prop10="' + (0, _get2.default)(omnitureMapping, 'prop10') + '";\n        window.fastco_s.prop11="' + (0, _get2.default)(omnitureMapping, 'prop11') + '";\n        window.fastco_s.prop13="' + (0, _get2.default)(omnitureMapping, 'prop13') + '";\n        window.fastco_s.prop21="' + (0, _get2.default)(omnitureMapping, 'prop21') + '";\n        window.fastco_s.prop22="' + (0, _get2.default)(omnitureMapping, 'prop22') + '";\n        window.fastco_s.prop23="' + (0, _get2.default)(omnitureMapping, 'prop23') + '";\n        window.fastco_s.prop28="' + (0, _get2.default)(omnitureMapping, 'prop28') + '";\n        window.fastco_s.prop31="' + (0, _get2.default)(omnitureMapping, 'prop31') + '";\n        window.fastco_s.prop32="' + (0, _get2.default)(omnitureMapping, 'prop32') + '";\n        window.fastco_s.prop33="' + (0, _get2.default)(omnitureMapping, 'prop33') + '";\n        window.fastco_s.prop34="' + (0, _get2.default)(omnitureMapping, 'prop34') + '";\n        window.fastco_s.eVar49="' + (0, _get2.default)(omnitureMapping, 'eVar49') + '";\n        window.s_code = fastco_s.t();\n        if (s_code)document.write(s_code)\n      }\n      // loading code borrowed directly from LABjs itself\n    setTimeout(function () {\n        if ("item" in head) { // check if ref is still a live node list\n            if (!head[0]) { // append_to node not yet ready\n                setTimeout(arguments.callee, 25);\n                return;\n            }\n            head = head[0]; // reassign from live node list ref to pure node ref -- avoids nasty IE bug where changes to DOM invalidate live node lists\n        }\n        var scriptElem = oDOC.createElement("script"),\n            scriptdone = false;\n        scriptElem.onload = scriptElem.onreadystatechange = function () {\n            if ((scriptElem.readyState && scriptElem.readyState !== "complete" && scriptElem.readyState !== "loaded") || scriptdone) {\n                return false;\n            }\n            scriptElem.onload = scriptElem.onreadystatechange = null;\n            scriptdone = true;\n            LABjsLoaded();\n        };\n        scriptElem.src = "' + (0, _get2.default)(omnitureConfig, 'scode') + '";\n        head.insertBefore(scriptElem, head.firstChild);\n    }, 0);\n\n    // required: shim for FF <= 3.5 not having document.readyState\n    if (oDOC.readyState == null && oDOC.addEventListener) {\n        oDOC.readyState = "loading";\n        oDOC.addEventListener("DOMContentLoaded", handler = function () {\n            oDOC.removeEventListener("DOMContentLoaded", handler, false);\n            oDOC.readyState = "complete";\n        }, false);\n    }\n})(window, document);\n    </script>\n    <script type="text/javascript"><!--\n    if(navigator.appVersion.indexOf(\'MSIE\')>=0)document.write(unescape(\'%3C\')+\'\\!-\'+\'-\')\n    //--></script><noscript><img src="' + omnitureConfig.trackingPixel + '"\n    height="1" width="1" alt="" style="border:0;" /></noscript><!--/DO NOT REMOVE/-->\n  ';
}

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parsely;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(17);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parsely(context, location, firstLoad, url, isFBIA) {
  var siteConfig = _identity2.default[context.site];
  if (siteConfig === undefined) {
    return '';
  }
  var parselyConfig = (0, _get2.default)(siteConfig, 'parsely');
  var domain = parselyConfig.domain;


  return '\n    ' + (isFBIA ? '<script>\n    PARSELY = {\n        autotrack: false,\n        onload: function() {\n            PARSELY.beacon.trackPageView({\n                urlref: \'http://facebook.com/instantarticles\'\n            });\n            return true;\n        }\n    }\n</script>' : '') + '\n    <div id="parsely-root" style="display: none">\n      <span id="parsely-cfg" data-parsely-site="' + domain + '"></span>\n    </div>\n    <script>\n      (function(s, p, d) {\n      var h=d.location.protocol, i=p+"-"+s,\n      e=d.getElementById(i), r=d.getElementById(p+"-root"),\n      u=h==="https:"?"d1z2jf7jlzjs58.cloudfront.net"\n      :"static."+p+".com";\n      if (e) return;\n      e = d.createElement(s); e.id = i; e.async = true;\n      e.src = h+"//"+u+"/p.js"; r.appendChild(e);\n      })("script", "parsely", document);\n    </script>\n  ';
}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pingdom;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(17);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function pingdom(context) {
  var siteConfig = _identity2.default[context.site];
  if (siteConfig === undefined) {
    return '';
  }
  var pingdomConfig = (0, _get2.default)(siteConfig, 'pingdom');
  var id = pingdomConfig.id;


  return '\n    <script>\n      var _prum = [[\'id\', \'' + id + '\'],\n      [\'mark\', \'firstbyte\', (new Date()).getTime()]];\n      (function() {\n      var s = document.getElementsByTagName(\'script\')[0]\n      , p = document.createElement(\'script\');\n      p.async = \'async\';\n      p.src = \'//rum-static.pingdom.net/prum.min.js\';\n      s.parentNode.insertBefore(p, s);\n      })();\n    </script>\n  ';
}

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parsely;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _striptags = __webpack_require__(35);

var _striptags2 = _interopRequireDefault(_striptags);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _identity = __webpack_require__(17);

var _identity2 = _interopRequireDefault(_identity);

var _url_util = __webpack_require__(133);

var _content_util = __webpack_require__(226);

var _content_util2 = _interopRequireDefault(_content_util);

var _cloudinary_asset_util = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Validate your structured data page here (paste in entire view-source: https://search.google.com/structured-data/testing-tool/u/0/
*/
function parsely(context, location, firstLoad, unsanitizedURL) {
  var postData = context.postData,
      homeList = context.homeList,
      categoryHomeList = context.categoryHomeList,
      tagHomeList = context.tagHomeList,
      authorAllFeed = context.authorAllFeed,
      mostCreativePeoplePageData = context.mostCreativePeoplePageData,
      ibdPageData = context.ibdPageData,
      giftGuideData = context.giftGuideData,
      companyPageData = context.companyPageData,
      videoPageData = context.videoPageData,
      micYearPageData = context.micYearPageData,
      jwPlaylistIndex = context.jwPlaylistIndex,
      playlistAllFeedData = context.playlistAllFeedData;
  var type = context.type;


  var siteConfig = _identity2.default[context.site];
  var url = unsanitizedURL.includes('?amp=') ? unsanitizedURL.split('?')[0] : unsanitizedURL;

  if (siteConfig === undefined) {
    return '';
  }

  var articleType = (0, _get2.default)(postData, 'categories[0].name') === 'News' ? 'NewsArticle' : 'Article';

  var topicList = [];
  var articleTitle = '';
  var authorName = '';
  var articleSection = '';
  var thumbnail = '';
  var articleDate = '';
  var thumbnailCaption = void 0;
  var thumbnailWidth = void 0;
  var thumbnailHeight = void 0;
  var dateModified = void 0;
  var DESKTOP_SIZE = true;

  var livePostStructuredData = {};

  if (postData) {
    topicList = (0, _get2.default)(postData, 'tags');
    articleTitle = (0, _get2.default)(postData, 'title');
    authorName = (0, _get2.default)(postData, 'author.name');
    articleSection = (0, _get2.default)(postData, 'categories[0].slug'); // TODO, needs primary tag if exist
    thumbnail = (0, _cloudinary_asset_util.buildAssetUrlWithPresets)((0, _cloudinary_asset_util.changeAssetDomain)((0, _get2.default)(postData, 'featured_image.source')), _cloudinary_asset_util.imageSizesLookup.meta, DESKTOP_SIZE);

    if (/.gif$/.test(thumbnail)) {
      thumbnail = thumbnail.replace('f_auto', 'f_jpg');
    }

    articleDate = (0, _get2.default)(postData, 'structuredData.published');
    dateModified = (0, _get2.default)(postData, 'structuredData.modified');
    thumbnailCaption = (0, _striptags2.default)((0, _get2.default)(postData, 'featured_image.caption') || '');
    thumbnailWidth = (0, _get2.default)(postData, 'featured_image.width') || 700;
    thumbnailHeight = (0, _get2.default)(postData, 'featured_image.height') || 700;
  }

  var siteMaps = {
    fastcompany: {
      humanReadable: 'Fast Company',
      logo: {
        url: 'https://assets.fastcompany.com/image/upload/v1510092328/fc-logo.png',
        width: '346',
        height: '60'
      }
    },
    fastcodesign: {
      humanReadable: 'Co.Design',
      logo: {
        url: 'https://images.fastcompany.net/image/upload/v1485296802/fcweb/codesign-seo.png',
        width: '200',
        height: '200'
      }
    }
  };

  var siteData = (0, _get2.default)(siteMaps, context.site);
  var siteName = (0, _get2.default)(siteData, 'humanReadable');
  var logo = (0, _get2.default)(siteData, 'logo.url');
  var logoWidth = (0, _get2.default)(siteData, 'logo.width');
  var logoHeight = (0, _get2.default)(siteData, 'logo.height');

  var tags = '';

  if (topicList) {
    topicList.forEach(function (tag, index) {
      if (index !== topicList.length - 1) {
        tags += '"' + tag.name + '",';
      } else {
        tags += '"' + tag.name + '"';
      }
    });
  }
  // Set specific structured data for live posts
  if (postData) {
    var livePosts = (0, _get2.default)(postData, 'live.posts', []);
    var livePostsLength = livePosts.length;

    if (livePostsLength) {
      type = 'livePost';
      livePostStructuredData = {
        coverageStartTime: (0, _get2.default)(livePosts[livePostsLength - 1], 'published'),
        coverageEndTime: (0, _get2.default)(livePosts, '[0].published'),
        liveBlogUpdate: livePosts.map(function (post) {
          return {
            '@type': 'BlogPosting',
            headline: articleTitle,
            author: {
              '@type': 'Person',
              name: (0, _get2.default)(post, 'author.name')
            },
            publisher: {
              '@type': 'Organization',
              name: siteName,
              logo: {
                '@type': 'ImageObject',
                url: logo,
                width: logoWidth,
                height: logoHeight
              }
            },
            url: url + '#update-' + (0, _get2.default)(post, 'id'),
            datePublished: (0, _get2.default)(post, 'published'),
            articleBody: (0, _striptags2.default)((0, _content_util2.default)((0, _get2.default)(post, 'content', [])))
          };
        })
      };
    }
  }

  var baseData = {
    '@context': 'https://schema.org'
  };

  var dupeLookUp = {};

  var typeLookup = {
    post: {
      '@type': articleType,
      headline: articleTitle,
      url: url,
      mainEntityOfPage: {
        '@id': url,
        '@type': 'WebPage'
      },
      thumbnailUrl: thumbnail,
      dateCreated: articleDate,
      datePublished: articleDate,
      dateModified: dateModified,
      articleSection: articleSection,
      creator: authorName,
      author: {
        '@type': 'Person',
        name: authorName
      },
      keywords: [tags],
      image: {
        '@type': 'ImageObject',
        caption: thumbnailCaption,
        url: thumbnail,
        width: thumbnailWidth,
        height: thumbnailHeight
      },
      publisher: {
        '@type': 'Organization',
        name: siteName,
        logo: {
          '@type': 'ImageObject',
          url: logo,
          width: logoWidth,
          height: logoHeight
        }
      }
    },
    livePost: {
      '@type': 'LiveBlogPosting',
      url: url,
      headline: articleTitle,
      datePublished: articleDate,
      coverageStartTime: (0, _get2.default)(livePostStructuredData, 'coverageStartTime'),
      coverageEndTime: (0, _get2.default)(livePostStructuredData, 'coverageEndTime'),
      dateModified: dateModified,
      publisher: {
        '@type': 'Organization',
        name: siteName,
        logo: {
          '@type': 'ImageObject',
          url: logo,
          width: logoWidth,
          height: logoHeight
        }
      },
      liveBlogUpdate: (0, _get2.default)(livePostStructuredData, 'liveBlogUpdate')
    },
    homepage: {
      '@type': 'ItemList',
      url: url,
      itemListElement: homeList
      // we can only provide same-origin urls for structured data, so we should filter out
      // any urls that don't share the same domain as current homepage
      .filter(function (item) {
        // list item url is populated in the url field if it's scheduled in manage
        var listItemUrl = item.url || item.link;

        if (listItemUrl) {
          return listItemUrl.indexOf(url) !== -1;
        }

        return false;
      }).map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          url: item.url || 'https://www.' + (0, _url_util.resolveHost)((0, _get2.default)(item, 'link')) + '/' + (0, _get2.default)(item, 'id') + '/' + (0, _get2.default)(item, 'slug')
        };
      })
    },
    category: {
      '@type': 'ItemList',
      url: url,
      itemListElement: categoryHomeList.map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          url: item.url || 'https://www.' + (0, _url_util.resolveHost)((0, _get2.default)(item, 'link')) + '/' + (0, _get2.default)(item, 'id') + '/' + (0, _get2.default)(item, 'slug')
        };
      })
    },
    tag: {
      '@type': 'ItemList',
      url: url,
      itemListElement: tagHomeList.map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          url: item.url || 'https://www.' + (0, _url_util.resolveHost)((0, _get2.default)(item, 'link')) + '/' + (0, _get2.default)(item, 'id') + '/' + (0, _get2.default)(item, 'slug')
        };
      })
    },
    author: {
      '@type': 'ItemList',
      url: url,
      itemListElement: authorAllFeed.map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          url: item.url || 'https://www.' + (0, _url_util.resolveHost)((0, _get2.default)(item, 'link')) + '/' + (0, _get2.default)(item, 'id') + '/' + (0, _get2.default)(item, 'slug')
        };
      })
    },
    personPage: {
      '@type': 'ItemList',
      url: url,
      itemListElement: []
    },
    mostCreativePeoplePage: {
      '@type': 'ItemList',
      url: url,
      itemListElement: (0, _get2.default)(mostCreativePeoplePageData, 'data.rows', []).map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          url: 'https://www.fastcompany.com/person/' + item.url
        };
      })
    },
    ibdPage: {
      '@type': 'ItemList',
      url: url,
      itemListElement: (0, _get2.default)(ibdPageData, 'data.rows', []).map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          url: 'https://www.fastcodesign.com/innovation-by-design/2017/category/' + item.url
        };
      })
    },
    micYearPage: {
      '@type': 'ItemList',
      url: url,
      itemListElement: (0, _get2.default)(micYearPageData, 'data.rows', []).map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          url: 'https://www.fastcompany.com/company/' + item.url
        };
      })
    },
    giftGuidePage: {
      '@type': 'ItemList',
      url: url,
      itemListElement: (0, _get2.default)(giftGuideData, 'data.rows', []).map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          url: 'https://www.fastcodesign.com/gift-guide/holiday-2017/category/' + item.url
        };
      })
    },
    companyPage: {
      '@type': 'ItemList',
      url: url,
      itemListElement: (0, _get2.default)(companyPageData, 'data.posts', []).map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          url: item.link
        };
      })
    },
    videoIndexPage: {
      '@type': 'ItemList',
      url: url,
      itemListElement: (0, _get2.default)(jwPlaylistIndex, 'data.playlists', []).reduce(function (accum, currVal) {
        (0, _get2.default)(currVal, 'playlist', []).forEach(function (item) {
          var itemUrl = item.link;
          var itemJwId = item.mediaid;

          if (!dupeLookUp.hasOwnProperty(itemJwId) &&
          // we can't include fastcodesign videos in structured data
          // only fastcompany domain can be included because of
          // google's requirements
          itemUrl.indexOf('https://www.fastcodesign.com') !== 0) {
            accum.push({
              '@type': 'ListItem',
              position: accum.length + 1,
              url: itemUrl
            });
            dupeLookUp[itemJwId] = true;
          }
        });
        return accum;
      }, [])
    },
    videoPage: {
      '@type': 'VideoObject',
      url: url,
      name: (0, _get2.default)(videoPageData, 'data.playlist[0].title', ''),
      description: (0, _get2.default)(videoPageData, 'data.playlist[0].description', ''),
      thumbnailUrl: (0, _cloudinary_asset_util.buildAssetUrlWithPresets)((0, _cloudinary_asset_util.changeAssetDomain)((0, _get2.default)(videoPageData, 'data.playlist[0].featured_image.source', '')), _cloudinary_asset_util.imageSizesLookup.meta, DESKTOP_SIZE),
      uploadDate: (0, _get2.default)(videoPageData, 'data.playlist[0].structuredData.published', ''),
      transcript: (0, _get2.default)(videoPageData, 'data.videoSeoText', ''),
      duration: 'PT' + (0, _get2.default)(videoPageData, 'data.playlist[0].duration', '') + 'S',
      contentUrl: (0, _get2.default)(videoPageData, 'data.playlist[0].sources[4].file', '')
    },
    videoPlaylistPage: {
      '@type': 'ItemList',
      url: url,
      itemListElement: (0, _get2.default)(playlistAllFeedData, 'data.playlist', []).map(function (video, index) {
        var itemUrl = video.link;

        return {
          '@type': 'ListItem',
          position: index + 1,
          url: itemUrl
        };
      })
    }
  };
  var JSONMeta = JSON.stringify((0, _assign2.default)(baseData, typeLookup[type]));
  var lookUp = typeLookup[type];
  if (!lookUp) {
    _logger_service2.default.error('Structured Data Type Lookup: ' + type + ' not found.');
  }

  return lookUp ? '<script type="application/ld+json">' + JSONMeta + '</script>' : '';
}

/***/ }),
/* 510 */,
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trackjs;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trackjs(currentState) {
  if ((0, _get2.default)(currentState, 'config.env') === 'development') {
    return '';
  }

  return '<!-- BEGIN TRACKJS -->\n<script type="text/javascript">window._trackJs = { token: \'273b729e2fa84da381a6ddafecd71c58\' };</script>\n<script async type="text/javascript" src="https://cdn.trackjs.com/releases/current/tracker.js"></script>\n<!-- END TRACKJS -->';
}

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = comscore;

var _identity = __webpack_require__(17);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function comscore(context) {
  var siteConfig = _identity2.default[context.site];

  if (siteConfig === undefined) {
    return '';
  }

  var key = '';

  return '<script type="text/javascript">\n  if (typeof $igniter_var === \'undefined\') {\n  // Ensures that our client code is updated.\n  (function(w,d,s,p,v,e,r) {w[\'$igniter_var\']=v;w[v]=w[v]||function(){(w[v].q=w[v].q||[]).push(\n  arguments)};w[v].l=1*new Date();e=d.createElement(s),r=d.getElementsByTagName(s)[0];e.async=1;\n  e.src=p+\'?ts=\'+(+new Date()/3600000|0);\n  r.parentNode.insertBefore(e,r)})(window,document, \'script\', \'//cdn.petametrics.com/' + key + '.js\', \'$p\');\n\n  $p("init", ' + key + ');\n  $p("send", "pageview");\n  }\n  </script>';
}

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Link = __webpack_require__(43);

var _Link2 = _interopRequireDefault(_Link);

var _nav_main_menu = __webpack_require__(514);

var _nav_main_menu2 = _interopRequireDefault(_nav_main_menu);

var _nav_main_menu_data = __webpack_require__(515);

var _nav_main_menu_data2 = _interopRequireDefault(_nav_main_menu_data);

var _search = __webpack_require__(257);

var _search2 = _interopRequireDefault(_search);

var _client_util = __webpack_require__(40);

var _client_util2 = _interopRequireDefault(_client_util);

var _ga = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Nav = function (_Component) {
  _inherits(Nav, _Component);

  function Nav() {
    _classCallCheck(this, Nav);

    var _this = _possibleConstructorReturn(this, (Nav.__proto__ || Object.getPrototypeOf(Nav)).call(this));

    _this.state = {
      scale: false,
      menu: false,
      search: false
    };

    _this.setNavScale = _this.setNavScale.bind(_this);
    _this.getCategoryData = _this.getCategoryData.bind(_this);
    _this.toggleMenu = _this.toggleMenu.bind(_this);
    _this.closeMenuIfOpen = _this.closeMenuIfOpen.bind(_this);
    _this.toggleSearchModal = _this.toggleSearchModal.bind(_this);
    _this.renderCategoryLink = _this.renderCategoryLink.bind(_this);
    _this.renderPageTitle = _this.renderPageTitle.bind(_this);
    return _this;
  }

  _createClass(Nav, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if ((0, _client_util2.default)()) {
        window.addEventListener('scroll', this.setNavScale);
      }
    }
  }, {
    key: 'setNavScale',
    value: function setNavScale() {
      var _window = window,
          scrollY = _window.scrollY;
      var scale = this.state.scale;

      var featureFlags = (0, _get2.default)(this.props, 'config.featureFlags');

      if (this.props.isHome && featureFlags.topNavAdEnabled) {
        this.setState({ scale: false });
      } else {
        if (scale && scrollY <= 20) {
          this.setState({ scale: false });
        }

        if (!scale && scrollY > 20) {
          this.setState({ scale: true });
        }
      }
    }
  }, {
    key: 'getCategoryData',
    value: function getCategoryData(topic) {
      var className = 'nav__link';
      var active = topic.url === (0, _get2.default)(this.props, 'activeCategory');

      if (active) {
        className = ' nav__active';
      }

      return { className: className, active: active };
    }
  }, {
    key: 'setHeaderClass',
    value: function setHeaderClass(modifier, menu, isHome) {
      var featureFlags = (0, _get2.default)(this.props, 'config.featureFlags');
      var className = 'page-header';

      if (modifier) {
        className += ' page-header--' + modifier;
      }
      if (menu) {
        className += ' page-header--menu';
      }

      // For when we have homepage ad, manually add this for now for now
      if (isHome && featureFlags.topNavAdEnabled) {
        className += ' page-header--with-top-ad';
      }
      return className;
    }
  }, {
    key: 'toggleMenu',
    value: function toggleMenu(event) {
      var menu = this.state.menu;

      var html = document.querySelector('html');
      var addRemove = menu ? 'remove' : 'add';
      this.setState({ menu: !menu, search: false });

      html.classList[addRemove]('no-scroll');

      if (event) {
        event.preventDefault();
      }
    }
  }, {
    key: 'closeMenuIfOpen',
    value: function closeMenuIfOpen() {
      if (this.state.menu) {
        this.toggleMenu();
      }
    }
  }, {
    key: 'toggleSearchModal',
    value: function toggleSearchModal() {
      var triggerFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (triggerFocus && window.location.pathname.includes('/search')) {
        document.querySelector('.search-form__input--in-page').focus();
        return;
      }

      this.setState({ search: !this.state.search });
    }
  }, {
    key: 'renderCategoryLink',
    value: function renderCategoryLink(topic) {
      var url = topic.url,
          title = topic.title,
          external = topic.external;

      var data = this.getCategoryData(topic);
      var attrs = {
        className: data.className,
        title: title
      };

      if (data.active) {
        return _react2.default.createElement(
          'span',
          attrs,
          title
        );
      }

      if (external) {
        attrs.href = '//' + url;
        return _react2.default.createElement(
          'a',
          _extends({}, attrs, {
            onClick: function onClick() {
              (0, _ga.trackGAEvent)({
                eventCategory: 'Interaction',
                eventAction: 'Top Nav Category',
                eventLabel: title
              });
            }
          }),
          title
        );
      }

      attrs.to = url;
      return _react2.default.createElement(
        _Link2.default,
        _extends({}, attrs, {
          onClick: function onClick() {
            (0, _ga.trackGAEvent)({
              eventCategory: 'Interaction',
              eventAction: 'Top Nav Category',
              eventLabel: title
            });
          }
        }),
        title
      );
    }
  }, {
    key: 'renderPageTitle',
    value: function renderPageTitle() {
      var _props = this.props,
          isHome = _props.isHome,
          modifier = _props.modifier,
          title = _props.title;
      var scale = this.state.scale;

      var className = 'page-header__title';

      if (scale) {
        className += ' page-header__title--scaled';
      }

      if (modifier) {
        className += ' page-header__title--' + modifier;
      }

      if (isHome) {
        return _react2.default.createElement(
          'h2',
          { className: className },
          title
        );
      }

      return _react2.default.createElement(
        _Link2.default,
        { to: '/', className: className },
        title
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          modifier = _props2.modifier,
          newsletterLink = _props2.newsletterLink,
          isHome = _props2.isHome,
          topics = _props2.topics,
          config = _props2.config;
      var subscribeLink = this.props.subscribeLink;
      var _state = this.state,
          menu = _state.menu,
          search = _state.search,
          scale = _state.scale;

      var site = (0, _get2.default)(config, 'site', '');
      var social = (0, _get2.default)(_nav_main_menu_data2.default, 'social.' + site, []);

      // When we want to A/B test this link
      subscribeLink = 'https://magazine.fastcompany.com/loc/FST/topnav1999';

      return _react2.default.createElement(
        'header',
        {
          className: this.setHeaderClass(modifier, menu, isHome),
          onClick: this.closeMenuIfOpen
        },
        _react2.default.createElement(
          'div',
          { className: 'nav__main-items' },
          this.renderPageTitle(),
          _react2.default.createElement(
            'ul',
            {
              className: 'nav__extras nav__extras--left ' + (scale ? 'nav__extras--scaled' : '')
            },
            _react2.default.createElement(
              'li',
              { className: 'nav__extras-item' },
              _react2.default.createElement(
                'a',
                { className: 'nav__menu', onClick: this.toggleMenu },
                'Menu'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'nav__extras-item' },
              _react2.default.createElement(
                'a',
                { className: 'nav__newsletter', href: newsletterLink },
                'Newsletter'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'nav__extras-item' },
              _react2.default.createElement(
                'a',
                { href: subscribeLink, className: 'nav__subscribe' },
                'Subscribe'
              )
            )
          ),
          _react2.default.createElement(
            'ul',
            {
              className: 'nav__extras nav__extras--right ' + (scale ? 'nav__extras--scaled' : '')
            },
            _react2.default.createElement(
              'li',
              { className: 'nav__extras-item' },
              social.map(function (network) {
                return _react2.default.createElement(
                  'a',
                  {
                    key: network.url,
                    href: network.url,
                    className: 'nav__social-button nav__social-button--' + network.property,
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    onClick: function onClick() {
                      (0, _ga.trackGAEvent)({
                        eventCategory: 'Social',
                        eventAction: 'Top Nav Follow Us',
                        eventLabel: network.property
                      });
                    }
                  },
                  _react2.default.createElement('i', {
                    className: 'nav__icon nav__icon--' + network.property + ' icon-' + network.property
                  })
                );
              })
            ),
            _react2.default.createElement(
              'li',
              { className: 'nav__extras-item' },
              _react2.default.createElement(
                'button',
                {
                  className: 'nav__search-trigger',
                  onClick: this.toggleSearchModal
                },
                _react2.default.createElement('i', { className: 'icon-search-glass' })
              )
            )
          )
        ),
        _react2.default.createElement(
          'nav',
          { className: 'nav nav--' + modifier },
          _react2.default.createElement(
            'ul',
            { className: 'nav__list' },
            topics.map(function (topic) {
              return _react2.default.createElement(
                'li',
                { key: topic.title, className: 'nav__item' },
                _this2.renderCategoryLink(topic)
              );
            })
          )
        ),
        _react2.default.createElement(_search2.default, {
          skin: 'light',
          modifier: 'overlay',
          active: search,
          modal: true,
          closeModal: this.toggleSearchModal
        }),
        _react2.default.createElement(_nav_main_menu2.default, _extends({
          closeMenu: this.toggleMenu,
          mainMenuVisible: menu,
          scaled: this.state.scale
        }, _nav_main_menu_data2.default, {
          config: config
        }))
      );
    }
  }]);

  return Nav;
}(_react.Component);

exports.default = Nav;


Nav.propTypes = {
  isHome: _propTypes2.default.bool.isRequired,
  modifier: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired,
  subscribeLink: _propTypes2.default.string.isRequired,
  newsletterLink: _propTypes2.default.string.isRequired,
  topics: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    active: _propTypes2.default.bool, // eslint-disable-next-line react/no-unused-prop-types
    title: _propTypes2.default.string.isRequired, // eslint-disable-next-line react/no-unused-prop-types
    url: _propTypes2.default.string.isRequired // eslint-disable-next-line react/no-unused-prop-types
  })).isRequired,
  config: _propTypes2.default.shape({}).isRequired
};

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _fc_link = __webpack_require__(21);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _ga = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 * @param props
 * @returns {Component}
 * @constructor
 */

var MainMenu = function (_Component) {
  _inherits(MainMenu, _Component);

  function MainMenu() {
    _classCallCheck(this, MainMenu);

    var _this = _possibleConstructorReturn(this, (MainMenu.__proto__ || Object.getPrototypeOf(MainMenu)).call(this));

    _this.setMenuClasses = _this.setMenuClasses.bind(_this);
    _this.openSection = _this.openSection.bind(_this);
    _this.clickSiteCollectionItem = _this.clickSiteCollectionItem.bind(_this);

    _this.state = { active: null };
    return _this;
  }

  _createClass(MainMenu, [{
    key: 'setMenuClasses',
    value: function setMenuClasses(visible) {
      var classNames = ['main-menu'];

      if (visible) {
        classNames.push('main-menu--opened');
      }

      return classNames.join(' ');
    }
  }, {
    key: 'openSection',
    value: function openSection(section) {
      if (section === this.state.active) {
        this.setState({ active: null });
      } else {
        this.setState({ active: section });
      }
    }
  }, {
    key: 'openSectionMenuHeight',
    value: function openSectionMenuHeight(data) {
      var totalheight = void 0;

      if (data.title !== 'collections') {
        this.navItemHeight = document.querySelector('.main-menu__collection').offsetHeight;

        totalheight = this.navItemHeight * data.collectionItems;
      } else {
        var list = document.querySelector('.main-menu__collections-content--collections').childNodes;
        var collectionsHeight = 0;
        for (var i = 0; i < list.length; i += 1) {
          collectionsHeight += list[i].offsetHeight;
        }
        totalheight = collectionsHeight;
      }

      return totalheight;
    }
  }, {
    key: 'clickSiteCollectionItem',
    value: function clickSiteCollectionItem(title) {
      (0, _ga.trackGAEvent)({
        eventCategory: 'Interaction',
        eventAction: 'Burger Nav Category',
        eventLabel: title
      });
      this.props.closeMenu();
    }
  }, {
    key: 'renderSectionContent',
    value: function renderSectionContent(data) {
      var _this2 = this;

      if (!data) {
        return null;
      }

      var listLink = data.content.map(function (info) {
        var url = info.url,
            title = info.title,
            _info$deck = info.deck,
            deck = _info$deck === undefined ? '' : _info$deck,
            _info$external = info.external,
            external = _info$external === undefined ? false : _info$external;

        /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

        return _react2.default.createElement(
          'li',
          {
            key: title,
            className: 'main-menu__collection',
            onClick: function onClick() {
              return _this2.clickSiteCollectionItem(title);
            }
          },
          _react2.default.createElement(
            _fc_link2.default,
            {
              to: url,
              title: title,
              config: data.config,
              externalLink: external
            },
            _react2.default.createElement(
              'h3',
              { className: 'main-menu__collection-title' },
              title
            ),
            deck.length > 0 ? _react2.default.createElement(
              'p',
              { className: 'main-menu__collection-deck' },
              deck
            ) : ''
          )
        );
      });

      return listLink;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          social = _props.social,
          currentIssueCover = _props.currentIssueCover,
          magazineLink = _props.magazineLink,
          mainMenuVisible = _props.mainMenuVisible,
          collections = _props.collections,
          scaled = _props.scaled,
          config = _props.config;
      var subscribeLink = this.props.subscribeLink;

      var socialLinks = social[(0, _get2.default)(config, 'site', '')] || [];

      subscribeLink = 'https://magazine.fastcompany.com/loc/FST/sidenav1999';

      return _react2.default.createElement(
        'div',
        {
          className: this.setMenuClasses(mainMenuVisible, scaled),
          onClick: function onClick(e) {
            return e.stopPropagation();
          }
        },
        _react2.default.createElement(
          'div',
          {
            className: 'main-menu__brand ' + (scaled ? 'main-menu__brand--scaled' : '')
          },
          _react2.default.createElement('button', { className: 'icon-close', onClick: this.props.closeMenu })
        ),
        collections.map(function (collection, index) {
          var title = collection.title,
              sections = collection.sections;

          var content = sections;
          var collectionsList = title === 'collections';
          var collectionItems = content.length;

          return _react2.default.createElement(
            'div',
            {
              key: collection.className,
              className: 'main-menu__dropdown-content'
            },
            _react2.default.createElement(
              'a',
              {
                className: collection.className + ' ' + (_this3.state.active === collection.title ? collection.className + '--active' : ''),
                onClick: _this3.openSection.bind(null, collection.title)
              },
              _react2.default.createElement(
                'span',
                { className: 'main-menu__collections-title' },
                collection.title
              ),
              _react2.default.createElement('span', {
                className: 'main-menu__collections-caret ' + (_this3.state.active === collection.title ? 'main-menu__collections-caret--active' : '')
              })
            ),
            _react2.default.createElement(
              'ul',
              {
                className: 'main-menu__collections-content ' + (collectionsList ? 'main-menu__collections-content--collections' : '') + ' ' + (_this3.state.active === collection.title ? 'main-menu__collections-content--active' : '') + ' ',
                style: {
                  height: _this3.state.active === collection.title ? _this3.openSectionMenuHeight({ collectionItems: collectionItems, title: title }) : 0
                }
              },
              _this3.renderSectionContent({ content: content, index: index, config: config })
            )
          );
        }),
        _react2.default.createElement(
          'a',
          {
            href: 'https://www.fastcompany.com/newsletters',
            className: 'main-menu__newsletters',
            onClick: function onClick() {
              (0, _ga.trackGAEvent)({
                eventCategory: 'Burger',
                eventAction: 'Nav Item',
                eventLabel: 'Newsletters'
              });
            }
          },
          'Newsletters'
        ),
        _react2.default.createElement(
          'a',
          {
            href: 'http://events.fastcompany.com/fcny/',
            className: 'main-menu__innovation-festival',
            target: '_blank',
            rel: 'noopener noreferrer',
            onClick: function onClick() {
              (0, _ga.trackGAEvent)({
                eventCategory: 'Burger',
                eventAction: 'Nav Item',
                eventLabel: 'Innovation Festival'
              });
            }
          },
          'Innovation Festival'
        ),
        _react2.default.createElement(
          'a',
          { href: magazineLink, className: 'main-menu__current-issue' },
          'Current Issue'
        ),
        _react2.default.createElement(
          'div',
          { className: 'main-menu__subscription' },
          _react2.default.createElement(
            'a',
            {
              href: magazineLink,
              className: 'main-menu__mag-cover',
              style: { backgroundImage: 'url(' + currentIssueCover + ')' }
            },
            'Current Issue'
          ),
          _react2.default.createElement(
            'div',
            { className: 'main-menu__subscription-button-row' },
            _react2.default.createElement(
              'a',
              {
                href: subscribeLink,
                className: 'main-menu__subscribe-link',
                title: 'subscribe'
              },
              'SUBSCRIBE'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'main-menu__social-menu' },
          _react2.default.createElement(
            'div',
            { className: 'main-menu__social-text' },
            _react2.default.createElement(
              'span',
              { className: 'main-menu__social-text-hed' },
              'Follow us:'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'main-menu__social-list' },
            socialLinks.map(function (network) {
              return _react2.default.createElement(
                'a',
                {
                  key: network.url,
                  href: network.url,
                  className: 'main-menu__social-button main-menu__social-button--' + network.property,
                  target: '_blank',
                  rel: 'noopener noreferrer',
                  onClick: function onClick() {
                    (0, _ga.trackGAEvent)({
                      eventCategory: 'Social',
                      eventAction: 'Nav Follow Us',
                      eventLabel: network.property
                    });
                  }
                },
                _react2.default.createElement('i', {
                  className: 'main-menu__icon main-menu__icon--' + network.property + ' icon-' + network.property
                })
              );
            })
          )
        )
      );
    }
  }]);

  return MainMenu;
}(_react.Component);

exports.default = MainMenu;


MainMenu.defaultProps = {
  mainMenuVisible: false,
  scaled: false
};

MainMenu.propTypes = {
  social: _propTypes2.default.shape({}).isRequired,
  collections: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    title: _propTypes2.default.string.isRequired,
    url: _propTypes2.default.string,
    deck: _propTypes2.default.string
  })).isRequired,
  currentIssueCover: _propTypes2.default.string.isRequired,
  magazineLink: _propTypes2.default.string.isRequired,
  subscribeLink: _propTypes2.default.string.isRequired,
  mainMenuVisible: _propTypes2.default.bool,
  closeMenu: _propTypes2.default.func.isRequired,
  scaled: _propTypes2.default.bool,
  config: _propTypes2.default.shape({}).isRequired
};

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var data = {
  currentIssueCover: '//www.fastcompany.com/magazine/latest-cover.jpg',
  magazineLink: 'https://www.fastcompany.com/magazine/',
  subscribeLink: 'https://magazine.fastcompany.com/loc/FST/summersale',
  cosites: [{
    siteTitle: 'FastCoDesign',
    siteLogo: '//a.fastcompany.net/image/upload/v1488299643/fc/CO.DESIGN_BURGER_LOCKUP.svg',
    siteURL: '//www.fastcodesign.com'
  }, {
    siteTitle: 'FastCoStudios',
    siteLogo: '//a.fastcompany.net/image/upload/v1488300562/fc/video_burger.svg',
    siteURL: '//www.fastcompany.com/videos'
  }],
  social: {
    fastcompany: [{
      property: 'facebook',
      url: 'https://www.facebook.com/FastCompany/'
    }, {
      property: 'twitter',
      url: 'https://twitter.com/fastcompany'
    }, {
      property: 'instagram',
      url: 'https://www.instagram.com/fastcompany/'
    }, {
      property: 'pocket',
      url: 'https://getpocket.com/explore/fastcompany.com'
    }, {
      property: 'linkedin',
      url: 'https://www.linkedin.com/company/fast-company'
    }],
    fastcodesign: [{
      property: 'facebook',
      url: 'https://www.facebook.com/FastCoDesign/'
    }, {
      property: 'twitter',
      url: 'https://twitter.com/FastCoDesign'
    }, {
      property: 'instagram',
      url: 'https://www.instagram.com/fastcodesign/'
    }, {
      property: 'pocket',
      url: 'https://getpocket.com/explore/fastcodesign'
    }, {
      property: 'linkedin',
      url: 'https://www.linkedin.com/showcase/3700248/'
    }]
  },
  collections: [{
    title: 'fast company',
    className: 'main-menu__fastcompany-collection',
    sections: [{
      title: 'homepage',
      url: 'https://www.fastcompany.com'
    }, {
      title: 'technology',
      url: 'https://www.fastcompany.com/technology'
    }, {
      title: 'leadership',
      url: 'https://www.fastcompany.com/leadership'
    }, {
      title: 'entertainment',
      url: 'https://www.fastcompany.com/entertainment'
    }, {
      title: 'ideas',
      url: 'https://www.fastcompany.com/ideas'
    }, {
      title: 'video',
      url: 'https://www.fastcompany.com/videos',
      external: true
    }, {
      title: 'news',
      url: 'https://www.fastcompany.com/news'
    }]
  }, {
    title: 'co.Design',
    className: 'main-menu__codesign-collection',
    sections: [{
      title: 'homepage',
      url: 'https://www.fastcodesign.com'
    }, {
      title: 'cities',
      url: 'https://www.fastcodesign.com/cities'
    }, {
      title: 'graphics',
      url: 'https://www.fastcodesign.com/graphics'
    }, {
      title: 'innovation by design',
      url: 'https://www.fastcodesign.com/innovation-by-design'
    }, {
      title: 'interactive',
      url: 'https://www.fastcodesign.com/interactive'
    }, {
      title: 'products',
      url: 'https://www.fastcodesign.com/products'
    }, {
      title: 'spaces',
      url: 'https://www.fastcodesign.com/spaces'
    }]
  }, {
    title: 'collections',
    className: 'main-menu__collections',
    sections: [{
      title: 'Recommender',
      url: 'https://www.fastcompany.com/section/the-recommender',
      deck: 'The apps, books, movies, music, TV shows, and art are inspiring our some of the most creative people in business this month'
    }, {
      title: 'Strong Female Lead',
      url: 'https://www.fastcompany.com/section/strong-female-lead',
      deck: 'The struggles and triumphs of prominent women in leadership positions'
    }, {
      title: 'Platform Wars',
      url: 'https://www.fastcompany.com/section/platform-wars',
      deck: 'The major tech ecosystems that battle for our attention and dollars'
    }, {
      title: 'Tech Forecast',
      url: 'https://www.fastcompany.com/section/tech-forecast',
      deck: 'What’s next for hardware, software, and services'
    }, {
      title: 'Most Innovative Companies',
      url: 'https://www.fastcompany.com/most-innovative-companies/2017',
      deck: 'Our annual guide to the businesses that matter the most'
    }, {
      title: 'Most Creative People',
      url: 'https://www.fastcompany.com/most-creative-people/2017',
      deck: 'Leaders who are shaping the future of business in creative ways'
    }, {
      title: 'World Changing Ideas',
      url: 'https://www.fastcompany.com/section/world-changing-ideas',
      deck: 'New workplaces, new food sources, new medicine--even an entirely new economic system'
    }, {
      title: 'Innovation By Design',
      url: 'https://www.fastcodesign.com/innovation-by-design/2017',
      deck: 'Celebrating the best ideas in business'
    }, {
      title: 'FastCo.Works Studio',
      url: 'https://www.fastcompany.com/user/fastco-works',
      deck: "An award-winning team of journalists, designers, and videographers who tell brand stories through Fast Company's distinctive lens"
    }]
  }]
};

exports.default = data;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var data = {
  fastcompany: {
    logo: '//a.fastcompany.net/image/upload/v1488299125/fc/fastcompany-logo.svg',
    title: 'Fast Company',
    subscribeLink: 'https://magazine.fastcompany.com/loc/FST/summersale',
    newsletterLink: 'https://www.fastcompany.com/newsletters',
    topics: [{
      url: '/technology',
      title: 'Technology'
    }, {
      url: '/leadership',
      title: 'Leadership'
    }, {
      url: '/entertainment',
      title: 'Entertainment'
    }, {
      url: '/ideas',
      title: 'Ideas'
    }, {
      url: '/videos',
      title: 'Video'
    }, {
      url: '/news',
      title: 'News'
    }]
  },
  fastcodesign: {
    logo: '//g.fastcompany.net/asset_files/-/2015/12/22/CODESIGN.svg',
    title: 'Co.Design',
    subscribeLink: 'https://magazine.fastcompany.com/loc/FST/summersale',
    newsletterLink: 'https://www.fastcompany.com/newsletters',
    topics: [{
      url: '/ui-ux-interactive',
      title: 'UI & UX'
    }, {
      url: '/products',
      title: 'Products'
    }, {
      url: '/cities-spaces',
      title: 'Cities & Spaces'
    }, {
      url: '/graphics',
      title: 'Graphics'
    }, {
      url: '/innovation-by-design',
      title: 'Innovation By Design'
    }]
  }
};

exports.default = data;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _card = __webpack_require__(36);

var _card2 = _interopRequireDefault(_card);

var _fc_link = __webpack_require__(21);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _ga = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // import get from 'lodash/get';


// eslint-disable-next-line react/prefer-stateless-function
var Recirc = function (_Component) {
  _inherits(Recirc, _Component);

  function Recirc() {
    _classCallCheck(this, Recirc);

    return _possibleConstructorReturn(this, (Recirc.__proto__ || Object.getPrototypeOf(Recirc)).apply(this, arguments));
  }

  _createClass(Recirc, [{
    key: 'render',

    // TODO: @mbenin @jferrie Revisit this logic
    /*
    shouldComponentUpdate(nextProps) {
      return (
        get(this.props, 'recircFeed.hide') !== get(nextProps, 'recircFeed.hide')
      );
    } */

    value: function render() {
      var _props = this.props,
          config = _props.config,
          feed = _props.feed;

      // TODO: This should be moved into the API.

      var properties = [{
        key: 'fastcoexist',
        title: 'Ideas',
        data: feed.fastcoexist,
        link: 'https://www.fastcompany.com/ideas'
      }, {
        key: 'fastcocreate',
        title: 'Entertainment',
        data: feed.fastcocreate,
        link: 'https://www.fastcompany.com/entertainment'
      }, {
        key: 'fastcodesign',
        title: 'Co.Design',
        data: feed.fastcodesign,
        link: 'https://www.fastcodesign.com'
      }, {
        key: 'fastcompany',
        title: 'Fast Company',
        data: feed.fastcompany,
        link: 'https://www.fastcompany.com/'
      }];

      return _react2.default.createElement(
        'div',
        { className: 'recirc' },
        properties.map(function (property) {
          return _react2.default.createElement(
            'div',
            { key: property.key, className: 'recirc__column' },
            _react2.default.createElement(
              'h3',
              { className: 'recirc__title recirc__title--' + property.key },
              _react2.default.createElement(
                _fc_link2.default,
                { config: config, to: property.link },
                property.title
              )
            ),
            property.data.map(function (story, idx) {
              return _react2.default.createElement(_card2.default, {
                type: 'recirc',
                config: config,
                metadata: story,
                key: story.id,
                cardEvent: function cardEvent() {
                  (0, _ga.trackGAEvent)({
                    eventCategory: 'Engagement',
                    eventAction: 'RecirculationModule:Pos-' + (idx + 1),
                    eventLabel: property.title + ':' + (0, _get2.default)(story, 'link')
                  });
                }
              });
            })
          );
        })
      );
    }
  }]);

  return Recirc;
}(_react.Component);

exports.default = Recirc;


Recirc.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  feed: _propTypes2.default.shape({}).isRequired
};

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DefaultCard;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _fc_link = __webpack_require__(21);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _poster = __webpack_require__(56);

var _poster2 = _interopRequireDefault(_poster);

var _eyebrow = __webpack_require__(57);

var _eyebrow2 = _interopRequireDefault(_eyebrow);

var _advertorial = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DefaultCard(props) {
  var config = props.config,
      metadata = props.metadata,
      fullPageAdvertorial = props.fullPageAdvertorial,
      cardEvent = props.cardEvent,
      totalCards = props.totalCards;

  var advertorial = (0, _advertorial.isAdvertorial)(metadata.tags) && !fullPageAdvertorial;
  var textOnlyCard = metadata.allowTextOnly && !(0, _get2.default)(metadata, 'featured_image.source');
  var setCardClasses = function setCardClasses() {
    var classNames = ['card', 'card--default'];

    if (textOnlyCard) {
      classNames.push('card--text');

      if (totalCards) {
        classNames.push('card--size-' + totalCards);
      }
    }

    if (metadata.events) {
      classNames.push('card--event');
    }

    if (advertorial) {
      classNames.push('card--advertorial');
    }

    return classNames.join(' ');
  };
  var setPosterClasses = function setPosterClasses() {
    var posterClasses = ['card__poster', 'card__poster--default'];

    if (metadata.hasVideoPoster) {
      posterClasses.push('card__poster--video');
    }

    return posterClasses.join(' ');
  };
  var setTextWrapperClass = function setTextWrapperClass() {
    var event = (0, _get2.default)(metadata, 'events');
    var textWrapperClasses = ['card__text-wrapper'];

    if (!event) {
      textWrapperClasses.push('card__text-wrapper--default');
    }

    if (textOnlyCard) {
      textWrapperClasses.push('card__text-wrapper--text-only');
    } else if (!advertorial && !event) {
      textWrapperClasses.push('card__text-wrapper--border-bottom');
    }

    return textWrapperClasses.join(' ');
  };

  return _react2.default.createElement(
    'article',
    { className: setCardClasses(), onClick: function onClick(event) {
        return cardEvent(event);
      } },
    _react2.default.createElement(
      _fc_link2.default,
      {
        to: (0, _get2.default)(metadata, 'link'),
        title: (0, _get2.default)(metadata, 'title'),
        config: config,
        externalLink: (0, _get2.default)(metadata, 'external') || (0, _get2.default)(metadata, 'source') === 'external'
      },
      _react2.default.createElement(_poster2.default, {
        metadata: metadata,
        className: setPosterClasses(),
        generateClasses: false
      }),
      _react2.default.createElement(
        'div',
        { className: setTextWrapperClass() },
        _react2.default.createElement(_eyebrow2.default, { metadata: metadata }),
        _react2.default.createElement(
          'h2',
          {
            className: 'card__title card__title--default ' + (textOnlyCard ? 'card__title--only' : '')
          },
          (0, _get2.default)(metadata, 'title')
        ),
        (0, _get2.default)(metadata, 'events') ? _react2.default.createElement(
          'button',
          { className: 'card__button' },
          (0, _get2.default)(metadata, 'buttonText')
        ) : ''
      )
    )
  );
}

DefaultCard.defaultProps = {
  cardEvent: function cardEvent() {},
  fullPageAdvertorial: false,
  totalCards: 0
};

DefaultCard.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  metadata: _propTypes2.default.shape({}).isRequired,
  fullPageAdvertorial: _propTypes2.default.bool,
  cardEvent: _propTypes2.default.func,
  totalCards: _propTypes2.default.number
};

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Featured;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _fc_link = __webpack_require__(21);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _poster = __webpack_require__(56);

var _poster2 = _interopRequireDefault(_poster);

var _eyebrow = __webpack_require__(57);

var _eyebrow2 = _interopRequireDefault(_eyebrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Featured(props) {
  var config = props.config,
      metadata = props.metadata,
      cardEvent = props.cardEvent;

  var noImage = !(0, _get2.default)(metadata, 'featured_image.source');
  var textOnlyCard = metadata.allowTextOnly && noImage;
  var setCardClasses = function setCardClasses() {
    var cardClasses = ['card', 'card--featured'];

    if (textOnlyCard) {
      cardClasses.push('card--text');
    }

    return cardClasses.join(' ');
  };
  var setPosterClasses = function setPosterClasses() {
    var posterClasses = ['card__poster', 'card__poster--featured'];

    if (metadata.hasVideoPoster) {
      posterClasses.push('card__poster--video');
    }

    return posterClasses.join(' ');
  };

  return _react2.default.createElement(
    'article',
    { className: setCardClasses(), onClick: function onClick(event) {
        return cardEvent(event);
      } },
    _react2.default.createElement(
      _fc_link2.default,
      {
        to: (0, _get2.default)(metadata, 'link'),
        title: (0, _get2.default)(metadata, 'title'),
        config: config,
        externalLink: (0, _get2.default)(metadata, 'external') || (0, _get2.default)(metadata, 'source') === 'external'
      },
      _react2.default.createElement(_poster2.default, {
        metadata: metadata,
        className: setPosterClasses(),
        generateClasses: false
      }),
      _react2.default.createElement(
        'div',
        {
          className: 'card__text-wrapper card__text-wrapper--featured ' + (textOnlyCard ? 'card__text-wrapper--text-only' : '')
        },
        _react2.default.createElement(_eyebrow2.default, { metadata: metadata }),
        _react2.default.createElement(
          'h2',
          {
            className: 'card__title card__title--featured ' + (textOnlyCard ? 'card__title--only' : '')
          },
          (0, _get2.default)(metadata, 'title')
        )
      )
    )
  );
}

Featured.defaultProps = {
  cardEvent: function cardEvent() {}
};

Featured.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  metadata: _propTypes2.default.shape({}).isRequired,
  cardEvent: _propTypes2.default.func
};

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AllFeed;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _fc_link = __webpack_require__(21);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _poster = __webpack_require__(56);

var _poster2 = _interopRequireDefault(_poster);

var _eyebrow = __webpack_require__(57);

var _eyebrow2 = _interopRequireDefault(_eyebrow);

var _advertorial = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AllFeed(props) {
  var config = props.config,
      top = props.top,
      metadata = props.metadata,
      cardEvent = props.cardEvent,
      fullPageAdvertorial = props.fullPageAdvertorial;

  var advertorial = (0, _advertorial.isAdvertorial)(metadata.tags) && !fullPageAdvertorial;
  var setCardClasses = function setCardClasses() {
    var cardClasses = ['card', 'card--all-feed'];

    if (advertorial) {
      cardClasses.push('card--advertorial');
    }

    if (top) {
      cardClasses.push('card--top');
    }

    return cardClasses.join(' ');
  };
  var setPosterClasses = function setPosterClasses() {
    var posterClasses = ['card__poster', 'card__poster--all-feed'];

    if (metadata.hasVideoPoster) {
      posterClasses.push('card__poster--video');
    }

    return posterClasses.join(' ');
  };
  var hasImage = (0, _get2.default)(metadata, 'featured_image.source') && metadata.layout !== 'short';

  return _react2.default.createElement(
    'article',
    {
      className: setCardClasses('card'),
      onClick: function onClick(event) {
        return cardEvent(event);
      }
    },
    _react2.default.createElement(
      _fc_link2.default,
      {
        currentSite: (0, _get2.default)(metadata, 'currentSite'),
        to: (0, _get2.default)(metadata, 'link'),
        title: (0, _get2.default)(metadata, 'title'),
        config: config,
        externalLink: (0, _get2.default)(metadata, 'external')
      },
      _react2.default.createElement(
        'div',
        { className: 'card__text-wrapper card__text-wrapper--all-feed' },
        _react2.default.createElement(_eyebrow2.default, { metadata: metadata }),
        _react2.default.createElement(
          'h2',
          { className: 'card__title card__title--all-feed' },
          (0, _get2.default)(metadata, 'title')
        ),
        hasImage ? _react2.default.createElement(
          'h3',
          { className: 'card__deck card__deck--all-feed' },
          (0, _get2.default)(metadata, 'excerpt')
        ) : null
      ),
      _react2.default.createElement(_poster2.default, {
        metadata: metadata,
        className: setPosterClasses(),
        generateClasses: false
      })
    )
  );
}

AllFeed.defaultProps = {
  top: false,
  cardEvent: function cardEvent() {},
  fullPageAdvertorial: false
};

AllFeed.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  top: _propTypes2.default.bool,
  metadata: _propTypes2.default.shape({}).isRequired,
  fullPageAdvertorial: _propTypes2.default.bool,
  cardEvent: _propTypes2.default.func
};

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VideoCard;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _fc_link = __webpack_require__(21);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _image = __webpack_require__(61);

var _image2 = _interopRequireDefault(_image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VideoCard(props) {
  var config = props.config,
      metadata = props.metadata,
      cardEvent = props.cardEvent,
      hasLink = props.hasLink;

  var videoState = (0, _get2.default)(metadata, 'isVideoActive') ? 'card--video-active' : 'card--video-play';
  var content = [_react2.default.createElement(_image2.default, {
    key: (0, _get2.default)(metadata, 'featured_image.source'),
    alt: (0, _get2.default)(metadata, 'title'),
    src: (0, _get2.default)(metadata, 'featured_image.source'),
    assetSizes: (0, _get2.default)(metadata, 'assetSizes')
  }), _react2.default.createElement(
    'figcaption',
    { key: (0, _get2.default)(metadata, 'title') },
    _react2.default.createElement(
      'h2',
      { className: 'card__title card__title--video' },
      (0, _get2.default)(metadata, 'title')
    )
  )];

  return _react2.default.createElement(
    'figure',
    {
      className: 'card card--video ' + videoState,
      onClick: function onClick(event) {
        return cardEvent(event, (0, _get2.default)(metadata, 'index'));
      }
    },
    hasLink ? _react2.default.createElement(
      _fc_link2.default,
      {
        config: config,
        to: (0, _get2.default)(metadata, 'link'),
        title: (0, _get2.default)(metadata, 'title'),
        externalLink: (0, _get2.default)(metadata, 'external')
      },
      content
    ) : content
  );
}

VideoCard.defaultProps = {
  cardEvent: function cardEvent() {},
  hasLink: true
};

VideoCard.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  metadata: _propTypes2.default.shape({}).isRequired,
  cardEvent: _propTypes2.default.func,
  hasLink: _propTypes2.default.bool
};

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RecircCard;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _advertorial = __webpack_require__(29);

var _fc_link = __webpack_require__(21);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _eyebrow = __webpack_require__(57);

var _eyebrow2 = _interopRequireDefault(_eyebrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RecircCard(props) {
  var config = props.config,
      metadata = props.metadata,
      cardEvent = props.cardEvent;

  var advertorial = (0, _advertorial.isAdvertorial)(metadata.tags);
  var setCardClasses = function setCardClasses() {
    var cardClasses = ['card', 'card--recirc'];

    if (advertorial) {
      cardClasses.push('card--advertorial');
    }

    return cardClasses.join(' ');
  };

  return _react2.default.createElement(
    'article',
    { className: setCardClasses(), onClick: function onClick(event) {
        return cardEvent(event);
      } },
    _react2.default.createElement(
      _fc_link2.default,
      {
        to: (0, _get2.default)(metadata, 'link'),
        title: (0, _get2.default)(metadata, 'title'),
        config: config,
        externalLink: (0, _get2.default)(metadata, 'external')
      },
      _react2.default.createElement(_eyebrow2.default, { metadata: metadata }),
      _react2.default.createElement(
        'h2',
        { className: 'card__title card__title--recirc' },
        (0, _get2.default)(metadata, 'title')
      )
    )
  );
}

RecircCard.defaultProps = {
  cardEvent: function cardEvent() {}
};

RecircCard.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  metadata: _propTypes2.default.shape({}).isRequired,
  cardEvent: _propTypes2.default.func
};

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SmallCard;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _fc_link = __webpack_require__(21);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _eyebrow = __webpack_require__(57);

var _eyebrow2 = _interopRequireDefault(_eyebrow);

var _poster = __webpack_require__(56);

var _poster2 = _interopRequireDefault(_poster);

var _advertorial = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SmallCard(props) {
  var metadata = props.metadata,
      config = props.config,
      cardEvent = props.cardEvent,
      disabledImage = props.disabledImage,
      fullPageAdvertorial = props.fullPageAdvertorial;

  var advertorial = (0, _advertorial.isAdvertorial)(metadata.tags) && !fullPageAdvertorial;
  var image = (0, _get2.default)(metadata, 'featured_image.source');
  var hasImage = image && !disabledImage;
  var setCardClasses = function setCardClasses() {
    var cardClasses = ['card', 'card--small'];

    if (advertorial) {
      cardClasses.push('card--advertorial');
    }

    return cardClasses.join(' ');
  };

  var setPosterClasses = function setPosterClasses() {
    var posterClasses = ['card__poster', 'card__poster--small'];

    if (metadata.hasVideoPoster) {
      posterClasses.push('card__poster--video');
    }

    return posterClasses.join(' ');
  };

  return _react2.default.createElement(
    'article',
    { className: setCardClasses(), onClick: cardEvent },
    _react2.default.createElement(
      _fc_link2.default,
      {
        currentSite: (0, _get2.default)(metadata, 'currentSite'),
        to: (0, _get2.default)(metadata, 'link'),
        title: (0, _get2.default)(metadata, 'title'),
        config: config,
        externalLink: (0, _get2.default)(metadata, 'external')
      },
      _react2.default.createElement(
        'div',
        { className: 'card__text-wrapper card__text-wrapper--small' },
        _react2.default.createElement(_eyebrow2.default, { metadata: metadata }),
        _react2.default.createElement(
          'h2',
          { className: 'card__title card__title--small' },
          (0, _get2.default)(metadata, 'title')
        )
      ),
      hasImage ? _react2.default.createElement(_poster2.default, {
        metadata: metadata,
        className: setPosterClasses(),
        generateClasses: false
      }) : null
    )
  );
}

SmallCard.defaultProps = {
  cardEvent: function cardEvent() {},
  fullPageAdvertorial: false,
  disabledImage: false
};

SmallCard.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  metadata: _propTypes2.default.shape({}).isRequired,
  cardEvent: _propTypes2.default.func,
  fullPageAdvertorial: _propTypes2.default.bool,
  disabledImage: _propTypes2.default.bool
};

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Magazine;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _fc_link = __webpack_require__(21);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _image = __webpack_require__(61);

var _image2 = _interopRequireDefault(_image);

var _cloudinary_asset_util = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Magazine(props) {
  var config = props.config,
      metadata = props.metadata,
      cardEvent = props.cardEvent,
      hasTitle = props.hasTitle,
      fullWidth = props.fullWidth,
      fullIssue = props.fullIssue;

  var setCardClasses = function setCardClasses() {
    var cardClasses = ['card', 'card--magazine'];

    if (fullWidth) {
      cardClasses.push('card--full-width');
    }

    return cardClasses.join(' ');
  };

  if (!metadata.title || !metadata.image) {
    return null;
  }

  return _react2.default.createElement(
    'figure',
    { className: setCardClasses(), onClick: function onClick(event) {
        return cardEvent(event);
      } },
    _react2.default.createElement(
      _fc_link2.default,
      {
        config: config,
        to: 'https://www.fastcompany.com/magazine/' + metadata.slug,
        title: (0, _get2.default)(metadata, 'title'),
        externalLink: false
      },
      _react2.default.createElement(_image2.default, {
        src: metadata.image,
        alt: metadata.title,
        assetSizes: _cloudinary_asset_util.imageSizesLookup.magazine
      }),
      hasTitle ? _react2.default.createElement(
        'figcaption',
        null,
        _react2.default.createElement(
          'h2',
          { className: 'card__title card__title--magazine' },
          metadata.title
        )
      ) : null
    ),
    _react2.default.createElement(
      'div',
      { className: 'card__issue-text' },
      _react2.default.createElement(
        'time',
        { className: 'card__issue-date' },
        metadata.date
      ),
      _react2.default.createElement(
        'ul',
        { className: 'card__links' },
        fullIssue ? _react2.default.createElement(
          'li',
          { className: 'card__links-item' },
          _react2.default.createElement(
            _fc_link2.default,
            {
              config: config,
              to: 'https://www.fastcompany.com/magazine/' + metadata.slug,
              title: (0, _get2.default)(metadata, 'title'),
              externalLink: false
            },
            'Full Issue'
          )
        ) : null,
        metadata.pdf_url ? _react2.default.createElement(
          'li',
          { className: 'card__links-item' },
          _react2.default.createElement(
            'a',
            { href: metadata.pdf_url, target: '_blank' },
            'View PDF'
          )
        ) : null
      )
    )
  );
}

Magazine.defaultProps = {
  cardEvent: function cardEvent() {},
  fullWidth: false,
  hasTitle: true,
  fullIssue: true
};

Magazine.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  metadata: _propTypes2.default.shape({}).isRequired,
  cardEvent: _propTypes2.default.func,
  fullWidth: _propTypes2.default.bool,
  hasTitle: _propTypes2.default.bool,
  fullIssue: _propTypes2.default.bool
};

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(43);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footer = function (_Component) {
  _inherits(Footer, _Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var currentYear = new Date().getFullYear();

      return _react2.default.createElement(
        'footer',
        { className: 'footer' },
        _react2.default.createElement(
          'nav',
          { className: 'footer__nav-wrapper' },
          _react2.default.createElement(
            'ul',
            { className: 'footer__link-container' },
            _react2.default.createElement(
              'li',
              { className: 'footer__link' },
              _react2.default.createElement(
                'a',
                { href: 'https://spotlight.fastcompany.com/' },
                'Advertise'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'footer__link' },
              _react2.default.createElement(
                'a',
                { href: 'https://www.fastcompany.com/privacy-policy' },
                'Privacy\xA0Policy'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'footer__link' },
              _react2.default.createElement(
                'a',
                { href: 'https://www.fastcompany.com/terms-and-conditions' },
                'Terms'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'footer__link' },
              _react2.default.createElement(
                'a',
                { href: 'https://www.fastcompany.com/contact-us' },
                'Contact'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'footer__link' },
              _react2.default.createElement(
                'a',
                { href: 'https://www.fastcompany.com/about-us' },
                'About Us'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'footer__link' },
              _react2.default.createElement(
                _Link2.default,
                { to: '/sitemap' },
                'Site Map'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'footer__link' },
              'Fast Company & Inc \xA9 ',
              currentYear,
              ' Mansueto Ventures, LLC'
            ),
            _react2.default.createElement(
              'li',
              { className: 'footer__link' },
              _react2.default.createElement(
                'a',
                { href: 'https://www.aboutads.info/', rel: 'nofollow' },
                _react2.default.createElement('img', {
                  className: 'footer__daa-logo',
                  src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAANCAAAAAC4QtCeAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAJ0Uk5TAAB2k804AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAAAEgAAABIAEbJaz4AAACASURBVAjXYyir3PaDAQby09KL9/2FcjIWf1mbVX0Mwklfw8DwbF5awzkwZzXDjco/j/vTuq+COe93APXcLE5bCeKczvzOwPCoPG0xiHMq6/f9SWkdF4HK1jKcyepJazgFNnrBpwtpVUchRuempR17+htqaU/55l9w5xzf+RHOBgC94zlXyQTR6wAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxMy0wMy0wOFQxOToxMDo0NC0wNTowMNnS5vEAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTMtMDMtMDhUMTk6MTA6NDQtMDU6MDCoj15NAAAAAElFTkSuQmCC',
                  alt: 'Digital Advertising Alliance (DAA) Self-Regulatory Program',
                  target: '_new'
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Footer;
}(_react.Component);

exports.default = Footer;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(15);

var _omit = __webpack_require__(123);

var _omit2 = _interopRequireDefault(_omit);

var _clone = __webpack_require__(107);

var _clone2 = _interopRequireDefault(_clone);

var _serializeJavascript = __webpack_require__(152);

var _serializeJavascript2 = _interopRequireDefault(_serializeJavascript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Config = function (_Component) {
  _inherits(Config, _Component);

  function Config() {
    _classCallCheck(this, Config);

    return _possibleConstructorReturn(this, (Config.__proto__ || Object.getPrototypeOf(Config)).apply(this, arguments));
  }

  _createClass(Config, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.initialPageLoad) {
        return null;
      }

      return _react2.default.createElement('script', {
        dangerouslySetInnerHTML: {
          __html: '/*<!--*/ \n\nwindow.appState = ' + this.props.state + '; \n /*-->*/'
        }
      });
    }
  }]);

  return Config;
}(_react.Component);

Config.propTypes = {
  state: _propTypes2.default.string.isRequired,
  initialPageLoad: _propTypes2.default.bool.isRequired
};

function mapStateToProps(state) {
  var clonedState = (0, _clone2.default)(state);
  var initialPageLoad = state.config.initialPageLoad;

  clonedState.config = (0, _omit2.default)(clonedState.config, ['criticalCss']);
  clonedState.config.initialQueryParams = (0, _serializeJavascript2.default)(clonedState.config.initialQueryParams);
  var currentState = initialPageLoad ? (0, _serializeJavascript2.default)(clonedState) : '';
  return {
    state: currentState,
    initialPageLoad: initialPageLoad
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Config);

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/',
    component: _index_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _homepage_state_manager2.default)(store)
  };
};

var _index_page = __webpack_require__(135);

var _index_page2 = _interopRequireDefault(_index_page);

var _homepage_state_manager = __webpack_require__(137);

var _homepage_state_manager2 = _interopRequireDefault(_homepage_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(34);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _card = __webpack_require__(36);

var _card2 = _interopRequireDefault(_card);

var _slug = __webpack_require__(23);

var _slug2 = _interopRequireDefault(_slug);

var _promo_banner = __webpack_require__(529);

var _promo_banner2 = _interopRequireDefault(_promo_banner);

var _ga = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Scroll = function (_Component) {
  _inherits(Scroll, _Component);

  function Scroll(props) {
    _classCallCheck(this, Scroll);

    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

    var metadata = _this.props.metadata;


    _this.currentSite = (0, _get2.default)(metadata, 'stories[0].currentSite');
    return _this;
  }

  _createClass(Scroll, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'buildSlugName',
    value: function buildSlugName(tag) {
      var tagName = (0, _get2.default)(tag, '[0].name');
      if (tagName) {
        return tagName;
      }

      return this.currentSite === 'fastcompany' ? 'News' : 'Latest';
    }
  }, {
    key: 'buildSlugLink',
    value: function buildSlugLink(tag) {
      var tagData = (0, _get2.default)(tag, '[0]');
      if (tagData) {
        var tagSlug = (0, _get2.default)(tagData, 'slug');
        var tagName = (0, _get2.default)(tagData, 'name');
        if (tagData.taxonomy === 'category') {
          return '/' + tagSlug;
        }

        if (tagData.taxonomy === 'post_tag') {
          return '/section/' + tagSlug;
        }
        return tagName;
      }

      return this.currentSite === 'fastcompany' ? '//www.fastcompany.com/news' : null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          config = _props.config,
          className = _props.className,
          metadata = _props.metadata,
          promoBanner = _props.promoBanner;


      if (!metadata) {
        return null;
      }

      var slugName = this.buildSlugName(metadata.tag);
      var slugLink = this.buildSlugLink(metadata.tag);
      var hasPromoBanner = !(0, _isEmpty2.default)(promoBanner);

      return _react2.default.createElement(
        'div',
        {
          className: 'column-component control ' + (className || 'card-wrapper--3')
        },
        hasPromoBanner ? _react2.default.createElement(_promo_banner2.default, promoBanner) : '',
        slugName ? _react2.default.createElement(_slug2.default, { linkTo: slugLink, slugName: slugName, className: 'column' }) : '',
        _react2.default.createElement(
          'div',
          {
            className: hasPromoBanner ? 'scroll-me scroll-me--promoting' : 'scroll-me'
          },
          metadata.stories.map(function (item, idx) {
            return _react2.default.createElement(_card2.default, {
              config: config,
              type: 'small',
              metadata: item,
              key: item.id,
              cardEvent: function cardEvent() {
                (0, _ga.trackGAEvent)({
                  eventCategory: 'Engagement',
                  eventAction: 'ScrollingModule:Pos-' + (idx + 1),
                  eventLabel: (0, _get2.default)(item, 'link')
                });
              }
            });
          })
        )
      );
    }
  }]);

  return Scroll;
}(_react.Component);

exports.default = Scroll;


Scroll.defaultProps = {
  className: '',
  promoBanner: {}
};

Scroll.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  className: _propTypes2.default.string,
  metadata: _propTypes2.default.shape({}).isRequired,
  promoBanner: _propTypes2.default.shape({})
};

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PromoBanner;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PromoBanner(props) {
  return _react2.default.createElement(
    'div',
    { className: 'scrolling-module__promo' },
    _react2.default.createElement(
      'a',
      { href: props.click_through_url, title: '' },
      _react2.default.createElement('img', { src: props.image_url, alt: '', width: 387, height: 100 })
    )
  );
}

PromoBanner.propTypes = {
  click_through_url: _propTypes2.default.string.isRequired,
  image_url: _propTypes2.default.string.isRequired
};

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(146);

function getSocialModel(encodedPostUrl, text) {
  var emailText = void 0;
  var twitterText = void 0;
  var linkedinText = void 0;

  if ((0, _lodash.isObject)(text)) {
    twitterText = text.twitter;
    linkedinText = text.linkedin;
    emailText = text.email;
  } else {
    emailText = text;
    twitterText = text;
    linkedinText = text;
  }

  return [{
    property: 'facebook',
    url: 'https://www.facebook.com/sharer.php?u=' + encodedPostUrl + '&app_id=178479832213933&display=popup',
    popup: true,
    socialShare: {
      platform: 'Facebook',
      action: 'share'
    }
  }, {
    property: 'twitter',
    url: 'https://twitter.com/share?url=' + encodedPostUrl + '&text=' + twitterText,
    popup: true,
    socialShare: {
      platform: 'Twitter',
      action: 'tweet'
    }
  }, {
    property: 'linkedin',
    url: 'https://www.linkedin.com/shareArticle?mini=true&url=' + encodedPostUrl + '&media=' + linkedinText,
    popup: true,
    socialShare: {
      platform: 'Linkedin',
      action: 'share'
    }
  }, {
    property: 'email',
    url: 'mailto:?body=' + encodedPostUrl + '&subject=' + emailText,
    icon: 'share-email',
    popup: false,
    socialShare: {
      platform: 'Email',
      action: 'email'
    }
  }];
}

exports.default = getSocialModel;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sendGASubscriptionEvents;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ga = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sendGASubscriptionEvents(arr, newsletters) {
  if (Array.isArray(arr) || Object.keys(newsletters || {}).length !== 0) {
    arr.forEach(function iterateThroughListIds(listId) {
      var nlGroup = (0, _get2.default)(Object.keys(newsletters).filter(function findCurrentNlGroup(nl) {
        return (0, _get2.default)(newsletters, '[' + nl + '].listId') === listId;
      }), [0]);
      (0, _ga.trackGAEvent)({
        eventCategory: 'Newsletter Signup',
        eventAction: 'subscribe',
        eventLabel: (0, _get2.default)(newsletters, '[' + nlGroup + '].listName')
      });
    });
  }
}

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _urlParse = __webpack_require__(50);

var _urlParse2 = _interopRequireDefault(_urlParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSiteFromURI(uri) {
  var parsed = (0, _urlParse2.default)(uri);
  var siteLookup = {
    'www.fastcompany.com': 'Fast Company',
    'www.fastcodesign.com': 'Co.Design'
  };

  return siteLookup[parsed.host] || '';
}

exports.default = getSiteFromURI;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _throttle = __webpack_require__(72);

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class(_ref) {
    var _this = this;

    var player = _ref.player,
        percentInView = _ref.percentInView,
        playWhenOnTop = _ref.playWhenOnTop,
        dontPlay = _ref.dontPlay;

    _classCallCheck(this, _class);

    this.player = player;
    this.playWhenOnTop = playWhenOnTop;
    this.wrapper = this.player.getContainer();
    this.throttledScrollListener = (0, _throttle2.default)(function () {
      _this.playerInView(percentInView, dontPlay);
    }, 300);
  }

  // throttledScrollListener() {
  //   return throttle(() => {
  //     console.log('gsdgdg')
  //     this.playerInView(percentInView);
  //   }, 300);
  // }

  _createClass(_class, [{
    key: 'playerPosition',
    value: function playerPosition(playerEl) {
      if (playerEl && playerEl.getBoundingClientRect) {
        var bodyRect = document.body.getBoundingClientRect();
        var playerRect = playerEl.getBoundingClientRect();
        return playerRect.top - bodyRect.top - this.scrollPosition().top;
      }
      return null;
    }
  }, {
    key: 'scrollPosition',
    value: function scrollPosition() {
      var doc = document.documentElement;
      return {
        left: (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0),
        top: (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
      };
    }
  }, {
    key: 'playerInView',
    value: function playerInView(percentInView, dontPlay) {
      if (dontPlay) {
        return this.player.stop();
      }
      var pixelsInView = this.player.getHeight() * percentInView / 100;
      var difference = this.playerPosition(this.wrapper) + pixelsInView;
      var adjust = window.innerHeight > pixelsInView ? window.innerHeight : 100;
      var inView = this.playWhenOnTop ? difference > pixelsInView && difference < adjust && this.scrollPosition().top >= 700 : difference > pixelsInView && difference < adjust;

      return this.player.play(inView);
    }
  }, {
    key: 'on',
    value: function on() {
      window.addEventListener('scroll', this.throttledScrollListener);
    }
  }, {
    key: 'off',
    value: function off() {
      window.removeEventListener('scroll', this.throttledScrollListener);
    }
  }]);

  return _class;
}();

exports.default = _class;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSlick = __webpack_require__(60);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _fc_link = __webpack_require__(21);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _franchise_data = __webpack_require__(535);

var _franchise_data2 = _interopRequireDefault(_franchise_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FranchiseRow = function (_Component) {
  _inherits(FranchiseRow, _Component);

  function FranchiseRow() {
    _classCallCheck(this, FranchiseRow);

    return _possibleConstructorReturn(this, (FranchiseRow.__proto__ || Object.getPrototypeOf(FranchiseRow)).apply(this, arguments));
  }

  _createClass(FranchiseRow, [{
    key: 'renderFranchies',
    value: function renderFranchies() {
      var config = this.props.config;


      return _franchise_data2.default.map(function (franchise, index) {
        return _react2.default.createElement(
          'div',
          { className: 'franchise', key: 'franchise-' + index },
          _react2.default.createElement(
            _fc_link2.default,
            { title: franchise.title, to: franchise.link, config: config },
            _react2.default.createElement(
              'div',
              { className: 'franchise__logo' },
              _react2.default.createElement('img', { src: franchise.logo, alt: franchise.title })
            ),
            _react2.default.createElement(
              'figure',
              { className: 'franchise__photo' },
              _react2.default.createElement('img', { src: franchise.image, alt: franchise.title })
            ),
            _react2.default.createElement(
              'h2',
              { className: 'franchise__title' },
              franchise.title
            ),
            _react2.default.createElement(
              'p',
              { className: 'franchise__description' },
              franchise.description
            )
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props) {
        return null;
      }
      var config = this.props.config;
      var initialPageLoad = config.initialPageLoad;


      var settings = {
        arrows: false,
        infinite: true,
        className: 'row franchise-showcase',
        slidesToScroll: 1,
        slide: '.franchise',
        dots: true,
        dotsClass: 'franchise-pagination',
        slidesToShow: 1,
        responsive: [{
          breakpoint: 1024
        }, {
          breakpoint: 100000,
          settings: 'unslick'
        }]
      };

      if (initialPageLoad) {
        return _react2.default.createElement(
          'div',
          { className: 'row franchise-showcase' },
          this.renderFranchies()
        );
      }

      return _react2.default.createElement(
        _reactSlick2.default,
        _extends({}, settings, { key: 'franchise-showcase' }),
        this.renderFranchies()
      );
    }
  }]);

  return FranchiseRow;
}(_react.Component);

exports.default = FranchiseRow;


FranchiseRow.propTypes = {
  config: _propTypes2.default.shape({}).isRequired
};

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var data = [{
  title: 'MOST CREATIVE PEOPLE IN BUSINESS',
  description: 'Leaders who are shaping the future of business in creative ways.',
  logo: 'https://images.fastcompany.net/image/upload/h_70,f_auto,q_auto,fl_lossy/v1512595155/fcweb/mcp-logo-140_w6dozo.png',
  image: 'https://images.fastcompany.net/image/upload/h_475,f_auto,q_auto,fl_lossy/v1513181808/fcweb/p-1-Most-Creative-People-2017-Donald-Glover_w0ekjo.jpg',
  link: 'https://www.fastcompany.com/most-creative-people/2017'
}, {
  title: 'INNOVATION by design',
  description: 'The best products, services, interfaces, and design ideas in business.',
  logo: 'https://images.fastcompany.net/image/upload/h_70,f_auto,q_auto,fl_lossy/v1512595155/fcweb/ibd-logo-140_xdn5xi.png',
  image: 'https://images.fastcompany.net/image/upload/h_475,f_auto,q_auto,fl_lossy/v1513181808/fcweb/p-2-feature-219-Microsoft-rewrites-the-code_ttdxaq.jpg',
  link: 'https://www.fastcodesign.com/innovation-by-design/2017'
}, {
  title: 'Most Innovative Companies',
  description: 'The top companies in entertainment, media, sports, technology, and more.',
  logo: 'https://images.fastcompany.net/image/upload/h_70,f_auto,q_auto,fl_lossy/v1512595155/fcweb/mic-logo-140_ivn8bj.png',
  image: 'https://images.fastcompany.net/image/upload/h_475,f_auto,q_auto,fl_lossy/v1519143105/fcweb/p-waze-mar-223-FA0318WAZE001_mg0zsj.jpg',
  link: 'https://www.fastcompany.com/most-innovative-companies/2018'
}, {
  title: 'World Changing Ideas',
  description: 'Products, concepts, and policies that are pursuing innovation for good.',
  logo: 'https://images.fastcompany.net/image/upload/h_70,f_auto,q_auto,fl_lossy/v1512595155/fcweb/wci-logo-140_vuva6d.png',
  image: 'https://images.fastcompany.net/image/upload/h_475,f_auto,q_auto,fl_lossy/v1513181808/fcweb/3068717-poster-p-1-214-instagram-chris-paul-nba_ejg5fp.jpg',
  link: 'https://www.fastcompany.com/section/world-changing-ideas'
}];

exports.default = data;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchAllFeedIS;

var _all_feed_action_creators = __webpack_require__(232);

var allFeedActions = _interopRequireWildcard(_all_feed_action_creators);

var _all_feed_module = __webpack_require__(233);

var _all_feed_module2 = _interopRequireDefault(_all_feed_module);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchAllFeedIS(dispatch) {
  return function fetchModelData(params, config) {
    dispatch(allFeedActions.allFeedISLoading());
    return _all_feed_module2.default.fetchAllFeedIS(params, config).then(function handleAuthorAllFeedData(AllFeedData) {
      dispatch(allFeedActions.allFeedISLoaded(AllFeedData.data, config));
    }).catch(function handleAuthorAllFeedError(err) {
      dispatch(allFeedActions.allFeedISError(err, config));
      _logger_service2.default.error(err, 'Error in all  all feed actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__(44);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Request = function () {
  function Request() {
    _classCallCheck(this, Request);
  }

  _createClass(Request, null, [{
    key: 'getAsync',
    value: function getAsync(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return (0, _axios2.default)(url, options);
    }
  }]);

  return Request;
}();

exports.default = Request;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recircFeedLoading = recircFeedLoading;
exports.recircFeedLoaded = recircFeedLoaded;
exports.recircFeedLoadError = recircFeedLoadError;
exports.hideRecircFeed = hideRecircFeed;
// import { canUseDOM } from 'exenv';

function recircFeedLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'RECIRC_FEED_LOADING',
    recircFeed: resp,
    store: store
  };
}

function recircFeedLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'RECIRC_FEED_LOADED',
    recircFeed: resp,
    store: store
  };
}

function recircFeedLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'RECIRC_FEED_ERROR',
    recircFeed: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

function hideRecircFeed() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HIDE_RECIRC_FEED',
    recircFeed: resp,
    store: store
  };
}

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(16);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AllFeed = function (_Base) {
  _inherits(AllFeed, _Base);

  function AllFeed() {
    _classCallCheck(this, AllFeed);

    return _possibleConstructorReturn(this, (AllFeed.__proto__ || Object.getPrototypeOf(AllFeed)).apply(this, arguments));
  }

  _createClass(AllFeed, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/recirc-feed?total=3';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return AllFeed;
}(_base_model2.default);

exports.default = AllFeed;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _homepage_action_creators = __webpack_require__(541);

var homepageActions = _interopRequireWildcard(_homepage_action_creators);

var _async_scrolling_module_actions = __webpack_require__(542);

var _async_scrolling_module_actions2 = _interopRequireDefault(_async_scrolling_module_actions);

var _async_promo_banner_actions = __webpack_require__(545);

var _async_promo_banner_actions2 = _interopRequireDefault(_async_promo_banner_actions);

var _async_all_feed_actions = __webpack_require__(260);

var _async_all_feed_actions2 = _interopRequireDefault(_async_all_feed_actions);

var _async_recirc_feed_actions = __webpack_require__(58);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _async_featured_feed_actions = __webpack_require__(548);

var _async_featured_feed_actions2 = _interopRequireDefault(_async_featured_feed_actions);

var _async_homepage_tag_actions = __webpack_require__(551);

var _async_homepage_tag_actions2 = _interopRequireDefault(_async_homepage_tag_actions);

var _async_homepage_video_actions = __webpack_require__(554);

var _async_homepage_video_actions2 = _interopRequireDefault(_async_homepage_video_actions);

var _async_magazine_latest_issue_posts_actions = __webpack_require__(235);

var _async_magazine_latest_issue_posts_actions2 = _interopRequireDefault(_async_magazine_latest_issue_posts_actions);

var _not_found_status_action_creator = __webpack_require__(28);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _async_featured_sponsored_card_actions = __webpack_require__(144);

var _async_featured_sponsored_card_actions2 = _interopRequireDefault(_async_featured_sponsored_card_actions);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(homepageActions.homepageLoading());
    if (params.page) {
      return Promise.all([(0, _async_all_feed_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
        dispatch(homepageActions.homepageLoaded({}, store));
        return true;
      }).catch(function handleUserError(err) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
        dispatch(homepageActions.homepageLoadError(err, store));
        return _logger_service2.default.error(err, 'Error in homepage actions, message: ' + err.message);
      });
    }
    return Promise.all([(0, _async_featured_feed_actions2.default)(params, store)(dispatch), (0, _async_featured_sponsored_card_actions2.default)(params, store)(dispatch), (0, _async_promo_banner_actions2.default)(params, store)(dispatch), (0, _async_scrolling_module_actions2.default)(params, store)(dispatch), (0, _async_homepage_video_actions2.default)(params, store)(dispatch), (0, _async_homepage_tag_actions2.default)(params, store)(dispatch), (0, _async_all_feed_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch), (0, _async_magazine_latest_issue_posts_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(homepageActions.homepageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      dispatch(homepageActions.homepageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in homepage actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.homepageLoading = homepageLoading;
exports.homepageLoaded = homepageLoaded;
exports.homepageLoadError = homepageLoadError;
// import { canUseDOM } from 'exenv';

function homepageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HOMEPAGE_LOADING',
    homepage: resp,
    store: store
  };
}

function homepageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments[1];

  return {
    type: 'HOMEPAGE_LOADED',
    homepage: resp,
    store: store
  };
}

function homepageLoadError(error, store) {
  return {
    type: 'HOMEPAGE_ERROR',
    homepage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _scrolling_module_action_creators = __webpack_require__(543);

var scrollingModuleActions = _interopRequireWildcard(_scrolling_module_action_creators);

var _scrolling_module = __webpack_require__(544);

var _scrolling_module2 = _interopRequireDefault(_scrolling_module);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(scrollingModuleActions.scrollingModuleLoading({}, store));
    return _scrolling_module2.default.fetch(params, store).then(function handlePostDetailData(resp) {
      dispatch(scrollingModuleActions.scrollingModuleLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(scrollingModuleActions.scrollingModuleLoadError(err, store));
      _logger_service2.default.error(err, 'Error in scrollingModule actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollingModuleLoading = scrollingModuleLoading;
exports.scrollingModuleLoaded = scrollingModuleLoaded;
exports.scrollingModuleLoadError = scrollingModuleLoadError;
// import { canUseDOM } from 'exenv';

function scrollingModuleLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'SCROLLING_MODULE_LOADING',
    scrollingModule: resp,
    store: store
  };
}

function scrollingModuleLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'SCROLLING_MODULE_LOADED',
    scrollingModule: {
      posts: resp.posts,
      tag: resp.tag
    },
    store: store
  };
}

function scrollingModuleLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'SCROLLING_MODULE_ERROR',
    scrollingModule: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(16);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LatestPosts = function (_Base) {
  _inherits(LatestPosts, _Base);

  function LatestPosts() {
    _classCallCheck(this, LatestPosts);

    return _possibleConstructorReturn(this, (LatestPosts.__proto__ || Object.getPrototypeOf(LatestPosts)).apply(this, arguments));
  }

  _createClass(LatestPosts, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var site = (0, _get2.default)(state, 'config.site');

      var cacheKeyUrl = '' + protocol + host + '/api/v2/scrolling-module-posts/' + site + '?total=20';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return LatestPosts;
}(_base_model2.default);

exports.default = LatestPosts;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _promo_banner_action_creators = __webpack_require__(546);

var promoBannerActions = _interopRequireWildcard(_promo_banner_action_creators);

var _promo_banner = __webpack_require__(547);

var _promo_banner2 = _interopRequireDefault(_promo_banner);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(promoBannerActions.promoBannerLoading({}, store));
    return _promo_banner2.default.fetch(params, store).then(function handlePostDetailData(resp) {
      dispatch(promoBannerActions.promoBannerLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(promoBannerActions.promoBannerLoadError(err, store));
      _logger_service2.default.error(err, 'Error in promoBanner actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promoBannerLoading = promoBannerLoading;
exports.promoBannerLoaded = promoBannerLoaded;
exports.promoBannerLoadError = promoBannerLoadError;
// import { canUseDOM } from 'exenv';

function promoBannerLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PROMO_BANNER_LOADING',
    promoBanner: resp,
    store: store
  };
}

function promoBannerLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PROMO_BANNER_LOADED',
    promoBanner: resp.promoBanner,
    store: store
  };
}

function promoBannerLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PROMO_BANNER_ERROR',
    promoBanner: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(16);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PromoBanner = function (_Base) {
  _inherits(PromoBanner, _Base);

  function PromoBanner() {
    _classCallCheck(this, PromoBanner);

    return _possibleConstructorReturn(this, (PromoBanner.__proto__ || Object.getPrototypeOf(PromoBanner)).apply(this, arguments));
  }

  _createClass(PromoBanner, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var site = (0, _get2.default)(state, 'config.site');

      var cacheKeyUrl = '' + protocol + host + '/api/v1/promo-banner/' + site;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return PromoBanner;
}(_base_model2.default);

exports.default = PromoBanner;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchFeaturedModule;

var _featured_feed_action_creators = __webpack_require__(549);

var featuredFeedActions = _interopRequireWildcard(_featured_feed_action_creators);

var _featured_module = __webpack_require__(550);

var _featured_module2 = _interopRequireDefault(_featured_module);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchFeaturedModule(params, store) {
  return function firstDispatchFeatured(dispatch) {
    dispatch(featuredFeedActions.featuredFeedLoading());
    return _featured_module2.default.fetch(params, store).then(function handleFeaturedModuleData(resp) {
      dispatch(featuredFeedActions.featuredFeedLoaded(resp.data, store));
    }).catch(function handleFeaturedError(err) {
      dispatch(featuredFeedActions.featuredFeedLoadError(err, store));
      _logger_service2.default.error(err, 'Error in featured feed actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featuredFeedLoading = featuredFeedLoading;
exports.featuredFeedLoaded = featuredFeedLoaded;
exports.featuredFeedLoadError = featuredFeedLoadError;
// import { canUseDOM } from 'exenv';

function featuredFeedLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'FEATURED_FEED_LOADING',
    featuredFeed: resp,
    store: store
  };
}

function featuredFeedLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments[1];

  return {
    type: 'FEATURED_FEED_LOADED',
    featuredFeed: resp,
    store: store
  };
}

function featuredFeedLoadError(error, store) {
  return {
    type: 'FEATURED_FEED_ERROR',
    featuredFeed: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(16);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TopTags = function (_Base) {
  _inherits(TopTags, _Base);

  function TopTags() {
    _classCallCheck(this, TopTags);

    return _possibleConstructorReturn(this, (TopTags.__proto__ || Object.getPrototypeOf(TopTags)).apply(this, arguments));
  }

  _createClass(TopTags, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/featured-feed/' + site;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          if (!_exenv.canUseDOM) {
            _logger_service2.default.info('Setting cache key for featured feed: ' + cacheKey + ' from model.');
          }
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return TopTags;
}(_base_model2.default);

exports.default = TopTags;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _homepage_tag_action_creators = __webpack_require__(552);

var homepageTagActions = _interopRequireWildcard(_homepage_tag_action_creators);

var _homepage_tag_module = __webpack_require__(553);

var _homepage_tag_module2 = _interopRequireDefault(_homepage_tag_module);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(homepageTagActions.homepageTagLoading({}, store));
    return _homepage_tag_module2.default.fetch(params, store).then(function handlePostDetailData(resp) {
      dispatch(homepageTagActions.homepageTagLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(homepageTagActions.homepageTagLoadError(err, store));
      _logger_service2.default.error(err, 'Error in homepage tag actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.homepageTagLoading = homepageTagLoading;
exports.homepageTagLoaded = homepageTagLoaded;
exports.homepageTagLoadError = homepageTagLoadError;
// import { canUseDOM } from 'exenv';

function homepageTagLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HOMEPAGE_TAG_LOADING',
    homepageTag: resp,
    store: store
  };
}

function homepageTagLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments[1];

  return {
    type: 'HOMEPAGE_TAG_LOADED',
    homepageTag: {
      posts: resp
    },
    store: store
  };
}

function homepageTagLoadError(error, store) {
  return {
    type: 'HOMEPAGE_TAG_ERROR',
    homepageTag: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(16);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HomepageTagModel = function (_Base) {
  _inherits(HomepageTagModel, _Base);

  function HomepageTagModel() {
    _classCallCheck(this, HomepageTagModel);

    return _possibleConstructorReturn(this, (HomepageTagModel.__proto__ || Object.getPrototypeOf(HomepageTagModel)).apply(this, arguments));
  }

  _createClass(HomepageTagModel, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/tag-homepage-feed/' + site + '?total=4&with_body=0';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return HomepageTagModel;
}(_base_model2.default);

exports.default = HomepageTagModel;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _homepage_video_action_creators = __webpack_require__(555);

var homepageVideoActions = _interopRequireWildcard(_homepage_video_action_creators);

var _homepage_video_module = __webpack_require__(556);

var _homepage_video_module2 = _interopRequireDefault(_homepage_video_module);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(homepageVideoActions.homepageVideoLoading({}, store));
    return _homepage_video_module2.default.fetch(params, store).then(function handlePostDetailData(resp) {
      dispatch(homepageVideoActions.homepageVideoLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(homepageVideoActions.homepageVideoLoadError(err, store));
      _logger_service2.default.error(err, 'Error in homepage video actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.homepageVideoLoading = homepageVideoLoading;
exports.homepageVideoLoaded = homepageVideoLoaded;
exports.homepageVideoLoadError = homepageVideoLoadError;
// import { canUseDOM } from 'exenv';

function homepageVideoLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HOMEPAGE_VIDEO_LOADING',
    homepageVideo: resp,
    store: store
  };
}

function homepageVideoLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments[1];

  return {
    type: 'HOMEPAGE_VIDEO_LOADED',
    homepageVideo: resp,
    store: store
  };
}

function homepageVideoLoadError(error, store) {
  return {
    type: 'HOMEPAGE_VIDEO_ERROR',
    homepageVideo: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var homepageJwIdMap = {
  fastcompany: 'DCmFDcAw',
  fastcodesign: '8ltMmkrt'
};

var HomePageVideo = function (_Base) {
  _inherits(HomePageVideo, _Base);

  function HomePageVideo() {
    _classCallCheck(this, HomePageVideo);

    return _possibleConstructorReturn(this, (HomePageVideo.__proto__ || Object.getPrototypeOf(HomePageVideo)).apply(this, arguments));
  }

  _createClass(HomePageVideo, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var site = (0, _get2.default)(state, 'config.site');
      var id = (0, _get2.default)(homepageJwIdMap, site) || homepageJwIdMap.fastcompany;
      var host = 'content.jwplatform.com';
      var options = {};

      var cacheKeyUrl = 'https://' + host + '/feeds/' + id + '.json';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return HomePageVideo;
}(_base_model2.default);

exports.default = HomePageVideo;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.magazineLatestIssuePostsLoading = magazineLatestIssuePostsLoading;
exports.magazineLatestIssuePostsLoaded = magazineLatestIssuePostsLoaded;
exports.magazineLatestIssuePostsError = magazineLatestIssuePostsError;
function magazineLatestIssuePostsLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MAGAZINE_LATEST_ISSUE_POSTS_LOADING',
    magazineLatestIssuePosts: resp,
    store: store
  };
}

function magazineLatestIssuePostsLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MAGAZINE_LATEST_ISSUE_POSTS_LOADED',
    magazineLatestIssuePosts: resp,
    store: store
  };
}

function magazineLatestIssuePostsError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MAGAZINE_LATEST_ISSUE_POSTS_ERROR',
    magazineLatestIssuePosts: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(16);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MagazineLatestIssuePostsModel = function (_Base) {
  _inherits(MagazineLatestIssuePostsModel, _Base);

  function MagazineLatestIssuePostsModel() {
    _classCallCheck(this, MagazineLatestIssuePostsModel);

    return _possibleConstructorReturn(this, (MagazineLatestIssuePostsModel.__proto__ || Object.getPrototypeOf(MagazineLatestIssuePostsModel)).apply(this, arguments));
  }

  _createClass(MagazineLatestIssuePostsModel, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      // const site = get(state, 'config.site');
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v1/magazine/get-magazine-latest-issue-posts';

      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return MagazineLatestIssuePostsModel;
}(_base_model2.default);

exports.default = MagazineLatestIssuePostsModel;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featuredSponsoredCardLoading = featuredSponsoredCardLoading;
exports.featuredSponsoredCardLoaded = featuredSponsoredCardLoaded;
exports.featuredSponsoredCardLoadError = featuredSponsoredCardLoadError;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function featuredSponsoredCardLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'FEATURED_SPONSORED_CARD_LOADING',
    featuredSponsoredCard: (0, _get2.default)(resp, 'featuredSponsoredCard'),
    store: store
  };
} // import { canUseDOM } from 'exenv';
function featuredSponsoredCardLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments[1];

  return {
    type: 'FEATURED_SPONSORED_CARD_LOADED',
    featuredSponsoredCard: (0, _get2.default)(resp, 'featuredSponsoredCard'),
    store: store
  };
}

function featuredSponsoredCardLoadError(error, store) {
  return {
    type: 'FEATURED_SPONSORED_CARD_ERROR',
    featuredSponsoredCard: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(16);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeaturedSponsoredCard = function (_Base) {
  _inherits(FeaturedSponsoredCard, _Base);

  function FeaturedSponsoredCard() {
    _classCallCheck(this, FeaturedSponsoredCard);

    return _possibleConstructorReturn(this, (FeaturedSponsoredCard.__proto__ || Object.getPrototypeOf(FeaturedSponsoredCard)).apply(this, arguments));
  }

  _createClass(FeaturedSponsoredCard, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var site = (0, _get2.default)(state, 'config.site');
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v1/featured-sponsored-card/' + site;

      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;
      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      if (!_exenv.canUseDOM) {
        _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
      }
      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return FeaturedSponsoredCard;
}(_base_model2.default);

exports.default = FeaturedSponsoredCard;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/all/:page',
    component: _index_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _homepage_state_manager2.default)(store)
  };
};

var _index_page = __webpack_require__(135);

var _index_page2 = _interopRequireDefault(_index_page);

var _homepage_state_manager = __webpack_require__(137);

var _homepage_state_manager2 = _interopRequireDefault(_homepage_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/all',
    component: _index_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _homepage_state_manager2.default)(store, IS_ALL_INDEX)
  };
};

var _index_page = __webpack_require__(135);

var _index_page2 = _interopRequireDefault(_index_page);

var _homepage_state_manager = __webpack_require__(137);

var _homepage_state_manager2 = _interopRequireDefault(_homepage_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IS_ALL_INDEX = true;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/user/:slug/:page?',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 823)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'author'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'author-page' },
        _react2.default.createElement(
          'article',
          { className: 'author-page__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('../author_page').default;
}

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/:category',
    component: _category_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _category_page_state_manager2.default)(store)
  };
};

var _category_page = __webpack_require__(138);

var _category_page2 = _interopRequireDefault(_category_page);

var _category_page_state_manager = __webpack_require__(68);

var _category_page_state_manager2 = _interopRequireDefault(_category_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchCategoryPage;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _set = __webpack_require__(42);

var _set2 = _interopRequireDefault(_set);

var _category_page_action_creators = __webpack_require__(566);

var categoryPageActions = _interopRequireWildcard(_category_page_action_creators);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_category_video_actions = __webpack_require__(567);

var _async_category_video_actions2 = _interopRequireDefault(_async_category_video_actions);

var _async_category_all_feed_actions = __webpack_require__(570);

var _async_category_all_feed_actions2 = _interopRequireDefault(_async_category_all_feed_actions);

var _async_category_scrolling_module_actions = __webpack_require__(572);

var _async_category_scrolling_module_actions2 = _interopRequireDefault(_async_category_scrolling_module_actions);

var _async_category_promo_banner_actions = __webpack_require__(575);

var _async_category_promo_banner_actions2 = _interopRequireDefault(_async_category_promo_banner_actions);

var _async_category_featured_feed_actions = __webpack_require__(578);

var _async_category_featured_feed_actions2 = _interopRequireDefault(_async_category_featured_feed_actions);

var _async_recirc_feed_actions = __webpack_require__(58);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _async_featured_sponsored_card_actions = __webpack_require__(144);

var _async_featured_sponsored_card_actions2 = _interopRequireDefault(_async_featured_sponsored_card_actions);

var _async_magazine_latest_issue_posts_actions = __webpack_require__(235);

var _async_magazine_latest_issue_posts_actions2 = _interopRequireDefault(_async_magazine_latest_issue_posts_actions);

var _not_found_status_action_creator = __webpack_require__(28);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function fetchCategoryPage(params, store, isTag) {
  return function firstDispatchCategoryPage(dispatch) {
    dispatch(categoryPageActions.categoryPageLoading());
    var actions = [];

    switch (params.category) {
      case 'news':
        actions = [(0, _async_category_video_actions2.default)(params, store, isTag)(dispatch), (0, _async_category_all_feed_actions2.default)(params, store, isTag)(dispatch)];
        (0, _set2.default)(params, 'category', 'news');
        break;
      case 'magazine':
        actions = [(0, _async_magazine_latest_issue_posts_actions2.default)(params, store, isTag)(dispatch)];
        (0, _set2.default)(params, 'category', 'magazine');
        break;
      default:
        actions = [(0, _async_category_video_actions2.default)(params, store, isTag)(dispatch), (0, _async_category_all_feed_actions2.default)(params, store, isTag)(dispatch), (0, _async_featured_sponsored_card_actions2.default)(params, store, isTag)(dispatch), (0, _async_category_promo_banner_actions2.default)(params, store, isTag)(dispatch), (0, _async_category_scrolling_module_actions2.default)(params, store, isTag)(dispatch)];
        break;
    }

    return Promise.all([(0, _async_category_featured_feed_actions2.default)(params, store, isTag)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store, isTag)(dispatch)].concat(_toConsumableArray(actions))).then(function handleCategoryPageData() {
      dispatch(categoryPageActions.categoryPageLoaded({}, store));
      return true;
    }).catch(function handleCategoryPageError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(categoryPageActions.categoryPageLoadError(err, store));
      _logger_service2.default.error(err, 'Error in category page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryPageLoading = categoryPageLoading;
exports.categoryPageLoaded = categoryPageLoaded;
exports.categoryPageLoadError = categoryPageLoadError;
// import { canUseDOM } from 'exenv';

function categoryPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_PAGE_LOADING',
    categoryPage: resp,
    store: store
  };
}

function categoryPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_PAGE_LOADED',
    categoryPage: resp,
    store: store
  };
}

function categoryPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_PAGE_ERROR',
    categoryPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _category_video_action_creators = __webpack_require__(568);

var categoryVideoActions = _interopRequireWildcard(_category_video_action_creators);

var _category_video_module = __webpack_require__(569);

var _category_video_module2 = _interopRequireDefault(_category_video_module);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(categoryVideoActions.categoryVideoLoading());
    return _category_video_module2.default.fetch(params, store).then(function handlePostDetailData(resp) {
      dispatch(categoryVideoActions.categoryVideoLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(categoryVideoActions.categoryVideoLoadError(err, store));
      _logger_service2.default.error(err, 'Error in category video actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryVideoLoading = categoryVideoLoading;
exports.categoryVideoLoaded = categoryVideoLoaded;
exports.categoryVideoLoadError = categoryVideoLoadError;
// import { canUseDOM } from 'exenv';

function categoryVideoLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_VIDEO_LOADING',
    categoryVideo: resp,
    store: store
  };
}

function categoryVideoLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_VIDEO_LOADED',
    categoryVideo: resp,
    store: store
  };
}

function categoryVideoLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_VIDEO_ERROR',
    categoryVideo: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var categoryJwIdMap = {
  technology: 'PSsJtDkM',
  leadership: 'QIKO4Bg0',
  magazine: 'Y9DjLnt6',
  MCP: '7qluGmg9',
  MIC: 'dGGdpkNJ',
  news: 'W56TTMkA',
  ads: 'AYdibOhm',
  movies: '9pyPGMMb',
  games: 'pcPUSNzp',
  tv: 'BFft6WE8',
  music: '31g3mGyX',
  graphics: 'E94CFqkP',
  IBD: 'ugHwoYDj',
  interactive: 'QhzkgUg4',
  product: 'SguMMpt0',
  spaces: 'G9BPHwFi',
  cities: 'GofVu1Ze',
  ideas: 'OATCOesq',
  sustainability: 'osKp5aZy',
  science: 'WFvqDhWI',
  transportation: '7Knj3gow',
  entertainment: 'Rdek7nNz',
  default: 'R6of2m4z'
};

var CategoryPageVideo = function (_Base) {
  _inherits(CategoryPageVideo, _Base);

  function CategoryPageVideo() {
    _classCallCheck(this, CategoryPageVideo);

    return _possibleConstructorReturn(this, (CategoryPageVideo.__proto__ || Object.getPrototypeOf(CategoryPageVideo)).apply(this, arguments));
  }

  _createClass(CategoryPageVideo, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var category = params.category;

      var id = (0, _get2.default)(categoryJwIdMap, category) || categoryJwIdMap.default;
      var host = 'content.jwplatform.com';
      var options = {};
      var cacheKeyUrl = 'https://' + host + '/feeds/' + id + '.json';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return CategoryPageVideo;
}(_base_model2.default);

exports.default = CategoryPageVideo;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchCategoryAllFeed;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _category_all_feed_action_creators = __webpack_require__(236);

var categoryAllFeedActions = _interopRequireWildcard(_category_all_feed_action_creators);

var _category_all_feed = __webpack_require__(571);

var _category_all_feed2 = _interopRequireDefault(_category_all_feed);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _not_found_status_action_creator = __webpack_require__(28);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchCategoryAllFeed(params, store, isTag) {
  return function firstDispatchCategoryAllFeed(dispatch) {
    dispatch(categoryAllFeedActions.categoryAllFeedLoading());
    return _category_all_feed2.default.fetch(params, store, isTag).then(function handleCategoryAllFeedData(CategoryData) {
      if ((params.page || isTag) && !(0, _get2.default)(CategoryData, 'data.posts.length')) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }
      dispatch(categoryAllFeedActions.categoryAllFeedLoaded(CategoryData.data, store));
    }).catch(function handleCategoryAllFeedError(err) {
      dispatch(categoryAllFeedActions.categoryAllFeedLoadError(err, store));
      _logger_service2.default.error(err, 'Error in category all feed actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(16);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryAllFeed = function (_Base) {
  _inherits(CategoryAllFeed, _Base);

  function CategoryAllFeed() {
    _classCallCheck(this, CategoryAllFeed);

    return _possibleConstructorReturn(this, (CategoryAllFeed.__proto__ || Object.getPrototypeOf(CategoryAllFeed)).apply(this, arguments));
  }

  _createClass(CategoryAllFeed, null, [{
    key: 'fetch',
    value: function fetch(_ref, store, isTag) {
      var category = _ref.category,
          page = _ref.page,
          tag = _ref.tag;

      var pageParams = page ? '&page=' + page : '';
      var tagStr = isTag ? '&tag=' + tag : '';
      var total = 20;
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var isNews = category === 'news';
      var url = 'v2/posts-category-slug/' + site + '/' + category + '?total=' + total + pageParams + (isNews ? '&with_body=true' : '') + tagStr;
      var cacheKeyUrl = '' + protocol + host + '/api/' + url;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      if (!_exenv.canUseDOM) {
        _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
      }
      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return CategoryAllFeed;
}(_base_model2.default);

exports.default = CategoryAllFeed;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchCategory;

var _category_scrolling_module_action_creators = __webpack_require__(573);

var categoryScrollingModuleActions = _interopRequireWildcard(_category_scrolling_module_action_creators);

var _category_scrolling_module = __webpack_require__(574);

var _category_scrolling_module2 = _interopRequireDefault(_category_scrolling_module);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchCategory(params, store, isTag) {
  return function firstDispatch(dispatch) {
    dispatch(categoryScrollingModuleActions.categoryScrollingModuleLoading({}, store));
    return _category_scrolling_module2.default.fetch(params, store, isTag).then(function handleCategoryDetailData(CategoryData) {
      dispatch(categoryScrollingModuleActions.categoryScrollingModuleLoaded(CategoryData.data, store));
    }).catch(function handleUserError(err) {
      dispatch(categoryScrollingModuleActions.categoryScrollingModuleLoadError(err, store));
      _logger_service2.default.error(err, 'Error in category scrollingModule actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryScrollingModuleLoading = categoryScrollingModuleLoading;
exports.categoryScrollingModuleLoaded = categoryScrollingModuleLoaded;
exports.categoryScrollingModuleLoadError = categoryScrollingModuleLoadError;
// import { canUseDOM } from 'exenv';

function categoryScrollingModuleLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_SCROLLING_MODULE_LOADING',
    categoryScrollingModule: resp,
    store: store
  };
}

function categoryScrollingModuleLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_SCROLLING_MODULE_LOADED',
    categoryScrollingModule: {
      posts: resp.posts,
      tag: resp.tag
    },
    store: store
  };
}

function categoryScrollingModuleLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_SCROLLING_MODULE_ERROR',
    categoryScrollingModule: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(16);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryScrollingModule = function (_Base) {
  _inherits(CategoryScrollingModule, _Base);

  function CategoryScrollingModule() {
    _classCallCheck(this, CategoryScrollingModule);

    return _possibleConstructorReturn(this, (CategoryScrollingModule.__proto__ || Object.getPrototypeOf(CategoryScrollingModule)).apply(this, arguments));
  }

  _createClass(CategoryScrollingModule, null, [{
    key: 'fetch',
    value: function fetch(_ref, store, isTag) {
      var category = _ref.category,
          tag = _ref.tag;

      var state = store.getState();
      var tagStr = isTag ? '&tag=' + tag : '';
      var site = (0, _get2.default)(state, 'config.site');
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/category-scrolling-module-posts/' + site + '/' + category + '?total=20' + tagStr;

      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;
      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      if (!_exenv.canUseDOM) {
        _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
      }
      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return CategoryScrollingModule;
}(_base_model2.default);

exports.default = CategoryScrollingModule;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _category_promo_banner_action_creators = __webpack_require__(576);

var categoryPromoBannerActions = _interopRequireWildcard(_category_promo_banner_action_creators);

var _category_promo_banner = __webpack_require__(577);

var _category_promo_banner2 = _interopRequireDefault(_category_promo_banner);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store, isTag) {
  return function firstDispatch(dispatch) {
    dispatch(categoryPromoBannerActions.categoryPromoBannerLoading({}, store));
    return _category_promo_banner2.default.fetch(params, store, isTag).then(function handlePostDetailData(resp) {
      dispatch(categoryPromoBannerActions.categoryPromoBannerLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(categoryPromoBannerActions.categoryPromoBannerLoadError(err, store));
      _logger_service2.default.error(err, 'Error in categoryPromoBanner actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryPromoBannerLoading = categoryPromoBannerLoading;
exports.categoryPromoBannerLoaded = categoryPromoBannerLoaded;
exports.categoryPromoBannerLoadError = categoryPromoBannerLoadError;
// import { canUseDOM } from 'exenv';

function categoryPromoBannerLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_PROMO_BANNER_LOADING',
    categoryPromoBanner: resp,
    store: store
  };
}

function categoryPromoBannerLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_PROMO_BANNER_LOADED',
    categoryPromoBanner: resp.categoryPromoBanner,
    store: store
  };
}

function categoryPromoBannerLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_PROMO_BANNER_ERROR',
    categoryPromoBanner: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(16);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryPromoBanner = function (_Base) {
  _inherits(CategoryPromoBanner, _Base);

  function CategoryPromoBanner() {
    _classCallCheck(this, CategoryPromoBanner);

    return _possibleConstructorReturn(this, (CategoryPromoBanner.__proto__ || Object.getPrototypeOf(CategoryPromoBanner)).apply(this, arguments));
  }

  _createClass(CategoryPromoBanner, null, [{
    key: 'fetch',
    value: function fetch(_ref, store, isTag) {
      var category = _ref.category,
          tag = _ref.tag;

      var state = store.getState();
      var tagStr = isTag ? '?tag=' + tag : '';
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v1/category-promo-banner/' + site + '/' + category + tagStr;

      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return CategoryPromoBanner;
}(_base_model2.default);

exports.default = CategoryPromoBanner;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchCategoryFeaturedFeed;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _category_featured_feed_action_creators = __webpack_require__(579);

var categoryTagFeaturedActions = _interopRequireWildcard(_category_featured_feed_action_creators);

var _category_featured_feed = __webpack_require__(580);

var _category_featured_feed2 = _interopRequireDefault(_category_featured_feed);

var _not_found_status_action_creator = __webpack_require__(28);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchCategoryFeaturedFeed(params, store, isTag) {
  return function dispatchCategoryFeaturedFeed(dispatch) {
    dispatch(categoryTagFeaturedActions.categoryFeaturedFeedLoading());
    return _category_featured_feed2.default.fetch(params, store, isTag).then(function categoryFeaturedFeedData(resp) {
      dispatch(categoryTagFeaturedActions.categoryFeaturedFeedLoaded(resp.data, store));
    }).catch(function categoryFeaturedFeedError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(categoryTagFeaturedActions.categoryFeaturedFeedLoadError(err, store));
      _logger_service2.default.error(err, 'Error in category featured feed actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryFeaturedFeedLoading = categoryFeaturedFeedLoading;
exports.categoryFeaturedFeedLoaded = categoryFeaturedFeedLoaded;
exports.categoryFeaturedFeedLoadError = categoryFeaturedFeedLoadError;
// import { canUseDOM } from 'exenv';

function categoryFeaturedFeedLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_FEATURED_FEED_LOADING',
    categoryFeaturedFeed: resp,
    store: store
  };
}

function categoryFeaturedFeedLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_FEATURED_FEED_LOADED',
    categoryFeaturedFeed: {
      featured: resp.featured,
      top: resp.top,
      category: resp.category,
      source: resp.source
    },
    store: store
  };
}

function categoryFeaturedFeedLoadError(error, store) {
  return {
    type: 'CATEGORY_FEATURED_FEED_ERROR',
    categoryFeaturedFeed: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(16);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryFeatured = function (_Base) {
  _inherits(CategoryFeatured, _Base);

  function CategoryFeatured() {
    _classCallCheck(this, CategoryFeatured);

    return _possibleConstructorReturn(this, (CategoryFeatured.__proto__ || Object.getPrototypeOf(CategoryFeatured)).apply(this, arguments));
  }

  _createClass(CategoryFeatured, null, [{
    key: 'fetch',
    value: function fetch(_ref, store, isTag) {
      var category = _ref.category,
          tag = _ref.tag;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var tagStr = isTag ? '?tag=' + tag : '';
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/category-featured-feed/' + site + '/' + category + tagStr;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;
      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      if (!_exenv.canUseDOM) {
        _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
      }
      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return CategoryFeatured;
}(_base_model2.default);

exports.default = CategoryFeatured;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/category/:category/:page',
    component: _category_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _category_page_state_manager2.default)(store)
  };
};

var _category_page = __webpack_require__(138);

var _category_page2 = _interopRequireDefault(_category_page);

var _category_page_state_manager = __webpack_require__(68);

var _category_page_state_manager2 = _interopRequireDefault(_category_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/news/:page?',
    component: _news_page2.default,
    strict: true,
    exact: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'news')
  };
};

var _news_page = __webpack_require__(583);

var _news_page2 = _interopRequireDefault(_news_page);

var _category_page_state_manager = __webpack_require__(68);

var _category_page_state_manager2 = _interopRequireDefault(_category_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _withRouter = __webpack_require__(59);

var _withRouter2 = _interopRequireDefault(_withRouter);

var _reactRouterRedux = __webpack_require__(51);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(15);

var _reactPaginate = __webpack_require__(147);

var _reactPaginate2 = _interopRequireDefault(_reactPaginate);

var _set = __webpack_require__(42);

var _set2 = _interopRequireDefault(_set);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _throttle = __webpack_require__(72);

var _throttle2 = _interopRequireDefault(_throttle);

var _cloneDeep = __webpack_require__(75);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _findIndex = __webpack_require__(99);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _not_found_component = __webpack_require__(49);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _container = __webpack_require__(150);

var _container2 = _interopRequireDefault(_container);

var _revcontent = __webpack_require__(241);

var _revcontent2 = _interopRequireDefault(_revcontent);

var _video_module = __webpack_require__(73);

var _video_module2 = _interopRequireDefault(_video_module);

var _client_util = __webpack_require__(40);

var _client_util2 = _interopRequireDefault(_client_util);

var _trackThirdPartyJS = __webpack_require__(140);

var _trackThirdPartyJS2 = _interopRequireDefault(_trackThirdPartyJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var scriptjs = false;

if (_exenv.canUseDOM) {
  // eslint-disable-next-line global-require
  scriptjs = __webpack_require__(37);
}

var News = function (_Component) {
  _inherits(News, _Component);

  function News() {
    _classCallCheck(this, News);

    var _this = _possibleConstructorReturn(this, (News.__proto__ || Object.getPrototypeOf(News)).call(this));

    _this.isDesktop = false;
    _this.setScrollEvents = (0, _throttle2.default)(function () {
      var _this$window = _this.window,
          scrollY = _this$window.scrollY,
          innerHeight = _this$window.innerHeight;

      _this.setInviewPost(scrollY, innerHeight);
    }, 100);
    _this.onPaginateClick = _this.onPaginateClick.bind(_this);
    _this.playerScriptIds = ['QV73eWiB', '4h5SWQPt', 'Pafg29um', '27mBLzWL', 'i70nsZ8K', 'Lrp0YsKC', 'wGNMZweZ', 'kMmGs8qw', 'WXJihrBk', 'iqio3VCM', 'OolwHeKf', 'FsIzKJce', 'r04h3Jdn', 'RvGXj7in', 'flarUGPa', 'HzdTLaau', 'gAy6i1bi', 'RqEFED7X', 'vp2iCnvh', 'b2BPV4nc'];
    return _this;
  }

  _createClass(News, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.window = window;
      this.activePost = null;
      this.isDesktop = (0, _client_util2.default)();
      this.trackedPosts = [];
      window.addEventListener('scroll', this.setScrollEvents);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.posts = this.getPostElements();

      if (_exenv.canUseDOM && this.posts.length) {
        if (!window.instgrm) {
          scriptjs('//platform.instagram.com/en_US/embeds.js', function () {
            window.instgrm.Embeds.process();
          });
        } else {
          window.instgrm.Embeds.process();
        }

        if (!window.twttr) {
          scriptjs('//platform.twitter.com/widgets.js', function () {
            window.twttr.widgets.load();
          });
        } else {
          window.twttr.widgets.load();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.window.removeEventListener('scroll', this.setScrollEvents);
    }
  }, {
    key: 'onPaginateClick',
    value: function onPaginateClick(data) {
      var url = '/news/' + (data.selected + 1);
      this.props.nextPage(url);
    }
  }, {
    key: 'setInviewPost',
    value: function setInviewPost(windowPosition, screenHeight) {
      if (!this.posts || !this.posts.length) {
        return false;
      }

      // Set url to /news if at top of screen.
      if (windowPosition === 0) {
        var page = (0, _get2.default)(this.props.match, 'params.page');
        var newsUrl = page ? '/news/' + page : '/news';
        window.history.replaceState({}, '', newsUrl);
        this.activePost = null;
        return false;
      }

      var triggerPoint = windowPosition + screenHeight / 2;
      for (var i = 1; i <= this.posts.length; i += 1) {
        var post = this.posts[i - 1];
        var sectionTopPosition = post.offsetTop;
        var sectionBottomPosition = sectionTopPosition + post.clientHeight;
        var _post$dataset = post.dataset,
            id = _post$dataset.id,
            slug = _post$dataset.slug;

        var postId = parseFloat(id);

        if (this.activePost !== postId && sectionTopPosition <= triggerPoint && sectionBottomPosition > triggerPoint) {
          var postData = (0, _get2.default)(this.props.categoryAllFeed, 'posts[' + (i - 1) + ']', {});
          this.activePost = postId;
          this.setActiveSocial(post);

          window.history.replaceState({}, '', '/' + postId + '/' + slug);

          if (this.trackedPosts.indexOf(this.activePost) === -1) {
            this.trackedPosts.push(this.activePost);
            this.refreshThirdPartyTrackers(postData, i);
          }
        }
      }
      return false;
    }
  }, {
    key: 'getPostElements',
    value: function getPostElements() {
      return document.querySelectorAll('.post__body');
    }
  }, {
    key: 'setActiveSocial',
    value: function setActiveSocial(post) {
      var activeClass = 'social--active';
      var activeSocial = document.querySelector('.' + activeClass);

      if (activeSocial) {
        activeSocial.classList.remove(activeClass);
      }

      var activePost = post || document.querySelector('.post__wrapper');
      if (activePost) {
        activePost.querySelector('.social').classList.add(activeClass);
      }
    }
  }, {
    key: 'refreshThirdPartyTrackers',
    value: function refreshThirdPartyTrackers(postData, pageNumber) {
      var config = this.props.config;

      var currentActivePostState = {
        context: {
          site: (0, _get2.default)(config, 'site'),
          type: 'post',
          postData: postData
        },
        config: config
      };
      (0, _trackThirdPartyJS2.default)(currentActivePostState, pageNumber);
    }
  }, {
    key: 'renderNewsSection',
    value: function renderNewsSection(numPosts) {
      var firstSection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var playerIds = arguments[2];

      var origPosts = (0, _get2.default)(this.props, 'categoryAllFeed.posts', []);
      var posts = this.posts;

      var slice = numPosts;
      var totalPosts = posts.length;

      if (!totalPosts) return null;

      if (totalPosts <= numPosts) {
        slice = totalPosts;
      }

      posts = this.posts.splice(0, slice);
      posts = posts.map(function (postData) {
        if (postData.isVideoPermalink || (0, _get2.default)(postData, 'posterVideo.feedId')) {
          var postIndex = (0, _findIndex2.default)(origPosts, { id: postData.id });
          if (!playerIds[postIndex]) {
            (0, _set2.default)(postData, 'playerScriptId', 'G2hQKLvX');
          } else {
            (0, _set2.default)(postData, 'playerScriptId', playerIds[postIndex]);
          }
        }
        return postData;
      });

      return _react2.default.createElement(_container2.default, _extends({}, this.props, {
        posts: posts,
        combinedAdModel: this.combinedAdModel,
        isDesktop: this.isDesktop,
        isFirstPost: firstSection,
        pageNum: 1,
        videoAdData: (0, _get2.default)(this.props.categoryPage, 'ads.model', {})
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var categoryAllFeed = this.props.categoryAllFeed;

      this.posts = (0, _cloneDeep2.default)((0, _get2.default)(categoryAllFeed, 'posts', []));

      if (this.props.categoryPage.error || this.props.categoryFeaturedFeed.error) {
        return _react2.default.createElement(
          'section',
          { className: 'category-page' },
          _react2.default.createElement(
            'article',
            { className: 'category-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.categoryPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'category-page' },
          _react2.default.createElement(
            'article',
            { className: 'category-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var _props = this.props,
          config = _props.config,
          match = _props.match;
      var totalPosts = categoryAllFeed.totalPosts,
          totalPages = categoryAllFeed.totalPages;
      var page = match.params.page;

      var adData = (0, _get2.default)(this.props, 'categoryPage.ads');
      this.combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      var currentSite = (0, _get2.default)(config, 'site');

      return _react2.default.createElement(
        'section',
        { className: 'category-page category-page--news' },
        this.renderNewsSection(3, true, this.playerScriptIds),
        _react2.default.createElement(_revcontent2.default, {
          initialPageLoad: (0, _get2.default)(this.props, 'config.initialPageLoad'),
          site: currentSite
        }),
        this.renderNewsSection(5, false, this.playerScriptIds),
        _react2.default.createElement(_video_module2.default, {
          config: config,
          type: 'category',
          data: this.props.categoryVideo,
          playerid: 'HliaKwd3',
          stories: this.props.categoryVideo.playlist,
          currentSite: currentSite,
          isPost: true
        }),
        this.renderNewsSection(3, false, this.playerScriptIds),
        this.renderNewsSection(5, false, this.playerScriptIds),
        this.renderNewsSection(4, false, this.playerScriptIds),
        _react2.default.createElement(
          'div',
          { className: 'pagination__meta' },
          _react2.default.createElement(
            'div',
            { className: 'pagination__container' },
            _react2.default.createElement(
              'h2',
              { className: 'pagination__count pagination__count--bottom' },
              totalPosts,
              ' Stories'
            ),
            _react2.default.createElement(_reactPaginate2.default, {
              forcePage: page ? parseInt(page, 10) - 1 : 0,
              onPageChange: this.onPaginateClick,
              pageCount: totalPages,
              pageRangeDisplayed: 2,
              marginPagesDisplayed: 1,
              previousLabel: 'Prev',
              nextLabel: 'Next',
              breakLabel: '...',
              containerClassName: 'pagination',
              pageClassName: 'pagination__page',
              activeClassName: 'pagination__page pagination__page--active',
              previousClassName: 'pagination__page pagination__page--prev',
              nextClassName: 'pagination__page pagination__page--next',
              breakClassName: 'pagination__page pagination__page--break',
              pageLinkClassName: 'pagination__link',
              previousLinkClassName: 'pagination__link',
              nextLinkClassName: 'pagination__link',
              disabledClassName: 'pagination__link--disabled'
            })
          )
        )
      );
    }
  }]);

  return News;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    categoryFeaturedFeed: {
      source: (0, _get2.default)(state, 'categoryFeaturedFeed.source') || '',
      featured: (0, _get2.default)(state, 'categoryFeaturedFeed.featured') || [],
      top: (0, _get2.default)(state, 'categoryFeaturedFeed.top') || [],
      category: (0, _get2.default)(state, 'categoryFeaturedFeed.category') || {},
      error: (0, _get2.default)(state, 'categoryFeaturedFeed.error') || false
    },
    categoryVideo: {
      playlist: (0, _get2.default)(state, 'categoryVideo.data.playlist') || [],
      title: (0, _get2.default)(state, 'categoryVideo.data.title') || '',
      feedid: (0, _get2.default)(state, 'categoryVideo.data.feedid') || ''
    },
    categoryPage: (0, _get2.default)(state, 'categoryPage') || {},
    categoryAllFeed: {
      posts: (0, _get2.default)(state, 'categoryAllFeed.data.posts') || [],
      totalPages: (0, _get2.default)(state, 'categoryAllFeed.data.totalPages'),
      totalPosts: (0, _get2.default)(state, 'categoryAllFeed.data.totalPosts')
    }
  };
}

function mapDispatchToProps(dispatch) {
  return {
    nextPage: function nextPage(url) {
      dispatch((0, _reactRouterRedux.push)(url));
    }
  };
}

News.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  match: _propTypes2.default.shape({}).isRequired,
  categoryPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  categoryFeaturedFeed: _propTypes2.default.shape({
    source: _propTypes2.default.string,
    featured: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    top: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    category: _propTypes2.default.object,
    error: _propTypes2.default.bool
  }).isRequired,
  categoryVideo: _propTypes2.default.shape({
    playlist: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    feedid: _propTypes2.default.string,
    title: _propTypes2.default.string
  }).isRequired,
  categoryAllFeed: _propTypes2.default.shape({
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    totalPages: _propTypes2.default.number,
    totalPosts: _propTypes2.default.number
  }).isRequired,
  nextPage: _propTypes2.default.func.isRequired
};

exports.default = (0, _withRouter2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(News));

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _forEach = __webpack_require__(93);

var _forEach2 = _interopRequireDefault(_forEach);

var _header = __webpack_require__(585);

var _header2 = _interopRequireDefault(_header);

var _by_line = __webpack_require__(591);

var _by_line2 = _interopRequireDefault(_by_line);

var _article = __webpack_require__(592);

var _article2 = _interopRequireDefault(_article);

var _footer = __webpack_require__(593);

var _footer2 = _interopRequireDefault(_footer);

var _social = __webpack_require__(94);

var _social2 = _interopRequireDefault(_social);

var _live = __webpack_require__(598);

var _live2 = _interopRequireDefault(_live);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Body = function (_Component) {
  _inherits(Body, _Component);

  function Body() {
    _classCallCheck(this, Body);

    return _possibleConstructorReturn(this, (Body.__proto__ || Object.getPrototypeOf(Body)).apply(this, arguments));
  }

  _createClass(Body, [{
    key: 'getByLineAttribution',
    value: function getByLineAttribution(tags) {
      var bylineAttribution = '';

      (0, _forEach2.default)(tags, function (tag) {
        if (tag.name.indexOf('byline_') !== -1 || tag.slug.indexOf('byline-') !== -1) {
          bylineAttribution = tag.name.replace('byline_', '');
        }
      });

      return bylineAttribution;
    }
  }, {
    key: 'renderKiaAdWords',
    value: function renderKiaAdWords() {
      var post = this.props.post;
      var tags = post.tags;

      var isKia = tags.filter(function (tag) {
        return tag.slug === 'kia_niro';
      }).length;

      // TODO: refactor to use scriptjs and fire js
      if (isKia) {
        return _react2.default.createElement('div', {
          dangerouslySetInnerHTML: {
            __html: '<script type="text/javascript">/* <![CDATA[ */ var google_conversion_id = 972240864; var google_custom_params = window.google_tag_params; var google_remarketing_only = true; /* ]]> */</script><script type="text/javascript" src="//www.googleadservices.com/pagead/conversion.js"></script><noscript><div style="display:inline;"><img height="1" width="1" style="border-style:none;" alt="" src="//googleads.g.doubleclick.net/pagead/viewthroughconversion/972240864/?guid=ON&amp;script=0"/></div></noscript>'
          }
        });
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          post = _props.post,
          advertorial = _props.advertorial,
          isFirstPost = _props.isFirstPost,
          combinedAdModel = _props.combinedAdModel,
          videoAdData = _props.videoAdData,
          config = _props.config,
          pageNum = _props.pageNum,
          isLongPost = _props.isLongPost,
          isVideoPost = _props.isVideoPost,
          hasNewsletter = _props.hasNewsletter,
          related = _props.related,
          live = _props.live;
      var tags = post.tags,
          article = post.content;

      var emptyContent = !article.length;
      var bylineAttribution = this.getByLineAttribution(tags);
      var postFiniteLive = !isFirstPost && (0, _get2.default)(post, 'tags', []).filter(function (tag) {
        return tag.name.indexOf('live:') > -1;
      }).length === 1;
      var hasLivePosts = (0, _get2.default)(post, 'live.posts.length', 0);

      return _react2.default.createElement(
        'div',
        { className: 'post__body', 'data-id': post.id, 'data-slug': post.slug },
        _react2.default.createElement(_header2.default, {
          tags: tags,
          advertorial: advertorial,
          post: post,
          combinedAdModel: combinedAdModel,
          isFirstPost: isFirstPost,
          isLongPost: isLongPost,
          isVideoPost: isVideoPost,
          related: related,
          videoAdData: videoAdData,
          live: live || postFiniteLive,
          config: config
        }),
        isVideoPost ? _react2.default.createElement(_social2.default, {
          enableSticky: this.props.isDesktop && isLongPost,
          empty: emptyContent,
          text: encodeURIComponent((0, _get2.default)(post, 'title') || ''),
          uri: post.link,
          modifier: 'post-video',
          bottomBoundary: '#social--' + post.id,
          encapsulateId: 'social--' + post.id
        }) : _react2.default.createElement(
          'div',
          { className: 'post__container post__container--' + post.layout },
          _react2.default.createElement(_social2.default, {
            enableSticky: this.props.isDesktop && isLongPost,
            empty: emptyContent,
            text: encodeURIComponent((0, _get2.default)(post, 'title') || ''),
            uri: post.link,
            modifier: 'post',
            bottomBoundary: '#social--' + post.id,
            encapsulateId: 'social--' + post.id
          }),
          _react2.default.createElement(
            'div',
            { className: 'post__content' },
            isLongPost ? _react2.default.createElement(_by_line2.default, { post: post, bylineAttribution: bylineAttribution }) : null,
            _react2.default.createElement(_article2.default, {
              post: post,
              combinedAdModel: combinedAdModel,
              pageNum: pageNum,
              isShortPost: !isLongPost
            }),
            postFiniteLive ? _react2.default.createElement(
              'a',
              {
                className: 'post__live-link',
                href: '/' + post.id + '/' + post.slug
              },
              'Follow Our Live Coverage'
            ) : null,
            !live && !hasLivePosts ? _react2.default.createElement(_footer2.default, {
              post: post,
              bylineAttribution: bylineAttribution,
              isLongPost: isLongPost,
              hasNewsletter: hasNewsletter,
              config: config
            }) : null,
            isFirstPost && live || hasLivePosts ? _react2.default.createElement(_live2.default, { parentPost: post, live: post.live, config: config }) : null,
            this.renderKiaAdWords()
          )
        )
      );
    }
  }]);

  return Body;
}(_react.Component);

exports.default = Body;


Body.defaultProps = {
  isDesktop: false,
  hasNewsletter: false,
  related: []
};

Body.propTypes = {
  post: _propTypes2.default.shape({}).isRequired,
  advertorial: _propTypes2.default.bool.isRequired,
  combinedAdModel: _propTypes2.default.shape({}).isRequired,
  isFirstPost: _propTypes2.default.bool.isRequired,
  config: _propTypes2.default.shape({}).isRequired,
  videoAdData: _propTypes2.default.shape({}).isRequired,
  isDesktop: _propTypes2.default.bool,
  pageNum: _propTypes2.default.number.isRequired,
  isLongPost: _propTypes2.default.bool.isRequired,
  hasNewsletter: _propTypes2.default.bool,
  isVideoPost: _propTypes2.default.bool.isRequired,
  related: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  live: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _media = __webpack_require__(586);

var _media2 = _interopRequireDefault(_media);

var _title = __webpack_require__(590);

var _title2 = _interopRequireDefault(_title);

var _advertorial = __webpack_require__(29);

var _advertorial2 = _interopRequireDefault(_advertorial);

var _related_slider = __webpack_require__(261);

var _related_slider2 = _interopRequireDefault(_related_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          config = _props.config,
          advertorial = _props.advertorial,
          tags = _props.tags,
          post = _props.post,
          combinedAdModel = _props.combinedAdModel,
          isLongPost = _props.isLongPost,
          isVideoPost = _props.isVideoPost,
          videoAdData = _props.videoAdData,
          isFirstPost = _props.isFirstPost,
          related = _props.related,
          live = _props.live;


      return _react2.default.createElement(
        'header',
        { className: 'post__header' },
        advertorial ? _react2.default.createElement(_advertorial2.default, { tags: tags, adModel: combinedAdModel }) : '',
        _react2.default.createElement(
          'div',
          { className: 'post__header-text' },
          _react2.default.createElement(_title2.default, {
            config: config,
            isVideoPost: isVideoPost,
            isFirstPost: isFirstPost,
            location: 'beforevideo',
            post: post,
            tags: tags,
            live: live
          }),
          isLongPost && !isVideoPost ? _react2.default.createElement('h2', {
            className: 'post__deck',
            dangerouslySetInnerHTML: { __html: post.excerpt }
          }) : ''
        ),
        _react2.default.createElement(_media2.default, {
          post: post,
          videoAdData: videoAdData,
          isVideoPost: isVideoPost,
          isFirstPost: isFirstPost
        }),
        isVideoPost ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_title2.default, {
            config: config,
            isVideoPost: isVideoPost,
            isFirstPost: isFirstPost,
            location: 'aftervideo',
            post: post,
            tags: tags,
            live: live
          }),
          _react2.default.createElement('div', {
            className: 'post__article',
            dangerouslySetInnerHTML: { __html: post.excerpt }
          }),
          _react2.default.createElement(_related_slider2.default, {
            title: 'Featured Videos',
            related: related,
            config: config,
            slideClassNames: ['video-slide--horizontal']
          })
        ) : ''
      );
    }
  }]);

  return Header;
}(_react.Component);

exports.default = Header;

Header.defaultProps = {
  related: []
};

Header.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  advertorial: _propTypes2.default.bool.isRequired,
  post: _propTypes2.default.shape({}).isRequired,
  combinedAdModel: _propTypes2.default.shape({}).isRequired,
  isFirstPost: _propTypes2.default.bool.isRequired,
  isLongPost: _propTypes2.default.bool.isRequired,
  videoAdData: _propTypes2.default.shape({}).isRequired,
  isVideoPost: _propTypes2.default.bool.isRequired,
  related: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  live: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(34);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _reactJwPlayer = __webpack_require__(95);

var _reactJwPlayer2 = _interopRequireDefault(_reactJwPlayer);

var _exenv = __webpack_require__(4);

var _fc_slider = __webpack_require__(237);

var _fc_slider2 = _interopRequireDefault(_fc_slider);

var _poster = __webpack_require__(56);

var _poster2 = _interopRequireDefault(_poster);

var _cloudinary_asset_util = __webpack_require__(25);

var _video_module_ads = __webpack_require__(97);

var _video_module_ads2 = _interopRequireDefault(_video_module_ads);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var scriptjs = false;
var ifvisible = false;

if (_exenv.canUseDOM) {
  // eslint-disable-next-line global-require
  scriptjs = __webpack_require__(37);
  // eslint-disable-next-line global-require
  ifvisible = __webpack_require__(96);
}

var Media = function (_Component) {
  _inherits(Media, _Component);

  function Media() {
    _classCallCheck(this, Media);

    var _this = _possibleConstructorReturn(this, (Media.__proto__ || Object.getPrototypeOf(Media)).call(this));

    _this.state = {
      userIsActive: true
    };

    _this.generatePreRoll = _this.generatePreRoll.bind(_this);
    _this.trackMoat = _this.trackMoat.bind(_this);
    _this.onReady = _this.onReady.bind(_this);
    return _this;
  }

  _createClass(Media, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (scriptjs) {
        var _props = this.props,
            post = _props.post,
            isVideoPost = _props.isVideoPost;
        var posterVideo = post.posterVideo;


        if (!(0, _isEmpty2.default)(posterVideo) || isVideoPost) {
          scriptjs('https://z.moatads.com/jwplayerplugin0938452/moatplugin.js');

          // Set up activity tracker, 10s = idle
          if (ifvisible) {
            ifvisible.setIdleDuration(10);
            ifvisible.on('idle', function () {
              _this2.setState({
                userIsActive: false
              });
            });

            ifvisible.on('wakeup', function () {
              _this2.setState({
                userIsActive: true
              });
            });
          }
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (_exenv.canUseDOM) {
        if (window.moatjw) {
          window.moatjw.removeAll();
        }

        if (ifvisible) {
          ifvisible.off();
        }
      }
    }
  }, {
    key: 'onReady',
    value: function onReady() {
      var _this3 = this;

      var post = this.props.post;

      var playerid = (0, _get2.default)(post, 'playerScriptId');
      var player = window.jwplayer(playerid);

      player.on('complete', function () {
        if (!_this3.state.userIsActive) {
          player.stop();
        }
      });
    }
  }, {
    key: 'trackMoat',
    value: function trackMoat(event) {
      if (_exenv.canUseDOM) {
        if (window.moatjw) {
          window.moatjw.add({
            partnerCode: 'mansuetojwint127635890115',
            player: window.jwplayer(this.playerId),
            adImpressionEvent: event
          });
        }
      }
    }
  }, {
    key: 'generatePreRoll',
    value: function generatePreRoll(video) {
      return new _video_module_ads2.default(video.title, 'article').adTag;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          post = _props2.post,
          isVideoPost = _props2.isVideoPost,
          isFirstPost = _props2.isFirstPost;
      var featured_image = post.featured_image,
          posterSlideshow = post.posterSlideshow,
          posterVideo = post.posterVideo,
          posterIframe = post.posterIframe,
          title = post.title;


      if (!(0, _isEmpty2.default)(posterSlideshow)) {
        return _react2.default.createElement(_fc_slider2.default, { slideShowData: posterSlideshow, title: title });
      }

      if (!(0, _isEmpty2.default)(posterVideo)) {
        var feed = (0, _get2.default)(posterVideo, 'feedId', '');
        var isAutoPlay = Boolean(isFirstPost);
        var playInView = Boolean(!isFirstPost);
        var isMuted = Boolean(!isFirstPost);
        return _react2.default.createElement(
          'div',
          { className: 'poster-video-wrapper poster-video-wrapper--video-permalink' },
          _react2.default.createElement(_reactJwPlayer2.default, {
            playerId: (0, _get2.default)(post, 'playerScriptId'),
            playerScript: 'https://content.jwplatform.com/libraries/' + (0, _get2.default)(post, 'playerScriptId') + '.js',
            playlist: 'https://fc-api.fastcompany.com/api/v1/jw-feed/' + feed,
            generatePrerollUrl: this.generatePreRoll,
            onAdPlay: this.trackMoat,
            isAutoPlay: isAutoPlay,
            playInView: playInView,
            isMuted: isMuted,
            onReady: this.onReady,
            playInViewPercentage: 100,
            aspectRatio: '16:9',
            className: 'jwplayer--video-post'
          })
        );
      }

      if (!(0, _isEmpty2.default)(posterIframe)) {
        var source = (0, _get2.default)(posterIframe, 'url');
        /* eslint-disable jsx-a11y/iframe-has-title */
        return _react2.default.createElement(
          'div',
          { className: 'poster-video-wrapper' },
          _react2.default.createElement('iframe', { className: 'poster-video-wrapper__video', src: source })
        );
      }
      if (isVideoPost) {
        var _isAutoPlay = Boolean(!isFirstPost);
        var _playInView = Boolean(isFirstPost);
        return _react2.default.createElement(
          'div',
          { className: 'poster-video-wrapper poster-video-wrapper--video-permalink' },
          _react2.default.createElement(_reactJwPlayer2.default, {
            playerId: (0, _get2.default)(post, 'mediaid'),
            playerScript: 'https://content.jwplatform.com/libraries/QV73eWiB.js',
            playlist: 'https://fc-api.fastcompany.com/api/v1/jw-feed/' + (0, _get2.default)(post, 'mediaid'),
            generatePrerollUrl: this.generatePreRoll,
            onAdPlay: this.trackMoat,
            isAutoPlay: _isAutoPlay,
            playInView: _playInView,
            onReady: this.onReady,
            playInViewPercentage: 100,
            aspectRatio: '16:9',
            className: 'jwplayer--video-post'
          })
        );
      }
      var posterSrc = (0, _get2.default)(featured_image, 'source', '');
      var posterCaption = (0, _get2.default)(featured_image, 'caption', '');
      var metadata = {
        title: title,
        featured_image: { source: posterSrc },
        assetSizes: (0, _get2.default)(_cloudinary_asset_util.imageSizesLookup, 'poster'),
        noLazy: true
      };

      if (!posterSrc) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        {
          className: 'post__poster-wrapper post__poster-wrapper--' + post.layout
        },
        _react2.default.createElement(_poster2.default, {
          metadata: metadata,
          className: 'post-featured',
          isVideo: post.hasPosterVideo
        }),
        posterCaption ? _react2.default.createElement('div', {
          className: 'post__featured-caption',
          dangerouslySetInnerHTML: { __html: posterCaption }
        }) : _react2.default.createElement('div', { className: 'post__featured-caption--no-caption' })
      );
    }
  }]);

  return Media;
}(_react.Component);

exports.default = Media;


Media.propTypes = {
  post: _propTypes2.default.shape({}).isRequired,
  isVideoPost: _propTypes2.default.bool.isRequired,
  isFirstPost: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trigger;
/**
 * Use this to trigger custom events in our client side app.
 * We use it to refresh the ad after a few clicks.
 *
 * @param {string} eventName - name for custom event
 * @param {object} [data={}}] data - custom data for the event
 * @param {node} [dispatcher=window] dispatcher - what dispatches the event
 * @return {boolean} returns true if triggered
 *
 * @example
 * trigger('FC_AD_REFRESH')
 * // true
 *
 * @external {Events} https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
 */
function trigger(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var dispatcher = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;

  if (typeof eventName !== 'string') {
    return false;
  }

  var event = new CustomEvent(eventName, data);

  dispatcher.dispatchEvent(event);

  return true;
}

/***/ }),
/* 588 */,
/* 589 */,
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Title;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _eyebrow = __webpack_require__(57);

var _eyebrow2 = _interopRequireDefault(_eyebrow);

var _fc_link = __webpack_require__(21);

var _fc_link2 = _interopRequireDefault(_fc_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Title(props) {
  var isVideoPost = props.isVideoPost,
      location = props.location,
      post = props.post,
      tags = props.tags,
      live = props.live,
      config = props.config,
      isFirstPost = props.isFirstPost;
  var title = post.title,
      id = post.id;

  var key = 'title-' + id;
  var renderPostTitle = function renderPostTitle() {
    var link = _react2.default.createElement(
      _fc_link2.default,
      {
        key: key,
        config: config,
        externalLink: !isFirstPost,
        to: post.link,
        title: title
      },
      title
    );

    if (isFirstPost) {
      return _react2.default.createElement(
        'h1',
        { key: key, className: 'post__title' },
        link
      );
    }

    return _react2.default.createElement(
      'h2',
      { key: key, className: 'post__title' },
      link
    );
  };

  if (isVideoPost && location === 'beforevideo' || !isVideoPost && location === 'aftervideo') {
    return null;
  }

  return [_react2.default.createElement(_eyebrow2.default, { key: 'eyebrow-' + id, post: post, tags: tags, live: live }), renderPostTitle()];
}

Title.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  isVideoPost: _propTypes2.default.bool.isRequired,
  isFirstPost: _propTypes2.default.bool.isRequired,
  location: _propTypes2.default.string.isRequired,
  post: _propTypes2.default.shape({}).isRequired,
  tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  live: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Link = __webpack_require__(43);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ByLine = function (_Component) {
  _inherits(ByLine, _Component);

  function ByLine() {
    _classCallCheck(this, ByLine);

    return _possibleConstructorReturn(this, (ByLine.__proto__ || Object.getPrototypeOf(ByLine)).apply(this, arguments));
  }

  _createClass(ByLine, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'renderAuthorLink',
    value: function renderAuthorLink() {
      var _props = this.props,
          bylineAttribution = _props.bylineAttribution,
          post = _props.post;
      var author = post.author;


      if (bylineAttribution) {
        return _react2.default.createElement(
          'span',
          { className: 'post__by-link-no-underline' },
          'By ',
          bylineAttribution
        );
      }

      return _react2.default.createElement(
        _Link2.default,
        { className: 'post__by-link', to: '/user/' + author.slug },
        'By ',
        author.name
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var readTime = this.props.post.readTime;

      return _react2.default.createElement(
        'div',
        { className: 'post__byline' },
        _react2.default.createElement(
          'cite',
          { className: 'post__by' },
          this.renderAuthorLink()
        ),
        _react2.default.createElement(
          'span',
          { className: 'post__readTime' },
          readTime,
          ' Read'
        )
      );
    }
  }]);

  return ByLine;
}(_react.Component);

exports.default = ByLine;


ByLine.propTypes = {
  post: _propTypes2.default.shape({
    tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
    author: _propTypes2.default.shape({}).isRequired,
    readTime: _propTypes2.default.string.isRequired
  }).isRequired,
  bylineAttribution: _propTypes2.default.string.isRequired
};

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _cloneDeep = __webpack_require__(75);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _fc_slider = __webpack_require__(237);

var _fc_slider2 = _interopRequireDefault(_fc_slider);

var _ad = __webpack_require__(24);

var _ad2 = _interopRequireDefault(_ad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Article = function (_Component) {
  _inherits(Article, _Component);

  function Article() {
    _classCallCheck(this, Article);

    var _this = _possibleConstructorReturn(this, (Article.__proto__ || Object.getPrototypeOf(Article)).call(this));

    _this.mobileAdIndex = 0;
    return _this;
  }

  _createClass(Article, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'setPostChunk',
    value: function setPostChunk(chunk, index) {
      var markup = chunk.join('');

      if (markup === 'INLINE_CAROUSEL') {
        return _react2.default.createElement(_fc_slider2.default, {
          slideShowData: this.inlineCarousels.shift(),
          location: 'post__inline'
        });
      }

      var _props = this.props,
          post = _props.post,
          isShortPost = _props.isShortPost;

      var totalChunkIndexes = post.content && post.content.length - 1;

      if (totalChunkIndexes === index && isShortPost) {
        var _post$author = post.author,
            slug = _post$author.slug,
            initials = _post$author.initials;

        var authorMarkup = '<a class="post__initials" href="/user/' + slug + '">' + initials + '</a>';
        var lastClosePpos = markup.lastIndexOf('</p>');
        var lastIframe = markup.substr(markup.length - 13) === '</iframe></p>';

        if (lastClosePpos + 4 === markup.length && !lastIframe) {
          markup = markup.substring(0, lastClosePpos) + authorMarkup + ' </p>';
        } else {
          markup += '<p>' + authorMarkup + '</p>';
        }
      }

      return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: markup } });
    }
  }, {
    key: 'setMobileAdName',
    value: function setMobileAdName(index) {
      var adName = void 0;
      var adMap = { 0: 'mobileparallax_1', 3: 'mobileparallax_2' };

      if (Object.prototype.hasOwnProperty.call(adMap, index)) {
        adName = adMap[index];
      } else {
        adName = 'mobilerectangle_' + (this.mobileAdIndex += 1);
      }

      return adName;
    }
  }, {
    key: 'notAroundCarousel',
    value: function notAroundCarousel(chunks, currentChunk, index) {
      var next = chunks[index + 1] || [];
      var nextZeroIndex = next[0];
      var carousel = 'INLINE_CAROUSEL';

      if (nextZeroIndex === carousel || currentChunk === carousel) {
        return false;
      }

      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          post = _props2.post,
          pageNum = _props2.pageNum,
          combinedAdModel = _props2.combinedAdModel,
          isShortPost = _props2.isShortPost;


      var chunks = post.content;

      this.inlineCarousels = (0, _cloneDeep2.default)((0, _get2.default)(post, 'inlineCarousels')) || [];

      if (post.isVideoPermalink) {
        return _react2.default.createElement(
          'article',
          { className: 'post__article' },
          _react2.default.createElement(
            'p',
            null,
            post.excerpt
          )
        );
      }

      return _react2.default.createElement(
        'article',
        { className: 'post__article' },
        chunks.map(function (chunk, index) {
          return [_this2.setPostChunk(chunk, index), !isShortPost && index < chunks.length - 1 && _this2.notAroundCarousel(chunks, chunk[0], index) ? _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
            pos: 'btf',
            pageNum: pageNum,
            name: _this2.setMobileAdName(index)
          })) : ''];
        })
      );
    }
  }]);

  return Article;
}(_react.Component);

exports.default = Article;


Article.propTypes = {
  post: _propTypes2.default.shape({}).isRequired,
  combinedAdModel: _propTypes2.default.shape({}).isRequired,
  pageNum: _propTypes2.default.number.isRequired,
  isShortPost: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _tag_category_util = __webpack_require__(594);

var _magazine_attribution = __webpack_require__(595);

var _magazine_attribution2 = _interopRequireDefault(_magazine_attribution);

var _author = __webpack_require__(596);

var _author2 = _interopRequireDefault(_author);

var _newsletterSignup = __webpack_require__(230);

var _newsletterSignup2 = _interopRequireDefault(_newsletterSignup);

var _personalized_recommendations = __webpack_require__(597);

var _personalized_recommendations2 = _interopRequireDefault(_personalized_recommendations);

var _feature_flags = __webpack_require__(139);

var _feature_flags2 = _interopRequireDefault(_feature_flags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footer = function (_Component) {
  _inherits(Footer, _Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: 'determineNewsletter',
    value: function determineNewsletter(categories, tags, currentSite) {
      if (!Array.isArray(categories)) return null;

      var categoryNewsletters = {
        leadership: '',
        technology: '',
        ideas: '',
        entertainment: '',
        news: ''
      };

      var cat = (0, _get2.default)(categories, '[0].slug', '');
      var primaryNewsletter = currentSite;

      if (categoryNewsletters.hasOwnProperty(cat)) {
        primaryNewsletter = cat;
      }

      if ((0, _tag_category_util.containsTag)(tags, 'work-smart')) {
        primaryNewsletter = 'work-smart';
      }

      if ((0, _tag_category_util.containsTag)(tags, 'ethonomics')) {
        primaryNewsletter = 'ethonomics';
      }

      if ((0, _tag_category_util.containsTag)(tags, 'well-to-do')) {
        primaryNewsletter = 'well-to-do';
      }

      if ((0, _tag_category_util.containsTag)(tags, 'hit-the-ground-running')) {
        primaryNewsletter = 'hit-the-ground-running';
      }

      return {
        primary: primaryNewsletter,
        newsletters: [{ list: primaryNewsletter, default: true }, { list: 'events', default: true }]
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          post = _props.post,
          isLongPost = _props.isLongPost,
          hasNewsletter = _props.hasNewsletter,
          bylineAttribution = _props.bylineAttribution,
          config = _props.config;
      var tags = post.tags,
          categories = post.categories,
          author = post.author,
          link = post.link;

      var isMagazine = (0, _tag_category_util.determineIfMagazine)(categories);
      var hasAuthor = isLongPost && !bylineAttribution;
      var hasPersonalizedRecommendations = _feature_flags2.default.postPersonalizedRecommendationsEnabled && !(0, _tag_category_util.containsTag)(tags, 'advertorial');

      if (!isMagazine && !hasAuthor && !hasNewsletter) {
        return null;
      }

      return _react2.default.createElement(
        'footer',
        { className: 'post__footer' },
        isMagazine ? _react2.default.createElement(_magazine_attribution2.default, {
          issueMonth: (0, _tag_category_util.determineMagazineIssueMonth)(tags),
          issueNumber: (0, _tag_category_util.determineMagazineIssueNumber)(tags),
          config: config
        }) : '',
        hasAuthor ? _react2.default.createElement(_author2.default, _extends({ modifier: 'post' }, author)) : '',
        hasPersonalizedRecommendations ? _react2.default.createElement(_personalized_recommendations2.default, {
          config: config,
          link: link,
          isAdvertorial: (0, _tag_category_util.containsTag)(tags, 'advertorial')
        }) : '',
        hasNewsletter ? _react2.default.createElement(_newsletterSignup2.default, _extends({
          modifier: 'post',
          id: '' + post.id
        }, this.determineNewsletter(categories, tags, (0, _get2.default)(config, 'site', '')))) : ''
      );
    }
  }]);

  return Footer;
}(_react.Component);

exports.default = Footer;


Footer.propTypes = {
  post: _propTypes2.default.shape({
    tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
    categories: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
    author: _propTypes2.default.shape({}).isRequired
  }).isRequired,
  config: _propTypes2.default.shape({}).isRequired,
  bylineAttribution: _propTypes2.default.string.isRequired,
  isLongPost: _propTypes2.default.bool.isRequired,
  hasNewsletter: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.containsTag = containsTag;
exports.determineIfMagazine = determineIfMagazine;
exports.determineMagazineIssueNumber = determineMagazineIssueNumber;
exports.determineMagazineIssueMonth = determineMagazineIssueMonth;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _string_util = __webpack_require__(131);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function containsTag(arr, tag) {
  return arr.some(function (item) {
    var slug = (0, _get2.default)(item, 'slug', '');
    return slug === tag;
  });
}

function determineIfMagazine(categories) {
  return categories.some(function (category) {
    return category.slug === 'magazine';
  });
}

function hasProperty(obj, str) {
  return obj.hasOwnProperty(str);
}

function determineMagazineIssueNumber(tags) {
  if (!Array.isArray(tags)) {
    return null;
  }

  var regexp = /^issue[-_]\d{0,3}$/;

  var issue = (0, _get2.default)(tags.filter(function filterForIssueNum(tag) {
    var slug = (0, _get2.default)(tag, 'slug');
    return slug ? slug.match(regexp) : false;
  }), '[0].slug');

  return issue || '';
}

function determineMagazineIssueMonth(tags) {
  if (!Array.isArray(tags)) {
    return null;
  }

  var months = {
    january: '',
    february: '',
    march: '',
    april: '',
    may: '',
    june: '',
    july: '',
    august: '',
    september: '',
    october: '',
    november: '',
    december: ''
  };

  var regexp = /^((\w{3,9})[-_](\d{4})([-_](\w{3,9})[-_](\d{4}))*|((\w{3,9})[-_](\w{3,9})[-_](\d{4})))$/;

  var issue = '';

  for (var i = 0; i < tags.length; i += 1) {
    var currTag = tags[i];
    var currTagSlug = (0, _get2.default)(currTag, 'slug') || '';
    if (regexp.test(currTagSlug)) {
      var matchArr = currTagSlug.match(regexp);
      var testMonth = matchArr[2];
      var year = matchArr[3];
      var isDoubleIssueDiffYear = matchArr[5] && matchArr[6] && hasProperty(months, matchArr[5]);

      var dblIssYr = matchArr[10];
      var dblM1 = matchArr[8];
      var dblM2 = matchArr[9];
      var isDoubleIssueSameYear = dblM1 && dblM2 && dblIssYr;

      if (months.hasOwnProperty(testMonth)) {
        issue += (0, _string_util.capitalize)(testMonth) + ' ' + year;
      }

      if (isDoubleIssueDiffYear) {
        issue += '/' + (0, _string_util.capitalize)(matchArr[5]) + ' ' + matchArr[6];
      }

      if (isDoubleIssueSameYear && hasProperty(months, dblM1) && hasProperty(months, dblM2)) {
        issue += (0, _string_util.capitalize)(dblM1) + '/' + (0, _string_util.capitalize)(dblM2) + ' ' + dblIssYr;
      }
    }
  }

  return issue && typeof issue === 'string' ? issue : '';
}

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MagazineAttribution;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _fc_link = __webpack_require__(21);

var _fc_link2 = _interopRequireDefault(_fc_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MagazineAttribution(props) {
  var config = props.config,
      issueMonth = props.issueMonth,
      issueNumber = props.issueNumber;

  if (!issueMonth || !issueNumber || !(0, _get2.default)(config, 'site', '') || !(0, _get2.default)(config, 'env', '')) {
    return null;
  }

  var linkToIssue = 'https://www.fastcompany.com/magazine/' + issueNumber;

  return _react2.default.createElement(
    'aside',
    { className: 'magazine-attribution' },
    'A version of this article appeared in the',
    ' ',
    _react2.default.createElement(
      _fc_link2.default,
      { to: linkToIssue, config: config, title: issueMonth + ' issue' },
      issueMonth
    ),
    ' ',
    'issue of Fast Company magazine.'
  );
}

MagazineAttribution.defaultProps = {
  issueMonth: '',
  issueNumber: ''
};

MagazineAttribution.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  issueMonth: _propTypes2.default.string,
  issueNumber: _propTypes2.default.string
};

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Author;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Link = __webpack_require__(43);

var _Link2 = _interopRequireDefault(_Link);

var _striptags = __webpack_require__(35);

var _striptags2 = _interopRequireDefault(_striptags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function truncateDesc(props) {
  var str = props.description || '';
  var string = (0, _striptags2.default)(str, ['a', 'b', 'em', 'i', 'u', 'strike', 'strong']);
  /* eslint-disable */
  var result = string.match(/(\S.+?[.!?])(?=\s+|$)/ig);
  /* eslint-enable */
  if (result) {
    var finalResult = result.slice(0, 2).join(' ');

    return finalResult;
  }
  return '';
}

function Author(props) {
  if (!props.description) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: 'author author--' + props.modifier },
    _react2.default.createElement(
      'h4',
      { className: 'author__title' },
      'About the author'
    ),
    _react2.default.createElement('p', { className: 'author__description', dangerouslySetInnerHTML: { __html: truncateDesc(props) } }),
    _react2.default.createElement(
      'p',
      { className: 'author__description' },
      ' ',
      _react2.default.createElement(
        _Link2.default,
        { className: 'author__bio-page', to: '/user/' + props.slug },
        'More'
      )
    )
  );
}

Author.propTypes = {
  modifier: _propTypes2.default.string.isRequired,
  description: _propTypes2.default.string.isRequired
};

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(4);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _axios = __webpack_require__(44);

var _axios2 = _interopRequireDefault(_axios);

var _uniqBy = __webpack_require__(126);

var _uniqBy2 = _interopRequireDefault(_uniqBy);

var _fc_link = __webpack_require__(21);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _parsely = __webpack_require__(136);

var _ga = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PersonalizedRecommendations = function (_Component) {
  _inherits(PersonalizedRecommendations, _Component);

  function PersonalizedRecommendations() {
    _classCallCheck(this, PersonalizedRecommendations);

    var _this = _possibleConstructorReturn(this, (PersonalizedRecommendations.__proto__ || Object.getPrototypeOf(PersonalizedRecommendations)).call(this));

    _this.fetchRecommendations = _this.fetchRecommendations.bind(_this);
    _this.state = {
      personalizedRecommendations: []
    };
    return _this;
  }

  _createClass(PersonalizedRecommendations, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (_exenv.canUseDOM) {
        this.fetchRecommendations();
        // track a widget viewed event to better gauge ctr %
        (0, _ga.trackGAEvent)({
          eventCategory: 'related',
          eventAction: 'viewed',
          eventLabel: 'article-page'
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      // If we don't do this, this widget will render every time inf scroll happens
      return this.state.personalizedRecommendations.length === 0;
    }
  }, {
    key: 'fetchRecommendations',
    value: function fetchRecommendations() {
      var _this2 = this;

      var uuid = (0, _get2.default)(window, 'PARSELY.config.uuid');
      var _props = this.props,
          config = _props.config,
          link = _props.link;

      var site = (0, _get2.default)(config, 'site');

      // https://www.parse.ly/help/api/time/
      // https://trello.com/c/YAM79Xv5/1740-add-a-4th-you-may-also-like-link-video-permalinks
      var pubDateStart = '35w';
      var pubDateEnd = '1m';

      // https://www.parse.ly/help/api/recommendations/#personalized
      Promise.all([_axios2.default.get('https://fc-api.fastcompany.com/api/v1/jw-playlist/Y4a4AwUd/1'), _axios2.default.get('https://api.parsely.com/v2/related?apikey=' + site + '.com&url=' + link + '&uuid=' + uuid + '&pub_date_start=' + pubDateStart + '&pub_date_end=' + pubDateEnd)]).then(function (res) {
        if (res.length) {
          var randomSeed = Math.floor(Math.random() * 9) + 0;
          var videoPlaylistData = (0, _get2.default)(res, '[0].data.playlist', []);

          // Select a random video from list, and append it to 4th item in result
          var randomVideo = videoPlaylistData[randomSeed];
          var randomVideoNormalized = {
            title: 'Video: ' + (0, _get2.default)(randomVideo, 'title'),
            section: 'video',
            url: (0, _get2.default)(randomVideo, 'link')
          };
          var parselyData = (0, _get2.default)(res, '[1].data.data', []);

          if (parselyData.length) {
            parselyData.splice(3, 0, randomVideoNormalized);
          }

          _this2.setState({
            personalizedRecommendations: _this2.sanitizeRecommendations(parselyData)
          });
        }
      });
    }
  }, {
    key: 'sanitizeRecommendations',
    value: function sanitizeRecommendations(recommendations) {
      // 1. Remove titles with Fast Company or Fastcodesign
      // 2. Remove any advertorial posts from non-advertorial posts
      // 3. Dedup any title
      var MAX_STORIES = 4;
      var isAdvertorial = this.props.isAdvertorial;

      var sanitizedRecommendations = (0, _uniqBy2.default)(recommendations, function (link) {
        var title = (0, _get2.default)(link, 'title', '');
        return title.toLowerCase();
      }).filter(function (link) {
        if (isAdvertorial) {
          return link.title !== 'Fast Company' && link.title !== 'Fastcodesign' && !link.url.includes('stage') && !link.url.includes('.local');
        }

        return link.title !== 'Fast Company' && link.title !== 'Fastcodesign' && link.section !== 'advertorial' && !link.url.includes('stage') && !link.url.includes('local');
      });

      if (sanitizedRecommendations.length > MAX_STORIES) {
        return sanitizedRecommendations.slice(0, MAX_STORIES);
      }

      return sanitizedRecommendations;
    }
  }, {
    key: 'render',
    value: function render() {
      var personalizedRecommendations = this.state.personalizedRecommendations;
      var config = this.props.config;


      if (!personalizedRecommendations.length) {
        return '';
      }

      return _react2.default.createElement(
        'section',
        { className: 'post-personalized-recommendations' },
        _react2.default.createElement(
          'h3',
          { className: 'post-personalized-recommendations__header' },
          'You Might Also Like:'
        ),
        _react2.default.createElement(
          'ul',
          { className: 'post-personalized-recommendations__list' },
          this.sanitizeRecommendations(personalizedRecommendations).map(function (link, index) {
            return _react2.default.createElement(
              'li',
              {
                className: 'post-personalized-recommendations__item',
                key: index,
                onClick: function onClick() {
                  var position = index;
                  position += 1;
                  (0, _ga.trackGAEvent)({
                    eventCategory: 'related',
                    eventAction: 'clicked',
                    eventLabel: 'algorithm=parsely,location=article-bottom,position=' + position
                  });
                  (0, _parsely.trainParselyProfile)(link.url);
                }
              },
              _react2.default.createElement(
                _fc_link2.default,
                { config: config, title: link.title, to: link.url },
                link.title
              )
            );
          })
        )
      );
    }
  }]);

  return PersonalizedRecommendations;
}(_react.Component);

PersonalizedRecommendations.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  link: _propTypes2.default.string.isRequired,
  isAdvertorial: _propTypes2.default.bool.isRequired
};

exports.default = PersonalizedRecommendations;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _uniqBy = __webpack_require__(126);

var _uniqBy2 = _interopRequireDefault(_uniqBy);

var _axios = __webpack_require__(44);

var _axios2 = _interopRequireDefault(_axios);

var _slug = __webpack_require__(23);

var _slug2 = _interopRequireDefault(_slug);

var _update = __webpack_require__(599);

var _update2 = _interopRequireDefault(_update);

var _scroll_to_el_util = __webpack_require__(142);

var _scroll_to_el_util2 = _interopRequireDefault(_scroll_to_el_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Live = function (_Component) {
  _inherits(Live, _Component);

  function Live(props) {
    _classCallCheck(this, Live);

    var _this = _possibleConstructorReturn(this, (Live.__proto__ || Object.getPrototypeOf(Live)).call(this, props));

    var REFRESH_IN_SECONDS = 30;
    _this.fetchDelay = REFRESH_IN_SECONDS * 1000;
    _this.api = '' + props.config.protocol + props.config.apiEndpoint;
    _this.state = {
      posts: props.live.posts
    };
    _this.scrolledToUpdate = false;
    _this.lastSeenParam = '';

    _this.updatesPerPage = 100;
    _this.fetchLiveUpdates = _this.fetchLiveUpdates.bind(_this);
    _this.fetchPaginatedUpdates = _this.fetchPaginatedUpdates.bind(_this);
    return _this;
  }

  _createClass(Live, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var live = this.props.live;

      if (live.enabled) {
        this.fetchLiveUpdates(true);
      } else {
        this.fetchPaginatedUpdates(1, live.posts.length);
      }
      this.scrollToUpdateElement();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.state.posts.length !== nextState.posts.length;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (!this.scrolledToUpdate) {
        this.scrollToUpdateElement();
      }

      if (window.instgrm) {
        window.instgrm.Embeds.process();
      }

      if (window.twttr) {
        window.twttr.widgets.load();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.refresher);
    }
  }, {
    key: 'setLastSeen',
    value: function setLastSeen() {
      var d = new Date();
      var year = d.getFullYear();
      var month = ('0' + (d.getMonth() + 1)).slice(-2);
      var date = ('0' + d.getDate()).slice(-2);
      var hours = ('0' + d.getHours()).slice(-2);
      var minutes = ('0' + d.getMinutes()).slice(-2);
      var seconds = d.getSeconds() <= 30 ? '00' : 30;
      var formattedDate = year + '-' + month + '-' + date + 'T' + hours + ':' + minutes + ':' + seconds + 'Z';
      this.lastSeenParam = '?lastSeen=' + formattedDate;
    }
  }, {
    key: 'fetchLiveUpdates',
    value: function fetchLiveUpdates() {
      var _this2 = this;

      var initialFetch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _axios2.default.get(this.api + '/api/v1/live-posts/' + this.props.live.tag).then(function (res) {
        _this2.setLastSeen();

        var livePosts = (0, _get2.default)(res, 'data.livePosts', []);
        var page = (0, _get2.default)(res, 'data.page');
        var total = (0, _get2.default)(res, 'data.total');

        if (livePosts.length) {
          livePosts.push.apply(livePosts, _toConsumableArray(_this2.state.posts));

          _this2.setState({
            posts: (0, _uniqBy2.default)(livePosts, 'id')
          });
        }

        if (initialFetch) {
          _this2.fetchPaginatedUpdates(page, total);
        }

        _this2.refresher = setTimeout(function () {
          _this2.fetchLiveUpdates();
        }, _this2.fetchDelay);
      });
    }
  }, {
    key: 'fetchPaginatedUpdates',
    value: function fetchPaginatedUpdates(page, total) {
      var _this3 = this;

      if (this.updatesPerPage * page <= total) {
        _axios2.default.get(this.api + '/api/v1/live-posts/' + this.props.live.tag + '?page=' + (page + 1)).then(function (res) {
          var nextPagePosts = (0, _get2.default)(res, 'data.livePosts', []);
          var nextPage = (0, _get2.default)(res, 'data.page');
          var totalPosts = (0, _get2.default)(res, 'data.total');
          var livePosts = [].concat(_toConsumableArray(_this3.state.posts), _toConsumableArray(nextPagePosts));

          _this3.setState({
            posts: (0, _uniqBy2.default)(livePosts, 'id')
          });

          if (nextPage && _this3.updatesPerPage * nextPage < totalPosts) {
            _this3.fetchPaginatedUpdates(nextPage, totalPosts);
          }
        });
      }
    }
  }, {
    key: 'scrollToUpdateElement',
    value: function scrollToUpdateElement() {
      var update = window.location.hash;


      if (update && document.querySelector(update)) {
        (0, _scroll_to_el_util2.default)(update, 100);
        this.scrolledToUpdate = true;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var posts = this.state.posts;
      var _props = this.props,
          parentPost = _props.parentPost,
          config = _props.config;


      if (!posts.length) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'live', id: 'updates' },
        _react2.default.createElement(_slug2.default, { slugName: 'Updates', className: 'live__header' }),
        posts.map(function (post) {
          return _react2.default.createElement(_update2.default, {
            key: post.id,
            update: post,
            parentPost: parentPost,
            site: config.site
          });
        })
      );
    }
  }]);

  return Live;
}(_react.Component);

exports.default = Live;


Live.propTypes = {
  config: _propTypes2.default.shape({
    protocol: _propTypes2.default.string,
    apiEndpoint: _propTypes2.default.string
  }).isRequired,
  parentPost: _propTypes2.default.shape({}).isRequired,
  live: _propTypes2.default.shape({
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    tag: _propTypes2.default.string,
    enabled: _propTypes2.default.bool
  }).isRequired
};

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _share_util = __webpack_require__(229);

var _content_util = __webpack_require__(226);

var _content_util2 = _interopRequireDefault(_content_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Update = function (_Component) {
  _inherits(Update, _Component);

  function Update(props) {
    _classCallCheck(this, Update);

    var _this = _possibleConstructorReturn(this, (Update.__proto__ || Object.getPrototypeOf(Update)).call(this, props));

    _this.shareUpdate = _this.shareUpdate.bind(_this);
    return _this;
  }

  _createClass(Update, [{
    key: 'shareUpdate',
    value: function shareUpdate(event) {
      var _props = this.props,
          parentPost = _props.parentPost,
          site = _props.site,
          update = _props.update;

      var status = encodeURIComponent(parentPost.title);
      var updateUrl = 'https%3A//www.' + site + '.com/' + parentPost.id + '/' + parentPost.slug + '%23update-' + update.id;
      var hashtags = parentPost.hashtags.join(',');
      var url = 'https://twitter.com/share?url=' + updateUrl + '&text=' + status + '&hashtags=' + hashtags;

      (0, _share_util.popupCenter)(event, url, 560, 725);
      (0, _share_util.trackSocial)('Twitter', 'Tweet');
    }
  }, {
    key: 'render',
    value: function render() {
      var update = this.props.update;

      this.content = (0, _content_util2.default)(update.content);

      return _react2.default.createElement(
        'div',
        { key: update.id, id: 'update-' + update.id, className: 'live__update' },
        _react2.default.createElement(
          'div',
          { className: 'live__eyebrow' },
          _react2.default.createElement(
            'span',
            null,
            update.author.name
          ),
          _react2.default.createElement(
            'span',
            null,
            update.dateFormatted
          ),
          _react2.default.createElement(
            'span',
            null,
            update.timePublished
          ),
          _react2.default.createElement(
            'span',
            { className: 'live__share', onClick: this.shareUpdate },
            'Share This Update'
          )
        ),
        _react2.default.createElement('div', {
          className: 'live__content post__article',
          dangerouslySetInnerHTML: {
            __html: this.content
          }
        })
      );
    }
  }]);

  return Update;
}(_react.Component);

exports.default = Update;


Update.propTypes = {
  update: _propTypes2.default.shape({}).isRequired,
  parentPost: _propTypes2.default.shape({}).isRequired,
  site: _propTypes2.default.string.isRequired
};

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Recommender;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(146);

var _books = __webpack_require__(601);

var _books2 = _interopRequireDefault(_books);

var _slug = __webpack_require__(23);

var _slug2 = _interopRequireDefault(_slug);

var _ga = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Recommender(props) {
  if (!props.initialPageLoad && _books2.default.length) {
    var randomBooks = (0, _lodash.sampleSize)(_books2.default, 4);

    return _react2.default.createElement(
      'div',
      { className: 'recommender' },
      _react2.default.createElement(_slug2.default, { slugName: 'The Recommender', className: 'column' }),
      randomBooks.map(function (book) {
        return _react2.default.createElement(
          'div',
          { className: 'book', key: book.affiliate_link },
          _react2.default.createElement(
            'a',
            {
              href: book.affiliate_link,
              target: '_blank',
              className: 'book__link',
              onClick: function onClick() {
                (0, _ga.trackGAEvent)({
                  eventCategory: 'Recommender',
                  eventAction: 'Book',
                  eventLabel: book.title
                });
              }
            },
            _react2.default.createElement(
              'figure',
              { className: 'book__cover' },
              _react2.default.createElement('img', {
                src: book.cover,
                alt: book.title,
                className: 'book__image'
              })
            ),
            _react2.default.createElement(
              'cite',
              { className: 'book__title' },
              book.title
            ),
            _react2.default.createElement(
              'span',
              { className: 'book__price' },
              '$',
              book.price
            )
          )
        );
      }),
      _react2.default.createElement(
        'p',
        { className: 'recommender__disclaimer' },
        'Thanks for supporting Fast Company with these affiliate links'
      )
    );
  }

  return null;
}

Recommender.propTypes = {
  initialPageLoad: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var books = [{
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511811766/fcweb/fc-book-barkingupthewrongtree_sk5uga.jpg',
  title: 'Barking Up The Wrong Tree',
  price: '18.30',
  affiliate_link: 'http://amzn.to/2ztvyoA'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511811943/fcweb/fc-book-fifthTrimester_kfsumj.jpg',
  title: 'The Fifth Trimester',
  price: '17.64',
  affiliate_link: 'http://amzn.to/2zsN2Bo'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812041/fcweb/fc-book-technicallyWrong_emqybr.jpg',
  title: 'Technically Wrong',
  price: '16.18',
  affiliate_link: 'http://amzn.to/2ztLcjH'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812117/fcweb/fc-book-perennialSeller_vbfloh.jpg',
  title: 'Perennial Seller',
  price: '14.67',
  affiliate_link: 'http://amzn.to/2AcDbTk'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812219/fcweb/fc-book-crackInCreation_kyn5nw.jpg',
  title: 'A Crack in Creation',
  price: '18.61',
  affiliate_link: 'http://amzn.to/2zuqSyU'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812368/fcweb/fc-book-greatTransformation_m2rbhw.jpg',
  title: 'The Great Transformation',
  price: '22.85',
  affiliate_link: 'http://amzn.to/2BrORQD'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812472/fcweb/fc-book-deepLearning_m8admo.jpg',
  title: 'Deep Learning',
  price: '47.00',
  affiliate_link: 'http://amzn.to/2k7zRDn'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812561/fcweb/fc-books-boysintheBoat_jgqdvx.jpg',
  title: 'The Boys in the Boat',
  price: '12.27',
  affiliate_link: 'http://amzn.to/2i7oLNX'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812647/fcweb/fc-book-greatConvergence_cbci1g.jpg',
  title: 'The Great Convergence',
  price: '22.84',
  affiliate_link: 'http://amzn.to/2BtoeuH'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812771/fcweb/fc-book-mindset_htkqvr.jpg',
  title: 'Mindset',
  price: '13.60',
  affiliate_link: 'http://amzn.to/2zscLtJ'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812898/fcweb/fc-book-nonViolentCommunication_fqvqed.jpg',
  title: 'Nonviolent Communication',
  price: '13.50',
  affiliate_link: 'http://amzn.to/2ztH4Ag'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813012/fcweb/fc-books-americanGrowth_swbtwj.jpg',
  title: 'The Rise and Fall of American Growth',
  price: '18.67',
  affiliate_link: 'http://amzn.to/2BtIAns'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813368/fcweb/fc-book-weaponsofMathDestruction_ziestc.jpg',
  title: 'Weapons of Math Destruction',
  price: '17.68',
  affiliate_link: 'http://amzn.to/2Bpln5M'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813416/fcweb/fc-book-urbanCrisis_ff1h7i.jpg',
  title: 'The New Urban Crisis',
  price: '19.04',
  affiliate_link: 'http://amzn.to/2iaCKCs'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813498/fcweb/fc-book-whiplash_ienuxv.jpg',
  title: 'Whiplash',
  price: '17.41',
  affiliate_link: 'http://amzn.to/2zrZt0d'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813630/fcweb/fc-book-playAnything_qgpjgn.jpg',
  title: 'Play Anything',
  price: '15.68',
  affiliate_link: 'http://amzn.to/2BrLHfC'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813735/fcweb/fc-book-dataGoliath_fi8pcv.jpg',
  title: 'Data and Goliath',
  price: '12.80',
  affiliate_link: 'http://amzn.to/2ztMKdv'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813817/fcweb/fc-books-powerofMoments_noieau.jpg',
  title: 'The Power of Moments',
  price: '17.38',
  affiliate_link: 'http://amzn.to/2zt43eS'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813916/fcweb/fc-book-tribeofMentors_bfaqkb.jpg',
  title: 'Tribe of Mentors',
  price: '17.85',
  affiliate_link: 'http://amzn.to/2BsKcho'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813976/fcweb/fc-book-startupWay_cmmoxs.jpg',
  title: 'The Startup Way',
  price: '17.98',
  affiliate_link: 'http://amzn.to/2zsmWyC'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511814039/fcweb/fc-book-secondMachineAge_npugcp.jpg',
  title: 'The Second Machine Age',
  price: '14.83',
  affiliate_link: 'http://amzn.to/2zt5rOC'
}];

exports.default = books;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _reactJwPlayer = __webpack_require__(95);

var _reactJwPlayer2 = _interopRequireDefault(_reactJwPlayer);

var _slug = __webpack_require__(23);

var _slug2 = _interopRequireDefault(_slug);

var _video_module_ads = __webpack_require__(97);

var _video_module_ads2 = _interopRequireDefault(_video_module_ads);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var scriptjs = false;
var ifvisible = false;

if (_exenv.canUseDOM) {
  // eslint-disable-next-line global-require
  scriptjs = __webpack_require__(37);
  // eslint-disable-next-line global-require
  ifvisible = __webpack_require__(96);
}

var VideoReactJW = function (_Component) {
  _inherits(VideoReactJW, _Component);

  function VideoReactJW() {
    _classCallCheck(this, VideoReactJW);

    var _this = _possibleConstructorReturn(this, (VideoReactJW.__proto__ || Object.getPrototypeOf(VideoReactJW)).call(this));

    _this.generatePreRoll = _this.generatePreRoll.bind(_this);
    _this.setMoatTracking = _this.setMoatTracking.bind(_this);
    _this.onReady = _this.onReady.bind(_this);
    _this.onVideoLoad = _this.onVideoLoad.bind(_this);
    _this.state = {
      videoTitle: '',
      userIsActive: true
    };
    return _this;
  }

  _createClass(VideoReactJW, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (scriptjs) {
        scriptjs(['https://z.moatads.com/jwplayerplugin0938452/moatplugin.js']);
      }

      // Set up activity tracker, 5s = idle
      if (ifvisible) {
        ifvisible.setIdleDuration(5);
        ifvisible.on('idle', function () {
          _this2.setState({
            userIsActive: false
          });
        });

        ifvisible.on('wakeup', function () {
          _this2.setState({
            userIsActive: true
          });
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (_exenv.canUseDOM) {
        if (window.moatjw) {
          window.moatjw.removeAll();
        }

        if (ifvisible) {
          ifvisible.off();
        }
      }
    }
  }, {
    key: 'onVideoLoad',
    value: function onVideoLoad(event) {
      this.setState({
        videoTitle: (0, _get2.default)(event, 'item.title')
      });
    }
  }, {
    key: 'onReady',
    value: function onReady() {
      var _this3 = this;

      var playerid = this.props.playerid;

      var player = window.jwplayer(playerid);

      player.on('complete', function () {
        if (!_this3.state.userIsActive) {
          player.stop();
        }
      });
    }
  }, {
    key: 'setMoatTracking',
    value: function setMoatTracking(event) {
      if (window.moatjw) {
        window.moatjw.add({
          partnerCode: 'mansuetojwint127635890115',
          player: this.player,
          adImpressionEvent: event
        });
      }
    }
  }, {
    key: 'generatePreRoll',
    value: function generatePreRoll() {
      var _props = this.props,
          data = _props.data,
          type = _props.type,
          pos = _props.pos,
          readTime = _props.readTime;

      return new _video_module_ads2.default((0, _get2.default)(data, 'title'), type, 'preroll_rightrail', readTime, pos).adTag;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          playerid = _props2.playerid,
          playlistId = _props2.playlistId;


      return _react2.default.createElement(
        'div',
        { className: 'siderail-video-module' },
        _react2.default.createElement(_slug2.default, { slugName: this.props.slugName, className: 'column' }),
        _react2.default.createElement(
          'div',
          { className: 'siderail-video-module__player-container' },
          _react2.default.createElement(_reactJwPlayer2.default, {
            playerId: playerid,
            playerScript: 'https://content.jwplatform.com/libraries/' + playerid + '.js',
            playlist: '//content.jwplatform.com/feeds/' + playlistId + '.json',
            generatePrerollUrl: this.generatePreRoll,
            onReady: this.onReady,
            onVideoLoad: this.onVideoLoad,
            playInView: true,
            onAdPlay: this.setMoatTracking,
            isMuted: true,
            isAutoPlay: false,
            playInViewPercentage: 100,
            aspectRatio: '16:9'
          })
        ),
        _react2.default.createElement(
          'h3',
          { className: 'card__title card__title--small siderail-video-module__player-title-slug' },
          this.state.videoTitle
        )
      );
    }
  }]);

  return VideoReactJW;
}(_react.Component);

exports.default = VideoReactJW;


VideoReactJW.defaultProps = {
  data: {},
  slugName: 'Featured Video',
  readTime: null
};

VideoReactJW.propTypes = {
  data: _propTypes2.default.shape({}),
  playerid: _propTypes2.default.string.isRequired,
  playlistId: _propTypes2.default.string.isRequired,
  slugName: _propTypes2.default.string,
  type: _propTypes2.default.string.isRequired,
  pos: _propTypes2.default.string.isRequired,
  readTime: _propTypes2.default.string
};

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadFBTracker;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(17);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
function loadFBTracker(currentState) {
  var site = (0, _get2.default)(currentState, 'context.site');
  var facebookConfig = (0, _get2.default)(_identity2.default[site], 'facebookPixel');
  var id = facebookConfig.id;

  // https://www.facebook.com/ads/manager/pixel/facebook_pixel/?act=1375631352670761&pid=p1

  if (window.fbq) {
    return false;
  }

  var _fbq2 = window.fbq;
  _fbq2 = function fbq() {
    var _fbq;

    _fbq2.callMethod ? (_fbq = _fbq2).callMethod.apply(_fbq, arguments) : _fbq2.queue.push(arguments);
  };

  if (!window._fbq) {
    window._fbq = _fbq2;
  }

  _fbq2.push = _fbq2;
  _fbq2.loaded = !0;
  _fbq2.version = '2.0';
  _fbq2.queue = [];

  _fbq2('init', '' + id);
  _fbq2('track', 'PageView');
}
/* eslint-disable */

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadComscoreTracker;

var _exenv = __webpack_require__(4);

function loadComscoreTracker() {
  if (_exenv.canUseDOM) {
    window.Nielsen_Event();
  }
}

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadKruxTracker;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(17);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loadKruxTracker(currentState) {
  var siteName = (0, _get2.default)(currentState, 'context.site', 'fastcompany');
  var context = (0, _get2.default)(currentState, 'context', {});
  var siteConfig = _identity2.default[siteName];
  var keywords = (0, _get2.default)(siteConfig, 'keywords', []);

  var postData = context.postData,
      type = context.type;


  if (window.Krux) {
    var FCKruxFPA = {
      author: null,
      channels: null,
      subChannels: null,
      contentType: null,
      keywords: null,
      socialTags: null,
      siteName: null,
      referrerUrl: null,
      url: window.location.origin + window.location.pathname,
      querystring: null
    };

    var category = null;
    var authorName = siteName || '';
    var contentType = type;
    var tags = [];
    var articleId = '';

    var typeMap = {
      post: 'article',
      gallery: 'slideshow',
      video: 'video'
    };

    // DO POST CHECK
    if (type === 'post') {
      category = (0, _get2.default)(postData, 'categories[0].slug', '');
      articleId = (0, _get2.default)(postData, 'id', null);
      authorName = (0, _get2.default)(postData, 'author.name', '');
      contentType = typeMap[(0, _get2.default)(postData, 'format', 'article')];
    }

    // FCKruxFPA['Read Length'] = null;  // todo @zhi
    FCKruxFPA['Article ID'] = articleId;
    FCKruxFPA.Subchannel = category;
    FCKruxFPA.Channel = category;

    if (window.location.search !== '') {
      FCKruxFPA.querystring = window.location.search;
    }

    if (document.referrer) {
      FCKruxFPA.referrerUrl = document.referrer;
    }

    FCKruxFPA.channels = keywords;
    FCKruxFPA.siteName = siteName;

    FCKruxFPA.author = authorName;
    FCKruxFPA.subChannels = category;
    FCKruxFPA.keywords = tags;
    FCKruxFPA.socialTags = tags;
    FCKruxFPA.contentType = contentType;

    window.FC_Krux_FPA = FCKruxFPA;

    if (window.Krux) {
      // eslint-disable-next-line new-cap
      window.Krux('ns:mansueto', 'page:load', function () {
        return true;
      });
    }
  }
}

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadLiftIgniterTracker;

var _exenv = __webpack_require__(4);

function loadLiftIgniterTracker() {
  if (_exenv.canUseDOM) {
    if (window.$p) {
      window.$p('send', 'pageview');
    }
  }
}

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/magazine',
    component: _magazine_page2.default,
    strict: true,
    exact: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'magazine')
  };
};

var _magazine_page = __webpack_require__(608);

var _magazine_page2 = _interopRequireDefault(_magazine_page);

var _category_page_state_manager = __webpack_require__(68);

var _category_page_state_manager2 = _interopRequireDefault(_category_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _withRouter = __webpack_require__(59);

var _withRouter2 = _interopRequireDefault(_withRouter);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(15);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _ad = __webpack_require__(24);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(49);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _slug = __webpack_require__(23);

var _slug2 = _interopRequireDefault(_slug);

var _card = __webpack_require__(36);

var _card2 = _interopRequireDefault(_card);

var _magazine_archive = __webpack_require__(149);

var _magazine_archive2 = _interopRequireDefault(_magazine_archive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var Magazine = function (_Component) {
  _inherits(Magazine, _Component);

  function Magazine() {
    _classCallCheck(this, Magazine);

    return _possibleConstructorReturn(this, (Magazine.__proto__ || Object.getPrototypeOf(Magazine)).apply(this, arguments));
  }

  _createClass(Magazine, [{
    key: 'render',
    value: function render() {
      if (this.props.categoryPage.error || this.props.categoryFeaturedFeed.error || this.props.status === 404) {
        return _react2.default.createElement(
          'section',
          { className: 'category-page' },
          _react2.default.createElement(
            'article',
            { className: 'category-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.categoryPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'category-page' },
          _react2.default.createElement(
            'article',
            { className: 'category-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var _props = this.props,
          config = _props.config,
          categoryPage = _props.categoryPage,
          categoryFeaturedFeed = _props.categoryFeaturedFeed,
          magazineLatestIssuePosts = _props.magazineLatestIssuePosts;

      var adData = (0, _get2.default)(categoryPage, 'ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      var pgName = (0, _get2.default)(categoryFeaturedFeed, 'category.name');
      var pgDesc = (0, _get2.default)(categoryFeaturedFeed, 'category.description');

      return _react2.default.createElement(
        'section',
        { className: 'category-page category-page--magazine' },
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true })),
        _react2.default.createElement(
          'section',
          { className: 'page-title' },
          _react2.default.createElement(_slug2.default, { slugName: pgName, className: 'category-page' }),
          pgDesc ? _react2.default.createElement(
            'h3',
            { className: 'page-description' },
            pgDesc
          ) : ''
        ),
        _react2.default.createElement(
          'div',
          { className: 'row row--magazine' },
          _react2.default.createElement(
            'div',
            { className: 'row__aside' },
            _react2.default.createElement(_card2.default, {
              type: 'magazine',
              metadata: (0, _get2.default)(magazineLatestIssuePosts, 'data.issue', {}),
              fullWidth: true,
              magPage: true,
              config: config
            }),
            _react2.default.createElement(
              'div',
              { className: 'small-cards' },
              (0, _get2.default)(magazineLatestIssuePosts, 'data.features', []).slice(0, 3).map(function (story) {
                return _react2.default.createElement(_card2.default, {
                  key: story.id,
                  type: 'small',
                  metadata: story,
                  disabledImage: true,
                  config: config
                });
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row__main' },
            _react2.default.createElement(_card2.default, {
              type: 'featured',
              metadata: (0, _get2.default)(magazineLatestIssuePosts, 'data.coverStory', {}),
              config: config
            }),
            _react2.default.createElement(
              'div',
              { className: 'card card--default card--subscribe' },
              _react2.default.createElement(
                'a',
                { href: 'https://magazine.fastcompany.com/loc/FST/fullissuepage1999' },
                _react2.default.createElement('img', {
                  className: 'subscribe--rectangle',
                  src: 'https://images.fastcompany.net/image/upload/v1513006211/fcweb/sub-ad-magazine-v3_eyxk8d.png',
                  alt: 'The future of business starts here. Subscribe now.'
                }),
                _react2.default.createElement('img', {
                  className: 'subscribe--square',
                  src: 'https://images.fastcompany.net/image/upload/v1513006211/fcweb/sub-ad-mobile-v3_dkso8i.png',
                  alt: 'The future of business starts here. Subscribe now.'
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'category-page__ff-ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_1' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
        ),
        _react2.default.createElement(_magazine_archive2.default, {
          config: config,
          title: 'Fast Company Magazine Archives',
          description: 'Browse our previous magazine issues',
          magazines: (0, _get2.default)(magazineLatestIssuePosts, 'data.magazineArchive', []),
          limit: 12
        }),
        _react2.default.createElement(
          'div',
          { className: 'category-page__ff-ad-containe' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_2' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_2' }))
        )
      );
    }
  }]);

  return Magazine;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    categoryFeaturedFeed: {
      source: (0, _get2.default)(state, 'categoryFeaturedFeed.source') || '',
      featured: (0, _get2.default)(state, 'categoryFeaturedFeed.featured') || [],
      top: (0, _get2.default)(state, 'categoryFeaturedFeed.top') || [],
      category: (0, _get2.default)(state, 'categoryFeaturedFeed.category') || {},
      error: (0, _get2.default)(state, 'categoryFeaturedFeed.error') || false
    },
    categoryPage: (0, _get2.default)(state, 'categoryPage') || {},
    categoryScrollingModule: (0, _get2.default)(state, 'categoryScrollingModule.data') || {},
    magazineLatestIssuePosts: (0, _get2.default)(state, 'magazineLatestIssuePosts') || {}
  };
}

Magazine.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  status: _propTypes2.default.number.isRequired,
  categoryPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  categoryFeaturedFeed: _propTypes2.default.shape({
    source: _propTypes2.default.string,
    featured: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    top: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    category: _propTypes2.default.object,
    error: _propTypes2.default.bool
  }).isRequired,
  magazineLatestIssuePosts: _propTypes2.default.shape({}).isRequired
  // categoryScrollingModule: PropTypes.shape({}).isRequired
};

exports.default = (0, _withRouter2.default)((0, _reactRedux.connect)(mapStateToProps)(Magazine));

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/community-spot-im',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 824)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'community'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'search' },
        _react2.default.createElement(_loading_spinner2.default, null)
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('./community_page').default;
}

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/sitemap',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 262)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'sitemapIndex'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'author-page' },
        _react2.default.createElement(
          'article',
          { className: 'author-page__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('./html_sitemap_index_page').default;
}

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/sitemap/year/:year',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 262)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'sitemapIndex'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'author-page' },
        _react2.default.createElement(
          'article',
          { className: 'author-page__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('./html_sitemap_index_page').default;
}

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/sitemap/posts',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 825)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'sitemapPost'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'post-page' },
        _react2.default.createElement(
          'article',
          { className: 'post__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('./html_sitemap_post_page').default;
}

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/:subpath(about-us|contact-us|privacy-policy|staff-masthead|terms-and-conditions)',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 263)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'aboutUsWpPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'video-page' },
        _react2.default.createElement(
          'article',
          { className: 'video-page__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('../wp_page').default;
}

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/apply/:slug',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 263)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'applyWpPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'video-page' },
        _react2.default.createElement(
          'article',
          { className: 'video-page__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('../wp_page').default;
}

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/search/:q?/:page?',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 826)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'searchPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'search' },
        _react2.default.createElement(_loading_spinner2.default, null)
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('../search_page').default;
}

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/section/:tag/:page?',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 264)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'tagPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'tag-page' },
        _react2.default.createElement(
          'article',
          { className: 'tag-page__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('../tag_page').default;
}

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/section/living-smarter',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store, 'living-smarter') : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 827)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store, 'living-smarter');
        return Component;
      });
    },

    chunk: 'sponsoredKiaTagCustomPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'search' },
        _react2.default.createElement(_loading_spinner2.default, null)
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('../sponsored_kia_tag_page').default;
}

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/section/urban-x',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store, 'urban-x') : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 828)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store, 'urban-x');
        return Component;
      });
    },

    chunk: 'sponsoredTagCustomPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'search' },
        _react2.default.createElement(_loading_spinner2.default, null)
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('../sponsored_tag_page_custom').default;
}

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return [magIssue1(store), magIssue2(store), magTag(store)];
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('../magazine_tag_page').default;
}

var TagComponent = false;

if (false) {
  // eslint-disable-next-line global-require
  TagComponent = require('../tag_page').default;
}

function magIssue1(store) {
  var routeConfig = {
    path: '/magazine/:tag(\\issue-\\d+)',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store, 'magazine') : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 265)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store, 'magazine');
        return Component;
      });
    },

    chunk: 'magazineTagPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'search' },
        _react2.default.createElement(_loading_spinner2.default, null)
      );
    }
  });

  return routeConfig;
}

function magIssue2(store) {
  var routeConfig = {
    path: '/magazine/:tag(\\issue-\\d+-\\d+)',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store, 'magazine') : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 265)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store, 'magazine');
        return Component;
      });
    },

    chunk: 'magazineTagPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'search' },
        _react2.default.createElement(_loading_spinner2.default, null)
      );
    }
  });

  return routeConfig;
}

function magTag(store) {
  var routeConfig = {
    path: '/magazine/:tag',
    component: function component() {
      if (TagComponent) {
        return _react2.default.createElement(TagComponent, null);
      }

      return _react2.default.createElement(LazyTagComponent, null);
    },

    exact: true,
    strict: true,
    loadData: TagComponent ? TagComponent.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 264)).then(function (resp) {
        TagComponent = resp.default;
        routeConfig.loadData = TagComponent.loadData(store);
        return TagComponent;
      });
    },

    chunk: 'tagPage'
  };

  var LazyTagComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'search' },
        _react2.default.createElement(_loading_spinner2.default, null)
      );
    }
  });

  return routeConfig;
}

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/product/:product',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 829)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'productPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'post-page' },
        _react2.default.createElement(
          'article',
          { className: 'post__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('./product_page').default;
}

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/stuff/:section?/:page?',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 830)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'productIndex'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'post-page' },
        _react2.default.createElement(
          'article',
          { className: 'post__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('../product_index_section_page').default;
}

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/person/:section?/:page?',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 831)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'personIndexSectionPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'post-page' },
        _react2.default.createElement(
          'article',
          { className: 'post__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('../person_index_section_page').default;
}

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/innovation-by-design/:year',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 266)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'ibdPage',
    autoScrollOff: true
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'post-page' },
        _react2.default.createElement(
          'article',
          { className: 'post__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('./innovation_by_design_page').default;
}

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShowMore = function (_Component) {
  _inherits(ShowMore, _Component);

  function ShowMore() {
    _classCallCheck(this, ShowMore);

    var _this = _possibleConstructorReturn(this, (ShowMore.__proto__ || Object.getPrototypeOf(ShowMore)).call(this));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.state = {
      showMore: false
    };
    return _this;
  }

  _createClass(ShowMore, [{
    key: 'handleClick',
    value: function handleClick(e) {
      e.preventDefault();
      e.stopPropagation();
      this.setState({
        showMore: !this.state.showMore
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', {
        onClick: this.handleClick,
        className: 'show-more ' + (this.state.showMore ? 'show-more--expanded' : ''),
        dangerouslySetInnerHTML: {
          __html: this.state.showMore ? this.props.data : '<p class="show-more__text">' + this.props.initialText + '</p>'
        }
      });
    }
  }]);

  return ShowMore;
}(_react.Component);

ShowMore.defaultProps = {
  initialText: 'Show More'
};

ShowMore.propTypes = {
  initialText: _propTypes2.default.string,
  data: _propTypes2.default.string.isRequired
};

exports.default = ShowMore;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/innovation-by-design/:year/category/:category',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 266)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'ibdPage',
    autoScrollOff: true
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'post-page' },
        _react2.default.createElement(
          'article',
          { className: 'post__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('./innovation_by_design_page').default;
}

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/most-creative-people-community/:section?/:page?',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 832)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'mcpCommunityPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'post-page' },
        _react2.default.createElement(
          'article',
          { className: 'post__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('../most_creative_people_community_section_page').default;
}

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/most-creative-people/:year',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 833)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'mcpPeoplePage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'post-page' },
        _react2.default.createElement(
          'article',
          { className: 'post__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('./most_creative_people_page').default;
}

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/company/:company',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 834)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'companyPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'post-page' },
        _react2.default.createElement(
          'article',
          { className: 'post__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('./company_page').default;
}

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/company/:section?/:page?',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 835)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'companyIndexSectionPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'post-page' },
        _react2.default.createElement(
          'article',
          { className: 'post__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('../company_index_section_page').default;
}

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return [micPage2018(store), legacyMicPage(store)];
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function micPage2018(store) {
  var Component = false;
  if (false) {
    // eslint-disable-next-line global-require
    Component = require('../mic_year_2018_page').default;
  }

  var routeConfig = {
    path: '/most-innovative-companies/2018/:sectors?/:sector?',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 836)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'MicYearPage2018'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'post-page' },
        _react2.default.createElement(
          'article',
          { className: 'post__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
}

function legacyMicPage(store) {
  var Component = false;
  if (false) {
    // eslint-disable-next-line global-require
    Component = require('../mic_year_page').default;
  }

  var routeConfig = {
    path: '/most-innovative-companies/:year/:sectors?/:sector?',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 837)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'micYearPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'post-page' },
        _react2.default.createElement(
          'article',
          { className: 'post__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
}

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/person/:person',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 838)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'personPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'post-page' },
        _react2.default.createElement(
          'article',
          { className: 'post__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('./person_page').default;
}

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/:id/:slug',
    component: _post_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _postpage_state_manager2.default)(store)
  };
};

var _post_page = __webpack_require__(69);

var _post_page2 = _interopRequireDefault(_post_page);

var _postpage_state_manager = __webpack_require__(70);

var _postpage_state_manager2 = _interopRequireDefault(_postpage_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _post_finite_action_creators = __webpack_require__(634);

var postFiniteActions = _interopRequireWildcard(_post_finite_action_creators);

var _post_finite_module = __webpack_require__(635);

var _post_finite_module2 = _interopRequireDefault(_post_finite_module);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(dispatch, id, config) {
  dispatch(postFiniteActions.postFiniteLoading());
  return _post_finite_module2.default.fetch(id, config).then(function handlePostDetailData(resp) {
    dispatch(postFiniteActions.postFiniteLoaded(resp.data));
  }).catch(function handleUserError(err) {
    dispatch(postFiniteActions.postFiniteLoadError(err));
    _logger_service2.default.error(err, 'Error in post finite actions, message: ' + err.message);
  });
}

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postFiniteLoading = postFiniteLoading;
exports.postFiniteLoaded = postFiniteLoaded;
exports.postFiniteLoadError = postFiniteLoadError;
// import { canUseDOM } from 'exenv';

function postFiniteLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: 'POST_FINITE_LOADING',
    postFinite: resp
  };
}

function postFiniteLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: 'POST_FINITE_LOADED',
    postFinite: {
      posts: resp.posts
    }
  };
}

function postFiniteLoadError(error) {
  return {
    type: 'POST_FINITE_ERROR',
    postFinite: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    }
  };
}

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _remove = __webpack_require__(636);

var _remove2 = _interopRequireDefault(_remove);

var _set = __webpack_require__(42);

var _set2 = _interopRequireDefault(_set);

var _toNumber = __webpack_require__(65);

var _toNumber2 = _interopRequireDefault(_toNumber);

var _auth_util = __webpack_require__(16);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PostFiniteScrollModel = function (_Base) {
  _inherits(PostFiniteScrollModel, _Base);

  function PostFiniteScrollModel() {
    _classCallCheck(this, PostFiniteScrollModel);

    return _possibleConstructorReturn(this, (PostFiniteScrollModel.__proto__ || Object.getPrototypeOf(PostFiniteScrollModel)).apply(this, arguments));
  }

  _createClass(PostFiniteScrollModel, null, [{
    key: 'fetch',
    value: function fetch(id, config) {
      var cacheEnabled = (0, _get2.default)(config, 'cacheEnabled');
      var cacheExpire = (0, _get2.default)(config, 'cacheExpire');
      var cacheNamespace = (0, _get2.default)(config, 'cacheNamespace');
      var site = (0, _get2.default)(config, 'site');
      var host = (0, _get2.default)(config, 'apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(config, 'protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(config, 'authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)({ config: config }));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/' + site + '/post-finite';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      function removeId(resp) {
        var posts = (0, _get2.default)(resp, 'data.posts');
        (0, _remove2.default)(posts, { id: (0, _toNumber2.default)(id) });
        (0, _set2.default)(resp, 'data.posts', posts);
        return resp;
      }

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(removeId);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(removeId).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return PostFiniteScrollModel;
}(_base_model2.default);

exports.default = PostFiniteScrollModel;

/***/ }),
/* 636 */,
/* 637 */,
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _postpage_action_creators = __webpack_require__(242);

var postpageActions = _interopRequireWildcard(_postpage_action_creators);

var _async_post_actions = __webpack_require__(639);

var _async_post_actions2 = _interopRequireDefault(_async_post_actions);

var _async_post_video_actions = __webpack_require__(642);

var _async_post_video_actions2 = _interopRequireDefault(_async_post_video_actions);

var _async_post_more_stories_actions = __webpack_require__(645);

var _async_post_more_stories_actions2 = _interopRequireDefault(_async_post_more_stories_actions);

var _async_afterbody_recirc_module_type_actions = __webpack_require__(648);

var _async_afterbody_recirc_module_type_actions2 = _interopRequireDefault(_async_afterbody_recirc_module_type_actions);

var _not_found_status_action_creator = __webpack_require__(28);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _async_recirc_feed_actions = __webpack_require__(58);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(postpageActions.postpageLoading({}, store));

    var asyncPostActionsList = [(0, _async_afterbody_recirc_module_type_actions2.default)(params, store)(dispatch), (0, _async_post_actions2.default)(params, store)(dispatch), (0, _async_post_video_actions2.default)(params, store)(dispatch), (0, _async_post_more_stories_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)];

    return Promise.all(asyncPostActionsList).then(function handlePostDetailData() {
      dispatch(postpageActions.postpageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(postpageActions.postpageLoadError(err, store));
      _logger_service2.default.error(err, 'Error in post page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _exenv = __webpack_require__(4);

var _urlParse = __webpack_require__(50);

var _urlParse2 = _interopRequireDefault(_urlParse);

var _post_action_creators = __webpack_require__(640);

var postActions = _interopRequireWildcard(_post_action_creators);

var _post = __webpack_require__(641);

var _post2 = _interopRequireDefault(_post);

var _not_found_status_action_creator = __webpack_require__(28);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _redirect_action_creators = __webpack_require__(268);

var _redirect_action_creators2 = _interopRequireDefault(_redirect_action_creators);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();
    dispatch(postActions.postLoading({}, store));
    return _post2.default.fetch(params, store).then(function handlePostDetailData(PostData) {
      var isPreview = (0, _get2.default)(state, 'config.isPreview');
      var isAmp = (0, _get2.default)(state, 'config.amp');
      var postLink = (0, _get2.default)(PostData, 'data.post.link');
      var currentUrl = (0, _get2.default)(state, 'config.navHistory[0]');
      if (!_exenv.canUseDOM && postLink && !isPreview) {
        if (currentUrl !== postLink) {
          var parsedCurrent = new _urlParse2.default(currentUrl).pathname;
          var parsedPostLink = new _urlParse2.default(postLink).pathname;
          if (parsedCurrent !== parsedPostLink) {
            if (isAmp) {
              postLink = postLink.replace('www', 'amp');
            }
            dispatch((0, _redirect_action_creators2.default)({
              status: 301,
              redirect: postLink
            }));
          }
        }
      }

      dispatch(postActions.postLoaded(PostData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 400 || status === 403) {
        dispatch((0, _not_found_status_action_creator2.default)(403, 'UNPUBLISHED_STATUS', store));
      }
      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }
      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(postActions.postLoadError(err, store));
      _logger_service2.default.error(err, 'Error in post actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postLoading = postLoading;
exports.postLoaded = postLoaded;
exports.postLoadError = postLoadError;
// import { canUseDOM } from 'exenv';

function postLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_LOADING',
    post: resp,
    store: store
  };
}

function postLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_LOADED',
    post: resp,
    store: store
  };
}

function postLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_ERROR',
    post: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(16);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Post = function (_Base) {
  _inherits(Post, _Base);

  function Post() {
    _classCallCheck(this, Post);

    return _possibleConstructorReturn(this, (Post.__proto__ || Object.getPrototypeOf(Post)).apply(this, arguments));
  }

  _createClass(Post, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var id = _ref.id;

      var state = store.getState();
      var isPreview = (0, _get2.default)(state, 'config.isPreview');
      var amp = (0, _get2.default)(state, 'config.amp') ? '?amp=true' : '';
      var fbia = (0, _get2.default)(state, 'config.fbia') ? '?fbia=true' : '';
      var cacheEnabled = isPreview ? false : (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      var postRelatedSlug = isPreview ? 'preview-post-related' : 'post-related';
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = isPreview ? '' + protocol + host + '/api/v2/' + postRelatedSlug + '/' + site + '/' + id + amp + fbia : '' + protocol + host + '/api/v3/' + postRelatedSlug + '/' + site + '/' + id + amp + fbia;

      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return Post;
}(_base_model2.default);

exports.default = Post;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _post_video_action_creators = __webpack_require__(643);

var postVideoActions = _interopRequireWildcard(_post_video_action_creators);

var _post_video_module = __webpack_require__(644);

var _post_video_module2 = _interopRequireDefault(_post_video_module);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(postVideoActions.postVideoLoading({}, store));
    return _post_video_module2.default.fetch(params, store).then(function handlePostDetailData(resp) {
      dispatch(postVideoActions.postVideoLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(postVideoActions.postVideoLoadError(err, store));
      _logger_service2.default.error(err, 'Error in post video actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postVideoLoading = postVideoLoading;
exports.postVideoLoaded = postVideoLoaded;
exports.postVideoLoadError = postVideoLoadError;
// import { canUseDOM } from 'exenv';

function postVideoLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_VIDEO_LOADING',
    postVideo: resp,
    store: store
  };
}

function postVideoLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_VIDEO_LOADED',
    postVideo: resp,
    store: store
  };
}

function postVideoLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_VIDEO_ERROR',
    postVideo: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var homepageJwIdMap = {
  fastcompany: 'R6of2m4z',
  fastcodesign: 'mQZdMNHq'
};

var HomePageVideo = function (_Base) {
  _inherits(HomePageVideo, _Base);

  function HomePageVideo() {
    _classCallCheck(this, HomePageVideo);

    return _possibleConstructorReturn(this, (HomePageVideo.__proto__ || Object.getPrototypeOf(HomePageVideo)).apply(this, arguments));
  }

  _createClass(HomePageVideo, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var site = (0, _get2.default)(state, 'config.site');
      var id = (0, _get2.default)(homepageJwIdMap, site) || homepageJwIdMap.fastcompany;
      var host = 'content.jwplatform.com';
      var options = {};

      var cacheKeyUrl = 'https://' + host + '/feeds/' + id + '.json';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return HomePageVideo;
}(_base_model2.default);

exports.default = HomePageVideo;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _post_more_stories_action_creators = __webpack_require__(646);

var postMoreStoriesActions = _interopRequireWildcard(_post_more_stories_action_creators);

var _post_more_stories_module = __webpack_require__(647);

var _post_more_stories_module2 = _interopRequireDefault(_post_more_stories_module);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(postMoreStoriesActions.postMoreStoriesLoading({}, store));
    return _post_more_stories_module2.default.fetch(params, store).then(function handlePostDetailData(resp) {
      dispatch(postMoreStoriesActions.postMoreStoriesLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(postMoreStoriesActions.postMoreStoriesLoadError(err, store));
      _logger_service2.default.error(err, 'Error in post see more actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postMoreStoriesLoading = postMoreStoriesLoading;
exports.postMoreStoriesLoaded = postMoreStoriesLoaded;
exports.postMoreStoriesLoadError = postMoreStoriesLoadError;
// import { canUseDOM } from 'exenv';

function postMoreStoriesLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_MORE_STORIES_LOADING',
    postMoreStories: resp,
    store: store
  };
}

function postMoreStoriesLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_MORE_STORIES_LOADED',
    postMoreStories: resp,
    store: store
  };
}

function postMoreStoriesLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_MORE_STORIES_ERROR',
    postMoreStories: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(16);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PostSeeMoreModel = function (_Base) {
  _inherits(PostSeeMoreModel, _Base);

  function PostSeeMoreModel() {
    _classCallCheck(this, PostSeeMoreModel);

    return _possibleConstructorReturn(this, (PostSeeMoreModel.__proto__ || Object.getPrototypeOf(PostSeeMoreModel)).apply(this, arguments));
  }

  _createClass(PostSeeMoreModel, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/tag-homepage-feed/' + site + '?total=4';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return PostSeeMoreModel;
}(_base_model2.default);

exports.default = PostSeeMoreModel;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = afterbodyRecircModuleTypeAction;

var _post_afterbody_recirc_module_type_action_creators = __webpack_require__(649);

var afterbodyRecircModuleTypeActions = _interopRequireWildcard(_post_afterbody_recirc_module_type_action_creators);

var _afterbody_recirc_module_type = __webpack_require__(650);

var _afterbody_recirc_module_type2 = _interopRequireDefault(_afterbody_recirc_module_type);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function afterbodyRecircModuleTypeAction(params, store) {
  return function afterbodyRecircModuleTypeDispatch(dispatch) {
    dispatch(afterbodyRecircModuleTypeActions.afterbodyRecircModuleTypeLoading(store));
    return _afterbody_recirc_module_type2.default.fetch(params, store).then(function handleAfterbodyRecircModuleTypeData(resp) {
      dispatch(afterbodyRecircModuleTypeActions.afterbodyRecircModuleTypeLoaded(resp.data, store));
    }).catch(function handleAfterbodyRecircModuleTypeError(err) {
      dispatch(afterbodyRecircModuleTypeActions.afterbodyRecircModuleTypeLoadError(err, store));
      _logger_service2.default.error(err, 'Error in all feed actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.afterbodyRecircModuleTypeLoading = afterbodyRecircModuleTypeLoading;
exports.afterbodyRecircModuleTypeLoaded = afterbodyRecircModuleTypeLoaded;
exports.afterbodyRecircModuleTypeLoadError = afterbodyRecircModuleTypeLoadError;
// import { canUseDOM } from 'exenv';

function afterbodyRecircModuleTypeLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_AFTERBODY_RECIRC_MODULE_TYPE_LOADING',
    postAfterbodyRecircModule: resp,
    store: store
  };
}

function afterbodyRecircModuleTypeLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_AFTERBODY_RECIRC_MODULE_TYPE_LOADED',
    postAfterbodyRecircModule: resp,
    store: store
  };
}

function afterbodyRecircModuleTypeLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_AFTERBODY_RECIRC_MODULE_TYPE_ERROR',
    postAfterbodyRecircModule: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(16);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AfterbodyRecircModuleType = function (_Base) {
  _inherits(AfterbodyRecircModuleType, _Base);

  function AfterbodyRecircModuleType() {
    _classCallCheck(this, AfterbodyRecircModuleType);

    return _possibleConstructorReturn(this, (AfterbodyRecircModuleType.__proto__ || Object.getPrototypeOf(AfterbodyRecircModuleType)).apply(this, arguments));
  }

  _createClass(AfterbodyRecircModuleType, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/afterbody-recirc-module-type/' + site;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return AfterbodyRecircModuleType;
}(_base_model2.default);

exports.default = AfterbodyRecircModuleType;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/:id/:section/:slug',
    component: _post_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _postpage_state_manager2.default)(store)
  };
};

var _post_page = __webpack_require__(69);

var _post_page2 = _interopRequireDefault(_post_page);

var _postpage_state_manager = __webpack_require__(70);

var _postpage_state_manager2 = _interopRequireDefault(_postpage_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/:id/:section/:slug/:pageNumber',
    component: _post_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _postpage_state_manager2.default)(store)
  };
};

var _post_page = __webpack_require__(69);

var _post_page2 = _interopRequireDefault(_post_page);

var _postpage_state_manager = __webpack_require__(70);

var _postpage_state_manager2 = _interopRequireDefault(_postpage_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/pvw/:id/:slug',
    component: _post_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _postpage_state_manager2.default)(store)
  };
};

var _post_page = __webpack_require__(69);

var _post_page2 = _interopRequireDefault(_post_page);

var _postpage_state_manager = __webpack_require__(70);

var _postpage_state_manager2 = _interopRequireDefault(_postpage_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/pvw/:id/:section/:slug',
    component: _post_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _postpage_state_manager2.default)(store)
  };
};

var _post_page = __webpack_require__(69);

var _post_page2 = _interopRequireDefault(_post_page);

var _postpage_state_manager = __webpack_require__(70);

var _postpage_state_manager2 = _interopRequireDefault(_postpage_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 839)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'notFoundPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'post-page' },
        _react2.default.createElement(
          'article',
          { className: 'post__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('./not_found_page').default;
}

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/video/:slug/:id',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 840)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'videoPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'search' },
        _react2.default.createElement(_loading_spinner2.default, null)
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('./video_page').default;
}

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/videos/playlists',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 841)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'playlistIndexPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'video-page' },
        _react2.default.createElement(
          'article',
          { className: 'video-page__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('./playlist_index_page').default;
}

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/videos',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 842)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'videoIndex'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'video-page' },
        _react2.default.createElement(
          'article',
          { className: 'video-page__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('./video_index_page').default;
}

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/videos/playlist/:playlistTitle/:playlistId/:page?',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 843)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'playlistPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'video-page' },
        _react2.default.createElement(
          'article',
          { className: 'video-page__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('./playlist_page').default;
}

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/newsletters',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 844)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'newslettersPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'post-page' },
        _react2.default.createElement(
          'article',
          { className: 'post__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('./newsletters_page').default;
}

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/newsletters-preferences',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 845)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'newslettersPreferencesPage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'post-page' },
        _react2.default.createElement(
          'article',
          { className: 'post__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('./newsletters_preferences_page').default;
}

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var state = store.getState();

  if (state.config.site === 'fastcompany') {
    return [{
      path: '/technology/:tag?/:page?',
      component: _category_page2.default,
      exact: true,
      strict: true,
      loadData: (0, _category_page_state_manager2.default)(store, 'technology', IS_TAG)
    }, {
      path: '/leadership/:tag/:page?',
      component: _category_page2.default,
      exact: true,
      strict: true,
      loadData: (0, _category_page_state_manager2.default)(store, 'leadership', IS_TAG)
    }, {
      path: '/entertainment/:tag/:page?',
      component: _category_page2.default,
      exact: true,
      strict: true,
      loadData: (0, _category_page_state_manager2.default)(store, 'entertainment', IS_TAG)
    }, {
      path: '/ideas/:tag/:page?',
      component: _category_page2.default,
      exact: true,
      strict: true,
      loadData: (0, _category_page_state_manager2.default)(store, 'ideas', IS_TAG)
    }, {
      path: '/fast-cities/:page?',
      component: _category_page2.default,
      exact: true,
      strict: true,
      loadData: (0, _category_page_state_manager2.default)(store, 'fast-cities', IS_TAG)
    }];
  }
  return [{
    path: '/cities/:tag/:page?',
    component: _category_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'cities', IS_TAG)
  }, {
    path: '/graphics/:tag/:page?',
    component: _category_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'graphics', IS_TAG)
  }, {
    path: '/interactive/:tag/:page?',
    component: _category_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'interactive', IS_TAG)
  }, {
    path: '/products/:tag/:page?',
    component: _category_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'products', IS_TAG)
  }, {
    path: '/spaces/:tag/:page?',
    component: _category_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'spaces', IS_TAG)
  }];
};

var _category_page = __webpack_require__(138);

var _category_page2 = _interopRequireDefault(_category_page);

var _category_page_state_manager = __webpack_require__(68);

var _category_page_state_manager2 = _interopRequireDefault(_category_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IS_TAG = true;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/gift-guide/:slug',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 243)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'giftguide'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'innovation-by-design-page' },
        _react2.default.createElement(
          'article',
          { className: 'innovation-by-design-page__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('./gift_guide_page').default;
}

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPersonPage;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _gift_guide_page_action_creators = __webpack_require__(665);

var giftGuidePageActions = _interopRequireWildcard(_gift_guide_page_action_creators);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _not_found_status_action_creator = __webpack_require__(28);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _async_recirc_feed_actions = __webpack_require__(58);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _async_gift_guide_actions = __webpack_require__(666);

var _async_gift_guide_actions2 = _interopRequireDefault(_async_gift_guide_actions);

var _async_gift_guide_details_actions = __webpack_require__(669);

var _async_gift_guide_details_actions2 = _interopRequireDefault(_async_gift_guide_details_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPersonPage(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();
    if ((0, _get2.default)(state, 'config.site') !== 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }
    if (!params.category) {
      dispatch(giftGuidePageActions.giftGuidePageLoading({}, store));
    }
    return Promise.all([(0, _async_gift_guide_details_actions2.default)(params, store)(dispatch), (0, _async_gift_guide_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(giftGuidePageActions.giftGuidePageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      dispatch(giftGuidePageActions.giftGuidePageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.giftGuidePageLoading = giftGuidePageLoading;
exports.giftGuidePageLoaded = giftGuidePageLoaded;
exports.giftGuidePageLoadError = giftGuidePageLoadError;
// import { canUseDOM } from 'exenv';

function giftGuidePageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_GUIDE_PAGE_LOADING',
    giftGuidePage: resp,
    store: store
  };
}

function giftGuidePageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_GUIDE_PAGE_LOADED',
    giftGuidePage: resp,
    store: store
  };
}

function giftGuidePageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_GUIDE_PAGE_ERROR',
    giftGuidePage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchGiftGuideDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _gift_guide_action_creators = __webpack_require__(667);

var giftGuide = _interopRequireWildcard(_gift_guide_action_creators);

var _gift_guide_model = __webpack_require__(668);

var _gift_guide_model2 = _interopRequireDefault(_gift_guide_model);

var _not_found_status_action_creator = __webpack_require__(28);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchGiftGuideDetail(params, store) {
  return function firstDispatch(dispatch) {
    var idMapping = {
      'holiday-2017': 1
    };
    var requestParams = {
      id: idMapping[(0, _get2.default)(params, 'slug', 0)]
    };

    if (params.category) {
      requestParams.category = params.category;
    }

    return _gift_guide_model2.default.fetch(requestParams, store).then(function handleGiftGuideDetailData(GiftGuideData) {
      if (requestParams.category) {
        var hasGiftGuideGuideCategory = GiftGuideData.data.rows.filter(function (category) {
          return category.url === requestParams.category;
        }).length;

        if (!hasGiftGuideGuideCategory) {
          dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
        }
      }

      dispatch(giftGuide.giftGuideLoaded(GiftGuideData.data, store, requestParams.id));
    }).catch(function handleUserError(err) {
      if (err.message === 'Invalid Year') {
        _logger_service2.default.warn('User tried a most creative people page with invalid year.');
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
        return dispatch(giftGuide.giftGuideLoadError(err, store));
      }

      var status = (0, _get2.default)(err, 'response.status');

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(giftGuide.giftGuideLoadError(err, store));

      return _logger_service2.default.error(err, 'Error in giftGuide actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.giftGuideLoading = giftGuideLoading;
exports.giftGuideLoaded = giftGuideLoaded;
exports.giftGuideLoadError = giftGuideLoadError;
// import { canUseDOM } from 'exenv';

function giftGuideLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_GUIDE_LOADING',
    giftGuide: resp,
    store: store
  };
}

function giftGuideLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var year = arguments[2];

  return {
    type: 'GIFT_GUIDE_LOADED',
    giftGuide: resp,
    store: store,
    year: year
  };
}

function giftGuideLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_GUIDE_ERROR',
    giftGuide: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GiftGuide = function (_Base) {
  _inherits(GiftGuide, _Base);

  function GiftGuide() {
    _classCallCheck(this, GiftGuide);

    return _possibleConstructorReturn(this, (GiftGuide.__proto__ || Object.getPrototypeOf(GiftGuide)).apply(this, arguments));
  }

  _createClass(GiftGuide, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var id = _ref.id;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = 'api.fastcompany.com';
      var options = {};
      // https://api.fastcompany.com/v1/packages/person/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=steve-jobs

      // Don't worry about this token. Can be public. Talked to Harry.
      var cacheKeyUrl = 'https://' + host + '/v1/packages/gifts/' + id + '/categories/top/50?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return GiftGuide;
}(_base_model2.default);

exports.default = GiftGuide;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchGiftGuideDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _gift_guide_details_action_creators = __webpack_require__(670);

var giftGuide = _interopRequireWildcard(_gift_guide_details_action_creators);

var _gift_guide_detail_model = __webpack_require__(671);

var _gift_guide_detail_model2 = _interopRequireDefault(_gift_guide_detail_model);

var _not_found_status_action_creator = __webpack_require__(28);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchGiftGuideDetail(params, store) {
  return function firstDispatch(dispatch) {
    return _gift_guide_detail_model2.default.fetch(params, store).then(function handleGiftGuideDetailData(GiftGuideData) {
      dispatch(giftGuide.giftGuideDetailLoaded(GiftGuideData.data, store, params.year));
    }).catch(function handleUserError(err) {
      if (err.message === 'Invalid Year') {
        _logger_service2.default.warn('User tried a most creative people page with invalid year.');
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
        return dispatch(giftGuide.giftGuideDetailLoadError(err, store));
      }

      var status = (0, _get2.default)(err, 'response.status');

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(giftGuide.giftGuideDetailLoadError(err, store));

      return _logger_service2.default.error(err, 'Error in giftGuideDetail actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.giftGuideDetailLoading = giftGuideDetailLoading;
exports.giftGuideDetailLoaded = giftGuideDetailLoaded;
exports.giftGuideDetailLoadError = giftGuideDetailLoadError;
// import { canUseDOM } from 'exenv';

function giftGuideDetailLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_GUIDE_DETAIL_LOADING',
    giftGuideDetail: resp,
    store: store
  };
}

function giftGuideDetailLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var year = arguments[2];

  return {
    type: 'GIFT_GUIDE_DETAIL_LOADED',
    giftGuideDetail: resp,
    store: store,
    year: year
  };
}

function giftGuideDetailLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_GUIDE_DETAIL_ERROR',
    giftGuideDetail: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(12);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(13);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(14);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GiftGuide = function (_Base) {
  _inherits(GiftGuide, _Base);

  function GiftGuide() {
    _classCallCheck(this, GiftGuide);

    return _possibleConstructorReturn(this, (GiftGuide.__proto__ || Object.getPrototypeOf(GiftGuide)).apply(this, arguments));
  }

  _createClass(GiftGuide, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var slug = _ref.slug;

      var idMapping = {
        'holiday-2017': 1
      };

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = 'api.fastcompany.com';
      var options = {};
      // https://api.fastcompany.com/v1/packages/person/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=steve-jobs

      // Don't worry about this token. Can be public. Talked to Harry.
      var cacheKeyUrl = 'https://' + host + '/v1/packages/gifts/' + idMapping[slug] + '/details?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return Promise.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return GiftGuide;
}(_base_model2.default);

exports.default = GiftGuide;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/gift-guide/:slug/category/:category',
    component: _gift_guide_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _gift_guide_page_state_manager2.default)(store),
    autoScrollOff: true
  };
};

var _gift_guide_page = __webpack_require__(243);

var _gift_guide_page2 = _interopRequireDefault(_gift_guide_page);

var _gift_guide_page_state_manager = __webpack_require__(244);

var _gift_guide_page_state_manager2 = _interopRequireDefault(_gift_guide_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var routeConfig = {
    path: '/gift/:product',
    component: function component() {
      if (Component) {
        return _react2.default.createElement(Component, null);
      }

      return _react2.default.createElement(LazyComponent, null);
    },

    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk: function preloadChunk() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 846)).then(function (resp) {
        Component = resp.default;
        routeConfig.loadData = Component.loadData(store);
        return Component;
      });
    },

    chunk: 'giftpage'
  };

  var LazyComponent = (0, _reactLoadable2.default)({
    loader: function loader() {
      return routeConfig.preloadChunk();
    },
    loading: function loading() {
      return _react2.default.createElement(
        'section',
        { className: 'innovation-by-design-page' },
        _react2.default.createElement(
          'article',
          { className: 'innovation-by-design-page__main' },
          _react2.default.createElement(_loading_spinner2.default, null)
        )
      );
    }
  });

  return routeConfig;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(9);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _loading_spinner = __webpack_require__(6);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = false;

if (false) {
  // eslint-disable-next-line global-require
  Component = require('./gift_page').default;
}

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(15);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _reactHelmet = __webpack_require__(162);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _script = __webpack_require__(228);

var _script2 = _interopRequireDefault(_script);

var _style = __webpack_require__(675);

var _style2 = _interopRequireDefault(_style);

var _noscript = __webpack_require__(676);

var _noscript2 = _interopRequireDefault(_noscript);

var _critical_css = __webpack_require__(245);

var _critical_css2 = _interopRequireDefault(_critical_css);

var _dev_css = __webpack_require__(677);

var _dev_css2 = _interopRequireDefault(_dev_css);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ClientSideHead(initialPageLoad, attr) {
  if (!initialPageLoad) {
    return _react2.default.createElement(_reactHelmet2.default, attr);
  }
  return null;
}

function PreloadJS(_ref) {
  var props = _ref.props;
  var env = props.env;


  if (env === 'production') {
    return [_react2.default.createElement('link', {
      key: 'gpt',
      rel: 'preload',
      href: 'https://www.googletagservices.com/tag/js/gpt.js',
      as: 'script'
    }), _react2.default.createElement('link', {
      key: 'vendor',
      rel: 'preload',
      href: props.staticVendorUrl + '/' + props.manifestJSON['vendor.js'],
      as: 'script'
    }), _react2.default.createElement('link', {
      key: 'app',
      rel: 'preload',
      href: props.staticBundleUrl + '/js/' + props.manifestJSON['app.js'],
      as: 'script'
    })];
  }

  if (env === 'test') {
    return [_react2.default.createElement('link', {
      key: 'gpt',
      rel: 'preload',
      href: 'https://www.googletagservices.com/tag/js/gpt.js',
      as: 'script'
    }), _react2.default.createElement('link', {
      key: 'vendor',
      rel: 'preload',
      href: '/js/' + props.manifestJSON['vendor.js'],
      as: 'script'
    }), _react2.default.createElement('link', {
      key: 'app',
      rel: 'preload',
      href: '/js/' + props.manifestJSON['app.js'],
      as: 'script'
    })];
  }
  return null;
}

function Head(props) {
  var meta = (0, _get2.default)(props, 'meta.meta') || [];
  var link = (0, _get2.default)(props, 'meta.link') || [];
  var script = (0, _get2.default)(props, 'meta.script') || [];
  var noscript = (0, _get2.default)(props, 'meta.noscript') || [];
  var style = (0, _get2.default)(props, 'meta.style') || [];
  var title = (0, _get2.default)(props, 'meta.title');

  var staticPath = 'https://images.fastcompany.net/multisite_files/fastcompany/static/sites/fonts/201010';

  // meta.push({'httpEquiv': 'Content-Type', 'content': 'text/html; charset=utf-8'});
  // meta.push({ charSet: 'UTF-8' });

  // On initial render Helmet has a bug: https://github.com/nfl/react-helmet/issues/98
  return _react2.default.createElement(
    'head',
    {
      prefix: 'og: http://ogp.me/ns# fb: http://ogp.me/ns/fb# article: http://ogp.me/ns/article#',
      lang: 'en'
    },
    _react2.default.createElement('meta', { charset: 'utf-8' }),
    _react2.default.createElement(
      'title',
      null,
      title
    ),
    meta.map(function createMetaTags(conf) {
      return _react2.default.createElement('meta', _extends({ key: JSON.stringify(conf) }, conf));
    }),
    _react2.default.createElement('link', { rel: 'dns-prefetch', href: props.staticUrl }),
    _react2.default.createElement(PreloadJS, { props: props }),
    _react2.default.createElement('link', {
      rel: 'preload',
      as: 'font',
      crossOrigin: 'crossorigin',
      type: 'font/woff',
      href: staticPath + '/fc-app-2017/fc-icons/fc-icon11.woff?pa1lh4'
    }),
    _react2.default.createElement('link', {
      rel: 'preload',
      as: 'font',
      crossOrigin: 'crossorigin',
      type: 'font/woff',
      href: staticPath + '/fc-app-2017/fczizou/FCZizouSans-Regular-Web.woff'
    }),
    _react2.default.createElement('link', {
      rel: 'preload',
      as: 'font',
      crossOrigin: 'crossorigin',
      type: 'font/woff',
      href: staticPath + '/fc-app-2017/fczizou/FCZizouSans-Medium-Web.woff'
    }),
    _react2.default.createElement('link', {
      rel: 'preload',
      as: 'font',
      crossOrigin: 'crossorigin',
      type: 'font/woff',
      href: staticPath + '/fc-app-2017/fczizou/FCZizouSans-Bold-Web.woff'
    }),
    _react2.default.createElement('link', {
      rel: 'preload',
      as: 'font',
      crossOrigin: 'crossorigin',
      type: 'font/woff',
      href: staticPath + '/fc-app-2017/fczizou/FCZizouSans-Black-Web.woff'
    }),
    _react2.default.createElement('link', {
      rel: 'preload',
      as: 'font',
      crossOrigin: 'crossorigin',
      type: 'font/woff',
      href: staticPath + '/fc-app-2017/fckaiser/FCKaiser-Medium-Web.woff'
    }),
    _react2.default.createElement('link', {
      rel: 'preload',
      as: 'font',
      crossOrigin: 'crossorigin',
      type: 'font/woff',
      href: staticPath + '/fc-app-2017/fckaiser/FCKaiser-Bold-Web.woff'
    }),
    _react2.default.createElement(_critical_css2.default, null),
    _react2.default.createElement(_dev_css2.default, null),
    _react2.default.createElement('script', { src: 'https://www.googletagservices.com/tag/js/gpt.js', async: true }),
    link.map(function createLinkTags(conf) {
      return _react2.default.createElement('link', _extends({ key: JSON.stringify(conf) }, conf));
    }),
    script.map(function createScriptTags(conf) {
      return _react2.default.createElement(_script2.default, _extends({ key: JSON.stringify(conf) }, conf));
    }),
    noscript.map(function createNoScriptTags(conf) {
      return _react2.default.createElement(_noscript2.default, _extends({ key: JSON.stringify(conf) }, conf));
    }),
    style.map(function createStyleTags(conf) {
      return _react2.default.createElement(_style2.default, _extends({ key: JSON.stringify(conf) }, conf));
    }),
    ClientSideHead(props.initialPageLoad, {
      title: title,
      meta: meta,
      link: link,
      script: script,
      noscript: noscript,
      style: style
    })
  );
}

function mapStateToProps(state) {
  return {
    env: state.config.env,
    staticUrl: state.config.staticUrl,
    manifestJSON: state.config.manifestJSON,
    staticVendorUrl: state.config.staticVendorUrl,
    staticBundleUrl: state.config.staticBundleUrl,
    meta: state.meta,
    initialPageLoad: state.config.initialPageLoad
  };
}

Head.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  env: _propTypes2.default.string.isRequired,
  staticUrl: _propTypes2.default.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  manifestJSON: _propTypes2.default.shape({
    'vendor.js': _propTypes2.default.string,
    'app.js': _propTypes2.default.string
  }).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  staticBundleUrl: _propTypes2.default.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  staticVendorUrl: _propTypes2.default.string.isRequired,
  initialPageLoad: _propTypes2.default.bool.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  meta: _propTypes2.default.shape({}).isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Head);

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Style;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Style(_ref) {
  var innerHtml = _ref.innerHtml;

  if (!innerHtml) {
    return null;
  }
  return _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: innerHtml } });
}

Style.defaultProps = {
  innerHtml: ''
};

Style.propTypes = {
  innerHtml: _propTypes2.default.string
};

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Noscript;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Noscript(_ref) {
  var innerHtml = _ref.innerHtml;

  if (!innerHtml) {
    return null;
  }
  return _react2.default.createElement('noscript', { dangerouslySetInnerHTML: { __html: innerHtml } });
}

Noscript.defaultProps = {
  innerHtml: ''
};

Noscript.propTypes = {
  innerHtml: _propTypes2.default.string
};

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DevStyles = function (_Component) {
  _inherits(DevStyles, _Component);

  function DevStyles() {
    _classCallCheck(this, DevStyles);

    return _possibleConstructorReturn(this, (DevStyles.__proto__ || Object.getPrototypeOf(DevStyles)).apply(this, arguments));
  }

  _createClass(DevStyles, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.shouldRender) {
        return null;
      }

      return _react2.default.createElement('link', { href: this.props.staticUrl + '/css/main.css', rel: 'stylesheet' });
    }
  }]);

  return DevStyles;
}(_react.Component);

DevStyles.propTypes = {
  staticUrl: _propTypes2.default.string.isRequired,
  shouldRender: _propTypes2.default.bool.isRequired
};

function mapStateToProps(state) {
  return {
    shouldRender: state.config.env === 'development',
    staticUrl: state.config.staticUrl
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DevStyles);

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(15);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _critical_css = __webpack_require__(245);

var _critical_css2 = _interopRequireDefault(_critical_css);

var _amp_styles = __webpack_require__(679);

var _amp_styles2 = _interopRequireDefault(_amp_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// function DevReloading(props) {
//   if (props.env === 'development') {
//     return (
//       <script
//         dangerouslySetInnerHTML={{
//           __html: `setTimeout(function(){window.location.reload();}, 60000);`
//         }}
//       />
//     );
//   }
//
//   return null;
// }

function Head(props) {
  var meta = (0, _get2.default)(props, 'meta.meta') || [];
  var link = (0, _get2.default)(props, 'meta.link') || [];
  var script = (0, _get2.default)(props, 'meta.script') || [];
  var title = (0, _get2.default)(props, 'meta.title');

  return _react2.default.createElement(
    'head',
    null,
    _react2.default.createElement('meta', { charset: 'utf-8' }),
    _react2.default.createElement('meta', {
      'http-equiv': 'origin-trial',
      content: 'AjQkyiCgG5iPFdJnbc/BHOxiJXzCd8tS1qO2BPNmUcjPhqTAlpCqguyW04T5U5JUik+rrEV/zE5+dMa+k3KT5gYAAABneyJvcmlnaW4iOiJodHRwczovL2Nkbi5hbXBwcm9qZWN0Lm9yZzo0NDMiLCJmZWF0dXJlIjoiV2ViU2hhcmUiLCJleHBpcnkiOjE0ODg4MTA2NjQsImlzU3ViZG9tYWluIjp0cnVlfQ=='
    }),
    _react2.default.createElement('link', { rel: 'canonical', href: props.canonical }),
    _react2.default.createElement('meta', {
      name: 'viewport',
      content: 'width=device-width,minimum-scale=1,initial-scale=1'
    }),
    _react2.default.createElement(
      'title',
      null,
      title
    ),
    _react2.default.createElement(_amp_styles2.default, null),
    meta.map(function createMetaTags(conf) {
      return _react2.default.createElement('meta', _extends({ key: JSON.stringify(conf) }, conf));
    }),
    link.map(function createLinkTags(conf) {
      return _react2.default.createElement('link', _extends({ key: JSON.stringify(conf) }, conf));
    }),
    _react2.default.createElement(_critical_css2.default, { amp: true }),
    _react2.default.createElement('script', { async: true, src: 'https://cdn.ampproject.org/v0.js' }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-ad',
      src: 'https://cdn.ampproject.org/v0/amp-ad-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-analytics',
      src: 'https://cdn.ampproject.org/v0/amp-analytics-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-iframe',
      src: 'https://cdn.ampproject.org/v0/amp-iframe-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-twitter',
      src: 'https://cdn.ampproject.org/v0/amp-twitter-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-instagram',
      src: 'https://cdn.ampproject.org/v0/amp-instagram-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-facebook',
      src: 'https://cdn.ampproject.org/v0/amp-facebook-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-youtube',
      src: 'https://cdn.ampproject.org/v0/amp-youtube-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-vimeo',
      src: 'https://cdn.ampproject.org/v0/amp-vimeo-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-sticky-ad',
      src: 'https://cdn.ampproject.org/v0/amp-sticky-ad-1.0.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-carousel',
      src: 'https://cdn.ampproject.org/v0/amp-carousel-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-anim',
      src: 'https://cdn.ampproject.org/v0/amp-anim-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-jwplayer',
      src: 'https://cdn.ampproject.org/v0/amp-jwplayer-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-sidebar',
      src: 'https://cdn.ampproject.org/v0/amp-sidebar-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-fit-text',
      src: 'https://cdn.ampproject.org/v0/amp-fit-text-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-social-share',
      src: 'https://cdn.ampproject.org/v0/amp-social-share-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-video',
      src: 'https://cdn.ampproject.org/v0/amp-video-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-audio',
      src: 'https://cdn.ampproject.org/v0/amp-audio-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-fx-flying-carpet',
      src: 'https://cdn.ampproject.org/v0/amp-fx-flying-carpet-0.1.js'
    })
  );
}

function mapStateToProps(state) {
  return {
    env: state.config.env,
    canonical: state.config.navHistory[0].split('?')[0],
    staticUrl: state.config.staticUrl,
    meta: state.meta,
    initialPageLoad: state.config.initialPageLoad
  };
}

Head.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  meta: _propTypes2.default.shape({}).isRequired,
  canonical: _propTypes2.default.string.isRequired
  // env: PropTypes.string.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Head);

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AmpStyleBoilerplate;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AmpStyleBoilerplate() {
  return [_react2.default.createElement("style", {
    "amp-boilerplate": "",
    dangerouslySetInnerHTML: {
      __html: "body{-webkit-animation:-amp-start 8s steps(1,end) 0s 1 normal both;-moz-animation:-amp-start 8s steps(1,end) 0s 1 normal both;-ms-animation:-amp-start 8s steps(1,end) 0s 1 normal both;animation:-amp-start 8s steps(1,end) 0s 1 normal both}@-webkit-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-moz-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-ms-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-o-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}"
    }
  }), _react2.default.createElement("noscript", {
    dangerouslySetInnerHTML: {
      __html: "<style amp-boilerplate=\"\">body{-webkit-animation:none;-moz-animation:none;-ms-animation:none;animation:none}</style>"
    }
  })];
}

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Head(props) {
  return _react2.default.createElement(
    'head',
    null,
    _react2.default.createElement('meta', { charset: 'utf-8' }),
    _react2.default.createElement('meta', { property: 'op:markup_version', content: 'v1.0' }),
    _react2.default.createElement('link', { rel: 'canonical', href: props.canonical }),
    _react2.default.createElement('meta', { name: 'robots', content: 'noindex' }),
    _react2.default.createElement('meta', { property: 'fb:use_automatic_ad_placement', content: 'true' }),
    _react2.default.createElement('link', { rel: 'stylesheet', title: 'default', href: '#' })
  );
}

function mapStateToProps(state) {
  return {
    canonical: state.config.navHistory[0].split('?')[0],
    staticUrl: state.config.staticUrl,
    meta: state.meta,
    initialPageLoad: state.config.initialPageLoad
  };
}

Head.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  meta: _propTypes2.default.shape({}).isRequired,
  canonical: _propTypes2.default.string.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Head);

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _exenv = __webpack_require__(4);

__webpack_require__(1).PropTypes = __webpack_require__(2);

// https://gist.github.com/gaearon/9a4d54653ae9c50af6c54b4e0e56b583#javascript-environment-requirements
if (!_exenv.canUseDOM) {
  global.requestAnimationFrame = function raf(callback) {
    setTimeout(callback, 0);
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// import P from 'bluebird';
// window.Promise = P;
// eslint-disable-next-line no-underscore-dangle, no-undef
window._LTracker = [];
// eslint-disable-next-line no-underscore-dangle
window._LTracker.push({
  logglyKey: 'd95daaf3-a943-48f4-8687-cd0c6696f50b',
  sendConsoleErrors: false,
  tag: 'fc-app-browser-logger'
});
// window.Promise.longStackTraces();

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = __webpack_require__(74);

var _reduxThunk = __webpack_require__(218);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reactRouterRedux = __webpack_require__(51);

var _reducers = __webpack_require__(684);

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://raw.githubusercontent.com/reactjs/react-router-redux/master/examples/server/store.js
function configureStore(history) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var env = arguments[2];

  // eslint-disable-next-line import/no-mutable-exports
  var store = {};

  // eslint-disable-next-line no-param-reassign
  initialState.config.initialQueryParams = JSON.parse(initialState.config.initialQueryParams);

  if (env !== 'development') {
    store = (0, _redux.createStore)(_reducers2.default, initialState, (0, _redux.compose)((0, _redux.applyMiddleware)((0, _reactRouterRedux.routerMiddleware)(history)), (0, _redux.applyMiddleware)(_reduxThunk2.default)));
  } else {
    var composeEnhancers =
    // eslint-disable-next-line no-underscore-dangle, max-len
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
    store = (0, _redux.createStore)(_reducers2.default, initialState, composeEnhancers((0, _redux.applyMiddleware)((0, _reactRouterRedux.routerMiddleware)(history)), (0, _redux.applyMiddleware)(_reduxThunk2.default)));
  }

  if (false) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', function () {
      // eslint-disable-next-line global-require
      var nextReducer = require('../reducers').default;
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}
// https://github.com/gaearon/redux-thunk

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(74);

var _reactRouterRedux = __webpack_require__(51);

var _homepage_reducer = __webpack_require__(685);

var _homepage_reducer2 = _interopRequireDefault(_homepage_reducer);

var _scrolling_module_reducer = __webpack_require__(686);

var _scrolling_module_reducer2 = _interopRequireDefault(_scrolling_module_reducer);

var _promo_banner_reducer = __webpack_require__(687);

var _promo_banner_reducer2 = _interopRequireDefault(_promo_banner_reducer);

var _all_feed_reducer = __webpack_require__(688);

var _all_feed_reducer2 = _interopRequireDefault(_all_feed_reducer);

var _featured_feed_reducer = __webpack_require__(689);

var _featured_feed_reducer2 = _interopRequireDefault(_featured_feed_reducer);

var _homepage_tag_reducer = __webpack_require__(690);

var _homepage_tag_reducer2 = _interopRequireDefault(_homepage_tag_reducer);

var _homepage_video_reducer = __webpack_require__(691);

var _homepage_video_reducer2 = _interopRequireDefault(_homepage_video_reducer);

var _featured_sponsored_card_reducer = __webpack_require__(692);

var _featured_sponsored_card_reducer2 = _interopRequireDefault(_featured_sponsored_card_reducer);

var _postpage_reducer = __webpack_require__(693);

var _postpage_reducer2 = _interopRequireDefault(_postpage_reducer);

var _post_reducer = __webpack_require__(694);

var _post_reducer2 = _interopRequireDefault(_post_reducer);

var _post_video_reducer = __webpack_require__(695);

var _post_video_reducer2 = _interopRequireDefault(_post_video_reducer);

var _post_finite_reducer = __webpack_require__(696);

var _post_finite_reducer2 = _interopRequireDefault(_post_finite_reducer);

var _post_afterbody_recirc_module_type_reducer = __webpack_require__(697);

var _post_afterbody_recirc_module_type_reducer2 = _interopRequireDefault(_post_afterbody_recirc_module_type_reducer);

var _post_more_stories_reducer = __webpack_require__(698);

var _post_more_stories_reducer2 = _interopRequireDefault(_post_more_stories_reducer);

var _video_page_reducer = __webpack_require__(699);

var _video_page_reducer2 = _interopRequireDefault(_video_page_reducer);

var _video_index_page_reducer = __webpack_require__(700);

var _video_index_page_reducer2 = _interopRequireDefault(_video_index_page_reducer);

var _jw_video_reducer = __webpack_require__(701);

var _jw_video_reducer2 = _interopRequireDefault(_jw_video_reducer);

var _jw_related_video_reducer = __webpack_require__(702);

var _jw_related_video_reducer2 = _interopRequireDefault(_jw_related_video_reducer);

var _jw_newest_video_reducer = __webpack_require__(703);

var _jw_newest_video_reducer2 = _interopRequireDefault(_jw_newest_video_reducer);

var _jw_playlist_reducer = __webpack_require__(704);

var _jw_playlist_reducer2 = _interopRequireDefault(_jw_playlist_reducer);

var _jw_playlist_index_reducer = __webpack_require__(705);

var _jw_playlist_index_reducer2 = _interopRequireDefault(_jw_playlist_index_reducer);

var _playlist_index_page_reducer = __webpack_require__(706);

var _playlist_index_page_reducer2 = _interopRequireDefault(_playlist_index_page_reducer);

var _playlist_page_reducer = __webpack_require__(707);

var _playlist_page_reducer2 = _interopRequireDefault(_playlist_page_reducer);

var _playlist_all_feed_reducer = __webpack_require__(708);

var _playlist_all_feed_reducer2 = _interopRequireDefault(_playlist_all_feed_reducer);

var _category_page_reducer = __webpack_require__(709);

var _category_page_reducer2 = _interopRequireDefault(_category_page_reducer);

var _category_featured_feed_reducer = __webpack_require__(710);

var _category_featured_feed_reducer2 = _interopRequireDefault(_category_featured_feed_reducer);

var _category_video_reducer = __webpack_require__(711);

var _category_video_reducer2 = _interopRequireDefault(_category_video_reducer);

var _category_all_feed_reducer = __webpack_require__(712);

var _category_all_feed_reducer2 = _interopRequireDefault(_category_all_feed_reducer);

var _category_scrolling_module_reducer = __webpack_require__(713);

var _category_scrolling_module_reducer2 = _interopRequireDefault(_category_scrolling_module_reducer);

var _category_promo_banner_reducer = __webpack_require__(714);

var _category_promo_banner_reducer2 = _interopRequireDefault(_category_promo_banner_reducer);

var _tag_page_reducer = __webpack_require__(715);

var _tag_page_reducer2 = _interopRequireDefault(_tag_page_reducer);

var _tag_featured_feed_reducer = __webpack_require__(716);

var _tag_featured_feed_reducer2 = _interopRequireDefault(_tag_featured_feed_reducer);

var _tag_video_reducer = __webpack_require__(717);

var _tag_video_reducer2 = _interopRequireDefault(_tag_video_reducer);

var _tag_all_feed_reducer = __webpack_require__(718);

var _tag_all_feed_reducer2 = _interopRequireDefault(_tag_all_feed_reducer);

var _tag_scrolling_module_reducer = __webpack_require__(719);

var _tag_scrolling_module_reducer2 = _interopRequireDefault(_tag_scrolling_module_reducer);

var _tag_promo_banner_reducer = __webpack_require__(720);

var _tag_promo_banner_reducer2 = _interopRequireDefault(_tag_promo_banner_reducer);

var _magazine_archive_page_reducer = __webpack_require__(721);

var _magazine_archive_page_reducer2 = _interopRequireDefault(_magazine_archive_page_reducer);

var _magazine_archive_reducer = __webpack_require__(722);

var _magazine_archive_reducer2 = _interopRequireDefault(_magazine_archive_reducer);

var _magazine_issue_posts_reducer = __webpack_require__(723);

var _magazine_issue_posts_reducer2 = _interopRequireDefault(_magazine_issue_posts_reducer);

var _magazine_latest_issue_posts_reducer = __webpack_require__(724);

var _magazine_latest_issue_posts_reducer2 = _interopRequireDefault(_magazine_latest_issue_posts_reducer);

var _person_page_reducer = __webpack_require__(725);

var _person_page_reducer2 = _interopRequireDefault(_person_page_reducer);

var _person_reducer = __webpack_require__(726);

var _person_reducer2 = _interopRequireDefault(_person_reducer);

var _person_index_page_reducer = __webpack_require__(727);

var _person_index_page_reducer2 = _interopRequireDefault(_person_index_page_reducer);

var _product_page_reducer = __webpack_require__(728);

var _product_page_reducer2 = _interopRequireDefault(_product_page_reducer);

var _product_reducer = __webpack_require__(729);

var _product_reducer2 = _interopRequireDefault(_product_reducer);

var _product_index_page_reducer = __webpack_require__(730);

var _product_index_page_reducer2 = _interopRequireDefault(_product_index_page_reducer);

var _innovation_by_design_page_reducer = __webpack_require__(731);

var _innovation_by_design_page_reducer2 = _interopRequireDefault(_innovation_by_design_page_reducer);

var _innovation_by_design_reducer = __webpack_require__(732);

var _innovation_by_design_reducer2 = _interopRequireDefault(_innovation_by_design_reducer);

var _innovation_by_design_details_reducer = __webpack_require__(733);

var _innovation_by_design_details_reducer2 = _interopRequireDefault(_innovation_by_design_details_reducer);

var _innovation_by_design_featured_feed_reducer = __webpack_require__(734);

var _innovation_by_design_featured_feed_reducer2 = _interopRequireDefault(_innovation_by_design_featured_feed_reducer);

var _innovation_by_design_scrolling_module_reducer = __webpack_require__(735);

var _innovation_by_design_scrolling_module_reducer2 = _interopRequireDefault(_innovation_by_design_scrolling_module_reducer);

var _gift_guide_page_reducer = __webpack_require__(736);

var _gift_guide_page_reducer2 = _interopRequireDefault(_gift_guide_page_reducer);

var _gift_guide_reducer = __webpack_require__(737);

var _gift_guide_reducer2 = _interopRequireDefault(_gift_guide_reducer);

var _gift_guide_details_reducer = __webpack_require__(738);

var _gift_guide_details_reducer2 = _interopRequireDefault(_gift_guide_details_reducer);

var _gift_page_reducer = __webpack_require__(739);

var _gift_page_reducer2 = _interopRequireDefault(_gift_page_reducer);

var _gift_reducer = __webpack_require__(740);

var _gift_reducer2 = _interopRequireDefault(_gift_reducer);

var _person_index_section_page_reducer = __webpack_require__(741);

var _person_index_section_page_reducer2 = _interopRequireDefault(_person_index_section_page_reducer);

var _person_index_section_reducer = __webpack_require__(742);

var _person_index_section_reducer2 = _interopRequireDefault(_person_index_section_reducer);

var _person_index_section_next_reducer = __webpack_require__(743);

var _person_index_section_next_reducer2 = _interopRequireDefault(_person_index_section_next_reducer);

var _product_index_section_page_reducer = __webpack_require__(744);

var _product_index_section_page_reducer2 = _interopRequireDefault(_product_index_section_page_reducer);

var _product_index_section_reducer = __webpack_require__(745);

var _product_index_section_reducer2 = _interopRequireDefault(_product_index_section_reducer);

var _product_index_section_next_reducer = __webpack_require__(746);

var _product_index_section_next_reducer2 = _interopRequireDefault(_product_index_section_next_reducer);

var _most_creative_people_page_reducer = __webpack_require__(747);

var _most_creative_people_page_reducer2 = _interopRequireDefault(_most_creative_people_page_reducer);

var _most_creative_people_reducer = __webpack_require__(748);

var _most_creative_people_reducer2 = _interopRequireDefault(_most_creative_people_reducer);

var _most_creative_people_featured_feed_reducer = __webpack_require__(749);

var _most_creative_people_featured_feed_reducer2 = _interopRequireDefault(_most_creative_people_featured_feed_reducer);

var _most_creative_people_scrolling_module_reducer = __webpack_require__(750);

var _most_creative_people_scrolling_module_reducer2 = _interopRequireDefault(_most_creative_people_scrolling_module_reducer);

var _most_creative_people_community_page_reducer = __webpack_require__(751);

var _most_creative_people_community_page_reducer2 = _interopRequireDefault(_most_creative_people_community_page_reducer);

var _most_creative_people_community_section_page_reducer = __webpack_require__(752);

var _most_creative_people_community_section_page_reducer2 = _interopRequireDefault(_most_creative_people_community_section_page_reducer);

var _most_creative_people_community_section_reducer = __webpack_require__(753);

var _most_creative_people_community_section_reducer2 = _interopRequireDefault(_most_creative_people_community_section_reducer);

var _most_creative_people_community_section_next_reducer = __webpack_require__(754);

var _most_creative_people_community_section_next_reducer2 = _interopRequireDefault(_most_creative_people_community_section_next_reducer);

var _company_page_reducer = __webpack_require__(755);

var _company_page_reducer2 = _interopRequireDefault(_company_page_reducer);

var _company_reducer = __webpack_require__(756);

var _company_reducer2 = _interopRequireDefault(_company_reducer);

var _company_data_reducer = __webpack_require__(757);

var _company_data_reducer2 = _interopRequireDefault(_company_data_reducer);

var _company_awards_reducer = __webpack_require__(758);

var _company_awards_reducer2 = _interopRequireDefault(_company_awards_reducer);

var _company_index_groups_reducer = __webpack_require__(759);

var _company_index_groups_reducer2 = _interopRequireDefault(_company_index_groups_reducer);

var _company_index_section_page_reducer = __webpack_require__(760);

var _company_index_section_page_reducer2 = _interopRequireDefault(_company_index_section_page_reducer);

var _company_index_section_reducer = __webpack_require__(761);

var _company_index_section_reducer2 = _interopRequireDefault(_company_index_section_reducer);

var _company_index_section_next_reducer = __webpack_require__(762);

var _company_index_section_next_reducer2 = _interopRequireDefault(_company_index_section_next_reducer);

var _company_index_page_reducer = __webpack_require__(763);

var _company_index_page_reducer2 = _interopRequireDefault(_company_index_page_reducer);

var _mic_year_page_reducer = __webpack_require__(764);

var _mic_year_page_reducer2 = _interopRequireDefault(_mic_year_page_reducer);

var _mic_sector_page_reducer = __webpack_require__(765);

var _mic_sector_page_reducer2 = _interopRequireDefault(_mic_sector_page_reducer);

var _mic_year_reducer = __webpack_require__(766);

var _mic_year_reducer2 = _interopRequireDefault(_mic_year_reducer);

var _mic_year_description_reducer = __webpack_require__(767);

var _mic_year_description_reducer2 = _interopRequireDefault(_mic_year_description_reducer);

var _mic_sector_reducer = __webpack_require__(768);

var _mic_sector_reducer2 = _interopRequireDefault(_mic_sector_reducer);

var _author_page_reducer = __webpack_require__(769);

var _author_page_reducer2 = _interopRequireDefault(_author_page_reducer);

var _author_reducer = __webpack_require__(770);

var _author_reducer2 = _interopRequireDefault(_author_reducer);

var _author_all_feed_reducer = __webpack_require__(771);

var _author_all_feed_reducer2 = _interopRequireDefault(_author_all_feed_reducer);

var _search_reducer = __webpack_require__(772);

var _search_reducer2 = _interopRequireDefault(_search_reducer);

var _search_page_reducer = __webpack_require__(773);

var _search_page_reducer2 = _interopRequireDefault(_search_page_reducer);

var _wp_page_reducer = __webpack_require__(774);

var _wp_page_reducer2 = _interopRequireDefault(_wp_page_reducer);

var _static_page_reducer = __webpack_require__(775);

var _static_page_reducer2 = _interopRequireDefault(_static_page_reducer);

var _newsletters_preferences_page_reducer = __webpack_require__(776);

var _newsletters_preferences_page_reducer2 = _interopRequireDefault(_newsletters_preferences_page_reducer);

var _custom_page_reducer = __webpack_require__(777);

var _custom_page_reducer2 = _interopRequireDefault(_custom_page_reducer);

var _html_sitemap_index_page_reducer = __webpack_require__(778);

var _html_sitemap_index_page_reducer2 = _interopRequireDefault(_html_sitemap_index_page_reducer);

var _html_sitemap_index_reducer = __webpack_require__(779);

var _html_sitemap_index_reducer2 = _interopRequireDefault(_html_sitemap_index_reducer);

var _html_sitemap_post_page_reducer = __webpack_require__(780);

var _html_sitemap_post_page_reducer2 = _interopRequireDefault(_html_sitemap_post_page_reducer);

var _html_sitemap_post_reducer = __webpack_require__(781);

var _html_sitemap_post_reducer2 = _interopRequireDefault(_html_sitemap_post_reducer);

var _recirc_feed_reducer = __webpack_require__(782);

var _recirc_feed_reducer2 = _interopRequireDefault(_recirc_feed_reducer);

var _context_reducer = __webpack_require__(783);

var _context_reducer2 = _interopRequireDefault(_context_reducer);

var _analytics_reducer = __webpack_require__(784);

var _analytics_reducer2 = _interopRequireDefault(_analytics_reducer);

var _config_reducer = __webpack_require__(785);

var _config_reducer2 = _interopRequireDefault(_config_reducer);

var _meta_reducer = __webpack_require__(786);

var _meta_reducer2 = _interopRequireDefault(_meta_reducer);

var _status_reducer = __webpack_require__(817);

var _status_reducer2 = _interopRequireDefault(_status_reducer);

var _not_found_page_reducer = __webpack_require__(818);

var _not_found_page_reducer2 = _interopRequireDefault(_not_found_page_reducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routerReducer,
  config: _config_reducer2.default,
  meta: _meta_reducer2.default,
  context: _context_reducer2.default,
  analytics: _analytics_reducer2.default,
  status: _status_reducer2.default,

  homepage: _homepage_reducer2.default,
  scrollingModule: _scrolling_module_reducer2.default,
  promoBanner: _promo_banner_reducer2.default,
  allFeed: _all_feed_reducer2.default,
  recircFeed: _recirc_feed_reducer2.default,
  featuredFeed: _featured_feed_reducer2.default,
  homepageTag: _homepage_tag_reducer2.default,
  homepageVideo: _homepage_video_reducer2.default,
  featuredSponsoredCard: _featured_sponsored_card_reducer2.default,

  postpage: _postpage_reducer2.default,
  post: _post_reducer2.default,
  postVideo: _post_video_reducer2.default,
  postAfterbodyRecircModuleType: _post_afterbody_recirc_module_type_reducer2.default,
  postMoreStories: _post_more_stories_reducer2.default,
  postFinite: _post_finite_reducer2.default,

  categoryPage: _category_page_reducer2.default,
  categoryScrollingModule: _category_scrolling_module_reducer2.default,
  categoryPromoBanner: _category_promo_banner_reducer2.default,
  categoryFeaturedFeed: _category_featured_feed_reducer2.default,
  categoryVideo: _category_video_reducer2.default,
  categoryAllFeed: _category_all_feed_reducer2.default,

  tagPage: _tag_page_reducer2.default,
  tagScrollingModule: _tag_scrolling_module_reducer2.default,
  tagPromoBanner: _tag_promo_banner_reducer2.default,
  tagFeaturedFeed: _tag_featured_feed_reducer2.default,
  tagVideo: _tag_video_reducer2.default,
  tagAllFeed: _tag_all_feed_reducer2.default,

  personPage: _person_page_reducer2.default,
  person: _person_reducer2.default,

  personIndexPage: _person_index_page_reducer2.default,

  personIndexSectionPage: _person_index_section_page_reducer2.default,
  personIndexSection: _person_index_section_reducer2.default,
  personIndexSectionNext: _person_index_section_next_reducer2.default,

  productPage: _product_page_reducer2.default,
  product: _product_reducer2.default,

  productIndexPage: _product_index_page_reducer2.default,
  productIndexSectionPage: _product_index_section_page_reducer2.default,
  productIndexSection: _product_index_section_reducer2.default,
  productIndexSectionNext: _product_index_section_next_reducer2.default,

  innovationByDesignPage: _innovation_by_design_page_reducer2.default,
  innovationByDesign: _innovation_by_design_reducer2.default,
  innovationByDesignDetail: _innovation_by_design_details_reducer2.default,
  innovationByDesignFeaturedFeed: _innovation_by_design_featured_feed_reducer2.default,
  innovationByDesignScrollingModule: _innovation_by_design_scrolling_module_reducer2.default,

  giftGuidePage: _gift_guide_page_reducer2.default,
  giftGuide: _gift_guide_reducer2.default,
  giftGuideDetail: _gift_guide_details_reducer2.default,
  giftPage: _gift_page_reducer2.default,
  gift: _gift_reducer2.default,

  mostCreativePeoplePage: _most_creative_people_page_reducer2.default,
  mostCreativePeople: _most_creative_people_reducer2.default,
  mostCreativePeopleFeaturedFeed: _most_creative_people_featured_feed_reducer2.default,
  mostCreativePeopleScrollingModule: _most_creative_people_scrolling_module_reducer2.default,

  mostCreativePeopleCommunityPage: _most_creative_people_community_page_reducer2.default,
  mostCreativePeopleCommunitySectionPage: _most_creative_people_community_section_page_reducer2.default,
  mostCreativePeopleCommunitySection: _most_creative_people_community_section_reducer2.default,
  mostCreativePeopleCommunitySectionNext: _most_creative_people_community_section_next_reducer2.default,

  companyPage: _company_page_reducer2.default,
  company: _company_reducer2.default,
  companyData: _company_data_reducer2.default,
  companyAwards: _company_awards_reducer2.default,
  companyIndexGroups: _company_index_groups_reducer2.default,

  companyIndexPage: _company_index_page_reducer2.default,
  companyIndexSection: _company_index_section_reducer2.default,
  companyIndexSectionNext: _company_index_section_next_reducer2.default,
  companyIndexSectionPage: _company_index_section_page_reducer2.default,

  micYearPage: _mic_year_page_reducer2.default,
  micSectorPage: _mic_sector_page_reducer2.default,
  micYear: _mic_year_reducer2.default,
  micYearDescription: _mic_year_description_reducer2.default,

  micSector: _mic_sector_reducer2.default,

  magazineArchivePage: _magazine_archive_page_reducer2.default,
  magazineArchive: _magazine_archive_reducer2.default,
  magazineIssuePosts: _magazine_issue_posts_reducer2.default,
  magazineLatestIssuePosts: _magazine_latest_issue_posts_reducer2.default,

  videoIndexPage: _video_index_page_reducer2.default,
  videoPage: _video_page_reducer2.default,
  jwVideo: _jw_video_reducer2.default,
  jwRelatedVideo: _jw_related_video_reducer2.default,
  jwNewestVideo: _jw_newest_video_reducer2.default,

  jwPlaylist: _jw_playlist_reducer2.default,
  jwPlaylistIndex: _jw_playlist_index_reducer2.default,
  playlistPage: _playlist_page_reducer2.default,
  playlistAllFeed: _playlist_all_feed_reducer2.default,
  playlistIndexPage: _playlist_index_page_reducer2.default,

  authorPage: _author_page_reducer2.default,
  authorAllFeed: _author_all_feed_reducer2.default,
  author: _author_reducer2.default,

  search: _search_reducer2.default,
  searchPage: _search_page_reducer2.default,

  wpPage: _wp_page_reducer2.default,
  staticPage: _static_page_reducer2.default,
  customPage: _custom_page_reducer2.default,

  newslettersPreferencesPage: _newsletters_preferences_page_reducer2.default,

  htmlSitemapIndexPage: _html_sitemap_index_page_reducer2.default,
  htmlSitemapIndex: _html_sitemap_index_reducer2.default,

  htmlSitemapPostPage: _html_sitemap_post_page_reducer2.default,
  htmlSitemapPost: _html_sitemap_post_reducer2.default,

  notFoundPage: _not_found_page_reducer2.default
});

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    HOMEPAGE_LOADING: function HOMEPAGE_LOADING() {
      return {
        isLoading: true,
        homepage: action.homepage
      };
    },
    HOMEPAGE_LOADED: function HOMEPAGE_LOADED() {
      // For future, the topic needs to be passed here,
      // to determine which topic page you're on, the adzone for topic will be
      // 'topicName/topicName', no need to look it up in keymap
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, null, 'homepage');

      return {
        isLoading: false,
        data: (0, _get2.default)(action, 'homepage'),
        ads: adModelData
      };
    },
    HOMEPAGE_ERROR: function HOMEPAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.homepage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    SCROLLING_MODULE_LOADING: function SCROLLING_MODULE_LOADING() {
      return {
        isLoading: true,
        scrollingModule: action.scrollingModule
      };
    },
    SCROLLING_MODULE_LOADED: function SCROLLING_MODULE_LOADED() {
      return {
        isLoading: false,
        data: action.scrollingModule
      };
    },
    SCROLLING_MODULE_ERROR: function SCROLLING_MODULE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.scrollingModule.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    PROMO_BANNER_LOADING: function PROMO_BANNER_LOADING() {
      return {
        isLoading: true,
        promoBanner: action.promoBanner
      };
    },
    PROMO_BANNER_LOADED: function PROMO_BANNER_LOADED() {
      return {
        isLoading: false,
        data: action.promoBanner
      };
    },
    PROMO_BANNER_ERROR: function PROMO_BANNER_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.promoBanner.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    ALL_FEED_LOADING: function ALL_FEED_LOADING() {
      return {
        isLoading: true,
        allFeed: action.allFeed,
        allRendered: false
      };
    },
    ALL_FEED_LOADED: function ALL_FEED_LOADED() {
      return {
        isLoading: false,
        data: action.allFeed,
        allRendered: false
      };
    },
    ALL_FEED_ERROR: function ALL_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        allRendered: false,
        errorMessage: action.allFeed.errorMessage
      };
    },
    ALL_FEED_ALL_STORIES_RENDERED: function ALL_FEED_ALL_STORIES_RENDERED() {
      return {
        isLoading: false,
        data: { posts: state.data.posts },
        allRendered: true
      };
    },
    ALL_FEED_IS_LOADING: function ALL_FEED_IS_LOADING() {
      return (0, _extend2.default)({}, state, { isEnabled: true, isLoading: true });
    },
    ALL_FEED_IS_LOADED: function ALL_FEED_IS_LOADED() {
      return {
        isEnabled: true,
        isLoading: false,
        data: (0, _extend2.default)({}, state.data, {
          page: (0, _get2.default)(action, 'allFeed.page'),
          posts: [].concat(_toConsumableArray(state.data.posts), _toConsumableArray((0, _get2.default)(action, 'allFeed.posts', [])))
        }),
        allRendered: false
      };
    },
    ALL_FEED_IS_ERROR: function ALL_FEED_IS_ERROR() {
      return {
        isEnabled: true,
        isLoading: true,
        data: (0, _extend2.default)({}, state, {
          page: (0, _get2.default)(action, 'allFeed.page'),
          posts: [].concat(_toConsumableArray(state.data.posts), _toConsumableArray((0, _get2.default)(action, 'allFeed.posts', [])))
        }),
        allRendered: false
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    FEATURED_FEED_LOADING: function FEATURED_FEED_LOADING() {
      return {
        isLoading: true,
        featuredFeed: action.featuredFeed
      };
    },
    FEATURED_FEED_LOADED: function FEATURED_FEED_LOADED() {
      return {
        isLoading: false,
        data: action.featuredFeed
      };
    },
    FEATURED_FEED_ERROR: function FEATURED_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.featuredFeed.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    HOMEPAGE_TAG_LOADING: function HOMEPAGE_TAG_LOADING() {
      return {
        isLoading: true,
        homepageTag: action.homepageTag
      };
    },
    HOMEPAGE_TAG_LOADED: function HOMEPAGE_TAG_LOADED() {
      var tagID = (0, _get2.default)(action, 'homepageTag.tag_id');

      return {
        isLoading: false,
        data: action.homepageTag.posts,
        tagID: tagID
      };
    },
    HOMEPAGE_TAG_ERROR: function HOMEPAGE_TAG_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.homepageTag.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    HOMEPAGE_VIDEO_LOADING: function HOMEPAGE_VIDEO_LOADING() {
      return {
        isLoading: true,
        homepageVideo: action.homepageVideo
      };
    },
    HOMEPAGE_VIDEO_LOADED: function HOMEPAGE_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.homepageVideo
      };
    },
    HOMEPAGE_VIDEO_ERROR: function HOMEPAGE_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.homepageVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    FEATURED_SPONSORED_CARD_LOADING: function FEATURED_SPONSORED_CARD_LOADING() {
      return {
        isLoading: true,
        featuredSponsoredCard: action.featuredSponsoredCard
      };
    },
    FEATURED_SPONSORED_CARD_LOADED: function FEATURED_SPONSORED_CARD_LOADED() {
      return {
        isLoading: false,
        data: action.featuredSponsoredCard
      };
    },
    FEATURED_SPONSORED_CARD_ERROR: function FEATURED_SPONSORED_CARD_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.featuredSponsoredCard.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    POSTPAGE_LOADING: function POSTPAGE_LOADING() {
      return {
        isLoading: true,
        postpage: action.postpage
      };
    },
    POSTPAGE_LOADED: function POSTPAGE_LOADED() {
      var currentState = store.getState();
      var postData = (0, _get2.default)(currentState, 'post.data.post');
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, postData, 'postPage');

      return {
        isLoading: false,
        data: (0, _get2.default)(action, 'postpage'),
        ads: adModelData,
        postScrollDepth: 0
      };
    },
    POSTPAGE_ERROR: function POSTPAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.postpage.errorMessage
      };
    },
    POSTPAGE_SCROLL_DEPTH: function POSTPAGE_SCROLL_DEPTH() {
      return {
        isLoading: state.isLoading,
        data: state.postpage,
        ads: state.ads,
        postScrollDepth: action.postScrollDepth
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    POST_LOADING: function POST_LOADING() {
      return {
        isLoading: true,
        post: action.post
      };
    },
    POST_LOADED: function POST_LOADED() {
      return {
        isLoading: false,
        data: action.post
      };
    },
    POST_ERROR: function POST_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.post.errorMessage
      };
    },
    REFRESH_AD: function REFRESH_AD() {
      return {
        isLoading: false,
        data: state.data,
        slotsToRefresh: [action.slot]
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    POST_VIDEO_LOADING: function POST_VIDEO_LOADING() {
      return {
        isLoading: true,
        postVideo: action.postVideo
      };
    },
    POST_VIDEO_LOADED: function POST_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.postVideo
      };
    },
    POST_VIDEO_ERROR: function POST_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.postVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    POST_FINITE_LOADING: function POST_FINITE_LOADING() {
      return {
        isLoading: true,
        postFinite: action.postFinite
      };
    },
    POST_FINITE_LOADED: function POST_FINITE_LOADED() {
      return {
        isLoading: false,
        data: action.postFinite
      };
    },
    POST_FINITE_ERROR: function POST_FINITE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.postFinite.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    POST_AFTERBODY_RECIRC_MODULE_TYPE_LOADING: function POST_AFTERBODY_RECIRC_MODULE_TYPE_LOADING() {
      return {
        isLoading: true,
        postAfterbodyRecircModule: action.postAfterbodyRecircModule
      };
    },
    POST_AFTERBODY_RECIRC_MODULE_TYPE_LOADED: function POST_AFTERBODY_RECIRC_MODULE_TYPE_LOADED() {
      return {
        isLoading: false,
        data: action.postAfterbodyRecircModule
      };
    },
    POST_AFTERBODY_RECIRC_MODULE_TYPE_ERROR: function POST_AFTERBODY_RECIRC_MODULE_TYPE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.postAfterbodyRecircModule.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    POST_MORE_STORIES_LOADING: function POST_MORE_STORIES_LOADING() {
      return {
        isLoading: true,
        postMoreStories: action.postMoreStories
      };
    },
    POST_MORE_STORIES_LOADED: function POST_MORE_STORIES_LOADED() {
      return {
        isLoading: false,
        data: action.postMoreStories
      };
    },
    POST_MORE_STORIES_ERROR: function POST_MORE_STORIES_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.postMoreStories.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    VIDEO_PAGE_LOADING: function VIDEO_PAGE_LOADING() {
      return {
        isLoading: true,
        videoPage: action.videoPage
      };
    },
    VIDEO_PAGE_LOADED: function VIDEO_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var videoPageData = (0, _get2.default)(currentState, 'jwVideo');
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, videoPageData, 'videoPage');

      // Override this for MCP
      // adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.videoPage,
        ads: adModelData
      };
    },
    VIDEO_PAGE_ERROR: function VIDEO_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.videoPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    VIDEO_INDEX_PAGE_LOADING: function VIDEO_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        videoIndexPage: action.videoIndexPage
      };
    },
    VIDEO_INDEX_PAGE_LOADED: function VIDEO_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, {}, 'videoIndexPage');

      // Override this for MCP
      // adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.videoIndexPage,
        ads: adModelData
      };
    },
    VIDEO_INDEX_PAGE_ERROR: function VIDEO_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.videoIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    JW_VIDEO_LOADING: function JW_VIDEO_LOADING() {
      return {
        isLoading: true
      };
    },
    JW_VIDEO_LOADED: function JW_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.jwVideo
      };
    },
    JW_VIDEO_ERROR: function JW_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.jwVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    JW_RELATED_VIDEO_LOADING: function JW_RELATED_VIDEO_LOADING() {
      return {
        isLoading: true
      };
    },
    JW_RELATED_VIDEO_LOADED: function JW_RELATED_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.jwRelatedVideo
      };
    },
    JW_RELATED_VIDEO_ERROR: function JW_RELATED_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.jwRelatedVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    JW_NEWEST_VIDEO_LOADING: function JW_NEWEST_VIDEO_LOADING() {
      return {
        isLoading: true
      };
    },
    JW_NEWEST_VIDEO_LOADED: function JW_NEWEST_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.jwNewestVideo
      };
    },
    JW_NEWEST_VIDEO_ERROR: function JW_NEWEST_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.jwNewestVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    PLAYLIST_PAGE_LOADING: function PLAYLIST_PAGE_LOADING() {
      return {
        isLoading: true
      };
    },
    PLAYLIST_PAGE_LOADED: function PLAYLIST_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';

      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, {}, 'videoPlaylistPage');
      return {
        isLoading: false,
        data: action.jwPlaylist,
        ads: adModelData
      };
    },
    PLAYLIST_PAGE_ERROR: function PLAYLIST_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.jwPlaylist.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    JW_PLAYLIST_INDEX_LOADING: function JW_PLAYLIST_INDEX_LOADING() {
      return {
        isLoading: true
      };
    },
    JW_PLAYLIST_INDEX_LOADED: function JW_PLAYLIST_INDEX_LOADED() {
      return {
        isLoading: false,
        data: action.jwPlaylistIndex
      };
    },
    JW_PLAYLIST_INDEX_ERROR: function JW_PLAYLIST_INDEX_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.jwPlaylistIndex.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    PLAYLIST_INDEX_PAGE_LOADING: function PLAYLIST_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        playlistIndexPage: action.playlistIndexPage
      };
    },
    PLAYLIST_INDEX_PAGE_LOADED: function PLAYLIST_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'playlist-index');

      // Override this for MCP
      // adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.playlistIndexPage,
        ads: adModelData
      };
    },
    PLAYLIST_INDEX_PAGE_ERROR: function PLAYLIST_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.playlistIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    PLAYLIST_PAGE_LOADING: function PLAYLIST_PAGE_LOADING() {
      return {
        isLoading: true
      };
    },
    PLAYLIST_PAGE_LOADED: function PLAYLIST_PAGE_LOADED() {
      return {
        isLoading: false
      };
    },
    PLAYLIST_PAGE_ERROR: function PLAYLIST_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.playlistPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;


  var typeMap = {
    PLAYLIST_ALL_FEED_LOADING: function PLAYLIST_ALL_FEED_LOADING() {
      return {
        isLoading: true,
        playlistAllFeed: action.playlistAllFeed,
        allRendered: false
      };
    },
    PLAYLIST_ALL_FEED_LOADED: function PLAYLIST_ALL_FEED_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var playlist = (0, _get2.default)(action, 'playlistAllFeed', {});

      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, playlist, 'videoPlaylistPage');

      return {
        isLoading: false,
        data: playlist,
        allRendered: false,
        ads: adModelData
      };
    },
    PLAYLIST_ALL_FEED_ERROR: function PLAYLIST_ALL_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: (0, _get2.default)(action, 'playlistAllFeed.errorMessage')
      };
    },
    PLAYLIST_ALL_FEED_IS_LOADING: function PLAYLIST_ALL_FEED_IS_LOADING() {
      return (0, _assign2.default)({}, state, { isEnabled: true, isLoading: true });
    },
    PLAYLIST_ALL_FEED_IS_LOADED: function PLAYLIST_ALL_FEED_IS_LOADED() {
      return {
        isEnabled: true,
        isLoading: false,
        data: (0, _assign2.default)({}, state.data, {
          page: (0, _get2.default)(action, 'playlistAllFeed.page'),
          playlist: [].concat(_toConsumableArray((0, _get2.default)(state, 'data.playlist', [])), _toConsumableArray((0, _get2.default)(action, 'playlistAllFeed.playlist', [])))
        }),
        allRendered: false
      };
    },
    PLAYLIST_ALL_FEED_IS_ERROR: function PLAYLIST_ALL_FEED_IS_ERROR() {
      return {
        isEnabled: true,
        isLoading: true,
        data: (0, _assign2.default)({}, state, {
          page: (0, _get2.default)(action, 'playlistAllFeed.page'),
          playlist: [].concat(_toConsumableArray((0, _get2.default)(state, 'data.playlist', [])), _toConsumableArray((0, _get2.default)(action, 'playlistAllFeed.playlist', [])))
        }),
        allRendered: false
      };
    },
    PLAYLIST_ALL_FEED_ALL_STORIES_RENDERED: function PLAYLIST_ALL_FEED_ALL_STORIES_RENDERED() {
      return {
        isLoading: true,
        data: state.data,
        allRendered: true
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    CATEGORY_PAGE_LOADING: function CATEGORY_PAGE_LOADING() {
      return {
        isLoading: true,
        categoryPage: action.categoryPage
      };
    },
    CATEGORY_PAGE_LOADED: function CATEGORY_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var category = (0, _get2.default)(currentState, 'categoryFeaturedFeed.category.slug');
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, category, 'categoryPage');

      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    CATEGORY_PAGE_ERROR: function CATEGORY_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.categoryPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    CATEGORY_FEATURED_FEED_LOADING: function CATEGORY_FEATURED_FEED_LOADING() {
      return {
        isLoading: true,
        categoryFeaturedFeed: action.categoryFeaturedFeed
      };
    },
    CATEGORY_FEATURED_FEED_LOADED: function CATEGORY_FEATURED_FEED_LOADED() {
      return {
        isLoading: false,
        featured: (0, _get2.default)(action, 'categoryFeaturedFeed.featured'),
        top: (0, _get2.default)(action, 'categoryFeaturedFeed.top'),
        category: (0, _get2.default)(action, 'categoryFeaturedFeed.category'),
        source: (0, _get2.default)(action, 'categoryFeaturedFeed.source')
      };
    },
    CATEGORY_FEATURED_FEED_ERROR: function CATEGORY_FEATURED_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.categoryFeaturedFeed.errorMessage,
        featured: [],
        category: {},
        top: []
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    CATEGORY_VIDEO_LOADING: function CATEGORY_VIDEO_LOADING() {
      return {
        isLoading: true,
        categoryVideo: action.categoryVideo
      };
    },
    CATEGORY_VIDEO_LOADED: function CATEGORY_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.categoryVideo
      };
    },
    CATEGORY_VIDEO_ERROR: function CATEGORY_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.categoryVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    CATEGORY_ALL_FEED_LOADING: function CATEGORY_ALL_FEED_LOADING() {
      return {
        isLoading: true,
        categoryAllFeed: action.categoryAllFeed,
        allRendered: false
      };
    },
    CATEGORY_ALL_FEED_LOADED: function CATEGORY_ALL_FEED_LOADED() {
      return {
        isLoading: false,
        data: action.categoryAllFeed,
        allRendered: false
      };
    },
    CATEGORY_ALL_FEED_ERROR: function CATEGORY_ALL_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.categoryAllFeed.errorMessage
      };
    },
    CATEGORY_ALL_FEED_ALL_STORIES_RENDERED: function CATEGORY_ALL_FEED_ALL_STORIES_RENDERED() {
      return {
        isLoading: false,
        data: state.data,
        allRendered: true
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    CATEGORY_SCROLLING_MODULE_LOADING: function CATEGORY_SCROLLING_MODULE_LOADING() {
      return {
        isLoading: true,
        categoryScrollingModule: action.categoryScrollingModule
      };
    },
    CATEGORY_SCROLLING_MODULE_LOADED: function CATEGORY_SCROLLING_MODULE_LOADED() {
      return {
        isLoading: false,
        data: action.categoryScrollingModule
      };
    },
    CATEGORY_SCROLLING_MODULE_ERROR: function CATEGORY_SCROLLING_MODULE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.categoryScrollingModule.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    CATEGORY_PROMO_BANNER_LOADING: function CATEGORY_PROMO_BANNER_LOADING() {
      return {
        isLoading: true,
        categoryPromoBanner: action.categoryPromoBanner
      };
    },
    CATEGORY_PROMO_BANNER_LOADED: function CATEGORY_PROMO_BANNER_LOADED() {
      return {
        isLoading: false,
        data: action.categoryPromoBanner
      };
    },
    CATEGORY_PROMO_BANNER_ERROR: function CATEGORY_PROMO_BANNER_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.categoryPromoBanner.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    TAG_PAGE_LOADING: function TAG_PAGE_LOADING() {
      return {
        isLoading: true,
        tagPage: action.tagPage
      };
    },
    TAG_PAGE_LOADED: function TAG_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var tag = (0, _get2.default)(currentState, 'tagFeaturedFeed.tag');
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, tag, 'tagPage');
      return {
        isLoading: false,
        data: {},
        ads: adModelData
      };
    },
    TAG_PAGE_ERROR: function TAG_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.tagPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    TAG_FEATURED_FEED_LOADING: function TAG_FEATURED_FEED_LOADING() {
      return {
        isLoading: true,
        tagFeaturedFeed: action.tagFeaturedFeed
      };
    },
    TAG_FEATURED_FEED_LOADED: function TAG_FEATURED_FEED_LOADED() {
      return {
        isLoading: false,
        featured: (0, _get2.default)(action, 'tagFeaturedFeed.featured'),
        top: (0, _get2.default)(action, 'tagFeaturedFeed.top'),
        tag: (0, _get2.default)(action, 'tagFeaturedFeed.tag'),
        source: (0, _get2.default)(action, 'tagFeaturedFeed.source')
      };
    },
    TAG_FEATURED_FEED_ERROR: function TAG_FEATURED_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.tagFeaturedFeed.errorMessage,
        featured: [],
        tag: {},
        top: []
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    TAG_VIDEO_LOADING: function TAG_VIDEO_LOADING() {
      return {
        isLoading: true,
        tagVideo: action.tagVideo
      };
    },
    TAG_VIDEO_LOADED: function TAG_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.tagVideo
      };
    },
    TAG_VIDEO_ERROR: function TAG_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.tagVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    TAG_ALL_FEED_LOADING: function TAG_ALL_FEED_LOADING() {
      return {
        isLoading: true,
        tagAllFeed: action.tagAllFeed,
        allRendered: false
      };
    },
    TAG_ALL_FEED_LOADED: function TAG_ALL_FEED_LOADED() {
      return {
        isLoading: false,
        data: action.tagAllFeed,
        allRendered: false
      };
    },
    TAG_ALL_FEED_ERROR: function TAG_ALL_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.tagAllFeed.errorMessage
      };
    },
    TAG_ALL_FEED_ALL_STORIES_RENDERED: function TAG_ALL_FEED_ALL_STORIES_RENDERED() {
      return {
        isLoading: false,
        data: state.data,
        allRendered: true
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    TAG_SCROLLING_MODULE_LOADING: function TAG_SCROLLING_MODULE_LOADING() {
      return {
        isLoading: true,
        tagScrollingModule: action.tagScrollingModule
      };
    },
    TAG_SCROLLING_MODULE_LOADED: function TAG_SCROLLING_MODULE_LOADED() {
      return {
        isLoading: false,
        data: action.tagScrollingModule
      };
    },
    TAG_SCROLLING_MODULE_ERROR: function TAG_SCROLLING_MODULE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.tagScrollingModule.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    TAG_PROMO_BANNER_LOADING: function TAG_PROMO_BANNER_LOADING() {
      return {
        isLoading: true,
        tagPromoBanner: action.tagPromoBanner
      };
    },
    TAG_PROMO_BANNER_LOADED: function TAG_PROMO_BANNER_LOADED() {
      return {
        isLoading: false,
        data: action.tagPromoBanner
      };
    },
    TAG_PROMO_BANNER_ERROR: function TAG_PROMO_BANNER_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.tagPromoBanner.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    MAGAZINE_ARCHIVE_PAGE_LOADING: function MAGAZINE_ARCHIVE_PAGE_LOADING() {
      return {
        isLoading: true,
        magazineArchivePage: action.magazineArchivePage
      };
    },
    MAGAZINE_ARCHIVE_PAGE_LOADED: function MAGAZINE_ARCHIVE_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var tag = (0, _get2.default)(currentState, 'tagFeaturedFeed.tag');
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, tag, 'magazineArchivePage');

      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    MAGAZINE_ARCHIVE_PAGE_ERROR: function MAGAZINE_ARCHIVE_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.magazineArchivePage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    MAGAZINE_ARCHIVE_LOADING: function MAGAZINE_ARCHIVE_LOADING() {
      return {
        isLoading: true,
        magazineArchive: action.magazineArchive
      };
    },
    MAGAZINE_ARCHIVE_LOADED: function MAGAZINE_ARCHIVE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'magazineArchive');

      return {
        isLoading: false,
        data: action.magazineArchive,
        ads: adModelData
      };
    },
    MAGAZINE_ARCHIVE_ERROR: function MAGAZINE_ARCHIVE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.magazineArchive.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  // const { store } = action;
  var typeMap = {
    MAGAZINE_ISSUE_POSTS_LOADING: function MAGAZINE_ISSUE_POSTS_LOADING() {
      return {
        isLoading: true,
        magazineIssuePosts: action.magazineIssuePosts
      };
    },
    MAGAZINE_ISSUE_POSTS_LOADED: function MAGAZINE_ISSUE_POSTS_LOADED() {
      return {
        isLoading: false,
        data: action.magazineIssuePosts
      };
    },
    MAGAZINE_ISSUE_POSTS_ERROR: function MAGAZINE_ISSUE_POSTS_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.magazineIssuePosts.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  // const { store } = action;
  var typeMap = {
    MAGAZINE_LATEST_ISSUE_POSTS_LOADING: function MAGAZINE_LATEST_ISSUE_POSTS_LOADING() {
      return {
        isLoading: true,
        magazineLatestIssuePosts: action.magazineLatestIssuePosts
      };
    },
    MAGAZINE_LATEST_ISSUE_POSTS_LOADED: function MAGAZINE_LATEST_ISSUE_POSTS_LOADED() {
      return {
        isLoading: false,
        data: action.magazineLatestIssuePosts
      };
    },
    MAGAZINE_LATEST_ISSUE_POSTS_ERROR: function MAGAZINE_LATEST_ISSUE_POSTS_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.magazineLatestIssuePosts.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    PERSON_PAGE_LOADING: function PERSON_PAGE_LOADING() {
      return {
        isLoading: true,
        personPage: action.personPage
      };
    },
    PERSON_PAGE_LOADED: function PERSON_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-creative-people', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.personPage,
        ads: adModelData
      };
    },
    PERSON_PAGE_ERROR: function PERSON_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.personPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    PERSON_LOADING: function PERSON_LOADING() {
      return {
        isLoading: true
      };
    },
    PERSON_LOADED: function PERSON_LOADED() {
      return {
        isLoading: false,
        data: action.person
      };
    },
    PERSON_ERROR: function PERSON_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.person.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    PERSON_INDEX_PAGE_LOADING: function PERSON_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        personIndexPage: action.personIndexPage
      };
    },
    PERSON_INDEX_PAGE_LOADED: function PERSON_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-creative-people', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.personIndexPage,
        ads: adModelData
      };
    },
    PERSON_INDEX_PAGE_ERROR: function PERSON_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.personIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    PRODUCT_PAGE_LOADING: function PRODUCT_PAGE_LOADING() {
      return {
        isLoading: true,
        productPage: action.productPage
      };
    },
    PRODUCT_PAGE_LOADED: function PRODUCT_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'product', 'productPage');

      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    PRODUCT_PAGE_ERROR: function PRODUCT_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.productPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    PRODUCT_LOADING: function PRODUCT_LOADING() {
      return {
        isLoading: true
      };
    },
    PRODUCT_LOADED: function PRODUCT_LOADED() {
      return {
        isLoading: false,
        data: action.product
      };
    },
    PRODUCT_ERROR: function PRODUCT_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.product.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    PRODUCT_INDEX_PAGE_LOADING: function PRODUCT_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        productIndexPage: action.productIndexPage
      };
    },
    PRODUCT_INDEX_PAGE_LOADED: function PRODUCT_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'product', 'productPage');

      return {
        isLoading: false,
        data: action.productIndexPage,
        ads: adModelData
      };
    },
    PRODUCT_INDEX_PAGE_ERROR: function PRODUCT_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.productIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    INNOVATION_BY_DESIGN_PAGE_LOADING: function INNOVATION_BY_DESIGN_PAGE_LOADING() {
      return {
        isLoading: true,
        innovationByDesignPage: action.innovationByDesignPage
      };
    },
    INNOVATION_BY_DESIGN_PAGE_LOADED: function INNOVATION_BY_DESIGN_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'innovation-by-design', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'innovation/innovation-by-design';
      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    INNOVATION_BY_DESIGN_PAGE_ERROR: function INNOVATION_BY_DESIGN_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.innovationByDesignPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    INNOVATION_BY_DESIGN_LOADING: function INNOVATION_BY_DESIGN_LOADING() {
      return {
        isLoading: true
      };
    },
    INNOVATION_BY_DESIGN_LOADED: function INNOVATION_BY_DESIGN_LOADED() {
      return {
        isLoading: false,
        data: action.innovationByDesign,
        year: action.year
      };
    },
    INNOVATION_BY_DESIGN_ERROR: function INNOVATION_BY_DESIGN_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.innovationByDesign.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    INNOVATION_BY_DESIGN_DETAIL_LOADING: function INNOVATION_BY_DESIGN_DETAIL_LOADING() {
      return {
        isLoading: true
      };
    },
    INNOVATION_BY_DESIGN_DETAIL_LOADED: function INNOVATION_BY_DESIGN_DETAIL_LOADED() {
      return {
        isLoading: false,
        data: action.innovationByDesignDetail,
        year: action.year
      };
    },
    INNOVATION_BY_DESIGN_DETAIL_ERROR: function INNOVATION_BY_DESIGN_DETAIL_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.innovationByDesign.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    INNOVATION_BY_DESIGN_FEATURED_FEED_LOADING: function INNOVATION_BY_DESIGN_FEATURED_FEED_LOADING() {
      return {
        isLoading: true,
        innovationByDesignFeaturedFeed: action.innovationByDesignFeaturedFeed
      };
    },
    INNOVATION_BY_DESIGN_FEATURED_FEED_LOADED: function INNOVATION_BY_DESIGN_FEATURED_FEED_LOADED() {
      return {
        isLoading: false,
        data: action.innovationByDesignFeaturedFeed
      };
    },
    INNOVATION_BY_DESIGN_FEATURED_FEED_ERROR: function INNOVATION_BY_DESIGN_FEATURED_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.innovationByDesignFeaturedFeed.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    INNOVATION_BY_DESIGN_SCROLLING_MODULE_LOADING: function INNOVATION_BY_DESIGN_SCROLLING_MODULE_LOADING() {
      return {
        isLoading: true,
        innovationByDesignScrollingModule: action.innovationByDesignScrollingModule
      };
    },
    INNOVATION_BY_DESIGN_SCROLLING_MODULE_LOADED: function INNOVATION_BY_DESIGN_SCROLLING_MODULE_LOADED() {
      return {
        isLoading: false,
        data: action.innovationByDesignScrollingModule
      };
    },
    INNOVATION_BY_DESIGN_SCROLLING_MODULE_ERROR: function INNOVATION_BY_DESIGN_SCROLLING_MODULE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.innovationByDesignScrollingModule.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    GIFT_GUIDE_PAGE_LOADING: function GIFT_GUIDE_PAGE_LOADING() {
      return {
        isLoading: true,
        giftGuidePage: action.giftGuidePage
      };
    },
    GIFT_GUIDE_PAGE_LOADED: function GIFT_GUIDE_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'gift-guide', 'categoryPage');

      adModelData.model.adzone = 'gift-guide/gift-guide';
      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    GIFT_GUIDE_PAGE_ERROR: function GIFT_GUIDE_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.giftGuidePage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    GIFT_GUIDE_LOADING: function GIFT_GUIDE_LOADING() {
      return {
        isLoading: true
      };
    },
    GIFT_GUIDE_LOADED: function GIFT_GUIDE_LOADED() {
      return {
        isLoading: false,
        data: action.giftGuide,
        year: action.year
      };
    },
    GIFT_GUIDE_ERROR: function GIFT_GUIDE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.giftGuide.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    GIFT_GUIDE_DETAIL_LOADING: function GIFT_GUIDE_DETAIL_LOADING() {
      return {
        isLoading: true
      };
    },
    GIFT_GUIDE_DETAIL_LOADED: function GIFT_GUIDE_DETAIL_LOADED() {
      return {
        isLoading: false,
        data: action.giftGuideDetail,
        year: action.year
      };
    },
    GIFT_GUIDE_DETAIL_ERROR: function GIFT_GUIDE_DETAIL_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.giftGuide.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    GIFT_PAGE_LOADING: function GIFT_PAGE_LOADING() {
      return {
        isLoading: true,
        giftPage: action.giftPage
      };
    },
    GIFT_PAGE_LOADED: function GIFT_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'gift', 'giftPage');

      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    GIFT_PAGE_ERROR: function GIFT_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.giftPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    GIFT_LOADING: function GIFT_LOADING() {
      return {
        isLoading: true
      };
    },
    GIFT_LOADED: function GIFT_LOADED() {
      return {
        isLoading: false,
        data: action.gift
      };
    },
    GIFT_ERROR: function GIFT_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.gift.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    PERSON_INDEX_SECTION_PAGE_LOADING: function PERSON_INDEX_SECTION_PAGE_LOADING() {
      return {
        isLoading: true,
        personIndexSectionPage: action.personIndexSectionPage
      };
    },
    PERSON_INDEX_SECTION_PAGE_LOADED: function PERSON_INDEX_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-creative-people', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.personIndexSectionPage,
        ads: adModelData
      };
    },
    PERSON_INDEX_SECTION_PAGE_ERROR: function PERSON_INDEX_SECTION_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.personIndexSectionPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    PERSON_INDEX_SECTION_LOADING: function PERSON_INDEX_SECTION_LOADING() {
      return {
        isLoading: true
      };
    },
    PERSON_INDEX_SECTION_LOADED: function PERSON_INDEX_SECTION_LOADED() {
      return {
        isLoading: false,
        data: action.personIndexSection
      };
    },
    PERSON_INDEX_SECTION_ERROR: function PERSON_INDEX_SECTION_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.personIndexSection.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    PERSON_INDEX_SECTION_NEXT_LOADING: function PERSON_INDEX_SECTION_NEXT_LOADING() {
      return {
        isLoading: true
      };
    },
    PERSON_INDEX_SECTION_NEXT_LOADED: function PERSON_INDEX_SECTION_NEXT_LOADED() {
      return {
        isLoading: false,
        data: action.personIndexSectionNext
      };
    },
    PERSON_INDEX_SECTION_NEXT_ERROR: function PERSON_INDEX_SECTION_NEXT_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.personIndexSectionNext.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    PRODUCT_INDEX_SECTION_PAGE_LOADING: function PRODUCT_INDEX_SECTION_PAGE_LOADING() {
      return {
        isLoading: true,
        productIndexSectionPage: action.productIndexSectionPage
      };
    },
    PRODUCT_INDEX_SECTION_PAGE_LOADED: function PRODUCT_INDEX_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'innovationbydesign', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'innovation/innovationbydesign';
      return {
        isLoading: false,
        data: action.productIndexSectionPage,
        ads: adModelData
      };
    },
    PRODUCT_INDEX_SECTION_PAGE_ERROR: function PRODUCT_INDEX_SECTION_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.productIndexSectionPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    PRODUCT_INDEX_SECTION_LOADING: function PRODUCT_INDEX_SECTION_LOADING() {
      return {
        isLoading: true
      };
    },
    PRODUCT_INDEX_SECTION_LOADED: function PRODUCT_INDEX_SECTION_LOADED() {
      return {
        isLoading: false,
        data: action.productIndexSection
      };
    },
    PRODUCT_INDEX_SECTION_ERROR: function PRODUCT_INDEX_SECTION_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.productIndexSection.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    PRODUCT_INDEX_SECTION_NEXT_LOADING: function PRODUCT_INDEX_SECTION_NEXT_LOADING() {
      return {
        isLoading: true
      };
    },
    PRODUCT_INDEX_SECTION_NEXT_LOADED: function PRODUCT_INDEX_SECTION_NEXT_LOADED() {
      return {
        isLoading: false,
        data: action.productIndexSectionNext
      };
    },
    PRODUCT_INDEX_SECTION_NEXT_ERROR: function PRODUCT_INDEX_SECTION_NEXT_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.productIndexSectionNext.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    MOST_CREATIVE_PEOPLE_PAGE_LOADING: function MOST_CREATIVE_PEOPLE_PAGE_LOADING() {
      return {
        isLoading: true,
        mostCreativePeoplePage: action.mostCreativePeoplePage
      };
    },
    MOST_CREATIVE_PEOPLE_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-creative-people', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    MOST_CREATIVE_PEOPLE_PAGE_ERROR: function MOST_CREATIVE_PEOPLE_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeoplePage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    MOST_CREATIVE_PEOPLE_LOADING: function MOST_CREATIVE_PEOPLE_LOADING() {
      return {
        isLoading: true
      };
    },
    MOST_CREATIVE_PEOPLE_LOADED: function MOST_CREATIVE_PEOPLE_LOADED() {
      return {
        isLoading: false,
        data: action.mostCreativePeople,
        year: action.year
      };
    },
    MOST_CREATIVE_PEOPLE_ERROR: function MOST_CREATIVE_PEOPLE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeople.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    MOST_CREATIVE_PEOPLE_FEATURED_FEED_LOADING: function MOST_CREATIVE_PEOPLE_FEATURED_FEED_LOADING() {
      return {
        isLoading: true,
        mostCreativePeopleFeaturedFeed: action.mostCreativePeopleFeaturedFeed
      };
    },
    MOST_CREATIVE_PEOPLE_FEATURED_FEED_LOADED: function MOST_CREATIVE_PEOPLE_FEATURED_FEED_LOADED() {
      return {
        isLoading: false,
        data: action.mostCreativePeopleFeaturedFeed
      };
    },
    MOST_CREATIVE_PEOPLE_FEATURED_FEED_ERROR: function MOST_CREATIVE_PEOPLE_FEATURED_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeopleFeaturedFeed.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    MOST_CREATIVE_PEOPLE_SCROLLING_MODULE_LOADING: function MOST_CREATIVE_PEOPLE_SCROLLING_MODULE_LOADING() {
      return {
        isLoading: true,
        mostCreativePeopleScrollingModule: action.mostCreativePeopleScrollingModule
      };
    },
    MOST_CREATIVE_PEOPLE_SCROLLING_MODULE_LOADED: function MOST_CREATIVE_PEOPLE_SCROLLING_MODULE_LOADED() {
      return {
        isLoading: false,
        data: action.mostCreativePeopleScrollingModule
      };
    },
    MOST_CREATIVE_PEOPLE_SCROLLING_MODULE_ERROR: function MOST_CREATIVE_PEOPLE_SCROLLING_MODULE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeopleScrollingModule.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADING: function MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADING() {
      return {
        isLoading: true,
        mostCreativePeopleCommunityPage: action.mostCreativePeopleCommunityPage
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-creative-people', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.mostCreativePeopleCommunityPage,
        ads: adModelData
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_ERROR: function MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeopleCommunityPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_LOADING: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_LOADING() {
      return {
        isLoading: true,
        mostCreativePeopleCommunitySectionPage: action.mostCreativePeopleCommunitySectionPage
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-creative-people', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.mostCreativePeopleCommunitySectionPage,
        ads: adModelData
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_ERROR: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeopleCommunitySectionPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_LOADING: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_LOADING() {
      return {
        isLoading: true
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_LOADED: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_LOADED() {
      return {
        isLoading: false,
        data: action.mostCreativePeopleCommunitySection
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_ERROR: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeopleCommunitySection.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_NEXT_LOADING: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_NEXT_LOADING() {
      return {
        isLoading: true
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_NEXT_LOADED: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_NEXT_LOADED() {
      return {
        isLoading: false,
        data: action.mostCreativePeopleCommunitySectionNext
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_NEXT_ERROR: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_NEXT_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeopleCommunitySectionNext.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    COMPANY_PAGE_LOADING: function COMPANY_PAGE_LOADING() {
      return {
        isLoading: true,
        companyPage: action.companyPage
      };
    },
    COMPANY_PAGE_LOADED: function COMPANY_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-innovative-companies', 'categoryPage');

      // Override this for Company page
      adModelData.model.adzone = 'leadership/most-innovative-companies';
      return {
        isLoading: false,
        data: action.companyPage,
        ads: adModelData
      };
    },
    COMPANY_PAGE_ERROR: function COMPANY_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    COMPANY_LOADING: function COMPANY_LOADING() {
      return {
        isLoading: true
      };
    },
    COMPANY_LOADED: function COMPANY_LOADED() {
      return {
        isLoading: false,
        data: action.company
      };
    },
    COMPANY_ERROR: function COMPANY_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.company.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    COMPANY_DATA_LOADING: function COMPANY_DATA_LOADING() {
      return {
        isLoading: true
      };
    },
    COMPANY_DATA_LOADED: function COMPANY_DATA_LOADED() {
      return {
        isLoading: false,
        data: action.companyData
      };
    },
    COMPANY_DATA_ERROR: function COMPANY_DATA_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyData.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    COMPANY_AWARDS_LOADING: function COMPANY_AWARDS_LOADING() {
      return {
        isLoading: true
      };
    },
    COMPANY_AWARDS_LOADED: function COMPANY_AWARDS_LOADED() {
      return {
        isLoading: false,
        data: action.companyAwards
      };
    },
    COMPANY_AWARDS_ERROR: function COMPANY_AWARDS_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyAwards.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    COMPANY_INDEX_GROUPS_LOADING: function COMPANY_INDEX_GROUPS_LOADING() {
      return {
        isLoading: true
      };
    },
    COMPANY_INDEX_GROUPS_LOADED: function COMPANY_INDEX_GROUPS_LOADED() {
      return {
        isLoading: false,
        data: action.companyIndexGroups
      };
    },
    COMPANY_INDEX_GROUPS_ERROR: function COMPANY_INDEX_GROUPS_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyIndexGroups.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    COMPANY_INDEX_SECTION_PAGE_LOADING: function COMPANY_INDEX_SECTION_PAGE_LOADING() {
      return {
        isLoading: true,
        companyIndexSectionPage: action.companyIndexSectionPage
      };
    },
    COMPANY_INDEX_SECTION_PAGE_LOADED: function COMPANY_INDEX_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-innovative-companies', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.companyIndexSectionPage,
        ads: adModelData
      };
    },
    COMPANY_INDEX_SECTION_PAGE_ERROR: function COMPANY_INDEX_SECTION_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyIndexSectionPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    COMPANY_INDEX_SECTION_LOADING: function COMPANY_INDEX_SECTION_LOADING() {
      return {
        isLoading: true
      };
    },
    COMPANY_INDEX_SECTION_LOADED: function COMPANY_INDEX_SECTION_LOADED() {
      return {
        isLoading: false,
        data: action.companyIndexSection
      };
    },
    COMPANY_INDEX_SECTION_ERROR: function COMPANY_INDEX_SECTION_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyIndexSection.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    COMPANY_INDEX_SECTION_NEXT_LOADING: function COMPANY_INDEX_SECTION_NEXT_LOADING() {
      return {
        isLoading: true
      };
    },
    COMPANY_INDEX_SECTION_NEXT_LOADED: function COMPANY_INDEX_SECTION_NEXT_LOADED() {
      return {
        isLoading: false,
        data: action.companyIndexSectionNext
      };
    },
    COMPANY_INDEX_SECTION_NEXT_ERROR: function COMPANY_INDEX_SECTION_NEXT_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyIndexSectionNext.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    COMPANY_INDEX_PAGE_LOADING: function COMPANY_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        companyIndexPage: action.companyIndexPage
      };
    },
    COMPANY_INDEX_PAGE_LOADED: function COMPANY_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-innovative-companies', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-innovative-companies';
      return {
        isLoading: false,
        data: action.companyIndexPage,
        ads: adModelData
      };
    },
    COMPANY_INDEX_PAGE_ERROR: function COMPANY_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    MIC_YEAR_PAGE_LOADING: function MIC_YEAR_PAGE_LOADING() {
      return {
        isLoading: true,
        micYearPage: action.micYearPage
      };
    },
    MIC_YEAR_PAGE_LOADED: function MIC_YEAR_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastmic';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-innovative-companies', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-innovative-companies';
      return {
        isLoading: false,
        data: action.micYearPage,
        ads: adModelData
      };
    },
    MIC_YEAR_PAGE_ERROR: function MIC_YEAR_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micYearPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    MIC_SECTOR_PAGE_LOADING: function MIC_SECTOR_PAGE_LOADING() {
      return {
        isLoading: true,
        micYearPage: action.micSectorPage
      };
    },
    MIC_SECTOR_PAGE_LOADED: function MIC_SECTOR_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastmic';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-innovative-companies', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-innovative-companies';
      return {
        isLoading: false,
        data: action.micSectorPage,
        ads: adModelData
      };
    },
    MIC_SECTOR_PAGE_ERROR: function MIC_SECTOR_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micSectorPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    MIC_YEAR_LOADING: function MIC_YEAR_LOADING() {
      return {
        isLoading: true
      };
    },
    MIC_YEAR_LOADED: function MIC_YEAR_LOADED() {
      return {
        isLoading: false,
        data: action.micYear,
        year: action.year
      };
    },
    MIC_YEAR_ERROR: function MIC_YEAR_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micYear.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    MIC_YEAR_DESCRIPTION_LOADING: function MIC_YEAR_DESCRIPTION_LOADING() {
      return {
        isLoading: true
      };
    },
    MIC_YEAR_DESCRIPTION_LOADED: function MIC_YEAR_DESCRIPTION_LOADED() {
      return {
        isLoading: false,
        data: action.micYearDescription
      };
    },
    MIC_YEAR_DESCRIPTION_ERROR: function MIC_YEAR_DESCRIPTION_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micYearDescription.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    MIC_SECTOR_LOADING: function MIC_SECTOR_LOADING() {
      return {
        isLoading: true
      };
    },
    MIC_SECTOR_LOADED: function MIC_SECTOR_LOADED() {
      return {
        isLoading: false,
        data: action.micSector,
        year: action.year,
        sector: action.sector
      };
    },
    MIC_SECTOR_ERROR: function MIC_SECTOR_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micSector.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    AUTHOR_PAGE_LOADING: function AUTHOR_PAGE_LOADING() {
      return {
        isLoading: true,
        authorPage: action.authorPage
      };
    },
    AUTHOR_PAGE_LOADED: function AUTHOR_PAGE_LOADED() {
      var currentState = store.getState();
      var authorData = (0, _get2.default)(currentState, 'author.data');
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, authorData, 'authorPage');

      return {
        isLoading: false,
        data: action.authorPage,
        ads: adModelData
      };
    },
    AUTHOR_PAGE_ERROR: function AUTHOR_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.authorPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    AUTHOR_LOADING: function AUTHOR_LOADING() {
      return {
        isLoading: true,
        author: action.author
      };
    },
    AUTHOR_LOADED: function AUTHOR_LOADED() {
      return {
        isLoading: false,
        data: (0, _get2.default)(action, 'author')
      };
    },
    AUTHOR_ERROR: function AUTHOR_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: (0, _get2.default)(action, 'author.errorMessage')
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    AUTHOR_ALL_FEED_LOADING: function AUTHOR_ALL_FEED_LOADING() {
      return {
        isLoading: true,
        authorAllFeed: action.authorAllFeed,
        allRendered: false
      };
    },
    AUTHOR_ALL_FEED_LOADED: function AUTHOR_ALL_FEED_LOADED() {
      return {
        isLoading: false,
        data: (0, _get2.default)(action, 'authorAllFeed', {}),
        allRendered: false
      };
    },
    AUTHOR_ALL_FEED_ERROR: function AUTHOR_ALL_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: (0, _get2.default)(action, 'authorAllFeed.errorMessage')
      };
    },
    AUTHOR_ALL_FEED_IS_LOADING: function AUTHOR_ALL_FEED_IS_LOADING() {
      return (0, _extend2.default)({}, state, { isEnabled: true, isLoading: true });
    },
    AUTHOR_ALL_FEED_IS_LOADED: function AUTHOR_ALL_FEED_IS_LOADED() {
      return {
        isEnabled: true,
        isLoading: false,
        data: (0, _extend2.default)({}, state.data, {
          page: (0, _get2.default)(action, 'authorAllFeed.page'),
          posts: [].concat(_toConsumableArray(state.data.posts), _toConsumableArray((0, _get2.default)(action, 'authorAllFeed.posts', [])))
        }),
        allRendered: false
      };
    },
    AUTHOR_ALL_FEED_IS_ERROR: function AUTHOR_ALL_FEED_IS_ERROR() {
      return {
        isEnabled: true,
        isLoading: true,
        data: (0, _extend2.default)({}, state, {
          page: (0, _get2.default)(action, 'authorAllFeed.page'),
          posts: [].concat(_toConsumableArray(state.data.posts), _toConsumableArray((0, _get2.default)(action, 'authorAllFeed.posts', [])))
        }),
        allRendered: false
      };
    },
    AUTHOR_ALL_FEED_ALL_STORIES_RENDERED: function AUTHOR_ALL_FEED_ALL_STORIES_RENDERED() {
      return {
        isLoading: true,
        data: state.data,
        allRendered: true
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    SEARCH_LOADING: function SEARCH_LOADING() {
      return {
        isLoading: true
      };
    },
    SEARCH_LOADED: function SEARCH_LOADED() {
      return {
        isLoading: false,
        data: action.search
      };
    },
    SEARCH_ERROR: function SEARCH_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.search.errorMessage,
        queryString: action.search.query
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    SEARCH_PAGE_LOADING: function SEARCH_PAGE_LOADING() {
      return {
        isLoading: true,
        searchPage: action.searchPage
      };
    },
    SEARCH_PAGE_LOADED: function SEARCH_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var searchQuery = (0, _get2.default)(currentState, 'search.data.query.queryString');
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, searchQuery, 'searchPage');

      return {
        isLoading: false,
        data: action.searchPage,
        ads: adModelData
      };
    },
    SEARCH_PAGE_ERROR: function SEARCH_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.searchPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    WP_PAGE_LOADING: function WP_PAGE_LOADING() {
      return {
        isLoading: true,
        wpPage: action.wpPage
      };
    },
    WP_PAGE_LOADED: function WP_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'page', 'wpPage');

      return {
        isLoading: false,
        data: action.wpPage,
        ads: adModelData
      };
    },
    WP_PAGE_ERROR: function WP_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.wpPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    STATIC_PAGE_LOADING: function STATIC_PAGE_LOADING() {
      return {
        isLoading: true,
        staticPage: action.staticPage
      };
    },
    STATIC_PAGE_LOADED: function STATIC_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.staticPage
      };
    },
    STATIC_PAGE_ERROR: function STATIC_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.staticPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    NEWSLETTERS_PREFERENCES_PAGE_LOADING: function NEWSLETTERS_PREFERENCES_PAGE_LOADING() {
      return {
        isLoading: true,
        newslettersPreferencesPage: action.newslettersPreferencesPage
      };
    },
    NEWSLETTERS_PREFERENCES_PAGE_LOADED: function NEWSLETTERS_PREFERENCES_PAGE_LOADED() {
      var baseNewsletterLookup = action.store.getState().config.newsletters.listsById;
      var allNewsletterIds = action.store.getState().config.newsletters.allIds;
      var allNewsletters = allNewsletterIds.map(function (key) {
        var found = baseNewsletterLookup[key];

        return (0, _assign3.default)({}, found, {
          listId: key
        });
      });

      return {
        isLoading: false,
        data: action.newslettersPreferencesPage,
        subscribe: [],
        unsubscribe: [],
        emailEditable: false,
        allNewsletterIds: allNewsletterIds,
        allNewsletters: allNewsletters,
        masterLookup: baseNewsletterLookup,
        allNewslettersSelected: _assign3.default.apply(undefined, _toConsumableArray(allNewsletterIds.map(function (id) {
          return _defineProperty({}, id, action.newslettersPreferencesPage.lists.indexOf(Number(id)) !== -1);
        })))
      };
    },
    NEWSLETTERS_PREFERENCES_PAGE_ERROR: function NEWSLETTERS_PREFERENCES_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.newslettersPreferencesPage.errorMessage
      };
    },
    CHANGE_NEWSLETTER_PREFERENCES_RADIO: function CHANGE_NEWSLETTER_PREFERENCES_RADIO() {
      var newNewsletterId = action.data.selectedListId;
      var radioSet = action.data.radioSet;

      var toUnsubscribe = radioSet.filter(function (id) {
        return id !== newNewsletterId;
      });

      var subscribeLists = determineSubscribeForRadio(newNewsletterId, toUnsubscribe, state.subscribe, state.unsubscribe);

      var newSelectionState = _defineProperty({}, newNewsletterId, true);

      toUnsubscribe.forEach(function (id) {
        newSelectionState[id] = false;
      });

      return (0, _assign3.default)({}, state, {
        allNewslettersSelected: (0, _assign3.default)({}, state.allNewslettersSelected, newSelectionState)
      }, subscribeLists);
    },
    CHANGE_NEWSLETTER_PREFERENCES: function CHANGE_NEWSLETTER_PREFERENCES() {
      var currentlySubscribedTo = state.data.lists;
      var newNewsletterId = action.data.id;
      var currentSelectionState = state.allNewslettersSelected;
      var subscribeLists = determineSubscribe(currentlySubscribedTo, newNewsletterId, currentSelectionState, state.subscribe, state.unsubscribe);
      return (0, _assign3.default)({}, state, {
        allNewslettersSelected: (0, _assign3.default)({}, state.allNewslettersSelected, _defineProperty({}, newNewsletterId, !currentSelectionState[newNewsletterId]))
      }, subscribeLists);
    },
    UPDATE_NEWSLETTER_PREFERENCES_SUCCESS: function UPDATE_NEWSLETTER_PREFERENCES_SUCCESS() {
      return (0, _assign3.default)({}, state, {
        isLoading: false,
        unsubscribe: [],
        subscribe: [],
        subscriptionUpdateSuccessMessage: 'Your subscriptions have been updated!',
        data: (0, _assign3.default)({}, state.data, {
          lists: pruneLists(state.data.lists, state.subscribe, state.unsubscribe)
        })
      });
    },
    PREPARE_EMAIL_FIELD_FOR_CHANGE: function PREPARE_EMAIL_FIELD_FOR_CHANGE() {
      return (0, _assign3.default)({}, state, {
        emailEditable: !state.emailEditable
      });
    },
    UPDATE_SUBSCRIPTION_EMAIL_SUCCESS: function UPDATE_SUBSCRIPTION_EMAIL_SUCCESS() {
      return (0, _assign3.default)({}, state, {
        emailEditable: false,
        data: Object.assign({}, state.data, { email: action.data.email }),
        emailUpdateSuccessMessage: 'Email change sucessful!'
      });
    },
    UPDATE_SUBSCRIPTION_EMAIL_ERROR: function UPDATE_SUBSCRIPTION_EMAIL_ERROR() {
      return (0, _assign3.default)({}, state, {
        emailUpdateMessageError: (0, _get2.default)(action, 'data', '')
      });
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _assign2 = __webpack_require__(18);

var _assign3 = _interopRequireDefault(_assign2);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';


function determineSubscribe(currentlySubscribedTo, id, nlState, toSubscribe, toUnsubscribe) {
  var currVal = nlState[id]; // true or false
  var isAlreadySubscribed = currentlySubscribedTo.indexOf(id) !== -1;
  var updatedUnsubscribed = toUnsubscribe.slice(0);
  var updatedToSubscribe = toSubscribe.slice(0);

  if (isAlreadySubscribed && currVal) {
    // add id to unsubscribe list
    updatedUnsubscribed.push(id);
  }

  if (isAlreadySubscribed && !currVal) {
    // remove id from unsubscribe list
    updatedUnsubscribed.splice(updatedUnsubscribed.indexOf(id), 1);
  }

  if (!isAlreadySubscribed && currVal) {
    // remove id to subscribe list
    updatedToSubscribe.splice(updatedToSubscribe.indexOf(id), 1);
  }

  if (!isAlreadySubscribed && !currVal) {
    // add id to subscribe list
    updatedToSubscribe.push(id);
  }

  return { subscribe: updatedToSubscribe, unsubscribe: updatedUnsubscribed };
}

function determineSubscribeForRadio(idToSubscribe, idsToUnsubscribe, toSubscribe, toUnsubscribe) {
  var updatedToSubscribe = [].concat(_toConsumableArray(toSubscribe), [idToSubscribe]);
  var updatedUnsubscribed = [].concat(_toConsumableArray(toUnsubscribe), _toConsumableArray(idsToUnsubscribe));

  return { subscribe: updatedToSubscribe, unsubscribe: updatedUnsubscribed };
}

function pruneLists(previousState, subscribe, unsubscribe) {
  unsubscribe.forEach(function (listId) {
    previousState.splice(previousState.indexOf(listId), 1);
  });
  return previousState.concat(subscribe);
}

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    CUSTOM_PAGE_LOADING: function CUSTOM_PAGE_LOADING() {
      return {
        isLoading: true
      };
    },
    CUSTOM_PAGE_LOADED: function CUSTOM_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.customPage
      };
    },
    CUSTOM_PAGE_ERROR: function CUSTOM_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.customPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    HTML_SITEMAP_INDEX_PAGE_LOADING: function HTML_SITEMAP_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        htmlSitemapIndexPage: action.htmlSitemapIndexPage
      };
    },
    HTML_SITEMAP_INDEX_PAGE_LOADED: function HTML_SITEMAP_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var htmlSitemapIndexQuery = (0, _get2.default)(currentState, 'htmlSitemapIndex.data.query.queryString');
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, htmlSitemapIndexQuery, 'htmlSitemapIndexPage');

      return {
        isLoading: false,
        data: action.htmlSitemapIndexPage,
        ads: adModelData
      };
    },
    HTML_SITEMAP_INDEX_PAGE_ERROR: function HTML_SITEMAP_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.htmlSitemapIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    HTML_SITEMAP_INDEX_LOADING: function HTML_SITEMAP_INDEX_LOADING() {
      return {
        isLoading: true,
        htmlSitemapIndex: action.htmlSitemapIndex
      };
    },
    HTML_SITEMAP_INDEX_LOADED: function HTML_SITEMAP_INDEX_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var htmlSitemapIndexQuery = (0, _get2.default)(currentState, 'htmlSitemapIndex.data.query.queryString');
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, htmlSitemapIndexQuery, 'htmlSitemapIndex');

      return {
        isLoading: false,
        data: action.htmlSitemapIndex,
        ads: adModelData
      };
    },
    HTML_SITEMAP_INDEX_ERROR: function HTML_SITEMAP_INDEX_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.htmlSitemapIndex.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    HTML_SITEMAP_POST_PAGE_LOADING: function HTML_SITEMAP_POST_PAGE_LOADING() {
      return {
        isLoading: true,
        htmlSitemapPostPage: action.htmlSitemapPostPage
      };
    },
    HTML_SITEMAP_POST_PAGE_LOADED: function HTML_SITEMAP_POST_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var htmlSitemapPostQuery = (0, _get2.default)(currentState, 'htmlSitemapPost.data.query.queryString');
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, htmlSitemapPostQuery, 'htmlSitemapPostPage');

      return {
        isLoading: false,
        data: action.htmlSitemapPostPage,
        ads: adModelData
      };
    },
    HTML_SITEMAP_POST_PAGE_ERROR: function HTML_SITEMAP_POST_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.htmlSitemapPostPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    HTML_SITEMAP_POST_LOADING: function HTML_SITEMAP_POST_LOADING() {
      return {
        isLoading: true,
        htmlSitemapPost: action.htmlSitemapPost
      };
    },
    HTML_SITEMAP_POST_LOADED: function HTML_SITEMAP_POST_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var htmlSitemapPostQuery = (0, _get2.default)(currentState, 'htmlSitemapPost.data.query.queryString');
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, htmlSitemapPostQuery, 'htmlSitemapPost');

      return {
        isLoading: false,
        data: action.htmlSitemapPost,
        ads: adModelData
      };
    },
    HTML_SITEMAP_POST_ERROR: function HTML_SITEMAP_POST_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.htmlSitemapPost.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(7);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    RECIRC_FEED_LOADING: function RECIRC_FEED_LOADING() {
      return {
        hide: false,
        isLoading: true,
        recircFeed: action.recircFeed
      };
    },
    RECIRC_FEED_LOADED: function RECIRC_FEED_LOADED() {
      return {
        hide: false,
        isLoading: false,
        data: action.recircFeed
      };
    },
    RECIRC_FEED_ERROR: function RECIRC_FEED_ERROR() {
      return {
        hide: false,
        isLoading: false,
        error: true,
        errorMessage: action.recircFeed.errorMessage
      };
    },
    HIDE_RECIRC_FEED: function HIDE_RECIRC_FEED() {
      return (0, _extend2.default)({}, state, {
        hide: true
      });
    }
  };

  if (/PAGE_LOADED/.test(action.type)) {
    return (0, _extend2.default)({}, state, {
      hide: false
    });
  }

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    HOMEPAGE_LOADED: function HOMEPAGE_LOADED(site) {
      return contextHelper('homepage', site);
    },
    HOMEPAGE_ERROR: function HOMEPAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    POSTPAGE_LOADED: function POSTPAGE_LOADED(site, currentState) {
      var postData = (0, _get2.default)(currentState, 'post.data.post');
      var id = (0, _get2.default)(postData, 'id');
      return contextHelper((0, _get2.default)(postData, 'type'), site, id, id + '/' + (0, _get2.default)(postData, 'slug'));
    },
    PREVIEW_POSTPAGE_LOADED: function PREVIEW_POSTPAGE_LOADED(site, currentState) {
      var postData = (0, _get2.default)(currentState, 'previewPost.data.post');
      var id = (0, _get2.default)(postData, 'id');
      return contextHelper((0, _get2.default)(postData, 'type'), site, id, 'pvw/' + id + '/' + (0, _get2.default)(postData, 'slug'));
    },
    POSTPAGE_ERROR: function POSTPAGE_ERROR(site, currentState) {
      var postData = (0, _get2.default)(currentState, 'post.data.post');
      var id = (0, _get2.default)(postData, 'id');
      return contextHelper('errorPage', site, id, id + '/' + (0, _get2.default)(postData, 'slug'));
    },
    CATEGORY_PAGE_LOADED: function CATEGORY_PAGE_LOADED(site) {
      return contextHelper('category', site);
    },
    CATEGORY_PAGE_ERROR: function CATEGORY_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    TAG_PAGE_LOADED: function TAG_PAGE_LOADED(site) {
      return contextHelper('tag', site);
    },
    TAG_PAGE_ERROR: function TAG_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    AUTHOR_PAGE_LOADED: function AUTHOR_PAGE_LOADED(site) {
      return contextHelper('author', site);
    },
    AUTHOR_PAGE_ERROR: function AUTHOR_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    SEARCH_PAGE_LOADED: function SEARCH_PAGE_LOADED(site) {
      return contextHelper('search', site);
    },
    SEARCH_PAGE_ERROR: function SEARCH_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    WP_PAGE_LOADED: function WP_PAGE_LOADED(site) {
      return contextHelper('page', site);
    },
    WP_PAGE_ERROR: function WP_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    CUSTOM_PAGE_LOADED: function CUSTOM_PAGE_LOADED(site) {
      return contextHelper('page', site);
    },
    CUSTOM_PAGE_ERROR: function CUSTOM_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    HTML_SITEMAP_INDEX_PAGE_LOADED: function HTML_SITEMAP_INDEX_PAGE_LOADED(site) {
      return contextHelper('sitemapIndexPage', site);
    },
    HTML_SITEMAP_POST_PAGE_LOADED: function HTML_SITEMAP_POST_PAGE_LOADED(site) {
      return contextHelper('sitemapPostPage', site);
    },
    MAGAZINE_ARCHIVE_PAGE_LOADED: function MAGAZINE_ARCHIVE_PAGE_LOADED(site) {
      return contextHelper('magazineArchivePage', site);
    },
    MOST_CREATIVE_PEOPLE_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_PAGE_LOADED(site) {
      return contextHelper('mostCreativePeoplePage', site);
    },
    MOST_CREATIVE_PEOPLE_PAGE_ERROR: function MOST_CREATIVE_PEOPLE_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED(site) {
      return contextHelper('mostCreativePeopleCommunityPage', site);
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_ERROR: function MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_LOADED(site) {
      return contextHelper('mostCreativePeopleCommunitySectionPage', site);
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_ERROR: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    PERSON_INDEX_PAGE_LOADED: function PERSON_INDEX_PAGE_LOADED(site) {
      return contextHelper('personIndexPage', site);
    },
    PERSON_INDEX_PAGE_ERROR: function PERSON_INDEX_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    PERSON_INDEX_SECTION_PAGE_LOADED: function PERSON_INDEX_SECTION_PAGE_LOADED(site) {
      return contextHelper('personIndexSectionPage', site);
    },
    PERSON_INDEX_SECTION_PAGE_ERROR: function PERSON_INDEX_SECTION_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    PERSON_PAGE_LOADED: function PERSON_PAGE_LOADED(site) {
      return contextHelper('personPage', site);
    },
    PERSON_PAGE_ERROR: function PERSON_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    PRODUCT_PAGE_LOADED: function PRODUCT_PAGE_LOADED(site) {
      return contextHelper('productPage', site);
    },
    PRODUCT_INDEX_PAGE_LOADED: function PRODUCT_INDEX_PAGE_LOADED(site) {
      return contextHelper('productIndexPage', site);
    },
    PRODUCT_INDEX_PAGE_ERROR: function PRODUCT_INDEX_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    PRODUCT_INDEX_SECTION_PAGE_LOADED: function PRODUCT_INDEX_SECTION_PAGE_LOADED(site) {
      return contextHelper('productIndexSectionPage', site);
    },
    PRODUCT_INDEX_SECTION_PAGE_ERROR: function PRODUCT_INDEX_SECTION_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    PRODUCT_PAGE_ERROR: function PRODUCT_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    STATIC_PAGE_LOADED: function STATIC_PAGE_LOADED(site) {
      return contextHelper('staticPage', site);
    },
    INNOVATION_BY_DESIGN_PAGE_LOADED: function INNOVATION_BY_DESIGN_PAGE_LOADED(site) {
      return contextHelper('ibdPage', site);
    },
    GIFT_GUIDE_PAGE_LOADED: function GIFT_GUIDE_PAGE_LOADED(site) {
      return contextHelper('giftGuidePage', site);
    },
    COMPANY_PAGE_LOADED: function COMPANY_PAGE_LOADED(site) {
      return contextHelper('companyPage', site);
    },
    VIDEO_INDEX_PAGE_LOADED: function VIDEO_INDEX_PAGE_LOADED(site) {
      return contextHelper('videoIndexPage', site);
    },
    PLAYLIST_PAGE_LOADED: function PLAYLIST_PAGE_LOADED(site) {
      return contextHelper('videoPlaylistPage', site);
    },
    VIDEO_PAGE_LOADED: function VIDEO_PAGE_LOADED(site) {
      return contextHelper('videoPage', site);
    },
    VIDEO_PAGE_ERROR: function VIDEO_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    COMPANY_INDEX_PAGE_LOADED: function COMPANY_INDEX_PAGE_LOADED(site) {
      return contextHelper('companyIndexPage', site);
    },
    COMPANY_INDEX_PAGE_ERROR: function COMPANY_INDEX_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    COMPANY_INDEX_SECTION_PAGE_LOADED: function COMPANY_INDEX_SECTION_PAGE_LOADED(site) {
      return contextHelper('companyIndexSectionPage', site);
    },
    COMPANY_INDEX_SECTION_PAGE_ERROR: function COMPANY_INDEX_SECTION_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    MIC_YEAR_PAGE_LOADED: function MIC_YEAR_PAGE_LOADED(site) {
      return contextHelper('micYearPage', site);
    },
    MIC_YEAR_PAGE_ERROR: function MIC_YEAR_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    MIC_SECTOR_PAGE_LOADED: function MIC_SECTOR_PAGE_LOADED(site) {
      return contextHelper('micSectorPage', site);
    },
    MIC_SECTOR_PAGE_ERROR: function MIC_SECTOR_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    NEWSLETTERS_PREFERENCES_PAGE_LOADED: function NEWSLETTERS_PREFERENCES_PAGE_LOADED(site) {
      return contextHelper('newslettersPreferencesPage', site);
    }
  };

  var store = action.store,
      type = action.type;


  if (typeMap[type]) {
    var currentState = store.getState();
    var site = (0, _get2.default)(currentState, 'config.site');
    return typeMap[action.type](site, currentState);
  }

  if (/PAGE_LOADED/.test(type)) {
    if (store && store.getState) {
      var _currentState = store.getState();
      var _site = (0, _get2.default)(_currentState, 'config.site');
      _logger_service2.default.error('CONTEXT REDUCER DID NOT HANDLE PAGE LOADED, ANALYTICS ARE BROKEN ON ' + type + '!!');
      return {
        type: 'unknown',
        site: _site
      };
    }
  }

  if (/PAGE_ERROR/.test(type)) {
    if (store && store.getState) {
      var _currentState2 = store.getState();
      var _site2 = (0, _get2.default)(_currentState2, 'config.site');
      _logger_service2.default.error('CONTEXT REDUCER DID NOT HANDLE PAGE ERROR, ANALYTICS ARE BROKEN ON ' + action.type + '!!');
      return contextHelper('errorPage', _site2);
    }
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _logger_service = __webpack_require__(3);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
function contextHelper(type, site, id, path) {
  if (!id && !path) {
    return {
      type: type,
      site: site
    };
  }
  return {
    type: type,
    site: site,
    id: id,
    path: path
  };
}

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store,
      type = action.type;


  var typeMap = {
    POSTPAGE_LOADED: function POSTPAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'post');
      return state;
    },
    POSTPAGE_ERROR: function POSTPAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'errorPage');
      return state;
    },
    HOMEPAGE_LOADED: function HOMEPAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'homepage');
      return state;
    },
    HOMEPAGE_ERROR: function HOMEPAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'errorPage');
      return state;
    },
    CATEGORY_PAGE_LOADED: function CATEGORY_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'category');
      return state;
    },
    CATEGORY_PAGE_ERROR: function CATEGORY_PAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'errorPage');
      return state;
    },
    TAG_PAGE_LOADED: function TAG_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'tag');
      return state;
    },
    TAG_PAGE_ERROR: function TAG_PAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'errorPage');
      return state;
    },
    SEARCH_PAGE_LOADED: function SEARCH_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'search');
      return state;
    },
    SEARCH_PAGE_ERROR: function SEARCH_PAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'errorPage');
      return state;
    },
    AUTHOR_PAGE_LOADED: function AUTHOR_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'author');
      return state;
    },
    AUTHOR_PAGE_ERROR: function AUTHOR_PAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'errorPage');
      return state;
    },
    WP_PAGE_LOADED: function WP_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'page');
      return state;
    },
    WP_PAGE_ERROR: function WP_PAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'errorPage');
      return state;
    },
    HTML_SITEMAP_INDEX_PAGE_LOADED: function HTML_SITEMAP_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'htmlSitemapIndex');
      return state;
    },
    HTML_SITEMAP_INDEX_PAGE_ERROR: function HTML_SITEMAP_INDEX_PAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'htmlSitemapIndex');
      return state;
    },
    HTML_SITEMAP_POST_PAGE_LOADED: function HTML_SITEMAP_POST_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'htmlSitemapPostPage');
      return state;
    },
    HTML_SITEMAP_POST_PAGE_ERROR: function HTML_SITEMAP_POST_PAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'htmlSitemapPostPage');
      return state;
    },
    MOST_CREATIVE_PEOPLE_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'mostCreativePeoplePage');
      return state;
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'mostCreativePeopleCommunityPage');
      return state;
    },
    PRODUCT_INDEX_PAGE_LOADED: function PRODUCT_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'productIndexPage');
      return state;
    },
    PRODUCT_INDEX_PAGE_ERROR: function PRODUCT_INDEX_PAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'productIndexPage');

      return state;
    },
    PRODUCT_INDEX_SECTION_PAGE_LOADED: function PRODUCT_INDEX_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'productIndexSectionPage');

      return state;
    },
    PRODUCT_INDEX_SECTION_PAGE_ERROR: function PRODUCT_INDEX_SECTION_PAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'productIndexSectionPage');
      return state;
    },
    PRODUCT_PAGE_LOADED: function PRODUCT_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'productPage');
      return state;
    },
    PERSON_PAGE_LOADED: function PERSON_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'personPage');
      return state;
    },
    STATIC_PAGE_LOADED: function STATIC_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'staticPageData');
      return state;
    },
    INNOVATION_BY_DESIGN_PAGE_LOADED: function INNOVATION_BY_DESIGN_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'ibdPage');
      return state;
    },
    COMPANY_PAGE_LOADED: function COMPANY_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'companyPage');
      return state;
    },
    COMPANY_INDEX_SECTION_PAGE_LOADED: function COMPANY_INDEX_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'companyIndexSectionPage');
      return state;
    },
    MIC_YEAR_PAGE_LOADED: function MIC_YEAR_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'micYearPage');
      return state;
    },
    MIC_SECTOR_PAGE_LOADED: function MIC_SECTOR_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'micSectorPage');
      return state;
    },
    VIDEO_PAGE_LOADED: function VIDEO_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'videoPage');
      return state;
    },
    JW_PLAYLIST_LOADED: function JW_PLAYLIST_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'jwPlaylist');
      return state;
    },
    PLAYLIST_PAGE_LOADED: function PLAYLIST_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'playlistAllFeed');
      return state;
    },
    VIDEO_INDEX_PAGE_LOADED: function VIDEO_INDEX_PAGE_LOADED() {
      var currentState = store.getState();

      trackAnalytics(currentState, 'videoIndexPage');
      return state;
    },
    MAGAZINE_ARCHIVE_PAGE_LOADED: function MAGAZINE_ARCHIVE_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'magazineArchivePage');
      return state;
    }
  };

  if (typeMap[type]) {
    return typeMap[type](action);
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _exenv = __webpack_require__(4);

var _trackThirdPartyJS = __webpack_require__(140);

var _trackThirdPartyJS2 = _interopRequireDefault(_trackThirdPartyJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trackAnalytics(currentState, type) {
  if (_exenv.canUseDOM) {
    var currentStateCopy = currentState;
    var initialPageLoad = (0, _get2.default)(currentStateCopy, 'config.initialPageLoad');
    // build context... sux but due to synchronous nature of reducers
    // this will have to be built here

    currentStateCopy.context = {
      site: (0, _get2.default)(currentStateCopy, 'config.site'),
      type: type,
      postData: (0, _get2.default)(currentStateCopy, 'post.data.post'),
      tagPageData: (0, _get2.default)(currentState, 'tagFeaturedFeed.tag'),
      categoryPageData: (0, _get2.default)(currentState, 'categoryFeaturedFeed.category'),
      authorPageData: (0, _get2.default)(currentState, 'author.data'),
      staticPageData: (0, _get2.default)(currentState, 'customPage.data.page[0]'),
      mostCreativePeoplePageData: (0, _get2.default)(currentState, 'mostCreativePeople'),
      personPageData: (0, _get2.default)(currentState, 'person'),
      searchPageData: (0, _get2.default)(currentState, 'search.data'),
      ibdPageData: (0, _get2.default)(currentState, 'innovationByDesign'),
      companyPageData: (0, _get2.default)(currentState, 'companyData'),
      micPageData: (0, _get2.default)(currentState, 'micYear'),
      micSectorPageData: (0, _get2.default)(currentState, 'micSector'),
      videoPageData: (0, _get2.default)(currentState, 'jwVideo'),
      videoIndexPageData: (0, _get2.default)(currentState, 'videoIndexPage'),
      productPageData: (0, _get2.default)(currentState, 'product'),
      playlistAllFeedData: (0, _get2.default)(currentState, 'playlistAllFeed.data')
    };

    if (!initialPageLoad) {
      (0, _trackThirdPartyJS2.default)(currentStateCopy);
    }
  }
}

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  if (action.type === 'INITIAL_PAGE_LOAD') {
    return (0, _assign2.default)({}, state, {
      initialPageLoad: false
    });
  }

  if (_exenv.canUseDOM && /PAGE_LOADED/.test(action.type)) {
    // console.log('reducer: ' + action.type + ' ' + window.location.href);
    var navHistory = (0, _cloneDeep2.default)(state.navHistory);
    navHistory.push(window.location.href);
    return (0, _assign2.default)({}, state, { navHistory: navHistory });
  }

  return state;
};

var _exenv = __webpack_require__(4);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _cloneDeep = __webpack_require__(75);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store,
      type = action.type;


  var typeMap = {
    POSTPAGE_LOADED: function POSTPAGE_LOADED() {
      var currentState = store.getState();
      return (0, _post_seo_util2.default)(currentState);
    },
    PREVIEW_POSTPAGE_LOADED: function PREVIEW_POSTPAGE_LOADED() {
      var currentState = store.getState();
      return (0, _post_seo_util2.default)(currentState);
    },
    HOMEPAGE_LOADED: function HOMEPAGE_LOADED() {
      var currentState = store.getState();
      return (0, _homepage_seo_util2.default)(currentState);
    },
    CATEGORY_PAGE_LOADED: function CATEGORY_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _category_seo_util2.default)(currentState);
    },
    TAG_PAGE_LOADED: function TAG_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _tag_seo_util2.default)(currentState);
    },
    PERSON_PAGE_LOADED: function PERSON_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _person_seo_util2.default)(currentState);
    },
    PRODUCT_PAGE_LOADED: function PRODUCT_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _product_seo_util2.default)(currentState);
    },
    MOST_CREATIVE_PEOPLE_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _most_creative_people_seo_util2.default)(currentState);
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _most_creative_people_community_seo_util2.default)(currentState);
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _most_creative_people_community_seo_util2.default)(currentState);
    },
    PERSON_INDEX_PAGE_LOADED: function PERSON_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _person_index_seo_util2.default)(currentState);
    },
    PERSON_INDEX_SECTION_PAGE_LOADED: function PERSON_INDEX_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _person_index_seo_util2.default)(currentState);
    },
    PRODUCT_INDEX_PAGE_LOADED: function PRODUCT_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _product_index_seo_util2.default)(currentState);
    },
    PRODUCT_INDEX_SECTION_PAGE_LOADED: function PRODUCT_INDEX_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _product_index_seo_util2.default)(currentState);
    },
    AUTHOR_PAGE_LOADED: function AUTHOR_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _author_seo_util2.default)(currentState);
    },
    SEARCH_PAGE_LOADED: function SEARCH_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _search_seo_util2.default)(currentState);
    },
    WP_PAGE_LOADED: function WP_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _wp_page_seo_util2.default)(currentState);
    },
    STATIC_PAGE_LOADED: function STATIC_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _static_page_seo_util2.default)(currentState);
    },
    HTML_SITEMAP_INDEX_PAGE_LOADED: function HTML_SITEMAP_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _sitemap_index_page_seo_util2.default)(currentState);
    },
    HTML_SITEMAP_POST_PAGE_LOADED: function HTML_SITEMAP_POST_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _sitemap_post_page_seo_util2.default)(currentState);
    },
    MAGAZINE_ARCHIVE_LOADED: function MAGAZINE_ARCHIVE_LOADED() {
      var currentState = store.getState();
      return (0, _magazine_archive_seo_util2.default)(currentState);
    },
    MIC_YEAR_PAGE_LOADED: function MIC_YEAR_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _mic_year_page_seo_util2.default)(currentState);
    },
    MIC_SECTOR_PAGE_LOADED: function MIC_SECTOR_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _mic_sector_page_seo_util2.default)(currentState);
    },
    COMPANY_PAGE_LOADED: function COMPANY_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _company_page_seo_util2.default)(currentState);
    },
    COMPANY_INDEX_PAGE_LOADED: function COMPANY_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _company_index_seo_util2.default)(currentState);
    },
    COMPANY_INDEX_SECTION_PAGE_LOADED: function COMPANY_INDEX_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _company_index_seo_util2.default)(currentState);
    },
    INNOVATION_BY_DESIGN_PAGE_LOADED: function INNOVATION_BY_DESIGN_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _ibd_year_page_seo_util2.default)(currentState);
    },
    GIFT_GUIDE_PAGE_LOADED: function GIFT_GUIDE_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _gift_guide_page_seo_util2.default)(currentState);
    },
    GIFT_PAGE_LOADED: function GIFT_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _gift_seo_util2.default)(currentState);
    },
    VIDEO_PAGE_LOADED: function VIDEO_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _video_seo_util2.default)(currentState);
    },
    PLAYLIST_PAGE_LOADED: function PLAYLIST_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _video_playlist_seo_util2.default)(currentState);
    },
    VIDEO_INDEX_PAGE_LOADED: function VIDEO_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _video_index_seo_util2.default)(currentState);
    },
    NEWSLETTERS_PREFERENCES_PAGE_LOADED: function NEWSLETTERS_PREFERENCES_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _newsletters_preferences_page_seo_util2.default)(currentState);
    }
  };
  if (typeMap[type]) {
    return typeMap[type](action);
  }

  return state;
};

var _homepage_seo_util = __webpack_require__(787);

var _homepage_seo_util2 = _interopRequireDefault(_homepage_seo_util);

var _post_seo_util = __webpack_require__(788);

var _post_seo_util2 = _interopRequireDefault(_post_seo_util);

var _video_seo_util = __webpack_require__(791);

var _video_seo_util2 = _interopRequireDefault(_video_seo_util);

var _video_index_seo_util = __webpack_require__(792);

var _video_index_seo_util2 = _interopRequireDefault(_video_index_seo_util);

var _video_playlist_seo_util = __webpack_require__(793);

var _video_playlist_seo_util2 = _interopRequireDefault(_video_playlist_seo_util);

var _category_seo_util = __webpack_require__(794);

var _category_seo_util2 = _interopRequireDefault(_category_seo_util);

var _tag_seo_util = __webpack_require__(795);

var _tag_seo_util2 = _interopRequireDefault(_tag_seo_util);

var _person_seo_util = __webpack_require__(796);

var _person_seo_util2 = _interopRequireDefault(_person_seo_util);

var _product_seo_util = __webpack_require__(797);

var _product_seo_util2 = _interopRequireDefault(_product_seo_util);

var _person_index_seo_util = __webpack_require__(798);

var _person_index_seo_util2 = _interopRequireDefault(_person_index_seo_util);

var _product_index_seo_util = __webpack_require__(799);

var _product_index_seo_util2 = _interopRequireDefault(_product_index_seo_util);

var _magazine_archive_seo_util = __webpack_require__(800);

var _magazine_archive_seo_util2 = _interopRequireDefault(_magazine_archive_seo_util);

var _most_creative_people_seo_util = __webpack_require__(801);

var _most_creative_people_seo_util2 = _interopRequireDefault(_most_creative_people_seo_util);

var _most_creative_people_community_seo_util = __webpack_require__(802);

var _most_creative_people_community_seo_util2 = _interopRequireDefault(_most_creative_people_community_seo_util);

var _mic_year_page_seo_util = __webpack_require__(803);

var _mic_year_page_seo_util2 = _interopRequireDefault(_mic_year_page_seo_util);

var _mic_sector_page_seo_util = __webpack_require__(804);

var _mic_sector_page_seo_util2 = _interopRequireDefault(_mic_sector_page_seo_util);

var _company_page_seo_util = __webpack_require__(805);

var _company_page_seo_util2 = _interopRequireDefault(_company_page_seo_util);

var _ibd_year_page_seo_util = __webpack_require__(806);

var _ibd_year_page_seo_util2 = _interopRequireDefault(_ibd_year_page_seo_util);

var _gift_guide_page_seo_util = __webpack_require__(807);

var _gift_guide_page_seo_util2 = _interopRequireDefault(_gift_guide_page_seo_util);

var _gift_seo_util = __webpack_require__(808);

var _gift_seo_util2 = _interopRequireDefault(_gift_seo_util);

var _company_index_seo_util = __webpack_require__(809);

var _company_index_seo_util2 = _interopRequireDefault(_company_index_seo_util);

var _author_seo_util = __webpack_require__(810);

var _author_seo_util2 = _interopRequireDefault(_author_seo_util);

var _search_seo_util = __webpack_require__(811);

var _search_seo_util2 = _interopRequireDefault(_search_seo_util);

var _wp_page_seo_util = __webpack_require__(812);

var _wp_page_seo_util2 = _interopRequireDefault(_wp_page_seo_util);

var _static_page_seo_util = __webpack_require__(813);

var _static_page_seo_util2 = _interopRequireDefault(_static_page_seo_util);

var _newsletters_preferences_page_seo_util = __webpack_require__(814);

var _newsletters_preferences_page_seo_util2 = _interopRequireDefault(_newsletters_preferences_page_seo_util);

var _sitemap_index_page_seo_util = __webpack_require__(815);

var _sitemap_index_page_seo_util2 = _interopRequireDefault(_sitemap_index_page_seo_util);

var _sitemap_post_page_seo_util = __webpack_require__(816);

var _sitemap_post_page_seo_util2 = _interopRequireDefault(_sitemap_post_page_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var siteHumanReadable = (0, _get2.default)(siteConf, '[og:site_name]');

  var next = false;
  var prev = false;

  var page = (0, _get2.default)(state, 'allFeed.data.page');
  var totalPages = (0, _get2.default)(state, 'allFeed.data.totalPages');
  var rss = '/latest/rss?truncated=true';

  var base = {
    site: site,
    siteConf: siteConf,
    title: siteHumanReadable || 'Fast Company',
    twitterCard: 'summary',
    publisher: false,
    type: 'website',
    config: state.config,
    rss: rss,
    extend: [{
      link: []
    }],
    useSloganTitle: true
  };

  if (page < totalPages && page - 1 !== 0) {
    prev = 'https://www.' + site + '.com/all/' + (page - 1);
  }

  if (page + 1 <= totalPages) {
    next = 'https://www.' + site + '.com/all/' + (page + 1);
  }

  if (next) {
    base.extend[0].link.push({
      rel: 'next',
      href: next
    });
  }

  if (prev) {
    base.extend[0].link.push({
      rel: 'prev',
      href: prev
    });
  }

  return (0, _base_seo_util2.default)(base);
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var post = (0, _get2.default)(state, 'post.data.post') || (0, _get2.default)(state, 'previewPost.data.post') || {};
  var categories = (0, _get2.default)(post, 'categories', []);
  var title = (0, _get2.default)(post, 'title', '');
  var id = (0, _get2.default)(post, 'id');
  var slug = (0, _get2.default)(post, 'slug');
  var author = (0, _get2.default)(post, 'author.name');

  var image = (0, _get2.default)(post, 'shareImage', '');
  if ((0, _get2.default)(post, 'featured_image.source')) {
    // TODO: move this into the api.
    image = (0, _cloudinary_asset_util.changeAssetDomain)(image);
    image = image.replace('.gif', '.jpg');
  }
  var DESKTOP_SIZE = true;
  image = (0, _cloudinary_asset_util.buildAssetUrlWithPresets)(image, _cloudinary_asset_util.imageSizesLookup.meta, DESKTOP_SIZE);

  var articleDate = (0, _get2.default)(post, 'datePublished');
  var dateModified = (0, _get2.default)(post, 'dateModified');
  var allTags = (0, _get2.default)(post, 'tags');
  var category = (0, _get2.default)(categories, '[0].name');
  var getTag = function cleanTag() {
    var name = (0, _get2.default)(allTags, '[0].name');
    if (name === 'homepage' || name === 'top' || name === 'featured') {
      return false;
    }
    return name;
  };

  var isVideoPost = (0, _get2.default)(post, 'posterVideo.feedId');
  var oTags = [category, getTag()];
  var dedupedTags = (0, _uniq2.default)((0, _compact2.default)(oTags));
  var standout = (0, _find2.default)(allTags, { name: 'standout' }) || (0, _find2.default)(allTags, { name: 'googlepick' }) || false;
  var tags = dedupedTags.filter(function (item) {
    return !/^byline_/.test(item);
  }).join(', ');
  var description = (0, _get2.default)(post, 'excerpt') || '';
  var url = 'https://www.' + site + '.com/' + id + '/' + slug;

  var titleTruncated = title.length >= 70 ? title.substring(0, 70) : title;

  var isAdvertorialPost = (0, _advertorial.isAdvertorial)(allTags);

  var data = (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    titleTruncated: titleTruncated,
    url: url,
    description: description,
    image: image,
    image_width: 1280,
    image_height: 720,
    articleSection: category,
    config: state.config,
    extend: [{
      meta: [{
        property: 'article:published_time',
        content: articleDate
      }, {
        property: 'article:modified_time',
        content: dateModified
      }, {
        property: 'author',
        content: author
      }, {
        name: 'news_keywords',
        content: tags
      }]
    }],
    noPipe: true
  });

  (0, _each2.default)(dedupedTags, function addOGMeta(tag) {
    data.meta.push({
      property: 'article:tag',
      content: tag
    });
  });

  if (standout) {
    data.meta.push({
      property: 'standout',
      content: url
    });
  }

  if (isAdvertorialPost) {
    data.meta.push({ name: 'ROBOTS', content: 'NOINDEX,FOLLOW' });
  }

  var ampUrl = url.replace('https://www', 'https://amp');
  data.link.push({
    rel: 'amphtml',
    href: ampUrl
  });

  // https://developers.facebook.com/docs/instant-articles/crawler-ingestion
  if ((0, _get2.default)(state, 'config.featureFlags.fbiaEnabled') && !isAdvertorialPost && !isVideoPost) {
    var fbiaUrl = url.replace('https://www', 'https://fbia');
    data.meta.push({
      property: 'ia:markup_url',
      content: fbiaUrl
    });
  }

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _uniq = __webpack_require__(246);

var _uniq2 = _interopRequireDefault(_uniq);

var _compact = __webpack_require__(247);

var _compact2 = _interopRequireDefault(_compact);

var _each = __webpack_require__(248);

var _each2 = _interopRequireDefault(_each);

var _find = __webpack_require__(789);

var _find2 = _interopRequireDefault(_find);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

var _advertorial = __webpack_require__(29);

var _cloudinary_asset_util = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 789 */,
/* 790 */,
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var url = (0, _get2.default)(state, 'config.navHistory[0]');
  var siteConf = _site_data_util2.default[site] || {};
  var video = (0, _get2.default)(state, 'jwVideo.data.playlist[0]', {});
  var title = 'VIDEO | ' + (0, _get2.default)(video, 'title', '');
  var id = (0, _get2.default)(video, 'mediaid');
  var slug = (0, _get2.default)(video, 'slug');
  var image = 'https://images.fastcompany.net/image/fetch/w_1280,f_auto,q_auto,fl_lossy/' + (0, _get2.default)(video, 'image', '');
  var date = (0, _get2.default)(video, 'formattedDate', '');
  var tags = (0, _get2.default)(video, 'tags', []).map(function (tag) {
    return tag.name;
  });
  var dedupedTags = (0, _uniq2.default)((0, _compact2.default)(tags));
  var description = (0, _get2.default)(video, 'description', '');

  var data = (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    url: 'https://www.' + site + '.com/video/' + slug + '/' + id,
    description: description,
    image: image,
    image_width: 1280,
    image_height: 720,
    type: 'video',
    config: state.config,
    extend: [{
      meta: [{
        property: 'video:published_time',
        content: date
      }]
    }]
  });

  (0, _each2.default)(dedupedTags, function addOGMeta(tag) {
    data.meta.push({
      property: 'video:tag',
      content: tag
    });
  });

  var ampUrl = url.replace('https://www', 'https://amp');
  data.link.push({
    rel: 'amphtml',
    href: ampUrl
  });

  /*
  if (isAdvertorial(allTags)) {
    data.meta.push({ name: 'ROBOTS', content: 'NOINDEX,FOLLOW' });
  }
  */

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _uniq = __webpack_require__(246);

var _uniq2 = _interopRequireDefault(_uniq);

var _compact = __webpack_require__(247);

var _compact2 = _interopRequireDefault(_compact);

var _each = __webpack_require__(248);

var _each2 = _interopRequireDefault(_each);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var title = 'Video | Fast Company | Business + Innovation';

  var image = 'https://images.fastcompany.net/image/upload/w_1280,q_auto,f_auto,fl_lossy/v1480632834/fast-company-share-graphic.png';
  var description = 'Fast Company inspires a new breed of innovative and creative thought leaders who are actively inventing the future of business.';

  var data = (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    url: 'https://www.fastcompany.com/videos',
    description: description,
    image: image,
    image_width: 1280,
    image_height: 720,
    type: 'video',
    config: state.config
  });

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var playlistName = (0, _get2.default)(state, 'playlistAllFeed.data.title');
  var playlistSlug = (0, _get2.default)(state, 'playlistAllFeed.data.slug');
  var playlistId = (0, _get2.default)(state, 'playlistAllFeed.data.feedid');
  var page = (0, _get2.default)(state, 'playlistAllFeed.data.page');
  var url = 'https://www.fastcompany.com/videos/playlist/' + playlistSlug + '/' + playlistId;
  var title = playlistName + ' Video Playlist';

  var image = 'https://images.fastcompany.net/image/upload/w_1280,q_auto,f_auto,fl_lossy/v1480632834/fast-company-share-graphic.png';
  var description = 'Fast Company inspires a new breed of innovative and creative thought leaders who are actively inventing the future of business.';

  var data = (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    noPipe: true,
    title: title,
    url: generateUrl(url, page),
    description: description,
    image: image,
    image_width: 1280,
    image_height: 720,
    type: 'video',
    config: state.config
  });

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generateUrl(url, page) {
  if (page) {
    return url + '/' + page;
  }

  return url;
}

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var category = (0, _get2.default)(state, 'categoryFeaturedFeed.category', {
    description: 'Breaking news and analysis on business, technology, and leadership from the Fast Company news team.',
    slug: 'news'
  });

  var tagName = (0, _get2.default)(state, 'categoryAllFeed.data.tag.name');
  var tagSlug = (0, _get2.default)(state, 'categoryAllFeed.data.tag.slug');
  var hasTagDescription = (0, _get2.default)(state, 'categoryAllFeed.data.tag.description') !== '';

  var categoryName = (0, _get2.default)(category, 'name');
  var slug = (0, _get2.default)(category, 'slug');
  var description = hasTagDescription ? (0, _get2.default)(state, 'categoryAllFeed.data.tag.description') : (0, _get2.default)(category, 'description');
  var title = categoryName ? '' + categoryName : '';
  var image = '';

  if (slug === 'magazine') {
    title = 'Fast Company Magazine';
  }

  if (tagName) {
    title = categoryName + ' : ' + tagName;
  }

  if (slug === 'news') {
    image = 'https://images.fastcompany.net/image/upload/v1501604705/fcweb/fastco-news-share-graphic_jot2bv.png';
  }

  var url = tagName ? 'https://www.' + site + '.com/' + slug + '/' + tagSlug : 'https://www.' + site + '.com/' + slug;

  var rss = '/' + slug + '/rss';

  var data = (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    image: image,
    url: url,
    description: description,
    config: state.config,
    articleSection: categoryName,
    rss: rss
  });

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var tag = (0, _get2.default)(state, 'tagFeaturedFeed.tag') || {};
  var tagName = (0, _get2.default)(tag, 'name');
  var slug = (0, _get2.default)(tag, 'slug');
  var tagDescription = (0, _get2.default)(tag, 'description');
  var tags = (0, _get2.default)(state, 'tagAllFeed.data[0].tags');
  var rss = '/section/' + slug + '/rss';
  var defaultDescription = 'Fast Company articles and posts tagged ' + tagName + ' with a unique editorial focus on innovation in technology, leadership, and design.';
  var currentIssue = null;

  if ((0, _get2.default)(state, 'magazineIssuePosts')) {
    currentIssue = (0, _get2.default)(state, 'magazineIssuePosts.data.issue', {});
  }

  var title = tagName ? 'Fast Company posts tagged ' + tagName : '';

  if ((0, _get2.default)(currentIssue, 'description', '')) {
    title = (0, _get2.default)(currentIssue, 'description', '').replace(/ \| /g, ', ');
  }

  var data = (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    url: 'https://www.' + site + '.com/section/' + slug,
    description: tagDescription ? (0, _striptags2.default)(tagDescription) : defaultDescription,
    articleSection: tagName,
    rss: rss,
    config: state.config
  });

  if ((0, _advertorial.isAdvertorial)(tags)) {
    data.meta.push({
      name: 'ROBOTS',
      content: 'NOINDEX,FOLLOW'
    });
  }

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _striptags = __webpack_require__(35);

var _striptags2 = _interopRequireDefault(_striptags);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

var _advertorial = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var person = (0, _get2.default)(state, 'person.data.rows[0]');
  var name = (0, _get2.default)(person, 'first_name') + ' ' + (0, _get2.default)(person, 'last_name');
  var url = 'https://www.fastcompany.com/person/' + (0, _get2.default)(person, 'url');
  var description = (0, _striptags2.default)((0, _get2.default)(person, 'bio'), '');
  var image = (0, _get2.default)(person, 'images[0].url') || '';
  var mcp = (0, _get2.default)(person, 'mcp');
  var mcpAwards = (0, _get2.default)(person, 'mcp_awards');
  var mcpYear = (0, _get2.default)(person, 'mcp_awards[0].year');

  // https://a.fastcompany.net/multisite_files/fastcompany/imagecache/w/300/h/300/crop/people/2017/05/03/ganesh-bell-fa0617head024a_sm-6orww8.jpg

  // https://a.fastcompany.net/multisite_files/fastcompany/people/2017/05/03/james-anderson-fa0617head029a_sm-i9y01m.jpg

  var imageParts = image.split('/fastcompany/');
  var twitterImage = 'https://a.fastcompany.net/multisite_files/fastcompany/imagecache/w/300/h/300/crop/' + (0, _get2.default)(imageParts, '[1]');

  var baseSEO = {
    site: site,
    siteConf: siteConf,
    url: url,
    description: description,
    image: image,
    twitterCard: 'summary',
    twitterImage: twitterImage
  };

  if (mcp === 1 && mcpAwards.length) {
    baseSEO.articleSection = 'Most Creative People';
    baseSEO.title = name + ', Most Creative People ' + mcpYear;
    return (0, _base_seo_util2.default)(baseSEO);
  }

  if (mcp === 1) {
    baseSEO.articleSection = 'Most Creative People';
    baseSEO.title = name + ', Most Creative People';
    return (0, _base_seo_util2.default)(baseSEO);
  }

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: name + ': Latest News, Work, Videos, Photos',
    url: url,
    description: description,
    image: image,
    articleSection: 'People',
    twitterCard: 'summary',
    twitterImage: twitterImage,
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _striptags = __webpack_require__(35);

var _striptags2 = _interopRequireDefault(_striptags);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var product = (0, _get2.default)(state, 'product.data.rows[0]');
  var name = '' + (0, _get2.default)(product, 'name');
  var url = 'https://www.fastcodesign.com/product/' + (0, _get2.default)(product, 'url');
  var description = name + ' and what makes it innovative for users, developers and partners.  Includes press releases, videos, screenshots and downloads.';
  var image = (0, _get2.default)(product, 'images[0].url') || '';

  var imageParts = image.split('/fastcompany/');
  var twitterImage = 'https://a.fastcompany.net/multisite_files/fastcompany/imagecache/w/300/h/300/crop/' + (0, _get2.default)(imageParts, '[1]');

  var title = name + ': Latest News, Work, Videos, Photos';
  var isIBDEntry = (0, _get2.default)(product, 'creator_people.length');
  if (isIBDEntry) {
    title = name + ': Innovation by Design';
  }

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    url: url,
    description: description,
    image: image,
    articleSection: 'Product',
    twitterCard: 'summary',
    twitterImage: twitterImage,
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: 'Person Index',
    url: 'https://www.fastcompany.com/person',
    description: 'A list of people in the Fast Company database',
    articleSection: 'Person Index',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: 'Product Index',
    url: 'https://www.fastcodesign.com/stuff',
    description: 'A list of products Co.Design has featured including finalists and winners of Innovation by Design Awards',
    articleSection: 'Product Index',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: 'Fast Company Magazine Archives From 1995 to Today',
    url: 'https://www.fastcompany.com/magazine/archives',
    description: 'Fast Company Magazine issues and archives published from 1995 to today. Available in print, on the web, and PDF format.',
    articleSection: 'Magazine Index',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var year = (0, _get2.default)(state, 'mostCreativePeople.year');
  var imgPresets = 'https://images.fastcompany.net/image/upload/w_530,q_auto,f_auto,fl_lossy';
  var posterImgs = {
    2017: imgPresets + '/v1494843167/MCPwith100and2017forSocial.jpg',
    2016: imgPresets + '/v1495030888/MCP100-2016Logo-SHARE.png',
    2015: imgPresets + '/v1495030888/MCP100-2015Logo-SHARE.png',
    2014: imgPresets + '/v1495030888/MCP100-2014Logo-SHARE.png',
    fallback: imgPresets + '/v1495030888/MCP-Logo-default-SHARE.png'
  };

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: 'Most Creative People in Business ' + year,
    url: 'https://www.fastcompany.com/most-creative-people/' + year,
    description: 'Meet ' + year + '\'s most inspiring leaders in the Fast Company community',
    image: posterImgs[year] || posterImgs.fallback,
    articleSection: 'Most Creative People',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var imgPresets = 'https://images.fastcompany.net/image/upload/w_530,q_auto,f_auto,fl_lossy';

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: 'Most Creative People in Business Community',
    url: 'https://www.fastcompany.com/most-creative-people-community',
    description: 'Meet the most inspiring leaders in the Fast Company community',
    image: imgPresets + '/v1495030888/MCP-Logo-default-SHARE.jpg',
    articleSection: 'Most Creative People',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var year = (0, _get2.default)(state, 'micYear.year');
  var imgPresets = 'https://images.fastcompany.net/image/upload/w_530,q_auto,f_auto,fl_lossy';

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: 'The ' + year + ' World\'s Most Innovative Companies',
    url: 'https://www.fastcompany.com/most-innovative-companies/' + year,
    description: 'Our annual guide to the businesses that matter the most',
    image: imgPresets + '/v1495030888/fcweb/MIC-' + year + '-Logo-OG.png',
    articleSection: 'Most Innovative Companies',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var year = (0, _get2.default)(state, 'micYear.year');
  var sector = (0, _get2.default)(state, 'micSector.sector');
  var imgPresets = 'https://images.fastcompany.net/image/upload/w_530,q_auto,f_auto,fl_lossy';
  if (sector) {
    var sectorIndex = (0, _findIndex2.default)((0, _get2.default)(state, 'micSector.data.rows', []), function (sec) {
      return sec.url === sector;
    });
    var sectorName = (0, _get2.default)(state, 'micSector.data.rows[' + sectorIndex + '].name', sector);
    return (0, _base_seo_util2.default)({
      site: site,
      siteConf: siteConf,
      title: 'The ' + year + ' Top 10 Most Innovative Companies by Sector: ' + sectorName,
      url: 'https://www.fastcompany.com/most-innovative-companies/' + year + '/sectors/' + sector,
      description: 'Our annual guide to the businesses that matter the most',
      image: imgPresets + '/v1501095175/fcweb/MICbySectorforSocial_tknaam.jpg',
      articleSection: 'Most Innovative Companies'
    });
  }
  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: 'The ' + year + ' World\'s Most Innovative Companies',
    url: 'https://www.fastcompany.com/most-innovative-companies/' + year,
    description: 'The ' + year + ' guide to the businesses that matter the most.',
    image: imgPresets + '/v1495030888/fcweb/MIC-' + year + '-Logo-OG.png',
    articleSection: 'Most Innovative Companies',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _findIndex = __webpack_require__(99);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var company = (0, _get2.default)(state, 'company.data.rows[0].name');
  var slug = (0, _get2.default)(state, 'company.data.rows[0].url');

  var isMIC = (0, _get2.default)(state, 'companyAwards.data.rows.length');
  var title = company + ': Latest News, Work, Videos, Photos';

  if (isMIC) {
    title = company + ': Most Innovative Company';
  }

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    url: 'https://www.fastcompany.com/company/' + slug,
    description: 'Read more about ' + company + ' on Fast Company',
    image: 'https://images.fastcompany.net/image/upload/v1480632834/fast-company-share-graphic.png',
    articleSection: 'Most Innovative Companies',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var year = (0, _get2.default)(state, 'innovationByDesign.year');
  var img = 'https://a.fastcompany.net/multisite_files/fastcompany/imagecache/w/500/h/400/scale/ibd/ibd-' + year + '-logo-share.png';

  // TODO: This solution is temporary. It needs some work to make sure the text is correct for each year.
  var description = 'Check out the ' + year + ' Innovation by Design Awards.';
  if (parseInt(year, 10) === 2017) {
    description = "Fast Company's sixth annual Innovation By Design Awards are now announced. Read on for this year's " + 'best products, services, interfaces, and ideas.';
  }

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: 'Innovation by Design Awards ' + year,
    url: 'https://www.fastcodesign.com/innovation-by-design/' + year,
    description: description,
    image: img,
    articleSection: 'Innovation By Design Awards',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var ggDetails = (0, _get2.default)(state, 'giftGuideDetail.data.rows[0]');
  var slugMapping = {
    1: 'holiday-2017'
  };
  var slug = slugMapping[(0, _get2.default)(ggDetails, 'year_id')];

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: (0, _get2.default)(ggDetails, 'title', ''),
    url: 'https://www.fastcodesign.com/gift-guide/' + slug,
    description: (0, _get2.default)(ggDetails, 'description', ''),
    image: (0, _get2.default)(ggDetails, 'logo_url', ''),
    articleSection: 'Gift Guide',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var gift = (0, _get2.default)(state, 'gift.data.rows[0]');
  var name = '' + (0, _get2.default)(gift, 'name');
  var url = 'https://www.fastcompany.com/gift/' + (0, _get2.default)(gift, 'url');
  var description = '';
  var image = (0, _get2.default)(gift, 'images[0].url') || '';

  var imageParts = image.split('/fastcompany/');
  var twitterImage = 'https://a.fastcompany.net/multisite_files/fastcompany/imagecache/w/300/h/300/crop/' + (0, _get2.default)(imageParts, '[1]');

  var title = name + ': Latest News, Work, Videos, Photos';
  var isIBDEntry = (0, _get2.default)(gift, 'creator_people.length');
  if (isIBDEntry) {
    title = name + ': Innovation by Design';
  }

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    url: url,
    description: description,
    image: image,
    articleSection: 'Product',
    twitterCard: 'summary',
    twitterImage: twitterImage,
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: 'All Companies',
    url: 'https://www.fastcompany.com/company',
    description: 'A list of companies Fast Company has featured including the Most Innovative',
    image: 'https://images.fastcompany.net/image/upload/v1480632834/fast-company-share-graphic.png',
    articleSection: 'Most Innovative Companies',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var siteHumanReadable = (0, _get2.default)(siteConf, '[og:site_name]');
  var author = (0, _get2.default)(state, 'author.data') || {};
  var authorName = (0, _get2.default)(author, 'name');
  var authorSlug = (0, _get2.default)(author, 'slug');
  var description = authorName ? 'Articles and posts written and edited by ' + authorName : 'Author stories on ' + siteHumanReadable;
  var title = authorName ? '' + authorName : '' + siteHumanReadable;

  var rss = '/user/' + authorSlug + '/rss';

  var next = false;
  var prev = false;

  var page = (0, _get2.default)(state, 'authorAllFeed.data.page');
  var totalPages = (0, _get2.default)(state, 'authorAllFeed.data.totalPages');

  if (page < totalPages && page - 1 !== 0) {
    prev = 'https://www.' + site + '.com/user/' + authorSlug + '/' + (page - 1);
  }

  if (page + 1 <= totalPages) {
    next = 'https://www.' + site + '.com/user/' + authorSlug + '/' + (page + 1);
  }

  var base = {
    site: site,
    siteConf: siteConf,
    title: title,
    url: 'https://www.' + site + '.com/user/' + authorSlug,
    description: description,
    articleSection: authorName,
    rss: rss,
    config: state.config,
    extend: [{
      link: []
    }]
  };

  if (next) {
    base.extend[0].link.push({
      rel: 'next',
      href: next
    });
  }

  if (prev) {
    base.extend[0].link.push({
      rel: 'prev',
      href: prev
    });
  }

  return (0, _base_seo_util2.default)(base);
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var siteHumanReadable = (0, _get2.default)(siteConf, '[og:site_name]');
  var searchQuery = (0, _get2.default)(state, 'search.data.query.queryString') || (0, _get2.default)(state, 'search.queryString') || '';
  var description = searchQuery ? 'Search results for: ' + searchQuery : 'Search results on ' + siteHumanReadable;
  var title = searchQuery ? 'Search results for: ' + searchQuery : 'Search results on ' + siteHumanReadable;

  var data = (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    url: 'https://www.' + site + '.com/search/' + searchQuery,
    description: description,
    articleSection: searchQuery,
    config: state.config
  });

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var wpPage = (0, _get2.default)(state, 'customPage.data.page[0]');
  var slug = (0, _get2.default)(wpPage, 'slug');
  var pageTitle = (0, _get2.default)(wpPage, 'title.rendered');
  var wpExcerpt = (0, _get2.default)(wpPage, 'excerpt.rendered');
  var description = wpExcerpt ? (0, _striptags2.default)(wpExcerpt).trim() : '';

  var slugLookup = {
    'world-changing-ideas': {
      title: 'World Changing Ideas',
      description: 'Rewarding ideas, projects, and products from the last year that have the potential to alter the lives of people and the direction of the planet for the better.',
      articleSection: 'World Changing Ideas'
    },
    'most-innovative-companies': {
      title: 'Most Innovative Companies',
      description: "Designating the world's most innovative companies to reflect today’s expanding innovation efforts across the business landscape.",
      articleSection: 'Most Innovative Companies'
    },
    'innovation-by-design': {
      title: 'Innovation By Design Awards',
      description: 'The 2018 Innovation By Design Awards honor the designers and businesses solving the problems of today and tomorrow. The entry period will run from February 12, 2018-May 10, 2018. Enter one of the most sought-after design awards in the industry today!',
      articleSection: 'Innovation By Design Award About'
    }
  };

  var foundStaticConfig = slugLookup[slug] || {};

  var slugOverride = slug;
  if (slug === 'innovation-by-design') {
    slugOverride = 'apply/' + slug;
  }

  var base = {
    site: site,
    siteConf: siteConf,
    url: 'https://www.' + site + '.com/' + slugOverride,
    title: pageTitle,
    articleSection: pageTitle,
    description: description,
    config: state.config
  };

  var union = (0, _assign2.default)({}, base, foundStaticConfig);

  var data = (0, _base_seo_util2.default)(union);
  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _striptags = __webpack_require__(35);

var _striptags2 = _interopRequireDefault(_striptags);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var siteHumanReadable = (0, _get2.default)(siteConf, '[og:site_name]');

  var url = (0, _get2.default)(state, 'config.navHistory[0]');

  /*
    USE CASE: add your url here if you are creating a static page that does not pull
    data from an external API. To start, there is only /newsletters page.
  */

  var urlLookup = {
    'https://www.fastcompany.com/newsletters': {
      title: 'Fast Company Newsletters',
      description: 'Get the latest stories and updates sent your inbox.',
      url: url,
      articleSection: 'Fast Company Newsletters'
    }
  };

  var foundStaticConfig = urlLookup[url] || {};

  var base = {
    site: site,
    siteConf: siteConf,
    title: siteHumanReadable,
    config: state.config
  };

  var union = (0, _assign2.default)({}, base, foundStaticConfig);

  var data = (0, _base_seo_util2.default)(union);

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var siteHumanReadable = (0, _get2.default)(siteConf, '[og:site_name]');

  var url = (0, _get2.default)(state, 'config.navHistory[0]');

  /*
    USE CASE: add your url here if you are creating a static page that does not pull
    data from an external API. To start, there is only /newsletters page.
  */

  var config = {
    title: 'Fast Company Newsletters Preferences Page',
    description: 'Update your subscriptions to Fast Company Newsletters',
    url: url,
    articleSection: 'Fast Company Newsletters Preferences Page'
  };

  var base = {
    site: site,
    siteConf: siteConf,
    title: siteHumanReadable,
    config: state.config
  };

  var union = (0, _assign2.default)({}, base, config);

  var data = (0, _base_seo_util2.default)(union);

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var siteHumanReadable = (0, _get2.default)(siteConf, '[og:site_name]');
  var description = 'Site map for ' + siteHumanReadable;

  var pageURL = (0, _get2.default)(state, 'config.navHistory[0]').split('/');
  var year = '';

  if (pageURL.length) {
    var yearIdentifier = pageURL[pageURL.length - 1];
    if (yearIdentifier !== 'sitemap') {
      year = ' > ' + yearIdentifier;
    }
  }

  var title = 'Site Map' + year;
  var data = (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    url: (0, _get2.default)(state, 'config.navHistory[0]'),
    description: description,
    articleSection: title,
    config: state.config
  });

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var sitemapPostPageTitle = (0, _get2.default)(state, 'htmlSitemapPost.data.title');
  var description = 'Site map for ' + sitemapPostPageTitle;
  var title = '' + sitemapPostPageTitle;

  var data = (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    url: (0, _get2.default)(state, 'config.navHistory[0]'),
    description: description,
    articleSection: title,
    config: state.config
  });

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(10);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(11);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    code: 200
  };
  var action = arguments[1];

  if (action.type === 'NOT_FOUND_STATUS') {
    return {
      code: 404
    };
  }

  if (action.type === 'ERROR_STATUS') {
    return {
      code: action.status
    };
  }

  if (action.type === 'UNPUBLISHED_STATUS') {
    return {
      code: 403
    };
  }

  if (action.type === 'REDIRECT_POST_URL') {
    return {
      code: 301,
      redirect: action.redirect
    };
  }

  if (/PAGE_LOADING/.test(action.type) && _exenv.canUseDOM) {
    return (0, _extend2.default)({}, state, {
      code: 200
    });
  }

  return state;
};

var _extend = __webpack_require__(8);

var _extend2 = _interopRequireDefault(_extend);

var _exenv = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    NOT_FOUND_PAGE_LOADING: function NOT_FOUND_PAGE_LOADING() {
      return {
        isLoading: true
      };
    },
    NOT_FOUND_PAGE_LOADED: function NOT_FOUND_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.notFoundPage
      };
    },
    NOT_FOUND_PAGE_ERROR: function NOT_FOUND_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.notFoundPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initialize;

var _font_loader_util = __webpack_require__(820);

var _font_loader_util2 = _interopRequireDefault(_font_loader_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initialize() {
  return Promise.all([_font_loader_util2.default.loadFonts()]);
} // import log from '../services/logger_service';

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fontfaceobserver = __webpack_require__(153);

var _fontfaceobserver2 = _interopRequireDefault(_fontfaceobserver);

var _logger_service = __webpack_require__(132);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var fonts = ['FCIcon2015', 'FCKaiser', 'FCZizouSans', 'MeretPro'];

var FontLoaderUtil = function () {
  function FontLoaderUtil() {
    _classCallCheck(this, FontLoaderUtil);
  }

  _createClass(FontLoaderUtil, null, [{
    key: 'loadFonts',
    value: function loadFonts() {
      var fontPromise = Promise.all(fonts.map(function observeFont(fontname) {
        return new _fontfaceobserver2.default(fontname);
      }));
      return fontPromise.then(function fontLoadSuccess() {
        document.documentElement.className += document.documentElement.className === '' ? 'fonts-loaded' : ' fonts-loaded';
      }).catch(function fontLoadFail(err) {
        document.documentElement.className += document.documentElement.className === '' ? 'fonts-loaded fonts-loaded-error' : ' fonts-loaded fonts-loaded-error';
        _logger_service2.default.error(err, 'Error in font loader loading fonts.');
      });
    }
  }]);

  return FontLoaderUtil;
}();

exports.default = FontLoaderUtil;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    type: 'INITIAL_PAGE_LOAD',
    initialPageLoad: false
  };
};

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = polyfillImages;
function polyfillImages() {
  // create an image node so we can test its properties
  var img = document.createElement('img');
  // feature detect
  var supportSrcset = 'srcset' in img && 'sizes' in img;
  if (!supportSrcset) {
    // feature not available:
    // create a script tag
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://cdn.jsdelivr.net/picturefill/3.0.3/picturefill.min.js';
    script.setAttribute('async', '');
    // add it to the document <head>...
    var head = document.getElementsByTagName('head')[0];
    head.appendChild(script);
  }
}

/***/ })
],[487]);


// WEBPACK FOOTER //
// bundle.f1634836dd61840af459.js